import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { ReportsService } from "./reports.service";
import {
  MatPaginator,
  MatSort,
  MatTableDataSource,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MAT_DATE_FORMATS,
  ShowOnDirtyErrorStateMatcher,
} from "@angular/material";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { of } from "rxjs";
import { delay } from "rxjs/operators";
import { NgxCarousel } from "ngx-carousel";
import { CospService } from "../cosp/cosp.service";
import { DatePipe } from "@angular/common";
import { SessionStorageService } from "angular-web-storage";
import { VesselsService } from "../vessels/vessels.service";
import { VoyagelistService } from "../voyagelist/voyagelist.service";
import { CompanyService } from "../company/company.service";
import domtoimage from "dom-to-image";
import * as jsPDF from "jspdf";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { CookieService } from "ngx-cookie-service";
import { formatDate } from "@angular/common";
import * as _ from "lodash";
import { Component, OnInit, ViewChild, Output, EventEmitter, TemplateRef } from "@angular/core";
import { AppCommonService } from 'src/app/app.common.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DownloadReportComponent } from 'src/app/reports/download-report/download-report.component';
import { NullTemplateVisitor } from "@angular/compiler";
import { debug, error } from "console";
import { OtpDialogComponent } from "../otp-dialog/otp-dialog.component";
import { promise } from "protractor";
import { OtpDialogService } from "../otp-dialog/otp-dialog.service";
import { VesseltypeService } from "../vesseltype/vesseltype.service";
import { importExpr } from "@angular/compiler/src/output/output_ast";

export const APP_DATE_FORMATS = {
  parse: { dateInput: { day: "numeric", month: "short", year: "numeric" } },
  display: {
    dateInput: { day: "numeric", month: "short", year: "numeric" },
    monthYearLabel: { year: "numeric" },
  },
};

@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class ReportsComponent implements OnInit {
  @ViewChild('content', { static: true }) private content: TemplateRef<any>;
  modalRef: any;
  editedInfo: any=[];
  displayedColumns: string[] = ["reportName", "actionDate", "actionTime", "edit"];
  dataSource;
  htmlContent: string;
  dataSource1: any = [];
  dataSource2: any = [];
  formIdObject: any;
  isLoading = true;
  myForm: FormGroup;
  afs: any;
  success: boolean;
  data: any = [];
  watchHours: any = [];
  bookType: any = [];
  formBuilder: any = [];
  formData: any = [];
  formBuilderSections: any = [];
  formBuilderSectionList: any = [];
  formDetails: any = [];
  formSectionDetails: any = [];
  objcol: any = [];
  objcolsection: any = [];
  objcolcollection: any = [];
  fSection1: any = [];
  fSection2: any = [];
  fSection3: any = [];
  fSection4: any = [];
  fSection5: any = [];
  fSection6: any = [];
  fSection7: any = [];
  fSection8: any = [];
  formKeys: any = [];
  watchhr: any;
  garbegForm1: any;
  garbegForm2: any;
  oilnozoneForm: any;
  auditform: any;
  deckLogBook: any;
  blstForm: any;
  orbForm: any;
  bookTypeId: any;
  watchId: any;
  numberSection: any;
  formId: any;
  formCount: any = [];
  createdAt: any = [];
  responseDetails: any = [];
  currentBook: any;
  currentBookName: any;
  createdDate: any;
  reportTitle: any;
  hId: any;
  formKeyId: any;
  showpop: any;
  showpop1: any;
  showpop2: any;
  showpop3: any;
  showpop4: any;
  showpop5: any;
  showpop6: any;
  showLogBookHID: any;
  showpop7: any;
  showpop8: any;
  showpop9: any;
  //for olb
  showpop10: any;
  showpop11: any;
  showpop12: any;
  showpop13: any;
  showpop14: any;
  showpop15: any;
  showpop16: any;
  showpop17: any;
  showpop18: any;
  showpop19: any;
  show: string;
  orbpart2: any;
  voyageNo: any;
  voyageId: any;
  imoNo: any;
  shipName: any;
  shipFrom: any;
  shipTo: any;
  startDate: any;
  gmdss: any;
  olb: any;
  getFormRecordsList: any = [];
  alphabets = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  userSign: any = [];
  masterSignature: any = [];
  signdate: any;
  masterName: string;
  roleName: string;
  roleId: any;
  chiefOfficerSignature: any = [];
  chiefOfficersigndate: any;
  chiefOfficerName: string;
  chiefOfficerroleName: string;
  chiefOfficerroleId: any;
  id: any;
  formid: any;
  mmsi: any;
  calsign: any;
  mvsv: any;

  public cookieIp = "";
  selectedValue: string;
  watchHoursList: any = [];
  selectedValueWatch: string;
  allDeckLogBookGroupByDate: any = [];
  allNoonPositionGroupByDate: any = [];
  editedBy: string;
  timeZone: string;
  deckLogActionDate: any;

  userVesselData: any = [];
  userVoyageData: any = [];
  companyList: any = [];
  selectedVoyage: string;
  newVesselId: number;
  currentVessel: any;
  selectedCompany: string;
  mainEngineData: any = [];
  vesselInfo: any = [];
  testData: any = [];
  loading: boolean = false;
  selectedStatus: string = '';
  fromDate: string = '';
  toDate: string = '';
  filteredFormRecordsList: any[] = [];
  // getFormRecordsList: any[] = [];
  logoBase64: string = this.vts.logoBase64;
  vesselData;
  cospData;
  showMasterName;
  showVoyageNo;


  public Config: NgxCarousel = {
    grid: { xs: 2, sm: 3, md: 3, lg: 5, all: 0 },
    slide: 1,
    speed: 5,
    interval: 10000,
    point: {
      visible: true,
    },
    touch: true,
    loop: false,
    custom: "banner",
  };

  //@HostListener('click', ['$event']) //'click', ['$event.target']
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("successbox", { static: true }) successbox: SwalComponent;
  @ViewChild("errorbox", { static: true }) errorbox: SwalComponent;

  constructor(
    private cookieService: CookieService,
    private domSanitizer: DomSanitizer,
    public cmps: CompanyService,
    public voyagelistService: VoyagelistService,
    public vs: VesselsService,
    public cs: CospService,
    public session: SessionStorageService,
    public fb: FormBuilder,
    public reportsService: ReportsService,
    public http: HttpClient,
    public datePipe: DatePipe,
    public commonService: AppCommonService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    public otpService: OtpDialogService,
    public vts: VesseltypeService,
    public rs: ReportsService
  ) {

    (window as any).displayedit = this.displayedit.bind(this);
    (window as any).closePopover = this.closePopover.bind(this);
  }

  ngOnInit() {
    this.testData = {
      "responsecode": 200,
      "message": "Success",
      "timestamp": "Mon Jul 17 09:58:41 UTC 2023",
      "data": [
        {
          "id": 1,
          "actionDate": "6WWKN",
          "firstName": "Super",
          "middleName": "",
          "lastName": "Admin",
          "userName": "admin",
          "email": "adminadmin@gmail.com",
          "dateOfBirth": "20-02-1996",
          "roleId": 7,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "Super Admin",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "http://18.221.172.227:8089/campbellservice/downloadFile/804951-1672233810639.png",
          "signatureImage": "http://13.127.158.45:8089/campbellservice/downloadFile/download-1561714450479.jpeg",
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 2,
          "actionDate": "OETF4",
          "firstName": "NIXON FA",
          "middleName": "",
          "lastName": "FURTADO",
          "userName": "nixon",
          "email": "master.C6AY7@globeemail.com",
          "dateOfBirth": "23-07-1982",
          "roleId": 11,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "MASTER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 3,
          "actionDate": "UZH9W",
          "firstName": "ARJUN",
          "middleName": "",
          "lastName": "DIKSHIT",
          "userName": "arjun",
          "email": "arjun@sample.com",
          "dateOfBirth": "10-03-1990",
          "roleId": 13,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "2ND OFFICER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 4,
          "actionDate": "6NVI6",
          "firstName": "PARESH",
          "middleName": "SHYAMJI",
          "lastName": "VADHEL",
          "userName": "paresh",
          "email": "paresh@ilogs.com",
          "dateOfBirth": "01-04-1988",
          "roleId": 13,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "2ND OFFICER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 5,
          "actionDate": "YXANT",
          "firstName": "PIPON",
          "middleName": "",
          "lastName": "TALUKDER",
          "userName": "pipon",
          "email": "pipon@ilogs.com",
          "dateOfBirth": "19-09-1995",
          "roleId": 36,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "3RD OFFICER",
          "nationality": "BG-Bangladesh",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 6,
          "actionDate": "LVSWZ",
          "firstName": "MELAKU",
          "middleName": "WELDEMARIAM",
          "lastName": "HABTEMARIAM",
          "userName": "melaku",
          "email": "melaku@ilogs.com",
          "dateOfBirth": "12-03-1986",
          "roleId": 15,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "CHIEF ENGINEER",
          "nationality": "ET-Ethiopia",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 7,
          "actionDate": "MUK6J",
          "firstName": "MAUVIN",
          "middleName": "APOLINARIO",
          "lastName": "BRITTO",
          "userName": "mauvin",
          "email": "mauvin@ilogs.com",
          "dateOfBirth": "19-10-1985",
          "roleId": 42,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "3RD ENGINEER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 8,
          "actionDate": "HXNDN",
          "firstName": "VIRENDRA",
          "middleName": "PARAS",
          "lastName": "PRAJAPATI",
          "userName": "virendra",
          "email": "virendra@ilogs.com",
          "dateOfBirth": "03-02-1997",
          "roleId": 18,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "JUNIOR ENGINEER W.K.",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 9,
          "actionDate": "TVDEU",
          "firstName": "SUDELAYESAN",
          "middleName": "NADESAN",
          "lastName": "NADAR",
          "userName": "sudelayesan",
          "email": "sudelayesan@ilogs.com",
          "dateOfBirth": "07-06-1998",
          "roleId": 27,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "TRAINEE MARINE ENGINEER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 10,
          "actionDate": "L2HFQ",
          "firstName": "APARAJITO",
          "middleName": "",
          "lastName": "BASU",
          "userName": "aparajito",
          "email": "aparajito@ilogs.com",
          "dateOfBirth": "16-12-1978",
          "roleId": 91,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "2ND ENGINEER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 11,
          "actionDate": "ZDTV5",
          "firstName": "sada",
          "middleName": "",
          "lastName": "pol",
          "userName": "pols55",
          "email": "sada@esoftech.in",
          "dateOfBirth": "08-02-2006",
          "roleId": 1,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "Captain",
          "nationality": "IC-Iceland",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "signatureData": null,
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 12,
          "actionDate": "NUNVV",
          "firstName": "Sagar",
          "middleName": "D",
          "lastName": "More",
          "userName": "sagar1995",
          "email": "sagar@esoftech.in",
          "dateOfBirth": "03-01-2023",
          "roleId": 12,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "CHIEF OFFICER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 14,
          "actionDate": "KAJV3",
          "firstName": "rajashree",
          "middleName": "",
          "lastName": "kuwar",
          "userName": "rajashree",
          "email": "rajashree@esoftech.org",
          "dateOfBirth": "11-01-2023",
          "roleId": 12,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "CHIEF OFFICER",
          "nationality": "IN-India",
          "gender": "Female",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        },
        {
          "id": 15,
          "actionDate": "MYJQR",
          "firstName": "umair",
          "middleName": "",
          "lastName": "chauhan",
          "userName": "umair",
          "email": "umair@esoftech.org",
          "dateOfBirth": "12-01-2023",
          "roleId": 12,
          "companyId": 1,
          "companyName": "Campbell",
          "roleName": "CHIEF OFFICER",
          "nationality": "IN-India",
          "gender": "Male",
          "profileImage": "assets/media/logo/logo.png",
          "signatureImage": "assets/media/logo/logo.png",
          "active": true,
          "appValue": null,
          "signintime": null,
          "singouttime": null
        }
      ]
    }

    console.log("===this.this.testData.data===", this.testData.data);
    this.dataSource2 = new MatTableDataSource(this.testData.data);
    this.dataSource2.paginator = this.paginator;


    this.cookieIp = this.cookieService.get("campbell_app_ip_address");

    var companyid = this.session.get("companyId");
    if (companyid) {
      this.getVesselList(companyid);
    } else {
      this.getCompanyList();
    }

    if (this.session.get("passcode")) {
      this.reportsService.getLatestCOSPByPasscode(
        this.session.get("passcode"),
        (response) => {
          console.log("==================1=================");
          console.log(response);
          console.log("==================111=================");
          const responseData = response.data;
          console.log("===ngOnInit====", responseData);
          console.log("=================2222222222==================");
          if (response.responsecode == 200) {
            console.log("voyageNo" + responseData.voyageNo);
            console.log("voyageId" + responseData.id);
            this.voyageNo = responseData.voyageNo;
            this.voyageId = responseData.id;

            this.timeZone = responseData.zoneTimeValue;
            // this.getVoyageData(responseData.vesselId);
            this.selectedVoyage = responseData.voyageNo;
            // this.currentVessel = responseData.vesselId;

            if (this.voyageId) {
              this.vs.getDataById(responseData.vesselId, (vesseldata) => {
                if (vesseldata.responsecode == 200) {
                  console.log("=================33333==================", vesseldata);

                  if (
                    vesseldata.data.imoNo != null &&
                    vesseldata.data.imoNo != ""
                  ) {
                    this.imoNo = vesseldata.data.imoNo;
                  } else {
                    this.imoNo = vesseldata.data.vesselCode;
                  }

                  this.shipName = responseData.shipName;
                  this.shipFrom = responseData.fromPort;
                  this.shipTo = responseData.toPort;
                  this.startDate = responseData.voyageStartDate;
                  this.selectedCompany = vesseldata.data.companyId;
                  if (!companyid) {
                    this.getVesselList(this.selectedCompany);
                  }
                }
              });
            }
          }
        }
      );
    }

    this.reportsService.getParentCategory((response) => {
      this.bookType = response.data[0].children;
      this.bookType[4].children = [
        {
          hName: "Ballast Water Record Book",
          id: "47",
          image: "/FileUpload/image.png",
        },
      ];
      this.bookType[5].children = [
        {
          hName: "Fuel Oil and Ozone Depleting Substances",
          id: "48",
          image: "/FileUpload/image.png",
        },
      ];
      this.bookType[6].children = [
        {
          hName: "SECTION A : PARTICULARS OF SHIP",
          id: "49",
          image: "/FileUpload/image.png",
        },
        {
          hName: "SECTION B : QUALIFIED PERSONNEL",
          id: "49-1",
          image: "/FileUpload/image.png",
        },
        {
          hName: "SECTION C : NAME OF SHIP",
          id: "49-2",
          image: "/FileUpload/image.png",
        },
        {
          hName: "GMDSS RADIO LOG",
          id: "49-3",
          image: "/FileUpload/image.png",
        },
      ];
      this.bookType[7].children = [
        {
          //OLB-1
          //hName: "OLB-1",
          hName: "OFFICIAL LOG BOOK",
          id: "53-1",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF SEAMEN EMPLOYED IN THE SHIP
          //hName: "OLB-2",
          hName: "EMPLOYED SEAMEN RECORD",
          id: "53-2",
          image: "/FileUpload/image.png",
        },
        {
          //RETURNS AND ENTRIES OF BIRTH AND DEATH IN THE OFFICIAL LOG BOOK
          //hName: "OLB-3",
          hName: "BIRTHS & DEATHS",
          id: "53-3",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF MUSTERS BOAT DRILLS AND FIRE DRILLS,TRAINING OF CREW,AND INSPECTIONS OF LIFE-SAVING APPLIANCES AND FIRE APPLIANCES AS REQUIRED BY THE MERCHANT SHIPPING ACTS,1976 TO 1992
          hName: "TRAINING & DRILLS MUSTERS",
          id: "53-4",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF TEST DRILLS AND INSPECTIONS OF THE SHIP'S STEERING GEAR
          hName: "TEST DRILLS & INSPECTIONS",
          id: "53-5",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF INSPECTIONS OF CREW ACCOMODATION CARRIED OUT UNDER REGULATION 38(2) ABD 31(2) OF SCHEDULE 6 OF THE MERCHANT SHIPPING (CREW ACCOMODATIONS),REGULATIONS 1978 AS AMMENDED
          hName: "CREW ACCOMMODATION INSPECTIONS",
          id: "53-6",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF INSPECTIONS CARRIED OUT IN ACCORDANCE WITH INTERNATIONAL LABOUR ORGANISATION CONVENTION NO.68 OF 1946 OF SUPPLIES OF FOOD AND WATER PROVIDED FOR THE CREW
          hName: "ILO ACCORDANCE",
          id: "53-7",
          image: "/FileUpload/image.png",
        },
        {
          //RECORD OF INSPECTIONS CARRIED OUT IN ACCORDANCE WITH INTERNATIONAL LABOUR ORGANISATION CONVENTION NO.68 OF 1946 OF SUPPLIES OF FOOD AND WATER PROVIDED FOR THE CREW
          hName: "LOADLINE",
          id: "53-8",
          image: "/FileUpload/image.png",
        },
        {
          //DATES OF DEPARTURE FROM AND ARRIVAL AT EACH ,DOCK,WHARF,HARBOUR OR OTHER PLACE WITH THE DRAUGHT OF WATER AND FREEBOARD UPON EVERY OCCASSION OF THE SHIP PROCEEDING TO THE SEA
          hName: "DEPARTURES & ARRIVALS",
          id: "53-9",
          image: "/FileUpload/image.png",
        },
        {
          //OFFICIAL LOG OF THE
          hName: "PART IV SCHEDULE OLB",
          id: "53-10",
          image: "/FileUpload/image.png",
        },
      ];

      console.log("===this.bookType===", this.bookType);
      //changing images as per server settings
      for (let key in this.bookType) {
        if (this.bookType[key].children != null) {
          for (let pey in this.bookType[key].children) {
            if (this.bookType[key].children[pey].image != null)
              this.bookType[key].children[pey].image = this.bookType[
                key
              ].children[pey].image
                .toString()
                .replace("13.127.158.45", this.cookieIp)
                .replace("13.232.247.131", this.cookieIp)
                .replace("192.168.0.25", this.cookieIp);
          }
        }

        if (this.bookType[key].image != null) {
          this.bookType[key].image = this.bookType[key].image
            .toString()
            .replace("13.127.158.45", this.cookieIp)
            .replace("13.232.247.131", this.cookieIp)
            .replace("192.168.0.25", this.cookieIp);
        }
      }

      console.log("logtype:children");
      console.log(this.bookType);
    });

    this.reportsService.getFormByHid((response) => {
      this.formBuilder = response.data;
    });

    this.reportsService.getAllActiveWatchHour((response) => {
      this.watchHours = response.data;
    });

    this.myForm = this.fb.group({
      bookTypeId: new FormControl(null, [Validators.required]),
      watchId: new FormControl(null),
      //'formId':new FormControl(null, [Validators.required])
    });
  }

  getCompanyList() {
    this.cmps.getData((response) => {
      console.log("====company====");
      console.log(response.data);
      this.companyList = response.data;
    });
  }

  selectCompany(id) {
    this.userVesselData = [];
    this.cleanReports();
    this.currentBook = -1;
    this.getVesselList(id);
    this.currentVessel = id;
  }

  getVesselList(id) {
    this.userVesselData = [];
    this.userVoyageData = [];
    this.vs.getDataByCompanyId(id, (response) => {
      console.log("===userVesselData==", response);
      this.userVesselData = response.data;
      this.currentVessel = null;
      this.userVoyageData = [];
      this.selectedVoyage = null;
      this.voyageNo = null;
    });
  }

  getVesselDetailsById(id) {
    this.vs.getDataById(id, (response) => {
      console.log("vessel===data");
      console.log(response);
      this.selectedCompany = response.data.companyId;
      this.getVesselList(response.data.companyId);
    });
  }

  getVoyageData(id) {
    this.loading = true;
    this.selectedVoyage = null;
    this.currentBook = -1;
    this.newVesselId = id;
    console.log('==newVesselId==', this.newVesselId);
    this.voyagelistService.getAllClosedVoyageByvesselId(id, (response) => {
      console.log("follow the data123");
      console.log(response.data);
      var combinedArray = [];

      this.voyagelistService.getDataById(id, (resp) => {
        this.loading = false;
        this.voyageNo = null;
        this.selectedVoyage = null;
        if (resp.data) combinedArray.push(resp.data);

        for (let key in response.data) {
          //response.data[key].cosp['type'] = (parseInt(key)+1) + '- COSP'
          combinedArray.push(response.data[key].cosp);
        }

        this.userVoyageData = combinedArray;
        // this.selectedVoyage = resp.data.voyageNo;
        this.voyageNo = resp.data.voyageNo;
        // this.currentVessel = resp.data.vesselId;
        //more variable
        console.log("====getVoyageData  resp.data====", resp.data);
        this.vs.getDataById(resp.data.vesselId, (responseVessel) => {
          if (
            responseVessel.data.imoNo != null &&
            responseVessel.data.imoNo != ""
          ) {
            this.imoNo = responseVessel.data.imoNo;
          } else {
            this.imoNo = responseVessel.data.vesselCode;
          }
        });

        this.shipName = resp.data.shipName;
        this.shipFrom = resp.data.fromPort;
        this.shipTo = resp.data.toPort;
        this.startDate = resp.data.voyageStartDate;

        this.cleanReports();
      });
    });
    this.cleanReports();
  }

  selectVoyage(value) {
    this.currentBook = -1;
    this.voyageNo = value;
    this.selectedVoyage = value;
    this.getVesselDetailByVesselId(this.newVesselId);
    this.getCospDetail(this.newVesselId, this.selectedVoyage);
    this.cleanReports();
  }

  createWatchHoursJson() {
    var watchlist = [];
    if (this.getFormRecordsList.length > 0 || this.getFormRecordsList[0].data != undefined) {
      for (var r = 0; r < this.getFormRecordsList[0].data.length; r++) {
        var actionTime = this.getFormRecordsList[0].data[r].actionTime;
        if (actionTime) {
          watchlist.push(actionTime);
        }
      }
      this.watchHoursList = Array.from(new Set(watchlist));
      this.watchHoursList.sort();
    }
  }

  getFormDetails(hid) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formName = this.formBuilder[i].formbuilderresponse[r].formName;
          this.formKeys.push(formName);
        }
      }
    }
  }

  getWatchHours(hid) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formName = this.formBuilder[i].formbuilderresponse[r].formName;
          this.formKeys.push(formName);
        }
      }
    }
  }

  callHType(hid, wid, sectionIndex) {
    //hid = 6;
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;
          //alert(formId);
          this.formBuilderSections =
            this.formBuilder[i].formbuilderresponse[
              r
            ].formbuildersectionnamelist[sectionIndex].formbuilderlist;
          this.numberSection =
            this.formBuilder[i].formbuilderresponse[
              r
            ].formbuildersectionnamelist.length;
          this.formDetails = [];
          this.objcol = [];
          var sectionId =
            this.formBuilder[i].formbuilderresponse[r]
              .formbuildersectionnamelist[sectionIndex].sectionId;
          this.reportsService.getFormDetailsById(
            formId,
            this.voyageNo,
            (formResponse) => {
              var response = formResponse[0];
              if (response.data != null) {
                for (var s = 0; s < response.data.length; s++) {
                  for (var p = 0; p < this.formBuilderSections.length; p++) {
                    var findKey = false;
                    for (let key in response.data[s]) {
                      if (key == this.formBuilderSections[p].fieldName) {
                        findKey = true;
                        this.objcol.push(response.data[s][key]);
                      }
                    }

                    if (findKey != true) {
                      this.objcol.push("NaN");
                    }
                  }

                  console.log(this.objcol);
                  this.formDetails.push(this.objcol);
                  this.objcol = [];
                }
              }
            }
          );
        }
      }
    }
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
  }

  addTestForm() {
    return {
      formData: {
        Name_of_sec_Tank_Designation_387: "FR-14017(P)",
        TextBox_388: "2222 <b> edited </b>",
        m3_389: "m3",
        TextBox_390: "",
        m3_391: "m3",
        TextBox_392: "",
        m3_393: "m3",
        collected_from_394: "",
        identification_of_source_456: "",
        TextBox_1_395: "",
        m3_396: "m3",
        Sludge_from_397: "",
        Name_of_sec__Tank_Designation_398: "",
        _399: ",",
        TextBox_2_400: "",
        m3_retained_to_401: "m3 retained, to",
        Name_of_sec_Tank_Designation_402: "",
        during_port_stay_403: "DURING PORT STAY",
        Name_of_Port_404: "",
        TextBox_1_405: "",
        m3_406: "m3",
        Water_drained_from_407: "",
        "Name_of_sec_Tank_Designation_408\t": "",
        // Name_of_sec_Tank_Designation_408: "",
        TextBox_2_409: "",
        m3_retained_to_410: "m3 retained, to",
        Name_of_sec_Tank_Designation_411: "",
        retained_in_tank_412: "RETAINED IN TANK(S)",
        TextBox_3_413: "",
        m3_414: "m3",
        TextBox_1_415: "",
        m3_417: "m3",
        Sludge_from_419: "",
        Name_of_sec_Tank_Designation_420: "",
        TextBox_2_423: "",
        m3_424: "m3 retained, Burned in incinerator for",
        TextBox_3_426: "",
        hours_427: "HOURS",
        TextBox_1_416: "",
        m3_418: "m3",
        Sludge_from_421: "",
        "Name of_sec Tank _Designation_422": "",
        TextBox_2_425: "",
        m3_428: "m3 retained, Burned in Boiler for",
        TextBox_3_429: "",
        hours_430: "HOURS",
      },
      timeStamp: 1581937459527,
      formId: "32",
      rowId: "123456",
      voyageId: "522",
      voyageNo: "12345",
      vesselId: "64",
      changeFields: "{TextBox_388,Name_of_sec_Tank_Designation_387}",
    };
  }

  getOrbPartTwoData(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 49 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 50 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 51 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 52 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 53 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 54 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 55 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 56 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 57 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 58 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 59 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 60 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 62 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 63 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 64 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 61 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 65 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 66
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);

        this.loading=true;
        this.reportsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            this.loading=false;
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec11 = [];
            var colsec12 = [];
            var colsec2 = [];
            var colsec21 = [];
            var colsec22 = [];
            var colsec23 = [];
            var colsec3 = [];
            var colsec31 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec61 = [];
            var colsec62 = [];
            var colsec63 = [];
            var colsec7 = [];
            var colsec8 = [];
            var colsec81 = [];
            var colsec82 = [];
            var coldate = [];
            var colsec9 = [];
            let response = [];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";

            let newData = multiresponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    // [item.data[0].formId] : item.data[0]._id['$oid']
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            // console.log('FormIdObject_List_1', this.formIdObject);
            if (multiresponse != null && multiresponse.length > 0) {
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              console.log("=========final data============", response);
              // all form response loop
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";
                  this.showpop4 = 0;
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                      //alert(this.editedBy); return;
                    }

                    var usersign = response[ky].data[s].userSign;
                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    var formId = response[ky].data[s].formId;
                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    this.id = id;
                    this.formId = formId;

                    this.userSign.push(usersign);

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    var p = 0;
                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] =
                              this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            if (formId == 49) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 0;
                              this.orbpart2 = 1;
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  key.toString().toLowerCase() ==
                                  "Place_of_loading_1175".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Type_of_oil_1176".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1177".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_of_oil_loaded_1178".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1179".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_content_1180".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1181".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              //
                            }

                            if (formId == 50) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 0;
                              this.orbpart2 = 1;
                              //alert(p)
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  (key.toString().toLowerCase() ==
                                    "4.1_from_1182".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1183".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "4.2_to_1184".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1185".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_transferred_1186".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "4000_m3_1187".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1188".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1189".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_retained_1190".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1191".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 51) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Place_of_unloading_1192".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1193".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1194".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1195".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_retained_1196".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1197".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 52) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1198".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_name_1199".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "position_1200".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1201".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_Degree_1202".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1203".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_minutes_1204".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1205".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1206".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1207".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1208".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1209".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1210".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1211".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1212".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1213".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "No_of_machines_1214".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1215".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "washing_pattern_1216".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 5) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Washing_line_pressure_1217".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 6) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1218".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 7) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "state_method_1219".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 8) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Remarks_1220".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec9[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            console.log("==formId==", formId);

                            if (formId == 53) {
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_1221".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1222".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_degree_1223".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1224".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1225".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1226".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1227".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1228".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1229".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_minutes_1230".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1231".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1232".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "STOP_1233".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_1234".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_degree_1235".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1236".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minurtes_1237".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1238".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1239".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1240".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1241".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1242".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_minutes_1243".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1244".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_direction_1245".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1620_1228".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "identity_of_tanks_1246".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tank_name_1247".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_and_start_1248".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Start_1249".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_1250".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "END_1251".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "time_1252".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_of_ballast_1253".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_ballast_received_1254".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1255".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 56) {
                              console.log(
                                "===response[ky] formId==",
                                response[ky]
                              );
                              this.orbpart2 = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1352".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1353".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1354".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1355".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1356".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_11357".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1358".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1359".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1360".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1361".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1362".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1363".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1364".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec11[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1366".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1367".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1368".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1369".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1370".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1371".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1373".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1374".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1375".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1376".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1377".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1378".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1621_1371".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec12[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "quantity_1379".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1380".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "speed_1380".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec21[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "yes_1382".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "no_1383".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec22[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "yes_1384".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "no_1385".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec23[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 7) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1386".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tank_name_1387".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_1388".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1389".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 8) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1390".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1391".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_Quantity_1392".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1393".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 59) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "LAT_1456".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1458".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1460".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1462".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1464".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1465".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1466".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1468".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1469".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1471".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1473".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1474".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1475".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1476".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1477".toLowerCase()
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                console.log(
                                  "====response[ky].data[s]==",
                                  response[ky].data[s]
                                );
                                if (
                                  (key.toString().toLowerCase() ==
                                    "LAT_1479".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1481".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1483".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1484".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1485".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1488".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1490".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1492".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1494".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1496".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1498".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1500".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Yes_1502".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1503".toLowerCase()
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 58) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1446".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_transferred_1447".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1448".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_retained_1449".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1450".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "disposal_of_reception_1451".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_name_1452".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "certificate_obtained_from_1453".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "yes_1454".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1455".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "time_1457".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1459".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1461".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "cargo_quantity_1467".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_1470".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "from_tank_1480".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "tanks_1482".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_tank_1486".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_1487".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "to_tank_1489".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tanks_1491".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_tank_1493".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "quantity_1495".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_transferred_1497".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "total_quantity_1499".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1501".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "other_method_1504".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_disposal_1505".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_quantity_1506".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1507".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 60) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1508".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1512".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1514".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1515".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1516".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1517".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1518".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1519".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1520".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1521".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1522".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1523".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1524".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1525".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1526".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1527".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1528".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1529".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1530".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1531".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1532".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1533".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1534".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1535".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1536".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1537".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1538".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "into_sea_1539".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1540".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_or_1541".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_1542".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reception_facilities_name_1543".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "port_1544".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1545".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1546".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "yes_1548".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1549".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "time_1550".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "date_1551".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1552".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1553".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "yes_1554".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1555".toLowerCase()
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "yes_1556".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "no_1557".toLowerCase()
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1558".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1559".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1560".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1561".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1562".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1563".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1564".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1565".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1566".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1567".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1568".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1569".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1570".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 61) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1509".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1510".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_1511".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 62) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1513".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "port_1481".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1574".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1575".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1576".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1577".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1578".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1579".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1580".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1581".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1582".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1583".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1584".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1585".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec11[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1586".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1587".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "type_of_oil_1588".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reason_1589".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 63) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Procedures_1590".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_remarks_1591".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 64) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1592".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1605".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1606".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Remarks_1607".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 65) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_1608".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 66) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Port_1609".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_reception_facility_1610".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1611".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1612".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Date_1613".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "yes_1615".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "no_1616".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "yes_1618".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "no_1619".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec31[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 57) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1394".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1395".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1396".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                console.log(
                                  "====response[ky]===",
                                  response[ky]
                                );
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1397".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1398".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1399".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1400".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1403".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1405".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1406".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1408".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1409".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1410".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1412".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1413".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1414".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec31[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                console.log(
                                  "====response[ky] colsec31===",
                                  colsec31
                                );
                              }

                              if (p == 4) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Ullage_of_contents_1401".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_oil_1402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_water_1404".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bulk_quantity_discharge_1407".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1411".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Rate_of_discharge_1415".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_hour_1416".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 7) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Final_quantity_discharge_1417".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1418".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Final_rate_of_discharge_1419".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_hour_1420".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec61[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 8) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1421".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_1423".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1425".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1427".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1428".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1430".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1432".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_1434".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1435".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1437".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1439".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1441".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1444".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec62[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 9) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Yes_1422".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "No_1424".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec63[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 10) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_oil_1226".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "metres_1429".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Ullage_of_water_1431".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "metres_1433".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 11) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Speed_1436".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 12) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Yes_1438".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "No_1440".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec81[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 13) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Yes_1442".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "No_1443".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Enter_here_1445".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec82[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 54) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1256".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1257".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1258".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1265".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1266".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1268".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1269".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1270".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1271".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1284".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1286".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1287".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1289".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1290".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1291".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Lat_1293".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1294".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1297".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1299".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1300".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1301".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1303".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1305".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1307".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1309".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1310".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1311".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantity_of_oily_water_1312".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "state_total_quantity_1314".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1316".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_name_1318".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Lat_1323".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1326".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1327".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1328".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1329".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1330".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1331".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1332".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1333".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1334".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1335".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1336".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "time_1337".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lat_1338".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_degree_1339".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1340".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_minutes_1341".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1342".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1343".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Long_1344".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1345".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1346".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1347".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1348".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1349".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 6) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Quantuty_of_clean_ballast_1350".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1351".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 55) {
                              this.orbpart2 = 1;
                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Tank_name_1259".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_1261".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_1262".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1264".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_Degree_1267".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1272".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_minutes_1273".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1274".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lat_direction_1275".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1276".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_degree_1277".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "degree_1278".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_minutes_1279".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "minutes_1280".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "long_direction_1281".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "time_1282".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Chemical_cleaning_1283".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Chemical_concerned_1285".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1288".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "reception_facilities_1292".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facilities_name_1295".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_1296".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1298".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "receipts_and_certificates_obtained_1302".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "Yes_1304".toLowerCase() ||
                                  key.toString().toLowerCase() ==
                                  "No_1306".toLowerCase() ||
                                  (key.toString().toLowerCase() ==
                                    "date_1313".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1315".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1317".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "slop_and_cargo_tank_designated_1319".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_quantity_transferred_1321".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1322".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Total_quantity_1324".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1325".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array
                    if (formId == 55) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1259".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "27",
                          colsec1["Tank_name_1259".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "27",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["degree_1272".toLowerCase()] != null) {
                        if (colsec2["Port_1261".toLowerCase()] == null)
                          colsec2["Port_1261".toLowerCase()] = "";
                        if (colsec2["Port_1262".toLowerCase()] == null)
                          colsec2["Port_1262".toLowerCase()] = "";
                        if (colsec2["LAT_Degree_1267".toLowerCase()] == null)
                          colsec2["LAT_Degree_1267".toLowerCase()] = "";
                        if (colsec2["LAT_1264".toLowerCase()] == null)
                          colsec2["LAT_1264".toLowerCase()] = "";
                        if (colsec2["LAT_minutes_1273".toLowerCase()] == null)
                          colsec2["LAT_minutes_1273".toLowerCase()] = "";
                        if (colsec2["minutes_1274".toLowerCase()] == null)
                          colsec2["minutes_1274".toLowerCase()] = "";
                        if (colsec2["lat_direction_1275".toLowerCase()] == null)
                          colsec2["lat_direction_1275".toLowerCase()] = "";
                        if (colsec2["LONG_1276".toLowerCase()] == null)
                          colsec2["LONG_1276".toLowerCase()] = "";
                        if (colsec2["long_degree_1277".toLowerCase()] == null)
                          colsec2["long_degree_1277".toLowerCase()] = "";
                        if (colsec2["degree_1278".toLowerCase()] == null)
                          colsec2["degree_1278".toLowerCase()] = "";
                        if (colsec2["long_minutes_1279".toLowerCase()] == null)
                          colsec2["long_minutes_1279".toLowerCase()] = "";
                        if (colsec2["minutes_1280".toLowerCase()] == null)
                          colsec2["minutes_1280".toLowerCase()] = "";
                        if (
                          colsec2["long_direction_1281".toLowerCase()] == null
                        )
                          colsec2["long_direction_1281".toLowerCase()] = "";

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "28",
                          colsec2["Port_1261".toLowerCase()] +
                          " " +
                          colsec2["Port_1262".toLowerCase()] +
                          " " +
                          colsec2["LAT_1264".toLowerCase()] +
                          " " +
                          colsec2["LAT_Degree_1267".toLowerCase()] +
                          " " +
                          colsec2["degree_1272".toLowerCase()] +
                          " " +
                          colsec2["LAT_minutes_1273".toLowerCase()] +
                          " " +
                          colsec2["minutes_1274".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1275".toLowerCase()] +
                          "/" +
                          colsec2["LONG_1276".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1277".toLowerCase()] +
                          " " +
                          colsec2["degree_1278".toLowerCase()] +
                          " " +
                          colsec2["long_minutes_1279".toLowerCase()] +
                          " " +
                          colsec2["minutes_1280".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1281".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "28",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["time_1282".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "29",
                          colsec3["time_1282".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "29",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["Chemical_cleaning_1283".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "30",
                          colsec4["Chemical_cleaning_1283".toLowerCase()] +
                          " " +
                          colsec4["Chemical_concerned_1285".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1288".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "30",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);
                      if (colsec5["m3_1325".toLowerCase()] != null) {
                        if (
                          colsec5["reception_facilities_1292".toLowerCase()] ==
                          null
                        )
                          colsec5["reception_facilities_1292".toLowerCase()] =
                            "";
                        if (
                          colsec5[
                          "reception_facilities_name_1295".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "reception_facilities_name_1295".toLowerCase()
                          ] = "";
                        if (colsec5["Port_1296".toLowerCase()] == null)
                          colsec5["Port_1296".toLowerCase()] = "";
                        if (colsec5["Quantity_1298".toLowerCase()] == null)
                          colsec5["Quantity_1298".toLowerCase()] = "";
                        if (
                          colsec5[
                          "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] = "";
                        if (colsec5["Yes_1304".toLowerCase()] == null)
                          colsec5["Yes_1304".toLowerCase()] = "";
                        if (colsec5["No_1306".toLowerCase()] == null)
                          colsec5["No_1306".toLowerCase()] = "";
                        if (colsec5["date_1313".toLowerCase()] == null)
                          colsec5["date_1313".toLowerCase()] = "";
                        if (colsec5["Quantity_1315".toLowerCase()] == null)
                          colsec5["Quantity_1315".toLowerCase()] = "";
                        if (
                          colsec5[
                          "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] = "";
                        if (
                          colsec5[
                          "State_quantity_transferred_1321".toLowerCase()
                          ] == null
                        )
                          colsec5[
                            "State_quantity_transferred_1321".toLowerCase()
                          ] = "";
                        if (colsec5["m3_1322".toLowerCase()] == null)
                          colsec5["m3_1322".toLowerCase()] = "";
                        if (
                          colsec5["Total_quantity_1324".toLowerCase()] == null
                        )
                          colsec5["Total_quantity_1324".toLowerCase()] = "";
                        if (colsec5["m3_1325".toLowerCase()] == null)
                          colsec5["m3_1325".toLowerCase()] = "";
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "31",
                          colsec5["reception_facilities_1292".toLowerCase()] +
                          " " +
                          colsec5[
                          "reception_facilities_name_1295".toLowerCase()
                          ] +
                          " " +
                          colsec5["Port_1296".toLowerCase()] +
                          " " +
                          colsec5["Quantity_1298".toLowerCase()] +
                          " " +
                          colsec5[
                          "receipts_and_certificates_obtained_1302".toLowerCase()
                          ] +
                          " " +
                          colsec5["Yes_1304".toLowerCase()] +
                          " " +
                          colsec5["No_1306".toLowerCase()] +
                          " " +
                          colsec5["date_1313".toLowerCase()] +
                          " " +
                          colsec5["Quantity_1315".toLowerCase()] +
                          " " +
                          colsec5["m3_1317".toLowerCase()] +
                          " " +
                          colsec5[
                          "slop_and_cargo_tank_designated_1319".toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "State_quantity_transferred_1321".toLowerCase()
                          ] +
                          " " +
                          colsec5["m3_1322".toLowerCase()] +
                          " " +
                          colsec5["Total_quantity_1324".toLowerCase()] +
                          " " +
                          colsec5["m3_1325".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "31",
                          "", usersign
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 54) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1256".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20",
                          colsec1["Tank_name_1256".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["degree_1268".toLowerCase()] != null) {
                        if (colsec2["Port_1257".toLowerCase()] == null) {
                          colsec2["Port_1257".toLowerCase()] = "";
                        }
                        if (colsec2["Port_name_1258".toLowerCase()] == null) {
                          colsec2["Port_name_1258".toLowerCase()] = "";
                        }
                        if (colsec2["LAT_1265".toLowerCase()] == null) {
                          colsec2["LAT_1265".toLowerCase()] = "";
                        }
                        if (colsec2["lat_degree_1266".toLowerCase()] == null) {
                          colsec2["lat_degree_1266".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1270".toLowerCase()] == null) {
                          colsec2["minutes_1270".toLowerCase()] = "";
                        }
                        if (
                          colsec2["lat_direction_1271".toLowerCase()] == null
                        ) {
                          colsec2["lat_direction_1271".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1269".toLowerCase()] == null) {
                          colsec2["lat_minutes_1269".toLowerCase()] = "";
                        }
                        if (colsec2["Long_1284".toLowerCase()] == null) {
                          colsec2["Long_1284".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1289".toLowerCase()] == null) {
                          colsec2["lat_minutes_1289".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1290".toLowerCase()] == null) {
                          colsec2["minutes_1290".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_direction_1291".toLowerCase()] == null
                        ) {
                          colsec2["long_direction_1291".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1287".toLowerCase()] == null) {
                          colsec2["degree_1287".toLowerCase()] = "";
                        }
                        if (colsec2["long_degree_1286".toLowerCase()] == null) {
                          colsec2["long_degree_1286".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21",
                          colsec2["Port_1257".toLowerCase()] +
                          " " +
                          colsec2["Port_name_1258".toLowerCase()] +
                          " " +
                          colsec2["LAT_1265".toLowerCase()] +
                          " " +
                          colsec2["lat_degree_1266".toLowerCase()] +
                          " " +
                          colsec2["degree_1268".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1269".toLowerCase()] +
                          " " +
                          colsec2["minutes_1270".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1271".toLowerCase()] +
                          "/" +
                          colsec2["Long_1284".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1286".toLowerCase()] +
                          " " +
                          colsec2["degree_1287".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1289".toLowerCase()] +
                          " " +
                          colsec2["minutes_1290".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1291".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["degree_1297".toLowerCase()] != null) {
                        if (colsec2["Lat_1293".toLowerCase()] == null) {
                          colsec2["Lat_1293".toLowerCase()] = "";
                        }
                        if (colsec2["lat_degree_1294".toLowerCase()] == null) {
                          colsec2["lat_degree_1294".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1297".toLowerCase()] == null) {
                          colsec2["degree_1297".toLowerCase()] = "";
                        }
                        if (colsec2["lat_minutes_1299".toLowerCase()] == null) {
                          colsec2["lat_minutes_1299".toLowerCase()] = "";
                        }
                        if (colsec2["Long_1303".toLowerCase()] == null) {
                          colsec2["Long_1303".toLowerCase()] = "";
                        }
                        if (colsec2["long_degree_1305".toLowerCase()] == null) {
                          colsec2["long_degree_1305".toLowerCase()] = "";
                        }
                        if (colsec2["minutes_1290".toLowerCase()] == null) {
                          colsec2["minutes_1290".toLowerCase()] = "";
                        }
                        if (colsec2["degree_1307".toLowerCase()] == null) {
                          colsec2["degree_1307".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_minutes_1309".toLowerCase()] == null
                        ) {
                          colsec2["long_minutes_1309".toLowerCase()] = "";
                        }
                        if (
                          colsec2["long_direction_1311".toLowerCase()] == null
                        ) {
                          colsec2["long_direction_1311".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22",
                          colsec3["Lat_1293".toLowerCase()] +
                          " " +
                          colsec3["lat_degree_1294".toLowerCase()] +
                          " " +
                          colsec3["degree_1297".toLowerCase()] +
                          " " +
                          colsec3["lat_minutes_1299".toLowerCase()] +
                          " " +
                          colsec3["minutes_1300".toLowerCase()] +
                          " " +
                          colsec3["lat_direction_1301".toLowerCase()] +
                          "/" +
                          colsec3["Long_1303".toLowerCase()] +
                          " " +
                          colsec3["long_degree_1305".toLowerCase()] +
                          " " +
                          colsec3["degree_1307".toLowerCase()] +
                          " " +
                          colsec3["long_minutes_1309".toLowerCase()] +
                          " " +
                          colsec3["minutes_1310".toLowerCase()] +
                          " " +
                          colsec3["long_direction_1311".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec4["m3_1316".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23",
                          colsec4["Quantity_of_oily_water_1312".toLowerCase()] +
                          " " +
                          colsec4["state_total_quantity_1314".toLowerCase()] +
                          " " +
                          colsec4["m3_1316".toLowerCase()] +
                          " " +
                          colsec4["Tank_name_1318".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec5["degree_1327".toLowerCase()] != null) {
                        if (colsec5["Lat_1323".toLowerCase()] == null) {
                          colsec5["Lat_1323".toLowerCase()] = "0.00";
                        }
                        if (colsec5["lat_degree_1326".toLowerCase()] == null) {
                          colsec5["lat_degree_1326".toLowerCase()] = "";
                        }
                        if (colsec5["degree_1327".toLowerCase()] == null) {
                          colsec5["degree_1327".toLowerCase()] = "";
                        }
                        if (colsec5["lat_minutes_1328".toLowerCase()] == null) {
                          colsec5["lat_minutes_1328".toLowerCase()] = "";
                        }
                        if (colsec5["minutes_1329".toLowerCase()] == null) {
                          colsec5["minutes_1329".toLowerCase()] = "";
                        }
                        if (
                          colsec5["lat_direction_1330".toLowerCase()] == null
                        ) {
                          colsec5["lat_direction_1330".toLowerCase()] = "";
                        }
                        if (colsec5["Long_1331".toLowerCase()] == null) {
                          colsec5["Long_1331".toLowerCase()] = "";
                        }
                        if (colsec5["long_degree_1332".toLowerCase()] == null) {
                          colsec5["long_degree_1332".toLowerCase()] = "";
                        }
                        if (colsec5["degree_1333".toLowerCase()] == null) {
                          colsec5["degree_1333".toLowerCase()] = "";
                        }
                        if (
                          colsec5["long_minutes_1334".toLowerCase()] == null
                        ) {
                          colsec5["long_minutes_1334".toLowerCase()] = "";
                        }
                        if (colsec5["minutes_1335".toLowerCase()] == null) {
                          colsec5["minutes_1335".toLowerCase()] = "";
                        }
                        if (
                          colsec5["long_direction_1336".toLowerCase()] == null
                        ) {
                          colsec5["long_direction_1336".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24",
                          colsec5["Lat_1323".toLowerCase()] +
                          " " +
                          colsec5["lat_degree_1326".toLowerCase()] +
                          " " +
                          colsec5["degree_1327".toLowerCase()] +
                          " " +
                          colsec5["lat_minutes_1328".toLowerCase()] +
                          " " +
                          colsec5["minutes_1329".toLowerCase()] +
                          " " +
                          colsec5["lat_direction_1330".toLowerCase()] +
                          "/" +
                          colsec5["Long_1331".toLowerCase()] +
                          " " +
                          colsec5["long_degree_1332".toLowerCase()] +
                          " " +
                          colsec5["degree_1333".toLowerCase()] +
                          " " +
                          colsec5["long_minutes_1334".toLowerCase()] +
                          " " +
                          colsec5["minutes_1335".toLowerCase()] +
                          " " +
                          colsec5["long_direction_1336".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24",
                          "", usersign
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec6["degree_1340".toLowerCase()] != null) {
                        if (colsec6["Lat_1338".toLowerCase()] == null) {
                          colsec6["Lat_1338".toLowerCase()] = "0.00";
                        }
                        if (colsec6["lat_degree_1339".toLowerCase()] == null) {
                          colsec6["lat_degree_1339".toLowerCase()] = "0.00";
                        }
                        if (colsec6["degree_1340".toLowerCase()] == null) {
                          colsec6["degree_1340".toLowerCase()] = "";
                        }
                        if (colsec6["lat_minutes_1341".toLowerCase()] == null) {
                          colsec6["lat_minutes_1341".toLowerCase()] = "";
                        }
                        if (colsec6["minutes_1342".toLowerCase()] == null) {
                          colsec6["minutes_1342".toLowerCase()] = "";
                        }
                        if (
                          colsec6["lat_direction_1343".toLowerCase()] == null
                        ) {
                          colsec6["lat_direction_1343".toLowerCase()] = "";
                        }
                        if (colsec6["Long_1344".toLowerCase()] == null) {
                          colsec6["Long_1344".toLowerCase()] = "";
                        }
                        if (colsec6["long_degree_1345".toLowerCase()] == null) {
                          colsec6["long_degree_1345".toLowerCase()] = "";
                        }
                        if (colsec6["degree_1346".toLowerCase()] == null) {
                          colsec6["degree_1346".toLowerCase()] = "";
                        }
                        if (
                          colsec6["long_minutes_1347".toLowerCase()] == null
                        ) {
                          colsec6["long_minutes_1347".toLowerCase()] = "";
                        }
                        if (colsec6["minutes_1348".toLowerCase()] == null) {
                          colsec6["minutes_1348".toLowerCase()] = "";
                        }
                        if (
                          colsec6["long_direction_1349".toLowerCase()] == null
                        ) {
                          colsec6["long_direction_1349".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25",
                          colsec6["time_1337".toLowerCase()] +
                          " " +
                          colsec6["Lat_1338".toLowerCase()] +
                          " " +
                          colsec6["lat_degree_1339".toLowerCase()] +
                          " " +
                          colsec6["degree_1340".toLowerCase()] +
                          " " +
                          colsec6["lat_minutes_1341".toLowerCase()] +
                          " " +
                          colsec6["minutes_1342".toLowerCase()] +
                          " " +
                          colsec6["lat_direction_1343".toLowerCase()] +
                          "/" +
                          colsec6["Long_1344".toLowerCase()] +
                          " " +
                          colsec6["long_degree_1345".toLowerCase()] +
                          " " +
                          colsec6["degree_1346".toLowerCase()] +
                          " " +
                          colsec6["long_minutes_1347".toLowerCase()] +
                          " " +
                          colsec6["minutes_1348".toLowerCase()] +
                          " " +
                          colsec6["long_direction_1349".toLowerCase()], usersign
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25",
                          "", usersign
                        ]);
                        colsec6 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec7[
                        "Quantuty_of_clean_ballast_1350".toLowerCase()
                        ] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26",
                          colsec7[
                          "Quantuty_of_clean_ballast_1350".toLowerCase()
                          ] +
                          " " +
                          colsec7["m3_1351".toLowerCase()], usersign
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26",
                          "", usersign
                        ]);
                        colsec7 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 57) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = 8; //coldate['section_length'];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1394".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "41",
                          colsec1["Tank_name_1394".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "41",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["time_1395".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "42",
                          colsec2["time_1395".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "42",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["time_1396".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "43",
                          colsec3["time_1396".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "43",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec31["time_1397".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "44",
                          colsec31["time_1397".toLowerCase()] +
                          " " +
                          colsec31["lat_1398".toLowerCase()] +
                          " " +
                          colsec31["lat_degree_1399".toLowerCase()] +
                          " " +
                          colsec31["degree_1400".toLowerCase()] +
                          " " +
                          colsec31["lat_minutes_1403".toLowerCase()] +
                          " " +
                          colsec31["minutes_1405".toLowerCase()] +
                          " " +
                          colsec31["lat_direction_1406".toLowerCase()] +
                          " " +
                          colsec31["Long_1408".toLowerCase()] +
                          " " +
                          colsec31["long_degree_1409".toLowerCase()] +
                          " " +
                          colsec31["degree_1410".toLowerCase()] +
                          " " +
                          colsec31["long_minutes_1412".toLowerCase()] +
                          " " +
                          colsec31["minutes_1413".toLowerCase()] +
                          " " +
                          colsec31["long_direction_1414".toLowerCase()], usersign
                        ]);
                        colsec31 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "44",
                          "", usersign
                        ]);
                        colsec31 = [];
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["Ullage_of_contents_1401".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "45",
                          colsec4["Ullage_of_contents_1401".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "45",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec5["Ullage_of_oil_1402".toLowerCase()] != null) {
                        if (
                          colsec5["Ullage_of_water_1404".toLowerCase()] == null
                        ) {
                          colsec5["Ullage_of_water_1404".toLowerCase()] =
                            "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "46",
                          colsec5["Ullage_of_oil_1402".toLowerCase()] +
                          " " +
                          colsec5["Ullage_of_water_1404".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "46",
                          "", usersign
                        ]);
                        colsec5 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec6["m3_1411".toLowerCase()] != null) {
                        if (
                          colsec6[
                          "Bulk_quantity_discharge_1407".toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bulk_quantity_discharge_1407".toLowerCase()
                          ] = "0.00";
                        }
                        if (
                          colsec6["Rate_of_discharge_1415".toLowerCase()] ==
                          null
                        ) {
                          colsec6["Rate_of_discharge_1415".toLowerCase()] = "";
                        }
                        if (colsec6["m3_hour_1416".toLowerCase()] == null) {
                          colsec6["m3_hour_1416".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "47",
                          colsec6[
                          "Bulk_quantity_discharge_1407".toLowerCase()
                          ] +
                          " " +
                          colsec6["m3_1411".toLowerCase()] +
                          " " +
                          colsec6["Rate_of_discharge_1415".toLowerCase()] +
                          " " +
                          colsec6["m3_hour_1416".toLowerCase()], usersign
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "47",
                          "", usersign
                        ]);
                        colsec6 = [];
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec61[
                        "Final_quantity_discharge_1417".toLowerCase()
                        ] != null
                      ) {
                        if (colsec61["m3_1418".toLowerCase()] == null) {
                          colsec61["m3_1418".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec61[
                          "Final_rate_of_discharge_1419".toLowerCase()
                          ] == null
                        ) {
                          colsec61[
                            "Final_rate_of_discharge_1419".toLowerCase()
                          ] = "";
                        }
                        if (colsec61["m3_hour_1420".toLowerCase()] == null) {
                          colsec61["m3_hour_1420".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "48",
                          colsec61[
                          "Final_quantity_discharge_1417".toLowerCase()
                          ] +
                          " " +
                          colsec61["m3_1418".toLowerCase()] +
                          " " +
                          colsec61[
                          "Final_rate_of_discharge_1419".toLowerCase()
                          ] +
                          " " +
                          colsec61["m3_hour_1420".toLowerCase()], usersign
                        ]);
                        colsec61 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "48",
                          "", usersign
                        ]);
                        colsec61 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec62["time_1421".toLowerCase()] != null) {
                        if (colsec62["lat_1423".toLowerCase()] == null) {
                          colsec62["lat_1423".toLowerCase()] = "0.00";
                        }
                        if (colsec62["lat_degree_1425".toLowerCase()] == null) {
                          colsec62["lat_degree_1425".toLowerCase()] = "0.00";
                        }
                        if (colsec62["degree_1427".toLowerCase()] == null) {
                          colsec62["degree_1427".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec62["lat_minutes_1428".toLowerCase()] == null
                        ) {
                          colsec62["lat_minutes_1428".toLowerCase()] = "0.00";
                        }
                        if (colsec62["minutes_1430".toLowerCase()] == null) {
                          colsec62["minutes_1430".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec62["lat_direction_1432".toLowerCase()] == null
                        ) {
                          colsec62["lat_direction_1432".toLowerCase()] = "0.00";
                        }
                        if (colsec62["long_1434".toLowerCase()] == null) {
                          colsec62["long_1434".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec62["long_degree_1435".toLowerCase()] == null
                        ) {
                          colsec62["long_degree_1435".toLowerCase()] = "0.00";
                        }
                        if (colsec62["degree_1437".toLowerCase()] == null) {
                          colsec62["degree_1437".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec62["long_minutes_1439".toLowerCase()] == null
                        ) {
                          colsec62["long_minutes_1439".toLowerCase()] = "0.00";
                        }
                        if (colsec62["minutes_1441".toLowerCase()] == null) {
                          colsec62["minutes_1441".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec62["long_direction_1444".toLowerCase()] == null
                        ) {
                          colsec62["long_direction_1444".toLowerCase()] =
                            "0.00";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "49",
                          colsec62["time_1421".toLowerCase()] +
                          " " +
                          colsec62["lat_1423".toLowerCase()] +
                          " " +
                          colsec62["lat_degree_1425".toLowerCase()] +
                          " " +
                          colsec62["degree_1427".toLowerCase()] +
                          " " +
                          colsec62["lat_minutes_1428".toLowerCase()] +
                          " " +
                          colsec62["minutes_1430".toLowerCase()] +
                          " " +
                          colsec62["lat_direction_1432".toLowerCase()] +
                          " " +
                          colsec62["long_1434".toLowerCase()] +
                          " " +
                          colsec62["long_degree_1435".toLowerCase()] +
                          " " +
                          colsec62["degree_1437".toLowerCase()] +
                          " " +
                          colsec62["long_minutes_1439".toLowerCase()] +
                          " " +
                          colsec62["minutes_1441".toLowerCase()] +
                          " " +
                          colsec62["long_direction_1444".toLowerCase()], usersign
                        ]);
                        colsec62 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "49",
                          "", usersign
                        ]);
                        colsec62 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec63["Yes_1422".toLowerCase()] != null) {
                        if (colsec63["No_1424".toLowerCase()] == null) {
                          colsec63["No_1424".toLowerCase()] = "0.00";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "50",
                          colsec63["Yes_1422".toLowerCase()] +
                          " " +
                          colsec63["No_1424".toLowerCase()], usersign
                        ]);
                        colsec63 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "50",
                          "", usersign
                        ]);
                        colsec63 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec7["metres_1429".toLowerCase()] != null) {
                        if (
                          colsec7["Ullage_of_oil_1226".toLowerCase()] == null
                        ) {
                          colsec7["Ullage_of_oil_1226".toLowerCase()] = "0.00";
                        }
                        if (
                          colsec7["Ullage_of_water_1431".toLowerCase()] == null
                        ) {
                          colsec7["Ullage_of_water_1431".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec7["metres_1433".toLowerCase()] == null) {
                          colsec7["metres_1433".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "51",
                          colsec7["Ullage_of_oil_1226".toLowerCase()] +
                          " " +
                          colsec7["metres_1429".toLowerCase()] +
                          " " +
                          colsec7["Ullage_of_water_1431".toLowerCase()] +
                          " " +
                          colsec7["metres_1433".toLowerCase()], usersign
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "51",
                          "", usersign
                        ]);
                        colsec7 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec8["Speed_1436".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "52",
                          colsec8["Speed_1436".toLowerCase()], usersign
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "52",
                          "", usersign
                        ]);
                        colsec8 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec81["Yes_1438".toLowerCase()] != null) {
                        if (colsec81["No_1440".toLowerCase()] == null) {
                          colsec81["No_1440".toLowerCase()] = "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "53",
                          colsec81["Yes_1438".toLowerCase()] +
                          " " +
                          colsec81["No_1440".toLowerCase()], usersign
                        ]);
                        colsec81 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "53",
                          "", usersign
                        ]);
                        colsec81 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec82["Yes_1442".toLowerCase()] != null) {
                        if (colsec82["No_1443".toLowerCase()] == null) {
                          colsec82["No_1443".toLowerCase()] = "";
                        }
                        if (colsec82["Enter_here_1445".toLowerCase()] == null) {
                          colsec82["Enter_here_1445".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "54",
                          colsec82["Yes_1442".toLowerCase()] +
                          " " +
                          colsec82["No_1443".toLowerCase()] +
                          " " +
                          colsec82["Enter_here_1445".toLowerCase()], usersign
                        ]);
                        colsec82 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "54",
                          "", usersign
                        ]);
                        colsec82 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 58) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1446".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "55",
                          colsec1["Tank_name_1446".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "55",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1450".toLowerCase()] != null) {
                        if (
                          colsec2["Quantity_transferred_1447".toLowerCase()] ==
                          null
                        ) {
                          colsec2["Quantity_transferred_1447".toLowerCase()] =
                            "";
                        }
                        if (colsec2["m3_1448".toLowerCase()] == null) {
                          colsec2["m3_1448".toLowerCase()] = "";
                        }
                        if (
                          colsec2["Quantity_retained_1449".toLowerCase()] ==
                          null
                        ) {
                          colsec2["Quantity_retained_1449".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "56",
                          colsec2["Quantity_transferred_1447".toLowerCase()] +
                          " " +
                          colsec2["m3_1448".toLowerCase()] +
                          " " +
                          colsec2["Quantity_retained_1449".toLowerCase()] +
                          " " +
                          colsec2["m3_1450".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "56",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["port_name_1452".toLowerCase()] != null) {
                        if (
                          colsec3["disposal_of_reception_1451".toLowerCase()] ==
                          null
                        ) {
                          colsec3["disposal_of_reception_1451".toLowerCase()] =
                            "";
                        }
                        if (colsec3["port_name_1452".toLowerCase()] == null) {
                          colsec3["port_name_1452".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "certificate_obtained_from_1453".toLowerCase()
                          ] == null
                        ) {
                          colsec3["Quantity_retained_1449".toLowerCase()] = "";
                        }
                        if (colsec3["yes_1454".toLowerCase()] == null) {
                          colsec3["yes_1454".toLowerCase()] = "";
                        }
                        if (colsec3["no_1455".toLowerCase()] == null) {
                          colsec3["no_1455".toLowerCase()] = "";
                        }
                        if (colsec3["time_1457".toLowerCase()] == null) {
                          colsec3["time_1457".toLowerCase()] = "";
                        }
                        if (colsec3["Date_1459".toLowerCase()] == null) {
                          colsec3["Date_1459".toLowerCase()] = "";
                        }
                        if (colsec3["Quantity_1461".toLowerCase()] == null) {
                          colsec3["Quantity_1461".toLowerCase()] = "";
                        }
                        if (colsec3["m3_1463".toLowerCase()] == null) {
                          colsec3["m3_1463".toLowerCase()] = "";
                        }
                        if (
                          colsec3["cargo_quantity_1467".toLowerCase()] == null
                        ) {
                          colsec3["cargo_quantity_1467".toLowerCase()] = "";
                        }
                        if (
                          colsec3["state_quantity_1470".toLowerCase()] == null
                        ) {
                          colsec3["state_quantity_1470".toLowerCase()] = "";
                        }
                        if (colsec3["from_tank_1480".toLowerCase()] == null) {
                          colsec3["from_tank_1480".toLowerCase()] = "";
                        }
                        if (colsec3["tanks_1482".toLowerCase()] == null) {
                          colsec3["tanks_1482".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_tank_1486".toLowerCase()] == null
                        ) {
                          colsec3["Quantity_tank_1486".toLowerCase()] = "";
                        }
                        if (colsec3["quantity_1487".toLowerCase()] == null) {
                          colsec3["quantity_1487".toLowerCase()] = "";
                        }
                        if (colsec3["to_tank_1489".toLowerCase()] == null) {
                          colsec3["to_tank_1489".toLowerCase()] = "";
                        }
                        if (colsec3["Tanks_1491".toLowerCase()] == null) {
                          colsec3["Tanks_1491".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_tank_1493".toLowerCase()] == null
                        ) {
                          colsec3["Quantity_tank_1493".toLowerCase()] = "";
                        }
                        if (colsec3["quantity_1495".toLowerCase()] == null) {
                          colsec3["quantity_1495".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_transferred_1497".toLowerCase()] ==
                          null
                        ) {
                          colsec3["Quantity_transferred_1497".toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["total_quantity_1499".toLowerCase()] == null
                        ) {
                          colsec3["total_quantity_1499".toLowerCase()] = "";
                        }
                        if (colsec3["m3_1501".toLowerCase()] == null) {
                          colsec3["m3_1501".toLowerCase()] = "";
                        }
                        if (
                          colsec3["other_method_1504".toLowerCase()] == null
                        ) {
                          colsec3["other_method_1504".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "state_quantity_disposal_1505".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "state_quantity_disposal_1505".toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["state_quantity_1506".toLowerCase()] == null
                        ) {
                          colsec3["state_quantity_1506".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "57",
                          colsec3["port_name_1452".toLowerCase()] +
                          " " +
                          colsec3[
                          "certificate_obtained_from_1453".toLowerCase()
                          ] +
                          " " +
                          colsec3["yes_1454".toLowerCase()] +
                          " " +
                          colsec3["no_1455".toLowerCase()] +
                          " " +
                          colsec3["time_1457".toLowerCase()] +
                          " " +
                          colsec3["Date_1459".toLowerCase()] +
                          " " +
                          colsec3["Quantity_1461".toLowerCase()] +
                          " " +
                          colsec3["m3_1463".toLowerCase()] +
                          " " +
                          colsec3["cargo_quantity_1467".toLowerCase()] +
                          " " +
                          colsec3["state_quantity_1470".toLowerCase()] +
                          "/" +
                          colsec3["from_tank_1480".toLowerCase()] +
                          " " +
                          colsec3["tanks_1482".toLowerCase()] +
                          " " +
                          colsec3["Quantity_tank_1486".toLowerCase()] +
                          " " +
                          colsec3["quantity_1487".toLowerCase()] +
                          " " +
                          colsec3["to_tank_1489".toLowerCase()] +
                          "/" +
                          colsec3["Tanks_1491".toLowerCase()] +
                          " " +
                          colsec3["Quantity_tank_1493".toLowerCase()] +
                          " " +
                          colsec3["quantity_1495".toLowerCase()] +
                          " " +
                          colsec3["Quantity_transferred_1497".toLowerCase()] +
                          " " +
                          colsec3["total_quantity_1499".toLowerCase()] +
                          " " +
                          colsec3["m3_1501".toLowerCase()] +
                          " " +
                          colsec3["other_method_1504".toLowerCase()] +
                          " " +
                          colsec3[
                          "state_quantity_disposal_1505".toLowerCase()
                          ] +
                          " " +
                          colsec3["state_quantity_1506".toLowerCase()] +
                          " " +
                          colsec3["m3_1507".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "57",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      console.log(
                        "===this.objcolsection==",
                        this.objcolsection
                      );
                    }

                    // end getting response data into array
                    if (formId == 66) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Port_1609".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "82",
                          colsec1["Port_1609".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "82",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }

                      if (
                        colsec2[
                        "Name_of_reception_facility_1610".toLowerCase()
                        ] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "83",
                          colsec2[
                          "Name_of_reception_facility_1610".toLowerCase()
                          ], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "83",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      if (colsec3["m3_1612".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "84",
                          colsec3["Quantity_1611".toLowerCase()] +
                          " " +
                          colsec3["m3_1612".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "84",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec31["Date_1613".toLowerCase()] != null) {
                        if (colsec31["yes_1615".toLowerCase()] == null) {
                          colsec31["yes_1615".toLowerCase()] = "";
                        }
                        if (colsec31["no_1616".toLowerCase()] == null) {
                          colsec31["no_1616".toLowerCase()] = "";
                        }
                        if (colsec31["yes_1618".toLowerCase()] == null) {
                          colsec31["yes_1618".toLowerCase()] = "";
                        }
                        if (colsec31["no_1619".toLowerCase()] == null) {
                          colsec31["no_1619".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "85",
                          colsec31["Date_1613".toLowerCase()] +
                          " " +
                          colsec31["yes_1615".toLowerCase()] +
                          " " +
                          colsec31["no_1616".toLowerCase()] +
                          " " +
                          colsec31["yes_1618".toLowerCase()] +
                          " " +
                          colsec31["no_1619".toLowerCase()], usersign
                        ]);
                        colsec31 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "85",
                          "", usersign
                        ]);
                        colsec31 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 65) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Reason_1608".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "81",
                          colsec1["Reason_1608".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "81",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 64) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1592".toLowerCase()] != null) {
                        if (colsec1["Tank_name_1592".toLowerCase()] == null) {
                          colsec1["Tank_name_1592".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "77",
                          colsec1["Tank_name_1592".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "77",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1606".toLowerCase()] != null) {
                        if (colsec2["Quantity_1605".toLowerCase()] == null) {
                          colsec2["Quantity_1605".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "79",
                          colsec2["Quantity_1605".toLowerCase()] +
                          " " +
                          colsec2["m3_1606".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "79",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["Remarks_1607".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "80",
                          colsec3["Remarks_1607".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "80",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 63) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Procedures_1590".toLowerCase()] != null) {
                        if (
                          colsec1["General_remarks_1591".toLowerCase()] == null
                        ) {
                          colsec1["General_remarks_1591".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "76",
                          colsec1["Procedures_1590".toLowerCase()] +
                          " " +
                          colsec1["General_remarks_1591".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "76",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 62) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["time_1513".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "73",
                          colsec1["time_1513".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "73",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec11["port_1481".toLowerCase()] != null) {
                        if (colsec11["lat_1574".toLowerCase()] == null) {
                          colsec11["lat_1574".toLowerCase()] = "";
                        }
                        if (colsec11["lat_degree_1575".toLowerCase()] == null) {
                          colsec11["lat_degree_1575".toLowerCase()] = "";
                        }
                        if (colsec11["degree_1576".toLowerCase()] == null) {
                          colsec11["degree_1576".toLowerCase()] = "";
                        }
                        if (
                          colsec11["lat_minutes_1577".toLowerCase()] == null
                        ) {
                          colsec11["lat_minutes_1577".toLowerCase()] = "";
                        }
                        if (colsec11["minutes_1578".toLowerCase()] == null) {
                          colsec11["minutes_1578".toLowerCase()] = "";
                        }
                        if (
                          colsec11["lat_direction_1579".toLowerCase()] == null
                        ) {
                          colsec11["lat_direction_1579".toLowerCase()] = "";
                        }
                        if (colsec11["long_1580".toLowerCase()] == null) {
                          colsec11["long_1580".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_degree_1581".toLowerCase()] == null
                        ) {
                          colsec11["long_degree_1581".toLowerCase()] = "";
                        }
                        if (colsec11["degree_1582".toLowerCase()] == null) {
                          colsec11["degree_1582".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_minutes_1583".toLowerCase()] == null
                        ) {
                          colsec11["long_minutes_1583".toLowerCase()] = "";
                        }
                        if (colsec11["minutes_1584".toLowerCase()] == null) {
                          colsec11["minutes_1584".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_direction_1585".toLowerCase()] == null
                        ) {
                          colsec11["long_direction_1585".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "74",
                          colsec11["port_1481".toLowerCase()] +
                          " " +
                          colsec11["lat_1574".toLowerCase()] +
                          " " +
                          colsec11["lat_degree_1575".toLowerCase()] +
                          " " +
                          colsec11["degree_1576".toLowerCase()] +
                          " " +
                          colsec11["lat_minutes_1577".toLowerCase()] +
                          " " +
                          colsec11["minutes_1578".toLowerCase()] +
                          " " +
                          colsec11["lat_direction_1579".toLowerCase()] +
                          " " +
                          colsec11["long_1580".toLowerCase()] +
                          " " +
                          colsec11["long_degree_1581".toLowerCase()] +
                          " " +
                          colsec11["degree_1582".toLowerCase()] +
                          " " +
                          colsec11["long_minutes_1583".toLowerCase()] +
                          " " +
                          colsec11["minutes_1584".toLowerCase()] +
                          " " +
                          colsec11["long_direction_1585".toLowerCase()], usersign
                        ]);
                        colsec11 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "74",
                          "", usersign
                        ]);
                        colsec11 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["m3_1587".toLowerCase()] != null) {
                        if (colsec2["Quantity_1586".toLowerCase()] == null) {
                          colsec2["Quantity_1586".toLowerCase()] = "";
                        }
                        if (colsec2["type_of_oil_1588".toLowerCase()] == null) {
                          colsec2["type_of_oil_1588".toLowerCase()] = "";
                        }
                        if (colsec2["reason_1589".toLowerCase()] == null) {
                          colsec2["reason_1589".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "75",
                          colsec2["Quantity_1586".toLowerCase()] +
                          " " +
                          colsec2["m3_1587".toLowerCase()] +
                          " " +
                          colsec2["type_of_oil_1588".toLowerCase()] +
                          " " +
                          colsec2["reason_1589".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "75",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 60) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1508".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "63",
                          colsec1["Tank_name_1508".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "63",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["minutes_1518".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "64",
                          colsec2["time_1512".toLowerCase()] +
                          " " +
                          colsec2["lat_1514".toLowerCase()] +
                          " " +
                          colsec2["lat_degree_1515".toLowerCase()] +
                          " " +
                          colsec2["degree_1516".toLowerCase()] +
                          " " +
                          colsec2["lat_minutes_1517".toLowerCase()] +
                          " " +
                          colsec2["minutes_1518".toLowerCase()] +
                          " " +
                          colsec2["lat_direction_1519".toLowerCase()] +
                          "/" +
                          colsec2["long_1520".toLowerCase()] +
                          " " +
                          colsec2["long_degree_1521".toLowerCase()] +
                          " " +
                          colsec2["degree_1522".toLowerCase()] +
                          " " +
                          colsec2["long_minutes_1523".toLowerCase()] +
                          " " +
                          colsec2["minutes_1524".toLowerCase()] +
                          " " +
                          colsec2["long_direction_1525".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "64",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec3["minutes_1531".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "65",
                          colsec3["time_1526".toLowerCase()] +
                          " " +
                          colsec3["lat_1527".toLowerCase()] +
                          " " +
                          colsec3["lat_degree_1528".toLowerCase()] +
                          " " +
                          colsec3["degree_1529".toLowerCase()] +
                          " " +
                          colsec3["lat_minutes_1530".toLowerCase()] +
                          " " +
                          colsec3["minutes_1531".toLowerCase()] +
                          " " +
                          colsec3["lat_direction_1532".toLowerCase()] +
                          "/" +
                          colsec3["long_1533".toLowerCase()] +
                          " " +
                          colsec3["long_degree_1534".toLowerCase()] +
                          " " +
                          colsec3["degree_1535".toLowerCase()] +
                          " " +
                          colsec3["long_minutes_1536".toLowerCase()] +
                          " " +
                          colsec3["minutes_1537".toLowerCase()] +
                          " " +
                          colsec3["long_direction_1538".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "65",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec4["m3_or_1541".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "66",
                          colsec4["into_sea_1539".toLowerCase()] +
                          " " +
                          colsec4["textbox_1540".toLowerCase()] +
                          " " +
                          colsec4["m3_or_1541".toLowerCase()] +
                          " " +
                          colsec4["reception_facility_1542".toLowerCase()] +
                          " " +
                          colsec4[
                          "Reception_facilities_name_1543".toLowerCase()
                          ] +
                          " " +
                          colsec4["port_1544".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1545".toLowerCase()] +
                          " " +
                          colsec4["m3_1546".toLowerCase()] +
                          " " +
                          colsec4["yes_1548".toLowerCase()] +
                          " " +
                          colsec4["no_1549".toLowerCase()] +
                          " " +
                          colsec4["time_1550".toLowerCase()] +
                          " " +
                          colsec4["date_1551".toLowerCase()] +
                          " " +
                          colsec4["Quantity_1552".toLowerCase()] +
                          " " +
                          colsec4["m3_1553".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "66",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec5["yes_1554".toLowerCase()] != null ||
                        colsec5["no_1555".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "67",
                          colsec5["yes_1554".toLowerCase()] +
                          " " +
                          colsec5["no_1555".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "67",
                          "", usersign
                        ]);
                        colsec5 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec6["yes_1556".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "68",
                          colsec6["yes_1556".toLowerCase()] +
                          " " +
                          colsec6["no_1557".toLowerCase()], usersign
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "68",
                          "", usersign
                        ]);
                        colsec6 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec7["degree_1561".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "69",
                          colsec7["time_1558".toLowerCase()] +
                          " " +
                          colsec7["lat_1559".toLowerCase()] +
                          " " +
                          colsec7["lat_degree_1560".toLowerCase()] +
                          " " +
                          colsec7["degree_1561".toLowerCase()] +
                          " " +
                          colsec7["lat_minutes_1562".toLowerCase()] +
                          " " +
                          colsec7["minutes_1563".toLowerCase()] +
                          " " +
                          colsec7["lat_direction_1564".toLowerCase()] +
                          "/" +
                          colsec7["long_1565".toLowerCase()] +
                          " " +
                          colsec7["long_degree_1566".toLowerCase()] +
                          " " +
                          colsec7["degree_1567".toLowerCase()] +
                          " " +
                          colsec7["long_minutes_1568".toLowerCase()] +
                          " " +
                          colsec7["minutes_1569".toLowerCase()] +
                          " " +
                          colsec7["long_direction_1570".toLowerCase()], usersign
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "69",
                          "", usersign
                        ]);
                        colsec7 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 61) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["time_1509".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "70",
                          colsec1["time_1509".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "70",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec2["time_1510".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "71",
                          colsec2["time_1510".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "71",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);
                      if (colsec3["Reason_1511".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "72",
                          colsec3["Reason_1511".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "72",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 59) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }
                      console.log("===colsec1===", colsec1);

                      if (colsec1["degree_1460".toLowerCase()] != null) {
                        if (colsec1["LAT_1456".toLowerCase()] == null) {
                          colsec1["LAT_1456".toLowerCase()] = "";
                        }
                        if (colsec1["lat_degree_1458".toLowerCase()] == null) {
                          colsec1["lat_degree_1458".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1460".toLowerCase()] == null) {
                          colsec1["degree_1460".toLowerCase()] = "";
                        }
                        if (colsec1["lat_minutes_1462".toLowerCase()] == null) {
                          colsec1["lat_minutes_1462".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1464".toLowerCase()] == null) {
                          colsec1["minutes_1464".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1465".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1465".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1468".toLowerCase()] == null) {
                          colsec1["long_degree_1468".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1469".toLowerCase()] == null) {
                          colsec1["degree_1469".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_minutes_1471".toLowerCase()] == null
                        ) {
                          colsec1["long_minutes_1471".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1473".toLowerCase()] == null) {
                          colsec1["minutes_1473".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1474".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1474".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "58",
                          colsec1["LAT_1456".toLowerCase()] +
                          " " +
                          colsec1["lat_degree_1458".toLowerCase()] +
                          " " +
                          colsec1["degree_1460".toLowerCase()] +
                          " " +
                          colsec1["lat_minutes_1462".toLowerCase()] +
                          " " +
                          colsec1["minutes_1464".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1465".toLowerCase()] +
                          "/" +
                          colsec1["LONG_1466".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1468".toLowerCase()] +
                          " " +
                          colsec1["degree_1469".toLowerCase()] +
                          " " +
                          colsec1["long_minutes_1471".toLowerCase()] +
                          " " +
                          colsec1["minutes_1473".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1474".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "58",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1475".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "59",
                          colsec2["Tank_name_1475".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "59",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["Yes_1476".toLowerCase()] != null) {
                        if (colsec3["No_1477".toLowerCase()] == null) {
                          colsec3["No_1477".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "60",
                          colsec3["Yes_1476".toLowerCase()] +
                          " " +
                          colsec3["No_1477".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "60",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }

                      this.userSign.push(usersign);

                      console.log("===colsec4===", colsec4);

                      if (colsec4["degree_1483".toLowerCase()] != null) {
                        if (colsec4["LAT_1479".toLowerCase()] == null) {
                          colsec4["LAT_1479".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "61",
                          colsec4["LAT_1479".toLowerCase()] +
                          " " +
                          colsec4["lat_degree_1481".toLowerCase()] +
                          " " +
                          colsec4["degree_1483".toLowerCase()] +
                          " " +
                          colsec4["lat_minutes_1484".toLowerCase()] +
                          " " +
                          colsec4["minutes_1485".toLowerCase()] +
                          " " +
                          colsec4["lat_direction_1488".toLowerCase()] +
                          "/" +
                          colsec4["long_1490".toLowerCase()] +
                          " " +
                          colsec4["long_degree_1492".toLowerCase()] +
                          " " +
                          colsec4["degree_1494".toLowerCase()] +
                          //    + ' ' + colsec4['LONG_1490'.toLowerCase()]
                          " " +
                          colsec4["long_minutes_1496".toLowerCase()] +
                          " " +
                          colsec4["minutes_1498".toLowerCase()] +
                          " " +
                          colsec4["long_direction_1500".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "61",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec5["Yes_1502".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "62",
                          colsec5["Yes_1502".toLowerCase()] +
                          " " +
                          colsec5["No_1503".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "62",
                          "", usersign
                        ]);
                        colsec5 = [];
                      }

                      this.userSign.push(usersign);
                    }

                    // end getting response data into array
                    if (formId == 56) {
                      console.log("===coldate==", coldate);
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["Tank_name_1352".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "32",
                          colsec1["Tank_name_1352".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "32",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec11["time_1353".toLowerCase()] != null) {
                        if (colsec11["lat_1354".toLowerCase()] == null) {
                          colsec11["lat_1354".toLowerCase()] = "";
                        }
                        if (colsec11["lat_degree_1355".toLowerCase()] == null) {
                          colsec11["lat_degree_1355".toLowerCase()] = "";
                        }
                        if (
                          colsec11["lat_minutes_11357".toLowerCase()] == null
                        ) {
                          colsec11["lat_minutes_11357".toLowerCase()] = "";
                        }
                        if (colsec11["minutes_1358".toLowerCase()] == null) {
                          colsec11["minutes_1358".toLowerCase()] = "";
                        }
                        if (
                          colsec11["lat_direction_1359".toLowerCase()] == null
                        ) {
                          colsec11["lat_direction_1359".toLowerCase()] = "";
                        }
                        if (colsec11["Long_1360".toLowerCase()] == null) {
                          colsec11["Long_1360".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_degree_1361".toLowerCase()] == null
                        ) {
                          colsec11["long_degree_1361".toLowerCase()] = "";
                        }
                        if (colsec11["degree_1362".toLowerCase()] == null) {
                          colsec11["degree_1362".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_minutes_1363".toLowerCase()] == null
                        ) {
                          colsec11["long_minutes_1363".toLowerCase()] = "";
                        }
                        if (colsec11["minutes_1364".toLowerCase()] == null) {
                          colsec11["minutes_1364".toLowerCase()] = "";
                        }
                        if (
                          colsec11["long_direction_1365".toLowerCase()] == null
                        ) {
                          colsec11["long_direction_1365".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "33",
                          colsec11["time_1353".toLowerCase()] +
                          " " +
                          colsec11["lat_1354".toLowerCase()] +
                          " " +
                          colsec11["lat_degree_1355".toLowerCase()] +
                          " " +
                          colsec11["lat_minutes_11357".toLowerCase()] +
                          " " +
                          colsec11["minutes_1358".toLowerCase()] +
                          " " +
                          colsec11["lat_direction_1359".toLowerCase()] +
                          " " +
                          colsec11["Long_1360".toLowerCase()] +
                          " " +
                          colsec11["long_degree_1361".toLowerCase()] +
                          " " +
                          colsec11["degree_1362".toLowerCase()] +
                          " " +
                          colsec11["long_minutes_1363".toLowerCase()] +
                          " " +
                          colsec11["minutes_1364".toLowerCase()] +
                          " " +
                          colsec11["long_direction_1365".toLowerCase()], usersign
                        ]);
                        colsec11 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "33",
                          "", usersign
                        ]);
                        colsec11 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec12["time_1366".toLowerCase()] != null) {
                        if (colsec12["lat_1367".toLowerCase()] == null) {
                          colsec12["lat_1367".toLowerCase()] = "";
                        }
                        if (colsec12["lat_degree_1368".toLowerCase()] == null) {
                          colsec12["lat_degree_1368".toLowerCase()] = "";
                        }
                        if (colsec12["degree_1369".toLowerCase()] == null) {
                          colsec12["degree_1369".toLowerCase()] = "";
                        }
                        if (
                          colsec12["lat_minutes_1370".toLowerCase()] == null
                        ) {
                          colsec12["lat_minutes_1370".toLowerCase()] = "";
                        }
                        if (colsec12["minutes_1371".toLowerCase()] == null) {
                          colsec12["minutes_1371".toLowerCase()] = "";
                        }
                        if (
                          colsec12["long_long_degree_13741373".toLowerCase()] ==
                          null
                        ) {
                          colsec12["long_degree_1374".toLowerCase()] = "";
                        }
                        if (colsec12["degree_1375".toLowerCase()] == null) {
                          colsec12["degree_1375".toLowerCase()] = "";
                        }
                        if (
                          colsec12["long_minutes_1376".toLowerCase()] == null
                        ) {
                          colsec12["long_minutes_1376".toLowerCase()] = "";
                        }
                        if (colsec12["minutes_1377".toLowerCase()] == null) {
                          colsec12["minutes_1377".toLowerCase()] = "";
                        }
                        if (
                          colsec12["long_direction_1378".toLowerCase()] == null
                        ) {
                          colsec12["long_direction_1378".toLowerCase()] = "";
                        }
                        if (
                          colsec12["lat_direction_1621_1371".toLowerCase()] ==
                          null
                        ) {
                          colsec12["lat_direction_1621_1371".toLowerCase()] =
                            "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "34",
                          colsec12["time_1366".toLowerCase()] +
                          " " +
                          colsec12["lat_1367".toLowerCase()] +
                          " " +
                          colsec12["lat_degree_1368".toLowerCase()] +
                          " " +
                          colsec12["degree_1369".toLowerCase()] +
                          " " +
                          colsec12["lat_minutes_1370".toLowerCase()] +
                          " " +
                          colsec12["minutes_1371".toLowerCase()] +
                          " " +
                          colsec12["long_1373".toLowerCase()] +
                          " " +
                          colsec12["long_degree_1374".toLowerCase()] +
                          " " +
                          colsec12["degree_1375".toLowerCase()] +
                          " " +
                          colsec12["long_minutes_1376".toLowerCase()] +
                          " " +
                          colsec12["minutes_1377".toLowerCase()] +
                          " " +
                          colsec12["long_direction_1378".toLowerCase()] +
                          " " +
                          colsec12["lat_direction_1621_1371".toLowerCase()], usersign
                        ]);
                        colsec12 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "34",
                          "", usersign
                        ]);
                        colsec12 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1380".toLowerCase()] != null) {
                        if (colsec2["quantity_1379".toLowerCase()] == null) {
                          colsec2["quantity_1379".toLowerCase()] = "";
                        }
                        if (colsec2["m3_1380".toLowerCase()] == null) {
                          colsec2["m3_1380".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "35",
                          colsec2["quantity_1379".toLowerCase()] +
                          " " +
                          colsec2["m3_1380".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "35",
                          "", usersign
                        ]);
                        colsec2 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec21["speed_1380".toLowerCase()] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "36",
                          colsec21["speed_1380".toLowerCase()], usersign
                        ]);
                        colsec21 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "36",
                          "", usersign
                        ]);
                        colsec21 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec22["yes_1382".toLowerCase()] != null) {
                        if (colsec22["no_1383".toLowerCase()] == null) {
                          colsec22["no_1383".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "37",
                          colsec22["yes_1382".toLowerCase()] +
                          " " +
                          colsec22["no_1383".toLowerCase()], usersign
                        ]);
                        colsec22 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "37",
                          "", usersign
                        ]);
                        colsec22 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec23["yes_1384".toLowerCase()] != null) {
                        if (colsec23["no_1385".toLowerCase()] == null) {
                          colsec23["no_1385".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "38",
                          colsec23["yes_1384".toLowerCase()] +
                          " " +
                          colsec23["no_1385".toLowerCase()], usersign
                        ]);
                        colsec23 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "38",
                          "", usersign
                        ]);
                        colsec23 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_1389".toLowerCase()] != null) {
                        if (
                          colsec3[
                          "Quantity_of_oily_water_1386".toLowerCase()
                          ] == null
                        ) {
                          colsec3["Quantity_of_oily_water_1386".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec3["tank_name_1387".toLowerCase()] == null) {
                          colsec3["tank_name_1387".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Total_quantity_1388".toLowerCase()] == null
                        ) {
                          colsec3["Total_quantity_1388".toLowerCase()] = "0.00";
                        }
                        if (colsec3["m3_1389".toLowerCase()] == null) {
                          colsec3["m3_1389".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "39",
                          colsec3["Quantity_of_oily_water_1386".toLowerCase()] +
                          " " +
                          colsec3["tank_name_1387".toLowerCase()] +
                          " " +
                          colsec3["Total_quantity_1388".toLowerCase()] +
                          " " +
                          colsec3["m3_1389".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "39",
                          "", usersign
                        ]);
                        colsec3 = [];
                      }
                      this.userSign.push(usersign);

                      if (colsec4["m3_1393".toLowerCase()] != null) {
                        if (
                          colsec4[
                          "Quantity_of_oily_water_1390".toLowerCase()
                          ] == null
                        ) {
                          colsec4["Quantity_of_oily_water_1390".toLowerCase()] =
                            "0.00";
                        }
                        if (colsec4["Port_name_1391".toLowerCase()] == null) {
                          colsec4["Port_name_1391".toLowerCase()] = "";
                        }
                        if (
                          colsec4["Total_Quantity_1392".toLowerCase()] == null
                        ) {
                          colsec4["Total_Quantity_1392".toLowerCase()] = "0.00";
                        }
                        if (colsec4["m3_1393".toLowerCase()] == null) {
                          colsec4["m3_1393".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "40",
                          colsec4["Quantity_of_oily_water_1390".toLowerCase()] +
                          " " +
                          colsec4["Port_name_1391".toLowerCase()] +
                          " " +
                          colsec4["Total_Quantity_1392".toLowerCase()] +
                          " " +
                          colsec4["m3_1393".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "40",
                          "", usersign
                        ]);
                        colsec4 = [];
                      }

                      this.userSign.push(usersign);
                      console.log(
                        "====this.objcolsection===",
                        this.objcolsection
                      );
                    }

                    if (formId == 49) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["Place_of_loading_1175".toLowerCase()] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "1",
                          colsec1["Place_of_loading_1175".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "1",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1177".toLowerCase()] != null) {
                        if (colsec2["Type_of_oil_1176".toLowerCase()] == null) {
                          colsec2["Type_of_oil_1176".toLowerCase()] = "";
                        }
                        if (colsec2["Tank_name_1177".toLowerCase()] == null) {
                          colsec2["Tank_name_1177".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "2",
                          colsec2["Type_of_oil_1176".toLowerCase()] +
                          " " +
                          colsec2["Tank_name_1177".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "2",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_1179".toLowerCase()] != null) {
                        if (
                          colsec3[
                          "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] = "0.00";
                        }
                        if (colsec3["m3_1179".toLowerCase()] == null) {
                          colsec3["m3_1179".toLowerCase()] = "";
                        }
                        if (
                          colsec3["Total_content_1180".toLowerCase()] == null
                        ) {
                          colsec3["Total_content_1180".toLowerCase()] = "0.00";
                        }
                        if (colsec3["m3_1181".toLowerCase()] == null) {
                          colsec3["m3_1181".toLowerCase()] = "m3";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "3",
                          colsec3[
                          "Total_quantity_of_oil_loaded_1178".toLowerCase()
                          ] +
                          " " +
                          colsec3["m3_1179".toLowerCase()] +
                          " " +
                          colsec3["Total_content_1180".toLowerCase()] +
                          " " +
                          colsec3["m3_1181".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "3",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);
                    }

                    if (formId == 50) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = 3; //coldate['section_length'];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt2++,
                        ]);
                      }

                      if (
                        colsec1[
                        "State_quantity_transferred_1186".toLowerCase()
                        ] != null
                      ) {
                        if (colsec1["4.1_from_1182".toLowerCase()] == null) {
                          colsec1["4.1_from_1182".toLowerCase()] = "";
                        }
                        if (colsec1["Tank_name_1183".toLowerCase()] == null) {
                          colsec1["Tank_name_1183".toLowerCase()] = "";
                        }
                        if (colsec1["4.2_to_1184".toLowerCase()] == null) {
                          colsec1["4.2_to_1184".toLowerCase()] = "";
                        }
                        //if(colsec1['Tank_name_1185'.toLowerCase()]==null) {colsec1['Tank_name_1185'.toLowerCase()] = ""};
                        if (
                          colsec1[
                          "State_quantity_transferred_1186".toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "State_quantity_transferred_1186".toLowerCase()
                          ] = "";
                        }
                        if (colsec1["4000_m3_1187".toLowerCase()] == null) {
                          colsec1["4000_m3_1187".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.1",
                          colsec1["4.1_from_1182".toLowerCase()] +
                          " " +
                          colsec1["Tank_name_1183".toLowerCase()], usersign
                        ]);

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.2",
                          colsec1["4.2_to_1184".toLowerCase()] +
                          " " +
                          colsec1["Tank_name_1185".toLowerCase()] +
                          " (" +
                          colsec1[
                          "State_quantity_transferred_1186".toLowerCase()
                          ] +
                          " m3)", usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.1",
                          "", usersign
                        ]);
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "4.2",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1191".toLowerCase()] != null) {
                        if (colsec2["Yes_1188".toLowerCase()] == null) {
                          colsec2["Yes_1188".toLowerCase()] = "";
                        }
                        if (colsec2["No_1189".toLowerCase()] == null) {
                          colsec2["No_1189".toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "State_quantity_retained_1190".toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "State_quantity_retained_1190".toLowerCase()
                          ] = "";
                        }
                        if (colsec2["m3_1191".toLowerCase()] == null) {
                          colsec2["m3_1191".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "5",
                          colsec2["Yes_1188".toLowerCase()] +
                          " " +
                          colsec2["No_1189".toLowerCase()] +
                          " " +
                          colsec2[
                          "State_quantity_retained_1190".toLowerCase()
                          ] +
                          " " +
                          colsec2["m3_1191".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "5",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 51) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt3++,
                        ]);
                      }

                      if (
                        colsec1["Place_of_unloading_1192".toLowerCase()] != null
                      ) {
                        if (
                          colsec1["Place_of_unloading_1192".toLowerCase()] ==
                          null
                        ) {
                          colsec1["Place_of_unloading_1192".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "6",
                          colsec1["Place_of_unloading_1192".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "6",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1193".toLowerCase()] != null) {
                        if (colsec2["Tank_name_1193".toLowerCase()] == null) {
                          colsec2["Tank_name_1193".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "7",
                          colsec2["Tank_name_1193".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "7",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec3["No_1195".toLowerCase()] != "" ||
                        colsec3["Yes_1194".toLowerCase()] != ""
                      ) {
                        if (colsec3["No_1195".toLowerCase()] == null) {
                          colsec3["No_1195".toLowerCase()] = "";
                        }
                        if (colsec3["Yes_1194".toLowerCase()] == null) {
                          colsec3["Yes_1194".toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "State_quantity_retained_1196".toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "State_quantity_retained_1196".toLowerCase()
                          ] = "";
                        }
                        if (colsec3["m3_1197".toLowerCase()] == null) {
                          colsec3["m3_1197".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "8",
                          colsec3["No_1195".toLowerCase()] +
                          colsec3["Yes_1194".toLowerCase()] +
                          " " +
                          colsec3[
                          "State_quantity_retained_1196".toLowerCase()
                          ] +
                          " " +
                          colsec3["m3_1197".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "8",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 52) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt4++,
                        ]);
                      }

                      if (colsec1["degree_1203".toLowerCase()] != null) {
                        if (colsec1["port_name_1199".toLowerCase()] == null) {
                          colsec1["port_name_1199".toLowerCase()] = "";
                        }
                        if (colsec1["position_1200".toLowerCase()] == null) {
                          colsec1["position_1200".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_1201".toLowerCase()] == null) {
                          colsec1["LAT_1201".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_Degree_1202".toLowerCase()] == null) {
                          colsec1["LAT_Degree_1202".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1203".toLowerCase()] == null) {
                          colsec1["degree_1203".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_minutes_1204".toLowerCase()] == null) {
                          colsec1["Lat_minutes_1204".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1205".toLowerCase()] == null) {
                          colsec1["minutes_1205".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1206".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1206".toLowerCase()] = "";
                        }
                        if (colsec1["LONG_1207".toLowerCase()] == null) {
                          colsec1["LONG_1207".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1208".toLowerCase()] == null) {
                          colsec1["long_degree_1208".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1209".toLowerCase()] == null) {
                          colsec1["degree_1209".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_minutes_1210".toLowerCase()] == null
                        ) {
                          colsec1["long_minutes_1210".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1211".toLowerCase()] == null) {
                          colsec1["minutes_1211".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1212".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1212".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "9",
                          colsec1["port_name_1199".toLowerCase()] +
                          " " +
                          colsec1["position_1200".toLowerCase()] +
                          " " +
                          colsec1["LAT_1201".toLowerCase()] +
                          " " +
                          colsec1["LAT_Degree_1202".toLowerCase()] +
                          " " +
                          colsec1["degree_1203".toLowerCase()] +
                          " " +
                          colsec1["Lat_minutes_1204".toLowerCase()] +
                          " " +
                          colsec1["minutes_1205".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1206".toLowerCase()] +
                          "/" +
                          colsec1["LONG_1207".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1208".toLowerCase()] +
                          " " +
                          colsec1["degree_1209".toLowerCase()] +
                          " " +
                          colsec1["long_minutes_1210".toLowerCase()] +
                          " " +
                          colsec1["minutes_1211".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1212".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "9",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["Tank_name_1213".toLowerCase()] != null) {
                        if (colsec2["Tank_name_1213".toLowerCase()] == null) {
                          colsec2["Tank_name_1213".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "10",
                          colsec2["Tank_name_1213".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "10",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec3["No_of_machines_1214".toLowerCase()] != null
                      ) {
                        if (
                          colsec3["No_of_machines_1214".toLowerCase()] == null
                        ) {
                          colsec3["No_of_machines_1214".toLowerCase()] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11",
                          colsec3["No_of_machines_1214".toLowerCase()], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec4["time_1215".toLowerCase()] != null) {
                        if (colsec4["time_1215".toLowerCase()] == null) {
                          colsec4["time_1215".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12",
                          colsec4["time_1215".toLowerCase()], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec5["washing_pattern_1216".toLowerCase()] != null
                      ) {
                        if (
                          colsec5["washing_pattern_1216".toLowerCase()] == null
                        ) {
                          colsec5["washing_pattern_1216".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13",
                          colsec5["washing_pattern_1216".toLowerCase()], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (
                        colsec6["Washing_line_pressure_1217".toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec6["Washing_line_pressure_1217".toLowerCase()] ==
                          null
                        ) {
                          colsec6["Washing_line_pressure_1217".toLowerCase()] =
                            "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14",
                          colsec6["Washing_line_pressure_1217".toLowerCase()], usersign
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec7["time_1218".toLowerCase()] != null) {
                        if (colsec7["time_1218".toLowerCase()] == null) {
                          colsec7["time_1218".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15",
                          colsec7["time_1218".toLowerCase()], usersign
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec8["state_method_1219".toLowerCase()] != null) {
                        if (
                          colsec8["state_method_1219".toLowerCase()] == null
                        ) {
                          colsec8["state_method_1219".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16",
                          colsec8["state_method_1219".toLowerCase()], usersign
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec9["Remarks_1220".toLowerCase()] != null) {
                        if (colsec9["Remarks_1220".toLowerCase()] == null) {
                          colsec9["Remarks_1220".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17",
                          colsec9["Remarks_1220".toLowerCase()], usersign
                        ]);
                        colsec9 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 53) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt5++,
                        ]);
                      }

                      if (colsec1["degree_1236".toLowerCase()] != null) {
                        if (colsec1["Start_1221".toLowerCase()] == null) {
                          colsec1["Start_1221".toLowerCase()] = "";
                        }
                        if (colsec1["LAT_1222".toLowerCase()] == null) {
                          colsec1["LAT_1222".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1224".toLowerCase()] == null) {
                          colsec1["degree_1224".toLowerCase()] = "";
                        }
                        if (colsec1["lat_minutes_1225".toLowerCase()] == null) {
                          colsec1["lat_minutes_1225".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1226".toLowerCase()] == null) {
                          colsec1["minutes_1226".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1227".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1227".toLowerCase()] = "";
                        }
                        if (colsec1["Long_1228".toLowerCase()] == null) {
                          colsec1["Long_1228".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1229".toLowerCase()] == null) {
                          colsec1["degree_1229".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_minutes_1230".toLowerCase()] == null
                        ) {
                          colsec1["Long_minutes_1230".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1231".toLowerCase()] == null) {
                          colsec1["minutes_1231".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_direction_1232".toLowerCase()] == null
                        ) {
                          colsec1["long_direction_1232".toLowerCase()] = "";
                        }
                        if (colsec1["STOP_1233".toLowerCase()] == null) {
                          colsec1["STOP_1233".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_1234".toLowerCase()] == null) {
                          colsec1["Lat_1234".toLowerCase()] = "";
                        }
                        if (colsec1["Lat_degree_1235".toLowerCase()] == null) {
                          colsec1["Lat_degree_1235".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1236".toLowerCase()] == null) {
                          colsec1["degree_1236".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_minurtes_1237".toLowerCase()] == null
                        ) {
                          colsec1["lat_minurtes_1237".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1238".toLowerCase()] == null) {
                          colsec1["minutes_1238".toLowerCase()] = "";
                        }
                        if (
                          colsec1["lat_direction_1239".toLowerCase()] == null
                        ) {
                          colsec1["lat_direction_1239".toLowerCase()] = "";
                        }
                        if (colsec1["Long_1240".toLowerCase()] == null) {
                          colsec1["Long_1240".toLowerCase()] = "";
                        }
                        if (colsec1["long_degree_1241".toLowerCase()] == null) {
                          colsec1["long_degree_1241".toLowerCase()] = "";
                        }
                        if (colsec1["degree_1242".toLowerCase()] == null) {
                          colsec1["degree_1242".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_minutes_1243".toLowerCase()] == null
                        ) {
                          colsec1["Long_minutes_1243".toLowerCase()] = "";
                        }
                        if (colsec1["minutes_1244".toLowerCase()] == null) {
                          colsec1["minutes_1244".toLowerCase()] = "";
                        }
                        if (
                          colsec1["Long_direction_1245".toLowerCase()] == null
                        ) {
                          colsec1["Long_direction_1245".toLowerCase()] = "";
                        }
                        if (
                          colsec1["long_degree_1620_1228".toLowerCase()] == null
                        ) {
                          colsec1["long_degree_1620_1228".toLowerCase()] = "";
                        }

                        console.log("===colsec1==", colsec1);
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18",
                          colsec1["Start_1221".toLowerCase()] +
                          " " +
                          colsec1["LAT_1222".toLowerCase()] +
                          " " +
                          colsec1["Lat_degree_1223".toLowerCase()] +
                          " " +
                          colsec1["degree_1224".toLowerCase()] +
                          " " +
                          colsec1["lat_minutes_1225".toLowerCase()] +
                          " " +
                          colsec1["minutes_1226".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1227".toLowerCase()] +
                          "/" +
                          colsec1["Long_1228".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1620_1228".toLowerCase()] +
                          " " +
                          colsec1["degree_1229".toLowerCase()] +
                          " " +
                          colsec1["Long_minutes_1230".toLowerCase()] +
                          " " +
                          colsec1["minutes_1231".toLowerCase()] +
                          " " +
                          colsec1["long_direction_1232".toLowerCase()] +
                          "/" +
                          colsec1["STOP_1233".toLowerCase()] +
                          " " +
                          colsec1["Lat_1234".toLowerCase()] +
                          " " +
                          colsec1["Lat_degree_1235".toLowerCase()] +
                          " " +
                          colsec1["degree_1236".toLowerCase()] +
                          " " +
                          colsec1["lat_minurtes_1237".toLowerCase()] +
                          " " +
                          colsec1["minutes_1238".toLowerCase()] +
                          " " +
                          colsec1["lat_direction_1239".toLowerCase()] +
                          "/" +
                          colsec1["Long_1240".toLowerCase()] +
                          " " +
                          colsec1["long_degree_1241".toLowerCase()] +
                          " " +
                          colsec1["degree_1242".toLowerCase()] +
                          " " +
                          colsec1["Long_minutes_1243".toLowerCase()] +
                          " " +
                          colsec1["minutes_1244".toLowerCase()] +
                          " " +
                          colsec1["Long_direction_1245".toLowerCase()], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_1255".toLowerCase()] != null) {
                        if (
                          colsec2["identity_of_tanks_1246".toLowerCase()] ==
                          null
                        ) {
                          colsec2["identity_of_tanks_1246".toLowerCase()] = "";
                        }
                        if (colsec2["tank_name_1247".toLowerCase()] == null) {
                          colsec2["tank_name_1247".toLowerCase()] = "";
                        }
                        if (
                          colsec2["time_and_start_1248".toLowerCase()] == null
                        ) {
                          colsec2["time_and_start_1248".toLowerCase()] = "";
                        }
                        if (colsec2["Start_1249".toLowerCase()] == null) {
                          colsec2["Start_1249".toLowerCase()] = "";
                        }
                        if (colsec2["time_1250".toLowerCase()] == null) {
                          colsec2["time_1250".toLowerCase()] = "";
                        }
                        if (colsec2["END_1251".toLowerCase()] == null) {
                          colsec2["END_1251".toLowerCase()] = "";
                        }
                        if (colsec2["time_1252".toLowerCase()] == null) {
                          colsec2["time_1252".toLowerCase()] = "";
                        }
                        if (
                          colsec2["quantity_of_ballast_1253".toLowerCase()] ==
                          null
                        ) {
                          colsec2["quantity_of_ballast_1253".toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2[
                          "Quantity_of_ballast_received_1254".toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Quantity_of_ballast_received_1254".toLowerCase()
                          ] = "";
                        }
                        if (colsec2["m3_1255".toLowerCase()] == null) {
                          colsec2["m3_1255".toLowerCase()] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19",
                          colsec2["identity_of_tanks_1246".toLowerCase()] +
                          " " +
                          colsec2["tank_name_1247".toLowerCase()] +
                          " " +
                          colsec2["time_and_start_1248".toLowerCase()] +
                          " " +
                          colsec2["Start_1249".toLowerCase()] +
                          " " +
                          colsec2["time_1250".toLowerCase()] +
                          " " +
                          colsec2["END_1251".toLowerCase()] +
                          " " +
                          colsec2["time_1252".toLowerCase()] +
                          " " +
                          colsec2["quantity_of_ballast_1253".toLowerCase()] +
                          " " +
                          colsec2[
                          "Quantity_of_ballast_received_1254".toLowerCase()
                          ] +
                          " " +
                          colsec2["m3_1255".toLowerCase()], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  console.log("mylog::mylog");
                  this.createCollectionLayout(this.objcolsection);
                  this.objcolcollection.push([
                    this.objcolsection,
                    this.createdAt,
                  ]);
                  console.log(this.objcolcollection);
                  this.objcolsection = [];
                  this.createdAt = [];
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  getFormdataAllforms1(hid) {
    var fromDate = (document.getElementById("dp4") as HTMLInputElement).value;
    fromDate = this.datePipe.transform(fromDate, "dd-MMM-yyyy");
    var toDate = (document.getElementById("dp3") as HTMLInputElement).value;
    toDate = this.datePipe.transform(toDate, "dd-MMM-yyyy");
    var watchHour = this.selectedValueWatch;
    if (fromDate == null) {
      return alert("From Date is required");
    }
    if (hid == 36) {
      this.orbForm = 1;
      console.log(hid + " whtchhours:" + watchHour + " fromdate:" + fromDate + " toDate:" + toDate);
      this.getFormdataAllforms(hid, "", "", fromDate, toDate);
    } else if (hid == 37) {
      this.getOrbPartTwoData(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 39 || hid == 40 || hid == 47 || hid == 48) {
      this.callHTypeGarbegBallast(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 42 || hid == 43) {
      this.callHTypeAudit(hid, "", watchHour, fromDate, toDate);
    } else if (hid == 44) {
      this.getFormdataAllformsDeckBook(hid, "", watchHour, fromDate, toDate);
    } else if (hid == "49-3") {
      this.gmdss_log_book_list(hid, "", "", fromDate, toDate);
    } else if (
      hid == "53-1" ||
      hid == "53-2" ||
      hid == "53-3" ||
      hid == "53-4" ||
      hid == "53-5" ||
      hid == "53-6" ||
      hid == "53-7" ||
      hid == "53-8" ||
      hid == "53-9" ||
      hid == "53-10"
    ) {
      console.log("OLB " + hid);
      this.Officiallogbooklist(hid, "", "", fromDate, toDate);
    } else if (
      hid == 6 ||
      hid == 7 ||
      hid == 46 ||
      hid == 8 ||
      hid == 45 ||
      hid == 17 ||
      hid == 12 ||
      hid == 9 ||
      hid == 14
    ) {
      this.callEngineLogBookData(hid, "", watchHour, fromDate, toDate);
    }
  }

  getFormdataAllforms(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    //alert(hid);

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId != 30 &&
            this.formBuilder[i].formbuilderresponse[r].formId != 31
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        this.loading=true;
        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        this.reportsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            this.loading=false;
            this.objcolsection = [];
            let response = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";

            let newData = multiresponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    // [item.data[0].formId] : item.data[0]._id['$oid']
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            // console.log('FormIdObject_List_2', this.formIdObject);

            if (multiresponse != null && multiresponse.length > 0) {
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              // all form response loop
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";
                  var sectionId = "";
                  this.showpop3 = 0;
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;
                    var rowId = response[ky].data[s].rowId;
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    var usersign = response[ky].data[s].userSign;
                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    this.id = id;
                    this.formId = formId;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName.charAt(
                          this.formBuilder[i].formbuilderresponse[r].formName
                            .length - 1
                        );

                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    var p = 0;
                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] =
                              this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionId = this.formBuilderSections[p].sectionId;
                            sectionId = this.formBuilderSections[p].sectionId;

                            //alert(sectionId);
                            if (formId == 32) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 1;
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_sec_Tank_Designation_387".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_388".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_389".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_390".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_391".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //TextBox_392,m3_393,collected_from_394,identification_of_source_456
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_392".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_393".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "collected_from_394".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "identification_of_source_456".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //TextBox_1_395, m3_396, Sludge_from_397, Name_of_sec__Tank_Designation_398, _399, TextBox_2_400, m3_retained_to_401, Name_of_sec_Tank_Designation_402,during_port_stay_403,Name_of_Port_404
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_395".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_396".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_397".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec__Tank_Designation_398".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "_399".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_400".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_retained_to_401".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "during_port_stay_403".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Port_404".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                //TextBox_1_405,m3_406,Water_drained_from_407,Name_of_sec_Tank_Designation_408,TextBox_2_409,m3_retained_to_410,Name_of_sec_Tank_Designation_411,retained_in_tank_412,TextBox_3_413,m3_414
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_405".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_406".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_402".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Water_drained_from_407".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_408".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_409".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_retained_to_410".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_411".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "retained_in_tank_412".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_413".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_414".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 6) {
                                //TextBox_1_415,m3_417,Sludge_from_419,Name_of_sec_Tank_Designation_420,TextBox_2_423,m3_424,TextBox_3_426,hours_427
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_415".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_417".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_419".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_420".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_423".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_424".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_426".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "hours_427".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec7[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 7) {
                                //TextBox_1_416,m3_418,Sludge_from_421,Name of_sec Tank _Designation_422,TextBox_2_425,m3_428,TextBox_3_429,hours_430
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_416".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_418".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sludge_from_421".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name _of_sec _tank _designation_422".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_425".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_428".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_429".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "hours_430".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec8[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 33) {
                              this.garbegForm1 = 0;
                              this.garbegForm2 = 0;
                              this.blstForm = 0;
                              this.orbForm = 1;
                              //alert(p)
                              if (p == 0) {
                                // Name of_sec Tank_Designation_387
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_431".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_432".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Blige_water_from_433".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Engine_room_bilge_wells_435".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_438".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_440".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "NA_442".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_494".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name _of_ port_495".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //TextBox_388,m3_389
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_434".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Stop_437".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_439".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_436".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //TextBox_390,m3_391
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Through_441".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_443".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ppm_474".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_overboard_475".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_start_476".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_477".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_478".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_479".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_480".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_481".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_482".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_483".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_484".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_stop_485".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_6_486".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_487".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_7_488".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_489".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_8_490".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_491".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_9_492".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_493".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //TextBox_392,m3_393,collected_from_394,identification_of_source_456
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_Port_459".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //TextBox_1_395, m3_396, Sludge_from_397, Name_of_sec__Tank_Designation_398, _399, TextBox_2_400, m3_retained_to_401, Name_of_sec_Tank_Designation_402,during_port_stay_403,Name_of_Port_404
                                if (
                                  (key.toString().toLowerCase() ==
                                    "collected_in_460".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_sec_tank_designation_461".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Retained_in_tank_462".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec__Tank_Designation_398".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_463".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_464".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 34) {
                              this.orbForm = 1;
                              console.log(
                                "===response[ky].data[s]==",
                                response[ky].data[s]
                              );
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Pump_start_496".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_497".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "at_498".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_499".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_500".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_501".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_502".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_503".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_504".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_505".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_E/W_from_506".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_507".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Transfer_start_508".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_509".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "to_510".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_sec_Tank_Designation_511".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Stop_512".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_513".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 35) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_514".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_515".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Reason_for_Failure_if_known_516".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 36) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "TextBox_517".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Place_or_Position_518".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_519".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "deg_520".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_521".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "min_522".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Type_of_Oil_523".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_524".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "of_oily_residue_525".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Circumstances_of_the_discharge_526".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 37) {
                              this.orbForm = 1;

                              if (p == 0) {
                                if (
                                  key.toString().toLowerCase() ==
                                  "Name_of_Port_527".toLowerCase() &&
                                  response[ky].data[s][key] != ""
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Start_528".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_529".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_530".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Stop_531".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_532".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_533".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_534".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_of_535".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_537".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_536".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_4_539".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "S_bunkered_in_tanks_538".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_540".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_541".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_542".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_5_543".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_544".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_6_555".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_556".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_557".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_558".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_7_559".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_560".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "TextBox_1_545".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_546".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Type_of_Oil_547".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "bunkered_in_tanks_548".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_2_549".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_added_to_550".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_Name_Designation_551".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "now_containing_552".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TextBox_3_553".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MT_554".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array

                    if (formId == 32) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var rand = this.getRandomInt(900000);
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["name_of_sec_tank_designation_387"] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.1",
                          colsec1["name_of_sec_tank_designation_387"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.1",
                          "", usersign
                        ]);
                        colsec1 = [];
                      }

                      this.userSign.push(usersign);

                      if (colsec2["m3_389"] != null) {
                        if (colsec2["textbox_388"] == null) {
                          colsec2["textbox_388"] = "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.2",
                          colsec2["textbox_388"] + " " + colsec2["m3_389"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.2",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["m3_391"] != null) {
                        if (colsec3["textbox_390"] == null) {
                          colsec3["textbox_390"] = "0.00";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.3",
                          colsec3["textbox_390"] + " " + colsec3["m3_391"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.3",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec4["m3_393"] != null) {
                        if (colsec4["textbox_392"] == null) {
                          colsec4["textbox_392"] = "0.00";
                        }
                        if (colsec4["collected_from_394"] == null) {
                          colsec4["collected_from_394"] = "";
                        }
                        if (colsec4["identification_of_source_456"] == null) {
                          colsec4["identification_of_source_456"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.4",
                          colsec4["textbox_392"] +
                          " " +
                          colsec4["m3_393"] +
                          "," +
                          colsec4["collected_from_394"] +
                          "," +
                          colsec4["identification_of_source_456"], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "11.4",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec5["m3_396"] != null) {
                        if (colsec5["textbox_1_395"] == null) {
                          colsec5["textbox_1_395"] = "0.00";
                        }
                        if (colsec5["m3_396"] == null) {
                          colsec5["m3_396"] = "";
                        }
                        if (colsec5["sludge_from_397"] == null) {
                          colsec5["sludge_from_397"] = "";
                        }
                        if (
                          colsec5["name_of_sec__tank_designation_398"] == null
                        ) {
                          colsec5["name_of_sec__tank_designation_398"] = "";
                        }
                        if (colsec5["_399"] == null) {
                          colsec5["_399"] = "";
                        }
                        if (colsec5["textbox_2_400"] == null) {
                          colsec5["textbox_2_400"] = "0.00";
                        }
                        if (colsec5["m3_retained_to_401"] == null) {
                          colsec5["m3_retained_to_401"] = "";
                        }
                        if (
                          colsec5["name_of_sec_tank_designation_402"] == null
                        ) {
                          colsec5["name_of_sec_tank_designation_402"] = "";
                        }
                        if (colsec5["during_port_stay_403"] == null) {
                          colsec5["during_port_stay_403"] = "";
                        }
                        if (colsec5["name_of_port_404"] == null) {
                          colsec5["name_of_port_404"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.1",
                          colsec5["textbox_1_395"] +
                          " " +
                          colsec5["m3_396"] +
                          "," +
                          colsec5["sludge_from_397"] +
                          "," +
                          colsec5["name_of_sec__tank_designation_398"] +
                          "," +
                          colsec5["_399"] +
                          "," +
                          colsec5["textbox_2_400"] +
                          " " +
                          colsec5["m3_retained_to_401"] +
                          "," +
                          colsec5["name_of_sec_tank_designation_402"] +
                          " " +
                          colsec5["during_port_stay_403"] +
                          "," +
                          colsec5["name_of_port_404"], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.1",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec6["m3_406"] != null) {
                        if (colsec6["textbox_1_405"] == null) {
                          colsec6["textbox_1_405"] = "0.00";
                        }
                        if (colsec6["water_drained_from_407"] == null) {
                          colsec6["water_drained_from_407"] = "";
                        }
                        if (
                          colsec6["name_of_sec_tank_designation_408"] == null
                        ) {
                          colsec6["name_of_sec_tank_designation_408"] = "";
                        }
                        if (colsec6["textbox_2_409"] == null) {
                          colsec6["textbox_2_409"] = "";
                        }
                        if (colsec6["m3_retained_to_410"] == null) {
                          colsec6["m3_retained_to_410"] = "";
                        }
                        if (
                          colsec6["name_of_sec_tank_designation_411"] == null
                        ) {
                          colsec6["name_of_sec_tank_designation_411"] = "";
                        }
                        if (colsec6["retained_in_tank_412"] == null) {
                          colsec6["retained_in_tank_412"] = "";
                        }
                        if (colsec6["textbox_3_413"] == null) {
                          colsec6["textbox_3_413"] = "0.00";
                        }
                        if (colsec6["m3_414"] == null) {
                          colsec6["m3_414"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.2",
                          colsec6["textbox_1_405"] +
                          " " +
                          colsec6["m3_406"] +
                          "," +
                          colsec6["water_drained_from_407"] +
                          "," +
                          colsec6["name_of_sec_tank_designation_408"] +
                          "," +
                          colsec6["textbox_2_409"] +
                          " " +
                          colsec6["m3_retained_to_410"] +
                          "," +
                          colsec6["name_of_sec_tank_designation_411"] +
                          " " +
                          colsec6["retained_in_tank_412"] +
                          "," +
                          colsec6["textbox_3_413"] +
                          " " +
                          colsec6["m3_414"], usersign
                        ]);
                        colsec6 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.2",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec7["m3_424"] != null) {
                        if (colsec7["textbox_1_415"] == null) {
                          colsec7["textbox_1_415"] = "0.00";
                        }
                        if (colsec7["sludge_from_419"] == null) {
                          colsec7["sludge_from_419"] = "";
                        }
                        if (colsec7["m3_417"] == null) {
                          colsec7["m3_417"] = "";
                        }
                        if (
                          colsec7["name_of_sec_tank_designation_420"] == null
                        ) {
                          colsec7["name_of_sec_tank_designation_420"] = "";
                        }
                        if (colsec7["textbox_2_423"] == null) {
                          colsec7["textbox_2_423"] = "0.00";
                        }
                        if (colsec7["textbox_3_426"] == null) {
                          colsec7["textbox_3_426"] = "";
                        }
                        if (colsec7["hours_427"] == null) {
                          colsec7["hours_427"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.3",
                          colsec7["textbox_1_415"] +
                          " " +
                          colsec7["m3_417"] +
                          "," +
                          colsec7["sludge_from_419"] +
                          "," +
                          colsec7["name_of_sec_tank_designation_420"] +
                          "," +
                          colsec7["textbox_2_423"] +
                          " " +
                          colsec7["m3_424"] +
                          "," +
                          colsec7["textbox_3_426"] +
                          " " +
                          colsec7["hours_427"], usersign
                        ]);
                        colsec7 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.3",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      console.log("===colsec8===", colsec8);
                      if (colsec8["m3_428"] != null) {
                        if (colsec8["textbox_1_416"] == null) {
                          colsec8["textbox_1_416"] = "0.00 ";
                        }
                        if (colsec8["m3_418"] == null) {
                          colsec8["m3_418"] = "";
                        }
                        if (colsec8["sludge_from_421"] == null) {
                          colsec8["sludge_from_421"] = "";
                        }
                        if (
                          colsec8["name _of_sec _tank _designation_422"] == null
                        ) {
                          colsec8["name _of_sec _tank _designation_422"] = "";
                        }
                        if (colsec8["textbox_2_425"] == null) {
                          colsec8["textbox_2_425"] = "0.00 ";
                        }
                        if (colsec8["textbox_3_429"] == null) {
                          colsec8["textbox_3_429"] = "";
                        }
                        if (colsec8["hours_430"] == null) {
                          colsec8["hours_430"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.4",
                          colsec8["textbox_1_416"] +
                          " " +
                          colsec8["m3_418"] +
                          "," +
                          colsec8["sludge_from_421"] +
                          "," +
                          colsec8["name _of_sec _tank _designation_422"] +
                          "," +
                          colsec8["textbox_2_425"] +
                          " " +
                          colsec8["m3_428"] +
                          "," +
                          colsec8["textbox_3_429"] +
                          " " +
                          colsec8["hours_430"], usersign
                        ]);
                        colsec8 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "12.4",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 33) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt2++,
                        ]);
                      }
                      console.log("===colsec1===", colsec1);

                      if (colsec1["m3_432"] != null) {
                        if (colsec1["textbox_1_431"] == null) {
                          colsec1["textbox_1_431"] = "0.00";
                        }
                        if (colsec1["blige_water_from_433"] == null) {
                          colsec1["blige_water_from_433"] = "";
                        }
                        if (colsec1["engine_room_bilge_wells_435"] == null) {
                          colsec1["engine_room_bilge_wells_435"] = "";
                        }
                        if (colsec1["t_438"] == null) {
                          colsec1["t_438"] = "";
                        }
                        if (colsec1["textbox_2_440"] == null) {
                          colsec1["textbox_2_440"] = "";
                        }
                        if (colsec1["textbox_494"] == null) {
                          colsec1["textbox_494"] = "";
                        }
                        if (colsec1["textbox_1_431"] == null) {
                          colsec1["textbox_1_431"] = "";
                        }
                        if (colsec1["name of Port_495"] == null) {
                          colsec1["name of Port_495"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13.0",
                          colsec1["textbox_1_431"] +
                          " " +
                          colsec1["m3_432"] +
                          " " +
                          colsec1["blige_water_from_433"] +
                          " " +
                          colsec1["engine_room_bilge_wells_435"] +
                          " " +
                          colsec1["t_438"] +
                          " " +
                          colsec1["textbox_2_440"] +
                          " " +
                          colsec1["na_442"] +
                          " " +
                          colsec1["textbox_494"] +
                          " " +
                          colsec1["name _of_ port_495"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "13.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["start_434"] != null) {
                        if (colsec2["stop_437"] == null) {
                          colsec2["stop_437"] = "";
                        }
                        if (colsec2["textbox_1_436"] == null) {
                          colsec2["textbox_1_436"] = "";
                        }
                        if (colsec2["textbox_2_439"] == null) {
                          colsec2["textbox_2_439"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14.0",
                          colsec2["start_434"] +
                          " " +
                          colsec2["textbox_1_436"] +
                          ", " +
                          colsec2["stop_437"] +
                          " " +
                          colsec2["textbox_2_439"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "14.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      console.log("====colsec3===", colsec3);

                      if (colsec3["through_441"] != null) {
                        if (colsec3["textbox_1_443"] == null) {
                          colsec3["textbox_1_443"] = "";
                        }
                        if (colsec3["ppm_474"] == null) {
                          colsec3["ppm_474"] = "";
                        }
                        if (colsec3["equipment_overboard_475"] == null) {
                          colsec3["equipment_overboard_475"] = "";
                        }
                        if (colsec3["position_start_476"] == null) {
                          colsec3["position_start_476"] = "";
                        }
                        if (colsec3["textbox_2_477"] == null) {
                          colsec3["textbox_2_477"] = "";
                        }
                        if (colsec3["deg_478"] == null) {
                          colsec3["deg_478"] = "";
                        }
                        if (colsec3["textbox_3_479"] == null) {
                          colsec3["textbox_3_479"] = "";
                        }
                        if (colsec3["min_480"] == null) {
                          colsec3["min_480"] = "";
                        }
                        if (colsec3["textbox_4_481"] == null) {
                          colsec3["textbox_4_481"] = "";
                        }
                        if (colsec3["deg_482"] == null) {
                          colsec3["deg_482"] = "";
                        }
                        if (colsec3["textbox_5_483"] == null) {
                          colsec3["textbox_5_483"] = "";
                        }

                        if (colsec3["min_484"] == null) {
                          colsec3["min_484"] = "";
                        }
                        if (colsec3["position_stop_485"] == null) {
                          colsec3["position_stop_485"] = "";
                        }
                        if (colsec3["textbox_5_483"] == null) {
                          colsec3["textbox_5_483"] = "";
                        }
                        if (colsec3["textbox_6_486"] == null) {
                          colsec3["textbox_6_486"] = "";
                        }

                        if (colsec3["deg_487"] == null) {
                          colsec3["deg_487"] = "";
                        }
                        if (colsec3["min_489"] == null) {
                          colsec3["min_489"] = "";
                        }
                        if (colsec3["textbox_8_490"] == null) {
                          colsec3["textbox_8_490"] = "";
                        }
                        if (colsec3["deg_491"] == null) {
                          colsec3["deg_491"] = "";
                        }
                        if (colsec3["textbox_9_492"] == null) {
                          colsec3["textbox_9_492"] = "";
                        }
                        if (colsec3["min_493"] == null) {
                          colsec3["min_493"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.1",
                          colsec3["through_441"] +
                          " : " +
                          colsec3["textbox_1_443"] +
                          " " +
                          colsec3["ppm_474"] +
                          ", " +
                          colsec3["equipment_overboard_475"] +
                          " " +
                          colsec3["position_start_476"] +
                          " " +
                          colsec3["textbox_2_477"] +
                          " " +
                          colsec3["deg_478"] +
                          ", " +
                          colsec3["textbox_3_479"] +
                          " " +
                          colsec3["min_480"] +
                          " " +
                          colsec3["textbox_4_481"] +
                          " " +
                          colsec3["deg_482"] +
                          ", " +
                          colsec3["textbox_5_483"] +
                          " " +
                          colsec3["min_484"] +
                          ", " +
                          colsec3["position_stop_485"] +
                          " " +
                          colsec3["textbox_6_486"] +
                          " " +
                          colsec3["deg_487"] +
                          ", " +
                          colsec3["textbox_7_488"] +
                          " " +
                          colsec3["min_489"] +
                          " " +
                          colsec3["textbox_8_490"] +
                          " " +
                          colsec3["deg_491"] +
                          ", " +
                          colsec3["textbox_9_492"] +
                          " " +
                          colsec3["min_493"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.1",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec4["name_of_port_459"] != null) {
                        if (colsec4["name_of_port_459"] == null) {
                          colsec4["name_of_port_459"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.2",
                          colsec4["name_of_port_459"], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.2",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);
                      console.log("==colsec5==", colsec5);
                      if (colsec5["collected_in_460"] != null) {
                        if (
                          colsec5["name_of_sec_tank_designation_461"] == null
                        ) {
                          colsec5["name_of_sec_tank_designation_461"] = "";
                        }
                        if (colsec5["retained_in_tank_462"] == null) {
                          colsec5["retained_in_tank_462"] = "";
                        }
                        if (colsec5["textbox_1_463"] == null) {
                          colsec5["textbox_1_463"] = "0.00";
                        }
                        if (colsec5["m3_464"] == null) {
                          colsec5["m3_464"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.3",
                          colsec5["collected_in_460"] +
                          " " +
                          colsec5["name_of_sec_tank_designation_461"] +
                          ", " +
                          colsec5["retained_in_tank_462"] +
                          " " +
                          colsec5["textbox_1_463"] +
                          " " +
                          colsec5["m3_464"], usersign
                        ]);
                        colsec5 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "15.3",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      p = 0;
                    }
                    //alert(formId);
                    if (formId == 34) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt3++,
                        ]);
                      }

                      if (colsec1["pump_start_496"] != null) {
                        if (colsec1["textbox_1_497"] == null) {
                          colsec1["textbox_1_497"] = "";
                        }
                        if (colsec1["at_498"] == null) {
                          colsec1["at_498"] = "";
                        }
                        if (colsec1["textbox_2_499"] == null) {
                          colsec1["textbox_2_499"] = "";
                        }
                        if (colsec1["deg_500"] == null) {
                          colsec1["deg_500"] = "";
                        }
                        if (colsec1["textbox_3_501"] == null) {
                          colsec1["textbox_3_501"] = "";
                        }
                        if (colsec1["min_502"] == null) {
                          colsec1["min_502"] = "";
                        }
                        if (colsec1["textbox_4_503"] == null) {
                          colsec1["textbox_4_503"] = "";
                        }
                        if (colsec1["deg_504"] == null) {
                          colsec1["deg_504"] = "";
                        }
                        if (colsec1["TextBox_5_505"] == null) {
                          colsec1["TextBox_5_505"] = "";
                        }
                        if (colsec1["min_e/w_from_506"] == null) {
                          colsec1["min_e/w_from_506"] = "";
                        }
                        if (
                          colsec1["name_of_sec_tank_designation_507"] == null
                        ) {
                          colsec1["name_of_sec_tank_designation_507"] = "";
                        }
                        console.log("==colsec1==", colsec1);

                        console.log("==colsec1==", colsec1["textbox_5_505"]);

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16.0",
                          colsec1["pump_start_496"] +
                          ": " +
                          colsec1["textbox_1_497"] +
                          " " +
                          colsec1["at_498"] +
                          ", " +
                          colsec1["textbox_2_499"] +
                          " " +
                          colsec1["deg_500"] +
                          ", " +
                          colsec1["textbox_3_501"] +
                          " " +
                          colsec1["min_502"] +
                          " " +
                          colsec1["textbox_4_503"] +
                          " " +
                          colsec1["deg_504"] +
                          ", " +
                          colsec1["textbox_5_505"] +
                          " " +
                          colsec1["min_e/w_from_506"] +
                          "," +
                          colsec1["name_of_sec_tank_designation_507"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "16.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["transfer_start_508"] != null) {
                        if (colsec2["textbox_509"] == null) {
                          colsec2["textbox_509"] = "";
                        }
                        if (colsec2["to_510"] == null) {
                          colsec2["to_510"] = "";
                        }
                        if (
                          colsec2["name_of_sec_tank_designation_511"] == null
                        ) {
                          colsec2["name_of_sec_tank_designation_511"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17.0",
                          colsec2["transfer_start_508"] +
                          "," +
                          colsec2["textbox_509"] +
                          "," +
                          colsec2["to_510"] +
                          "," +
                          colsec2["name_of_sec_tank_designation_511"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "17.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      console.log("===colsec3===", colsec3);

                      if (colsec3["stop_512"] != null) {
                        if (colsec3["textbox_513"] == null) {
                          colsec3["textbox_513"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18.0",
                          colsec3["stop_512"] + "," + colsec3["textbox_513"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "18.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 35) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt4++,
                        ]);
                      }

                      if (colsec1["textbox_514"] != null) {
                        if (colsec1["textbox_514"] == null) {
                          colsec1["textbox_514"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19.0",
                          colsec1["textbox_514"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "19.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec2["textbox_515"] != null) {
                        if (colsec2["textbox_515"] == null) {
                          colsec2["textbox_515"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20.0",
                          colsec2["textbox_515"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "20.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["reason_for_failure_if_known_516"] != null) {
                        if (
                          colsec3["reason_for_failure_if_known_516"] == null
                        ) {
                          colsec3["reason_for_failure_if_known_516"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21.0",
                          colsec3["reason_for_failure_if_known_516"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "21.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);
                      p = 0;
                    }

                    if (formId == 36) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt5++,
                        ]);
                      }

                      if (colsec1["textbox_517"] != null) {
                        if (colsec1["textbox_517"] == null) {
                          colsec1["textbox_517"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22.0",
                          colsec1["textbox_517"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "22.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["place_or_position_518"] != null) {
                        if (colsec2["textbox_1_519"] == null) {
                          colsec2["textbox_1_519"] = "";
                        }
                        if (colsec2["deg_520"] == null) {
                          colsec2["deg_520"] = "";
                        }
                        if (colsec2["textbox_2_521"] == null) {
                          colsec2["textbox_2_521"] = "";
                        }
                        if (colsec2["min_522"] == null) {
                          colsec2["min_522"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23.0",
                          colsec2["place_or_position_518"] +
                          "," +
                          colsec2["textbox_1_519"] +
                          "," +
                          colsec2["deg_520"] +
                          "," +
                          colsec2["textbox_2_521"] +
                          "," +
                          colsec2["min_522"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "23.0",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec3["of_oily_residue_525"] != null) {
                        if (colsec3["quantity_524"] == null) {
                          colsec3["quantity_524"] = "";
                        }
                        if (colsec3["type_of_oil_523"] == null) {
                          colsec3["type_of_oil_523"] = "";
                        }
                        if (colsec3["of_oily_residue_525"] == null) {
                          colsec3["of_oily_residue_525"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24.0",
                          colsec3["type_of_oil_523"] +
                          "," +
                          colsec3["quantity_524"] +
                          "," +
                          colsec3["of_oily_residue_525"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "24.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (
                        colsec4["circumstances_of_the_discharge_526"] != null
                      ) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25.0",
                          colsec4["circumstances_of_the_discharge_526"], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "25.0",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      p = 0;
                    }

                    if (formId == 37) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt6++,
                        ]);
                      }

                      if (colsec1["name_of_port_527"] != null) {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.1",
                          colsec1["name_of_port_527"], usersign
                        ]);
                        colsec1 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.1",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec2["start_528"] != null) {
                        if (colsec2["textbox_1_529"] == null) {
                          colsec2["textbox_1_529"] = "";
                        }
                        if (colsec2["textbox_2_530"] == null) {
                          colsec2["textbox_2_530"] = "";
                        }
                        if (colsec2["stop_531"] == null) {
                          colsec2["stop_531"] = "";
                        }
                        if (colsec2["textbox_3_532"] == null) {
                          colsec2["textbox_3_532"] = "";
                        }
                        if (colsec2["textbox_4_533"] == null) {
                          colsec2["textbox_4_533"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.2",
                          colsec2["start_528"] +
                          "," +
                          colsec2["textbox_1_529"] +
                          "," +
                          colsec2["textbox_2_530"] +
                          "," +
                          colsec2["stop_531"] +
                          "," +
                          colsec2["textbox_3_532"] +
                          "," +
                          colsec2["textbox_4_533"], usersign
                        ]);
                        colsec2 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.2",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);

                      if (colsec3["textbox_1_534"] != null) {
                        if (colsec3["mt_of_535"] == null) {
                          colsec3["mt_of_535"] = "";
                        }
                        if (colsec3["textbox_2_536"] == null) {
                          colsec3["textbox_2_536"] = "";
                        }
                        if (colsec3["textbox_3_537"] == null) {
                          colsec3["textbox_3_537"] = "";
                        }
                        if (colsec3["s_bunkered_in_tanks_538"] == null) {
                          colsec3["s_bunkered_in_tanks_538"] = "";
                        }
                        if (colsec3["textbox_4_539"] == null) {
                          colsec3["textbox_4_539"] = "";
                        }
                        if (colsec3["mt_added_to_540"] == null) {
                          colsec3["mt_added_to_540"] = "";
                        }
                        if (colsec3["tank_name_designation_541"] == null) {
                          colsec3["tank_name_designation_541"] = "";
                        }
                        if (colsec3["now_containing_542"] == null) {
                          colsec3["now_containing_542"] = "";
                        }
                        if (colsec3["textbox_5_543"] == null) {
                          colsec3["textbox_5_543"] = "";
                        }
                        if (colsec3["mt_544"] == null) {
                          colsec3["mt_544"] = "";
                        }

                        if (colsec3["textbox_6_555"] == null) {
                          colsec3["textbox_6_555"] = "";
                        }
                        if (colsec3["mt_added_to_556"] == null) {
                          colsec3["mt_added_to_556"] = "";
                        }
                        if (colsec3["tank_name_designation_557"] == null) {
                          colsec3["tank_name_designation_557"] = "";
                        }
                        if (colsec3["now_containing_558"] == null) {
                          colsec3["now_containing_558"] = "";
                        }
                        if (colsec3["textbox_7_559"] == null) {
                          colsec3["textbox_7_559"] = "";
                        }
                        if (colsec3["mt_560"] == null) {
                          colsec3["mt_560"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.3",
                          colsec3["textbox_1_534"] +
                          "," +
                          colsec3["mt_of_535"] +
                          "," +
                          colsec3["textbox_2_536"] +
                          "," +
                          colsec3["textbox_3_537"] +
                          "," +
                          colsec3["s_bunkered_in_tanks_538"] +
                          "," +
                          colsec3["textbox_4_539"] +
                          "," +
                          colsec3["mt_added_to_540"] +
                          "," +
                          colsec3["tank_name_designation_541"] +
                          "," +
                          colsec3["now_containing_542"] +
                          "," +
                          colsec3["textbox_5_543"] +
                          "," +
                          colsec3["mt_544"] +
                          "," +
                          colsec3["textbox_6_555"] +
                          "," +
                          colsec3["mt_added_to_556"] +
                          "," +
                          colsec3["tank_name_designation_557"] +
                          "," +
                          colsec3["now_containing_558"] +
                          "," +
                          colsec3["textbox_7_559"] +
                          "," +
                          colsec3["mt_560"], usersign
                        ]);
                        colsec3 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.3",
                          "", usersign
                        ]);
                      }

                      this.userSign.push(usersign);

                      if (colsec4["mt_546"] != null) {
                        if (colsec4["mt_546"] == null) {
                          colsec4["mt_546"] = "";
                        }
                        if (colsec4["type_of_oil_547"] == null) {
                          colsec4["type_of_oil_547"] = "";
                        }
                        if (colsec4["bunkered_in_tanks_548"] == null) {
                          colsec4["bunkered_in_tanks_548"] = "";
                        }
                        if (colsec4["textbox_2_549"] == null) {
                          colsec4["textbox_2_549"] = "";
                        }
                        if (colsec4["mt_added_to_550"] == null) {
                          colsec4["mt_added_to_550"] = "";
                        }
                        if (colsec4["now_containing_552"] == null) {
                          colsec4["now_containing_552"] = "";
                        }
                        if (colsec4["textbox_3_553"] == null) {
                          colsec4["textbox_3_553"] = "";
                        }
                        if (colsec4["mt_554"] == null) {
                          colsec4["mt_554"] = "";
                        }
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.4",
                          colsec4["textbox_1_545"] +
                          "," +
                          colsec4["mt_546"] +
                          "," +
                          colsec4["type_of_oil_547"] +
                          "," +
                          colsec4["bunkered_in_tanks_548"] +
                          "," +
                          colsec4["textbox_2_549"] +
                          "," +
                          colsec4["mt_added_to_550"] +
                          "," +
                          colsec4["tank_name_designation_551"] +
                          "," +
                          colsec4["now_containing_552"] +
                          "," +
                          colsec4["textbox_3_553"] +
                          "," +
                          colsec4["mt_554"], usersign
                        ]);
                        colsec4 = [];
                      } else {
                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          sectionName,
                          "26.4",
                          "", usersign
                        ]);
                      }
                      this.userSign.push(usersign);
                      p = 0;
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  console.log("mylog::mylog", this.objcolsection);
                  this.createCollectionLayout(this.objcolsection);
                  this.objcolcollection.push([
                    this.objcolsection,
                    this.createdAt,
                  ]);
                  console.log(
                    "====objcolcollection=====",
                    this.objcolcollection
                  );
                  console.log(
                    "====userSign=====",
                    this.userSign
                  );
                  this.objcolsection = [];
                  this.createdAt = [];

                  // this.objcolcollection[0].forEach((element: any) => {
                  //   element.forEach((ele: any) => {
                  //     console.log("===ele===", ele);
                  //     if(ele[3]!=undefined && typeof ele[3]=='string'){
                  //       var newstr = ele[3].replace(",,", ",");
                  //       var newstr1 = newstr.replace(",,", ",");
                  //       console.log("===newstr1===", newstr1);
                  //     }
                  //   });
                  // });

                  for (let key in this.objcolcollection[0]) {
                    for (let childkey in this.objcolcollection[0][key]) {
                      if (
                        this.objcolcollection[0][key][childkey][3] !=
                        undefined &&
                        typeof this.objcolcollection[0][key][childkey][3] ==
                        "string"
                      ) {
                        console.log(
                          "===childkey===",
                          this.objcolcollection[0][key][childkey][3]
                        );
                        var newstr = this.objcolcollection[0][key][
                          childkey
                        ][3].replace(",,", ",");
                        var newstr1 = newstr.replace(",,", ",");
                        var newstr2 = newstr1.replace(",, ", ",");
                        if (newstr2) {
                          this.objcolcollection[0][key][childkey][3] = newstr2;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  callHTypeGarbeg(bname, hid, wid, sectionIndex, bookstatus: string) {
    console.log('=bookstatus==', bookstatus,hid,this.currentBookName);
    this.loading = true;
    this.showpop1 = 0;
    this.currentBookName = bname;
    this.cleanReports();
    if (hid == 36 || hid == 0) {
      this.onSubReportPop(hid, '');
      //this.getFormdataAllforms(hid);
    } else if (hid == 42 || hid == 43) {
      this.onSubReportPop(hid, bookstatus);
      //this.callHTypeAudit(hid,wid,sectionIndex);
    } else if (hid == 44) {
      this.onSubReportPop(hid, '');
      //this.getFormdataAllformsDeckBook(hid);
    } else if (hid == 37) {
      this.onSubReportPop(hid, '');
      //this.getOrbPartTwoData(hid)
    } else if (hid == 49 || hid == "49-1" || hid == "49-2") {
      this.gmdss_log_book(hid);
    } else if (hid == "49-3") {
      this.onSubReportPop(hid, '');
      //this.callHTypeGarbegBallast(hid,wid,sectionIndex);
    } else if (
      hid == "53-1" ||
      hid == "53-2" ||
      hid == "53-3" ||
      hid == "53-4" ||
      hid == "53-5" ||
      hid == "53-6" ||
      hid == "53-7" ||
      hid == "53-8" ||
      hid == "53-9" ||
      hid == "53-10"
    ) {
      this.onSubReportPop(hid, '');
    } else {
      this.onSubReportPop(hid, '');
    }
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  // modifyedData(response) {
  //     console.log('==========response============')
  //     console.log(response);
  //     for (let row in response.data) {
  //         response.data[row].rowId = response.data[row].rowId.replace('rowId', '');
  //     }
  //     console.log('==========response after change rowId============')
  //     console.log(response.data);
  //     var groupedCollection = [];
  //     groupedCollection = _.sortBy(response.data, 'timeStamp');
  //     groupedCollection = _.groupBy(groupedCollection, 'rowId');
  //     console.log('==========response after grouped and sort============')
  //     console.log(groupedCollection);
  //     //response.data = groupedCollection;
  //     console.log('==========response after grouped and sort============')
  //     //console.log(response.data);
  //     response.data = [];
  //     var cnt = 0;
  //     let value = [];
  //     for (const [key, value] of Object.entries(groupedCollection)) {
  //         for (let arr in value) {

  //             if (value[arr].changeFields != null && value[arr].changeFields != '') {
  //                 var changeControlIds = value[arr].changeFields.toString().split(",");
  //                 for (let tey in value[arr]) {
  //                     if (changeControlIds.indexOf(tey) != -1) {
  //                         if (value.length > 1) { value[arr]['isDelete'] = '1' };
  //                         if (value[parseInt(arr) - 1] != null) {
  //                             value[parseInt(arr) - 1]['editedBy'] = '<span class="box-edit-time">Edited On: ' + value[parseInt(arr)].updated_at + '<br> Edited By: ' + value[parseInt(arr)].userName + '</span>';
  //                             value[parseInt(arr) - 1][tey] = '<strike>' + value[parseInt(arr) - 1][tey] + '</strike> &nbsp; <b>' + value[parseInt(arr)][tey] + '</b>';
  //                         } else {
  //                             value[parseInt(arr)]['editedBy'] = '<span class="box-edit-time">Edited On: ' + value[parseInt(arr)].updated_at + '<br> Edited By: ' + value[parseInt(arr)].userName + '</span>';
  //                             value[parseInt(arr)][tey] = '<b>' + value[parseInt(arr)][tey] + '</b>';
  //                         }
  //                     }
  //                 }
  //             }

  //             response.data.push(value[arr]);
  //         }
  //     }

  //     console.log('==========response after grouped and sort and managed for edited ============')
  //     console.log(response.data);
  //     return response;
  // }

  modifyedData(response) {
    console.log("==========modifyedData00============", response);
    for (let row in response.data) {
      response.data[row].rowId = response.data[row].rowId.replace("rowId", "");
    }
    console.log("==========modifyedData01============", response.data);
    var groupedCollection = [];
    groupedCollection = _.sortBy(response.data, "timeStamp").reverse();
    groupedCollection = _.groupBy(groupedCollection, "rowId");
    console.log("==========modifyedData02============", groupedCollection);
    response.data = [];
    var cnt = 0;
    let value = [];
    const start = '<div class="box-edit-message">';
    const end = '<div>';
    var fullText ='';
    for (const [key, value] of Object.entries(groupedCollection)) {
      for (let arr in value) {
        console.log("===modifyedData11==", parseInt(arr))
        if (parseInt(arr) > 0) {
          value[arr]["isDelete"] = "1";
        }
            console.log("fullText book", this.olb);
        if(this.olb=='8' || this.olb==8){
          for (let tey in value[arr]) {
            fullText = value[parseInt(arr)][tey]
            console.log("fullText 111", fullText);

            if (typeof fullText === 'string' && fullText.includes(start)) {
              const regex = new RegExp(`${start}(.*?)${end}`, 's'); // 's' for multiline match
              const match = fullText.match(regex);

              if (match && match[1]) {
                value[arr][tey] = match[1].trim();
                console.log("fullText box-edit-message", match[1].trim());
              } else {
                value[arr][tey] = fullText;
                console.log("fullText fullText", fullText);
              }
            }else if (typeof fullText === 'string' && fullText.includes('####')) {
              value[arr][tey] = fullText.split('####')[0] || '';
              console.log("fullText ('####'))", fullText.split('####')[0] || '');
            } else {
              value[arr][tey] = fullText;
              console.log("fullText all", fullText);
            }

          }
        }else{
          for (let tey in value[arr]) {
            fullText = value[parseInt(arr)][tey]
            console.log("fullText 222", fullText);
            if (typeof fullText === 'string' && fullText.includes('####')) {
              value[arr][tey] = fullText.split('####')[0] || '';
              console.log("fullText 222 ('####'))", fullText.split('####')[0] || '');
            } else {
              value[arr][tey] = fullText;
              console.log("fullText 222 all", fullText);
            }
          }
        }
        response.data.push(value[arr]);
      }
    }

    console.log(
      "==========response after grouped and sort and managed for edited ============"
    );
    console.log(response.data);
    console.log("return-response-modify", response);
    return response;
  }

  callHTypeGarbegBallast(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 39 || hid == 40 || hid == 47 || hid == 48) {
    } else {
      console.log("not found");
      return;
    }

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;

          console.log("main array result");
          console.log(this.formBuilder[i].formbuilderresponse[r]);

          if (
            (formId == 38 && hid == 39) ||
            (formId == 39 && hid == 40) ||
            (formId == 47 && hid == 47) ||
            (formId == 48 && hid == 48)
          ) {
            //alert(this.formBuilder[i].formbuilderresponse[r].formName + ' form Id' + formId );
            this.formCount.push(
              this.formBuilder[i].formbuilderresponse[r].formName
            );
            this.formBuilderSections = [];
            for (
              var u = 0;
              u <
              this.formBuilder[i].formbuilderresponse[r]
                .formbuildersectionnamelist.length;
              u++
            ) {
              this.formBuilderSections.push(
                this.formBuilder[i].formbuilderresponse[r]
                  .formbuildersectionnamelist[u]
              ); //.formbuilderlist
            }
            this.loading=true;

            this.reportsService.getFormDetailsByActionDateAndTime(
              formId,
              this.voyageNo,
              actionDate,
              actionTime,
              fromDate,
              toDate,
              (formResponse) => {
                this.loading=false;
                var response = this.modifyedData(formResponse[0]);
                console.log("=======filter response========");
                console.log(response);
                if (response.data != null) {

                  this.objcolsection = [];
                  this.objcol = [];
                  this.userSign = [];
                  this.showpop5 = 0;
                  this.showpop6 = 0;
                  this.showpop7 = 0;
                  this.showpop8 = 0;
                  for (var s = 0; s < response.data.length; s++) {
                    if (response.data[s].isDelete == "1") continue;
                    var findKey = false;
                    var sectionName = "";
                    var rowId = "";
                    var Id = "";

                    this.formDetails = [];
                    var colsec1 = [];
                    var colsec2 = [];
                    var colsec3 = [];
                    var colsec4 = [];
                    var colsec5 = [];
                    var colsec6 = [];
                    var coldate = [];
                    var changeSectionIds = [];
                    var sectionIdArray = [];
                    var changeControlIds = [];
                    var changeControlArray = [];
                    var rowId = "";
                    var sectionId = 0;
                    this.editedBy = "";
                    var usersign = "";
                    var signdate = "";
                    var masterName = "";
                    var masterSignature = "";
                    var roleId = "";
                    var roleName = "";
                    var id = "";

                    let newData = formResponse.map((item) => {
                      if (item && item.data && item.data[0].formId) {
                        if (item.data && item.data[0].formId) {
                          let itemId = {
                            // [item.data[0].formId] : item.data[0]._id['$oid']
                            [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                          };
                          return item.data && item.data[0].formId && itemId;
                        }
                        return item && item;
                      }
                    });

                    const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
                    this.formIdObject = mergedObject;
                    // console.log('FormIdObject_List_3', this.formIdObject);
                    //clearing the rest record if row is edited
                    console.log("===chanage value checking====");
                    if (response.data[s].editedBy != null) {
                      this.editedBy = response.data[s].editedBy;
                    }

                    usersign = response.data[s].userSign;

                    for (let key in response.data[s]) {
                      for (
                        var p = 0;
                        p < this.formBuilderSections.length;
                        p++
                      ) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //console.log(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response.data[s][key] != ""
                          ) {
                            coldate["date_created"] = response.data[s][key];
                            coldate["section_length"] =
                              this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionName =
                              this.formBuilderSections[p].sectionName;
                            sectionId = this.formBuilderSections[p].sectionId;

                            if (formId == 38) {
                              if (
                                response.data[s].sectionId != null &&
                                response.data[s].sectionId != "" &&
                                response.data[s][key] != "" &&
                                sectionIdArray.length == 0
                              ) {
                                changeSectionIds = response.data[s].sectionId
                                  .toString()
                                  .split(",");
                                sectionIdArray = Array.from(
                                  new Set(changeSectionIds)
                                );

                                if (response.data[s].changeFields != null) {
                                  changeControlIds = response.data[
                                    s
                                  ].changeFields
                                    .toString()
                                    .split(",");
                                  changeControlArray = Array.from(
                                    new Set(changeControlIds)
                                  );
                                }

                                rowId =
                                  response.data[s].id +
                                  "-" +
                                  response.data[s].rowId;
                              }

                              if (
                                response.data[s].userSign != null &&
                                response.data[s].userSign != ""
                              ) {
                                usersign = response.data[s].userSign;
                              }

                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.garbegForm1 = 1;
                              if (p == 0) {
                                //Port_580,Facility_581,Name_of_ship_582 Remarks_596:remarks,'-':estimate amoutn inceinrated, '-':estimate amount discharged in cm3 (textbox_589+m3_590):estimate amount discharged in reception facility, categories_585:category,long_578:longitude, lat_576:latitude, textbox_562:date start, textbox_563:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Port_580".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Facility_581".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_ship_582".toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remarks_1094" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_590" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_589" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_585" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_578" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_576" ||
                                  key.toString().toLowerCase() ==
                                  "textbox_1_562" ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_563" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //filter
                              }

                              if (p == 1) {
                                //remarks_630:remarks (textbox_626+m3_628):estimate amoutn inceinrated, '-':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, categories_622:category,long_612:longitude, lat_610:latitude ,long_617:longitude , lat_616:latitude, textbox_1_593:date start, textbox_2_594:time start,textbox_3_599:date end, textbox_4_601:time end
                                if (
                                  (key.toString().toLowerCase() ==
                                    "textbox_626" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_628" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remarks_630" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_622" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_612" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_610" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_617" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_616" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_593" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_594" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_599" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_4_601" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //remarks_661:remarks '_':estimate amoutn inceinrated, 'textbox_658'+'m3_660':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, categories_653:category,long_643:longitude , lat_641:latitude, textbox_1_635:date start, textbox_2_636:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "remarks_661" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_658" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_660" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_653" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_643" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_646" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_648" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_641" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_635" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_636" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //name_of_port_675, textarea_683:remarks ,textbox_680+m3_681:amount lost in  , categories_678:category,long_674:longitude , lat_673:latitude, textbox_1_666:date start, textbox_2_667:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_675" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textarea_683" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_680" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_681" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "categories_678" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_674" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_673" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "water_depth_676" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_666" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_667" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 39) {
                              if (
                                response.data[s].sectionId != null &&
                                response.data[s].sectionId != "" &&
                                response.data[s][key] != "" &&
                                sectionIdArray.length == 0
                              ) {
                                changeSectionIds = response.data[s].sectionId
                                  .toString()
                                  .split(",");
                                sectionIdArray = Array.from(
                                  new Set(changeSectionIds)
                                );

                                if (response.data[s].changeFields != null) {
                                  changeControlIds = response.data[
                                    s
                                  ].changeFields
                                    .toString()
                                    .split(",");
                                  changeControlArray = Array.from(
                                    new Set(changeControlIds)
                                  );
                                }
                              }

                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.garbegForm2 = 1;

                              if (p == 0) {
                                // '-':estimate amoutn inceinrated, '-':estimate amount discharged in (cm3) (textbox_3_586+m3_587):estimate amount discharged in reception , j_579:category,long_571:longitude, lat_570:latitude, textbox_1_566:date start, textbox_2_567:time start
                                if (
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_586" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_587" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "j_579" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_571" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_570" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() ==
                                  "textbox_1_566" ||
                                  key.toString().toLowerCase() ==
                                  "textbox_2_567"
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                //lat_689,long_690 : stop:lat_692,long_693 : textbox_3_695:remarks '-':estimate amoutn inceinrated, '(textbox_4_699+m3_700)':estimate amount discharged in cm3 ,'-':estimate amount discharged in reception facility, k_697:category,long_687:longitude , lat_686:latitude, textbox_1_633:date start
                                if (
                                  (key.toString().toLowerCase() == "lat_689" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_690" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_692" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_693" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_3_695" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_4_699" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_700" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "k_697" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_687" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_686" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_1_633" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "textbox_2_634" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                            }

                            if (formId == 47) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.blstForm = 1;

                              if (p == 0) {
                                // volume_of_uptake_902/m3_903/date_891 / time_892 / location_893/lat_894/long_895/depth_900/Volume_of_uptake_902/Name_of_port_896/reception_facility_name_898
                                if (
                                  (key.toString().toLowerCase() == "m3_903" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1091" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_896" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "date_891" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_892" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_893" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_894" ||
                                  (key.toString().toLowerCase() == "long_895" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "depth_900" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "estimated_volume_901" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_name_898" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_of_uptake_902" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                // Date_905/time_906/Volume_circulated_or_treated_908/m3_909
                                if (
                                  (key.toString().toLowerCase() == "date_905" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_906" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_circulated_or_treated_908" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_911" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_912" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1092" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_909" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                //date_914 / time_915/2_estimated_volume_923 /reception_facility_name_921/Name_of_port_919/location_916/lat_917/long_918/Volume_discharged_924/m3_925/remaining_volume_926/m3_927
                                if (
                                  (key.toString().toLowerCase() == "m3_927" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remaining_volume_926" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_925" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "date_914" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_915" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "reception_facility_name_921" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_916" &&
                                    response.data[s][key] != "") ||
                                  key.toString().toLowerCase() == "lat_917" ||
                                  (key.toString().toLowerCase() == "long_918" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "2_estimated_volume_923" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_919" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_929" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_930" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1093" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_discharged_924" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                //date_932/time_933/lat_935/long_936/date_938/time_939/lat_941/long_942/port/_944Name_of_port_945/Volume_discharged_947/m3_948/Volume_taken_up_949/m3_950
                                if (
                                  (key.toString().toLowerCase() == "date_932" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_933" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_935" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_936" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "date _938" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_939" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_941" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_942" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "port_944" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "location_of_discharge_940" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_945" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_discharge_947" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_948" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_taken_up_949" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_950" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_952" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_953" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "remark_1173" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                //date_955 / time_956 / port_958/Name_of_port_959/lat_960/long_961/Volume_964/m3_965/Circumstances_of_uptake_967/General_remarks_968
                                if (
                                  (key.toString().toLowerCase() == "date_955" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "time_956" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "port_958" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_of_port_959" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "lat_960" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_961" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "circumstances_of_uptake_967" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "general_remarks_968" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "long_961" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "m3_965" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "yes_970" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() == "no_971" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "volume_964" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                //operational_procedure_972/General_remarks_973
                                if (
                                  (key.toString().toLowerCase() ==
                                    "operational_procedure_972" &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "general_remarks_973" &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 48) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.oilnozoneForm = 1;

                              if (p == 1) {
                                // volume_of_uptake_902/m3_903/date_891 / time_892 / location_893/lat_894/long_895/depth_900/Volume_of_uptake_902/Name_of_port_896/reception_facility_name_898
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Date_of_Bunkering_975"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Deliver_note_Ref_No_976"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Supplier_978".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Supplier_979"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MARPOL_Sample_Seat_no_980"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Yes_982".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "No_983".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Supplier_checkbox_985"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_sample_destroyed_988"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 2) {
                                //Date_of_custody_transfer_993
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Deliver_note_ref_no_990"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "MARPOL_Sample_Seat_no_991"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_of_custody_transfer_992"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_custody_transfer_993"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reciever_name_994"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Reciever_Address_995"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Receiver_Contact_996"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Bunker_Delivery_Note_Ref_997"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_Name_998".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Delivery_Date_999"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_specification_1000"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_1001".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sulphur_1002".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_1003".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "t_1004".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Location_when_bunkered_1005"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Quantity_1007".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_No_1006".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "in_CO_to_LSF_1009"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date1_1010".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time1_1011".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1012".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1013".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1014".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Complete_CO_to_LSF_1015"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "DATE_1016".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "TIME_1017".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "POSITION_1018".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1019".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1020".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_1021".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank_1022".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_1023"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_1024".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Entry_1025"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1026".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1027".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1028".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1029".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1030".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Exit_1031"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1032".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1033".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1034".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1035".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1036".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Begin_CO_to_HSF_1037"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1038".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1039".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Position_1040".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1041".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1042".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Complete_CO_to_HSF_1043"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1044".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_1045".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Postion_1046".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1047".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1048".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fuel_Type_2_1049"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Tank2_1050".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_of_CO_2_1051"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "m3_2_1052".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "ODS_Name_1053".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_name_1054"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Capapcity_1055".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "kg_1056".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Recharge_1057".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Full_recharge_1058"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Partial_recharge_1059"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ODS_charged_mass_1060"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "kg1_1061".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Description_Of_repair_or_maintenanace_carried_out_1062"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Discharge_of_ODS_to_atmosphere_1063"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "State_1064".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Deliberate_1065"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Non-deliberate_1066"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Volume_of_LSF_after_completion_1023"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass_1067".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg3_1068".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Discharge_of_ods_to_shore_reception_facility_1069"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_reception_facility_1070"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Address_of_reception_facility_1071"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LAT_1029".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "LONG_1030".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Regulated_Area_Exit_1031"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass3_1072".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg3_1073".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ods_received_on_board_1074"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ODS_name_1075".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_name_1076".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_1077".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Mass5_1078".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Kg5_1079".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }
                          }
                        }
                      }
                    }

                    if (formId == 48) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Supplier_978".toString().toLowerCase()] !=
                        null &&
                        colsec1["yes_982".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_Bunkering_975".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Bunker_Deliver_note_Ref_No_976"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_Supplier_979".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Supplier_978".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Supplier_978".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Yes_982".toString().toLowerCase()] == null
                        ) {
                          colsec1["Yes_982".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_983".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_983".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Supplier_checkbox_985".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_sample_destroyed_988".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ],
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ],
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ],
                          colsec1["Yes_982".toString().toLowerCase()],
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ],
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["Supplier_978".toString().toLowerCase()] !=
                        null &&
                        colsec1["no_983".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_Bunkering_975".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Bunker_Deliver_note_Ref_No_976"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_Supplier_979".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Supplier_978".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Supplier_978".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ] = "";
                        }

                        if (
                          colsec1["Yes_982".toString().toLowerCase()] == null
                        ) {
                          colsec1["Yes_982".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_983".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_983".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Supplier_checkbox_985".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_sample_destroyed_988".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1[
                          "Date_of_Bunkering_975".toString().toLowerCase()
                          ],
                          colsec1[
                          "Bunker_Deliver_note_Ref_No_976"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "Name_of_Supplier_979".toString().toLowerCase()
                          ],
                          colsec1[
                          "MARPOL_Sample_Seat_no_980".toString().toLowerCase()
                          ],
                          colsec1["No_983".toString().toLowerCase()],
                          colsec1[
                          "Supplier_checkbox_985".toString().toLowerCase()
                          ],
                          colsec1[
                          "Date_sample_destroyed_988".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2[
                        "Bunker_Deliver_note_ref_no_990"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec2[
                        "Bunker_Deliver_note_ref_no_990"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec2[
                          "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Port_of_custody_transfer_992"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Port_of_custody_transfer_992"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Date_of_custody_transfer_993"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_of_custody_transfer_993"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Reciever_name_994".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Reciever_name_994".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Reciever_Address_995".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Reciever_Address_995".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Receiver_Contact_996".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Receiver_Contact_996".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection2.push([
                          colsec2[
                          "Bunker_Deliver_note_ref_no_990"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec2[
                          "MARPOL_Sample_Seat_no_991".toString().toLowerCase()
                          ],
                          colsec2[
                          "Port_of_custody_transfer_992"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec2[
                          "Date_of_custody_transfer_993"
                            .toString()
                            .toLowerCase()
                          ],

                          colsec2["Reciever_name_994".toString().toLowerCase()],
                          colsec2[
                          "Reciever_Address_995".toString().toLowerCase()
                          ],
                          colsec2[
                          "Receiver_Contact_996".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3[
                        "Bunker_Delivery_Note_Ref_997"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec3[
                        "Bunker_Delivery_Note_Ref_997"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec3["Port_Name_998".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Port_Name_998".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Delivery_Date_999".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Delivery_Date_999".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fuel_specification_1000".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fuel_specification_1000".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["Fuel_Type_1001".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Fuel_Type_1001".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Sulphur_1002".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Sulphur_1002".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["t_1003".toString().toLowerCase()] == null
                        ) {
                          colsec3["t_1003".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["t_1004".toString().toLowerCase()] == null
                        ) {
                          colsec3["t_1004".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "Location_when_bunkered_1005"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Location_when_bunkered_1005"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["Tank_No_1006".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Tank_No_1006".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Quantity_1007".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Quantity_1007".toString().toLowerCase()] =
                            "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection3.push([
                          colsec3[
                          "Bunker_Delivery_Note_Ref_997"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec3["Port_Name_998".toString().toLowerCase()] +
                          " " +
                          colsec3[
                          "Delivery_Date_999".toString().toLowerCase()
                          ],
                          //colsec3['Fuel_specification_1000'.toString().toLowerCase()] ,
                          colsec3["Fuel_Type_1001".toString().toLowerCase()],
                          //colsec3['Sulphur_1002'.toString().toLowerCase()] ,
                          colsec3["t_1003".toString().toLowerCase()],
                          //colsec3[   't_1004'.toString().toLowerCase()] ,
                          //colsec3['Location_when_bunkered_1005'.toString().toLowerCase()] ,
                          colsec3["Tank_No_1006".toString().toLowerCase()],
                          colsec3["Quantity_1007".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4["Date1_1010".toString().toLowerCase()] !=
                        null &&
                        colsec4["Date1_1010".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec4["Date1_1010".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date1_1010".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time1_1011".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time1_1011".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1012".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1012".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1013".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1013".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1014".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1014".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["DATE_1016".toString().toLowerCase()] == null
                        ) {
                          colsec4["DATE_1016".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["TIME_1017".toString().toLowerCase()] == null
                        ) {
                          colsec4["TIME_1017".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["POSITION_1018".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["POSITION_1018".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1019".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1019".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1020".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1020".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["Tank_1022".toString().toLowerCase()] == null
                        ) {
                          colsec4["Tank_1022".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Volume_of_LSF_after_completion_1023"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Volume_of_LSF_after_completion_1023"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Regulated_Area_Entry_1025".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Regulated_Area_Entry_1025".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1026".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1026".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1027".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1027".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1028".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1028".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1029".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1029".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1030".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1030".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Regulated_Area_Exit_1031".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Regulated_Area_Exit_1031".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1032".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1032".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1033".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1033".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1034".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1034".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1035".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1035".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1036".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1036".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Begin_CO_to_HSF_1037".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Begin_CO_to_HSF_1037".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1038".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1038".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1039".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1039".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Position_1040".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Position_1040".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["LAT_1041".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1041".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1042".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1042".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec4[
                          "Complete_CO_to_HSF_1043".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Complete_CO_to_HSF_1043".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["Date_1044".toString().toLowerCase()] == null
                        ) {
                          colsec4["Date_1044".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Time_1045".toString().toLowerCase()] == null
                        ) {
                          colsec4["Time_1045".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["Postion_1046".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec4["Postion_1046".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LAT_1047".toString().toLowerCase()] == null
                        ) {
                          colsec4["LAT_1047".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4["LONG_1048".toString().toLowerCase()] == null
                        ) {
                          colsec4["LONG_1048".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Fuel_Type_2_1049".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4["Fuel_Type_2_1049".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec4["Tank2_1050".toString().toLowerCase()] == null
                        ) {
                          colsec4["Tank2_1050".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec4[
                          "Volume_of_LSF_after_completion_of_CO_2_1051"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Volume_of_LSF_after_completion_of_CO_2_1051"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4["m3_2_1052".toString().toLowerCase()] == null
                        ) {
                          colsec4["m3_2_1052".toString().toLowerCase()] = "";
                        }

                        this.fSection4.push([
                          colsec4[
                          "in_CO_to_LSF_1009".toString().toLowerCase()
                          ] +
                          " " +
                          colsec4["Date1_1010".toString().toLowerCase()] +
                          " " +
                          colsec4["Time1_1011".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1012".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1013".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1014".toString().toLowerCase()],
                          //                                                                     colsec4['Complete_CO_to_LSF_1015'.toString().toLowerCase()] + ' ' +
                          colsec4["DATE_1016".toString().toLowerCase()] +
                          " " +
                          colsec4["TIME_1017".toString().toLowerCase()] +
                          " " +
                          colsec4["POSITION_1018".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1019".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1020".toString().toLowerCase()],
                          colsec4["Fuel_Type_1021".toString().toLowerCase()] +
                          " " +
                          colsec4["Tank_1022".toString().toLowerCase()] +
                          " " +
                          colsec4[
                          "Volume_of_LSF_after_completion_1023"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec4["m3_1024".toString().toLowerCase()],
                          //                                                                     colsec4['Regulated_Area_Entry_1025'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1026".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1027".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1028".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1029".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1030".toString().toLowerCase()],
                          "",
                          "",
                          //                                                                     colsec4['Regulated_Area_Exit_1031'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1032".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1033".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1034".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1035".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1036".toString().toLowerCase()],
                          //                                                                     colsec4['Begin_CO_to_HSF_1037'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1038".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1039".toString().toLowerCase()] +
                          " " +
                          colsec4["Position_1040".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1041".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1042".toString().toLowerCase()],
                          //                                                                     colsec4['Complete_CO_to_HSF_1043'.toString().toLowerCase()] + ' ' +
                          colsec4["Date_1044".toString().toLowerCase()] +
                          " " +
                          colsec4["Time_1045".toString().toLowerCase()] +
                          " " +
                          colsec4["Postion_1046".toString().toLowerCase()] +
                          " " +
                          colsec4["LAT_1047".toString().toLowerCase()] +
                          " " +
                          colsec4["LONG_1048".toString().toLowerCase()],
                          colsec4["Fuel_Type_2_1049".toString().toLowerCase()] +
                          " " +
                          colsec4["Tank2_1050".toString().toLowerCase()] +
                          " " +
                          colsec4[
                          "Volume_of_LSF_after_completion_of_CO_2_1051"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec4["m3_2_1052".toString().toLowerCase()],
                          "",
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec5[
                        "Equipment_name_1054".toString().toLowerCase()
                        ] != null &&
                        colsec5[
                        "Equipment_name_1054".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec5["ODS_Name_1053".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["ODS_Name_1053".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Equipment_name_1054".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Equipment_name_1054".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Capapcity_1055".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Capapcity_1055".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["kg_1056".toString().toLowerCase()] == null
                        ) {
                          colsec5["kg_1056".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5["Recharge_1057".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Recharge_1057".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Full_recharge_1058".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Full_recharge_1058".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Partial_recharge_1059".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Partial_recharge_1059".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ODS_charged_mass_1060".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ODS_charged_mass_1060".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["kg1_1061".toString().toLowerCase()] == null
                        ) {
                          colsec5["kg1_1061".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5[
                          "Description_Of_repair_or_maintenanace_carried_out_1062"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Description_Of_repair_or_maintenanace_carried_out_1062"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Discharge_of_ODS_to_atmosphere_1063"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Discharge_of_ODS_to_atmosphere_1063"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["State_1064".toString().toLowerCase()] == null
                        ) {
                          colsec5["State_1064".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Deliberate_1065".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Deliberate_1065".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5[
                          "Non-deliberate_1066".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Non-deliberate_1066".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Mass_1067".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass_1067".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Kg3_1068".toString().toLowerCase()] == null
                        ) {
                          colsec5["Kg3_1068".toString().toLowerCase()] = "";
                        }

                        if (
                          colsec5[
                          "Discharge_of_ods_to_shore_reception_facility_1069"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Discharge_of_ods_to_shore_reception_facility_1069"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Name_of_reception_facility_1070"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Name_of_reception_facility_1070"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "Address_of_reception_facility_1071"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "Address_of_reception_facility_1071"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["Mass3_1072".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass3_1072".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5[
                          "ods_received_on_board_1074"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ods_received_on_board_1074"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5["ODS_name_1075".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["ODS_name_1075".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["Port_name_1076".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec5["Port_name_1076".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec5["Date_1077".toString().toLowerCase()] == null
                        ) {
                          colsec5["Date_1077".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Mass5_1078".toString().toLowerCase()] == null
                        ) {
                          colsec5["Mass5_1078".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec5["Kg5_1079".toString().toLowerCase()] == null
                        ) {
                          colsec5["Kg5_1079".toString().toLowerCase()] = "";
                        }
                        this.fSection5.push([
                          colsec5["ODS_Name_1053".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Equipment_name_1054".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["Capapcity_1055".toString().toLowerCase()] +
                          " " +
                          colsec5["kg_1056".toString().toLowerCase()],
                          colsec5["Recharge_1057".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Full_recharge_1058".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Partial_recharge_1059".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "ODS_charged_mass_1060".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["kg1_1061".toString().toLowerCase()],
                          colsec5[
                          "Description_Of_repair_or_maintenanace_carried_out_1062"
                            .toString()
                            .toLowerCase()
                          ],
                          //                                                                        colsec5['Discharge_of_ODS_to_atmosphere_1063'.toString().toLowerCase()] + ' ' +
                          colsec5["State_1064".toString().toLowerCase()] +
                          " " +
                          colsec5[
                          "Deliberate_1065".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Non-deliberate_1066".toString().toLowerCase()
                          ] +
                          " " +
                          colsec5["Mass_1067".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg3_1068".toString().toLowerCase()],
                          //                                                                        colsec5['Discharge_of_ods_to_shore_reception_facility_1069'.toString().toLowerCase()] + ' ' +
                          colsec5[
                          "Name_of_reception_facility_1070"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec5[
                          "Address_of_reception_facility_1071"
                            .toString()
                            .toLowerCase()
                          ] +
                          " " +
                          colsec5["Mass3_1072".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg3_1073".toString().toLowerCase()],
                          //                                                                        colsec5['ods_received_on_board_1074'.toString().toLowerCase()] + ' ' +
                          colsec5["ODS_name_1075".toString().toLowerCase()] +
                          " " +
                          colsec5["Port_name_1076".toString().toLowerCase()] +
                          " " +
                          colsec5["Date_1077".toString().toLowerCase()] +
                          " " +
                          colsec5["Mass5_1078".toString().toLowerCase()] +
                          " " +
                          colsec5["Kg5_1079".toString().toLowerCase()],
                          "",
                        ]);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 47) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["lat_894"] != null &&
                        colsec1["lat_894"] != ""
                      ) {
                        if (colsec1["date_891"] == null) {
                          colsec1["date_891"] = "";
                        }
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["lat_894"] +
                          " " +
                          colsec1["long_895"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"], usersign
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["name_of_port_896"] != null &&
                        colsec1["name_of_port_896"] != ""
                      ) {
                        if (colsec1["date_891"] == null) {
                          colsec1["date_891"] = "";
                        }
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["name_of_port_896"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"], usersign
                        ]);
                        this.userSign.push(usersign);
                      } else if (
                        colsec1["reception_facility_name_898"] != null &&
                        colsec1["reception_facility_name_898"] != ""
                      ) {
                        if (colsec1["date_891"] == null) {
                          colsec1["date_891"] = "";
                        }
                        if (colsec1["time_892"] == null) {
                          colsec1["time_892"] = "";
                        }
                        if (colsec1["location_893"] == null) {
                          colsec1["location_893"] = "";
                        }
                        if (colsec1["long_895"] == null) {
                          colsec1["long_895"] = "";
                        }
                        if (colsec1["estimated_volume_901"] == null) {
                          colsec1["estimated_volume_901"] = "";
                        }
                        if (colsec1["depth_900"] == null) {
                          colsec1["depth_900"] = "";
                        }
                        if (colsec1["volume_of_uptake_902"] == null) {
                          colsec1["volume_of_uptake_902"] = "";
                        }
                        if (colsec1["remark_1091"] == null) {
                          colsec1["remark_1091"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.1",
                          colsec1["date_891"] +
                          " " +
                          colsec1["time_892"] +
                          " " +
                          colsec1["location_893"] +
                          " " +
                          colsec1["reception_facility_name_898"] +
                          " " +
                          colsec1["depth_900"] +
                          " " +
                          colsec1["estimated_volume_901"] +
                          " " +
                          colsec1["volume_of_uptake_902"] +
                          " " +
                          colsec1["m3_903"] +
                          " " +
                          colsec1["remark_1091"], usersign
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2["date_905"] != null &&
                        colsec2["date_905"] != ""
                      ) {
                        //Date_905/time_906/Volume_circulated_or_treated_908/m3_903
                        if (colsec2["date_905"] == null) {
                          colsec2["date_905"] = "";
                        }
                        if (colsec2["time_906"] == null) {
                          colsec2["time_906"] = "";
                        }
                        if (
                          colsec2["volume_circulated_or_treated_908"] == null
                        ) {
                          colsec2["volume_circulated_or_treated_908"] = "";
                        }
                        if (colsec2["m3_909"] == null) {
                          colsec2["m3_909"] = "";
                        }
                        if (colsec2["yes_911"] == null) {
                          colsec2["yes_911"] = "";
                        }
                        if (colsec2["no_912"] == null) {
                          colsec2["no_912"] = "";
                        }
                        if (colsec2["remark_1092"] == null) {
                          colsec2["remark_1092"] = "";
                        }

                        if (colsec2["no_912"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.2",
                            colsec2["date_905"] +
                            " " +
                            colsec2["time_906"] +
                            " " +
                            colsec2["volume_circulated_or_treated_908"] +
                            " " +
                            colsec2["m3_909"] +
                            " " +
                            colsec2["no_912"] +
                            " " +
                            colsec2["remark_1092"], usersign
                          ]);
                          this.userSign.push(usersign);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.2",
                            colsec2["date_905"] +
                            " " +
                            colsec2["time_906"] +
                            " " +
                            colsec2["volume_circulated_or_treated_908"] +
                            " " +
                            colsec2["m3_909"] +
                            " " +
                            colsec2["yes_911"] +
                            " " +
                            colsec2["remark_1092"], usersign
                          ]);
                          this.userSign.push(usersign);
                        }
                      }

                      if (
                        colsec3["lat_917"] != null &&
                        colsec3["lat_917"] != ""
                      ) {
                        //alert('lat');
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["lat_917"] +
                            " " +
                            colsec3["long_918"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["lat_917"] +
                            " " +
                            colsec3["long_918"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec3["name_of_port_919"] != null &&
                        colsec3["name_of_port_919"] != ""
                      ) {
                        //alert('name_of_port_919');
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["name_of_port_919"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["name_of_port_919"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec3["reception_facility_name_921"] != null &&
                        colsec3["reception_facility_name_921"] != ""
                      ) {
                        if (colsec3["date_914"] == null) {
                          colsec3["date_914"] = "";
                        }
                        if (colsec3["time_915"] == null) {
                          colsec3["time_915"] = "";
                        }
                        if (colsec3["location_916"] == null) {
                          colsec3["location_916"] = "";
                        }
                        if (colsec3["lat_917"] == null) {
                          colsec3["lat_917"] = "";
                        }
                        if (colsec3["long_918"] == null) {
                          colsec3["long_918"] = "";
                        }
                        if (colsec3["volume_discharged_924"] == null) {
                          colsec3["volume_discharged_924"] = "";
                        }
                        if (colsec3["remaining_volume_926"] == null) {
                          colsec3["remaining_volume_926"] = "";
                        }
                        if (colsec3["yes_929"] == null) {
                          colsec3["yes_929"] = "";
                        }
                        if (colsec3["no_930"] == null) {
                          colsec3["no_930"] = "";
                        }
                        if (colsec3["remark_1093"] == null) {
                          colsec3["remark_1093"] = "";
                        }
                        //alert('reception_facility_name_921');

                        if (colsec3["2_estimated_volume_923"] == null) {
                          colsec3["2_estimated_volume_923"] = "";
                        }

                        if (colsec3["no_930"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["reception_facility_name_921"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["no_930"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.3",
                            colsec3["date_914"] +
                            " " +
                            colsec3["time_915"] +
                            " " +
                            colsec3["location_916"] +
                            " " +
                            colsec3["reception_facility_name_921"] +
                            " " +
                            colsec3["volume_discharged_924"] +
                            " " +
                            colsec3["m3_925"] +
                            " " +
                            colsec3["remaining_volume_926"] +
                            " " +
                            colsec3["m3_927"] +
                            " " +
                            colsec3["yes_929"] +
                            " " +
                            colsec3["remark_1093"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4["lat_935"] != null &&
                        colsec4["lat_935"] != ""
                      ) {
                        if (colsec4["time_933"] == null) {
                          colsec4["time_933"] = "";
                        }
                        if (colsec4["date_932"] == null) {
                          colsec4["date_932"] = "";
                        }
                        if (colsec4["lat_935"] == null) {
                          colsec4["lat_935"] = "";
                        }
                        if (colsec4["date _938"] == null) {
                          colsec4["date _938"] = "";
                        }
                        if (colsec4["time_939"] == null) {
                          colsec4["time_939"] = "";
                        }
                        if (colsec4["long_936"] == null) {
                          colsec4["long_936"] = "";
                        }
                        if (colsec4["port_944"] == null) {
                          colsec4["port_944"] = "";
                        }
                        if (colsec4["location_of_discharge_940"] == null) {
                          colsec4["location_of_discharge_940"] = "";
                        }
                        if (colsec4["volume_discharge_947"] == null) {
                          colsec4["volume_discharge_947"] = "";
                        }
                        if (colsec4["name_of_port_945"] == null) {
                          colsec4["name_of_port_945"] = "";
                        }
                        if (colsec4["volume_taken_up_949"] == null) {
                          colsec4["volume_taken_up_949"] = "";
                        }
                        if (colsec4["yes_952"] == null) {
                          colsec4["yes_952"] = "";
                        }
                        if (colsec4["no_953"] == null) {
                          colsec4["no_953"] = "";
                        }
                        if (colsec4["remark_1173"] == null) {
                          colsec4["remark_1173"] = "";
                        }
                        if (colsec4["lat_941"] == null) {
                          colsec4["lat_941"] = "";
                        }
                        if (colsec4["long_942"] == null) {
                          colsec4["long_942"] = "";
                        }
                        if (colsec4["m3_948"] == null) {
                          colsec4["m3_948"] = "";
                        }
                        if (colsec4["m3_950"] == null) {
                          colsec4["m3_950"] = "";
                        }

                        //alert(colsec4['port_944'] + '=====' + colsec4['name_of_port_945'] )
                        if (colsec4["no_953"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " Location of uptake " +
                            colsec4["lat_935"] +
                            " " +
                            colsec4["long_936"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["no_953"] +
                            " " +
                            colsec4["remark_1173"], usersign
                          ]);
                        } else {
                          this.objcolsection.push();
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " Location of uptake " +
                            colsec4["lat_935"] +
                            " " +
                            colsec4["long_936"] +
                            " " +
                            colsec4["date_938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["yes_952"] +
                            " " +
                            colsec4["remark_1173"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      } else if (
                        colsec4["name_of_port_945"] != null &&
                        colsec4["name_of_port_945"] != ""
                      ) {
                        console.log("first-working");
                        if (colsec4["time_933"] == null) {
                          colsec4["time_933"] = "";
                        }
                        if (colsec4["date_932"] == null) {
                          colsec4["date_932"] = "";
                        }
                        if (colsec4["lat_935"] == null) {
                          colsec4["lat_935"] = "";
                        }
                        if (colsec4["date _938"] == null) {
                          colsec4["date _938"] = "";
                        }
                        if (colsec4["time_939"] == null) {
                          colsec4["time_939"] = "";
                        }
                        if (colsec4["long_936"] == null) {
                          colsec4["long_936"] = "";
                        }
                        if (colsec4["port_944"] == null) {
                          colsec4["port_944"] = "";
                        }
                        if (colsec4["location_of_discharge_940"] == null) {
                          colsec4["location_of_discharge_940"] = "";
                        }
                        if (colsec4["volume_discharge_947"] == null) {
                          colsec4["volume_discharge_947"] = "";
                        }
                        if (colsec4["name_of_port_945"] == null) {
                          colsec4["name_of_port_945"] = "";
                        }
                        if (colsec4["volume_taken_up_949"] == null) {
                          colsec4["volume_taken_up_949"] = "";
                        }
                        if (colsec4["yes_952"] == null) {
                          colsec4["yes_952"] = "";
                        }
                        if (colsec4["no_953"] == null) {
                          colsec4["no_953"] = "";
                        }
                        if (colsec4["remark_1173"] == null) {
                          colsec4["remark_1173"] = "";
                        }
                        if (colsec4["lat_941"] == null) {
                          colsec4["lat_941"] = "";
                        }
                        if (colsec4["long_942"] == null) {
                          colsec4["long_942"] = "";
                        }
                        if (colsec4["m3_948"] == null) {
                          colsec4["m3_948"] = "";
                        }
                        if (colsec4["m3_950"] == null) {
                          colsec4["m3_950"] = "";
                        }

                        if (colsec4["no_953"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["no_953"] +
                            " " +
                            colsec4["remark_1173"], usersign
                          ]);
                        } else {
                          console.log("second-working");
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.4",
                            colsec4["date_932"] +
                            " " +
                            colsec4["time_933"] +
                            " " +
                            colsec4["name_of_port_945"] +
                            " " +
                            colsec4["date _938"] +
                            " " +
                            colsec4["time_939"] +
                            " " +
                            colsec4["lat_941"] +
                            " " +
                            colsec4["long_942"] +
                            " " +
                            colsec4["port_944"] +
                            " " +
                            colsec4["location_of_discharge_940"] +
                            " " +
                            colsec4["volume_discharge_947"] +
                            " " +
                            colsec4["m3_948"] +
                            " " +
                            colsec4["volume_taken_up_949"] +
                            " " +
                            colsec4["m3_950"] +
                            " " +
                            colsec4["yes_952"] +
                            " " +
                            colsec4["remark_1173"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      }
                      if (
                        colsec5["lat_960"] != null &&
                        colsec5["lat_960"] != ""
                      ) {
                        if (colsec5["date_955"] == null) {
                          colsec5["date_955"] = "";
                        }
                        if (colsec5["time_956"] == null) {
                          colsec5["time_956"] = "";
                        }
                        if (colsec5["long_961"] == null) {
                          colsec5["long_961"] = "";
                        }
                        if (colsec5["volume_964"] == null) {
                          colsec5["volume_964"] = "";
                        }
                        if (colsec5["circumstances_of_uptake_967"] == null) {
                          colsec5["circumstances_of_uptake_967"] = "";
                        }
                        if (colsec5["general_remarks_968"] == null) {
                          colsec5["general_remarks_968"] = "";
                        }
                        if (colsec5["yes_970"] == null) {
                          colsec5["yes_970"] = "";
                        }
                        if (colsec5["no_971"] == null) {
                          colsec5["no_971"] = "";
                        }

                        if (colsec5["no_971"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["lat_960"] +
                            " " +
                            colsec5["long_961"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["no_971"], usersign
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["lat_960"] +
                            " " +
                            colsec5["long_961"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["yes_970"], usersign
                          ]);
                        }

                        this.userSign.push(usersign);
                      } else if (
                        colsec5["name_of_port_959"] != null &&
                        colsec5["name_of_port_959"] != ""
                      ) {
                        if (colsec5["date_955"] == null) {
                          colsec5["date_955"] = "";
                        }
                        if (colsec5["time_956"] == null) {
                          colsec5["time_956"] = "";
                        }
                        if (colsec5["long_961"] == null) {
                          colsec5["long_961"] = "";
                        }
                        if (colsec5["volume_964"] == null) {
                          colsec5["volume_964"] = "";
                        }
                        if (colsec5["circumstances_of_uptake_967"] == null) {
                          colsec5["circumstances_of_uptake_967"] = "";
                        }
                        if (colsec5["general_remarks_968"] == null) {
                          colsec5["general_remarks_968"] = "";
                        }
                        if (colsec5["port_958"] == null) {
                          colsec5["port_958"] = "";
                        }
                        if (colsec5["yes_970"] == null) {
                          colsec5["yes_970"] = "";
                        }
                        if (colsec5["no_971"] == null) {
                          colsec5["no_971"] = "";
                        }
                        if (colsec5["no_971"] != "") {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["port_958"] +
                            " " +
                            colsec5["name_of_port_959"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["no_971"], usersign
                          ]);
                        } else {
                          this.objcolsection.push([
                            year + "-" + month + "-" + day,
                            "3.5",
                            colsec5["date_955"] +
                            " " +
                            colsec5["time_956"] +
                            " " +
                            colsec5["port_958"] +
                            " " +
                            colsec5["name_of_port_959"] +
                            " " +
                            colsec5["volume_964"] +
                            " " +
                            colsec5["m3_965"] +
                            " " +
                            colsec5["circumstances_of_uptake_967"] +
                            " " +
                            colsec5["general_remarks_968"] +
                            " " +
                            colsec5["yes_970"], usersign
                          ]);
                        }
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec6["operational_procedure_972"] != null &&
                        colsec6["operational_procedure_972"] != ""
                      ) {
                        if (colsec6["operational_procedure_972"] == null) {
                          colsec6["operational_procedure_972"] = "";
                        }
                        if (colsec6["general_remarks_973"] == null) {
                          colsec6["general_remarks_973"] = "";
                        }

                        this.objcolsection.push([
                          year + "-" + month + "-" + day,
                          "3.6",
                          colsec6["operational_procedure_972"] +
                          " " +
                          colsec6["general_remarks_973"], usersign
                        ]);
                        this.userSign.push(usersign);
                      }
                    }
                    console.log("check-colsection-47", this.objcolsection);

                    if (formId == 38) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      //this.in_array(colsec1,'<b>')
                      //Port_580,Facility_581,Name_of_ship_582
                      if (colsec1["long_578"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }
                        if (colsec1["lat_576"] == null) {
                          colsec1["lat_576"] = "";
                        }
                        if (colsec1["long_578"] == null) {
                          colsec1["long_578"] = "";
                        }
                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        //if(colsec1['remarks_596']==null){colsec1['remarks_596']="";}
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        var arr = [
                          colsec1["textbox_1_562"] +
                          " " +
                          colsec1["textbox_2_563"],
                          colsec1["lat_576"] + " " + colsec1["long_578"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"],
                        ];
                        this.objcolsection.push(arr);

                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["port_580"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["port_580"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"], usersign
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["facility_581"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["facility_581"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"], usersign
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec1["name_of_ship_582"] != null) {
                        if (colsec1["textbox_1_562"] == null) {
                          colsec1["textbox_1_562"] = "";
                        }
                        if (colsec1["textbox_2_563"] == null) {
                          colsec1["textbox_2_563"] = "";
                        }

                        if (colsec1["categories_585"] == null) {
                          colsec1["categories_585"] = "";
                        }
                        if (colsec1["textbox_589"] == null) {
                          colsec1["textbox_589"] = "";
                        }
                        if (colsec1["remarks_1094"] == null) {
                          colsec1["remarks_1094"] = "";
                        }

                        this.objcolsection.push([
                          colsec1["textbox_1_562"] +
                          "," +
                          colsec1["textbox_2_563"],
                          colsec1["name_of_ship_582"],
                          colsec1["categories_585"],
                          "-",
                          colsec1["textbox_589"] + " " + colsec1["m3_590"],
                          "-",
                          colsec1["remarks_1094"], usersign
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec2["lat_610"] != null) {
                        if (colsec2["textbox_1_593"] == null) {
                          colsec2["textbox_1_593"] = "";
                        }
                        if (colsec2["textbox_2_594"] == null) {
                          colsec2["textbox_2_594"] = "";
                        }
                        if (colsec2["textbox_3_599"] == null) {
                          colsec2["textbox_3_599"] = "";
                        }
                        if (colsec2["textbox_4_601"] == null) {
                          colsec2["textbox_4_601"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["textbox_3_695"] == null) {
                          colsec2["textbox_3_695"] = "";
                        }
                        if (colsec2["lat_610"] == null) {
                          colsec2["lat_610"] = "";
                        }
                        if (colsec2["long_612"] == null) {
                          colsec2["long_612"] = "";
                        }
                        if (colsec2["lat_616"] == null) {
                          colsec2["lat_616"] = "";
                        }
                        if (colsec2["long_617"] == null) {
                          colsec2["long_617"] = "";
                        }
                        if (colsec2["textbox_626"] == null) {
                          colsec2["textbox_626"] = "0.00";
                        }
                        // this.objcolsection.push(['Start ' + colsec2['textbox_1_593']+' '+
                        // colsec2['textbox_2_594']+' Stop '+colsec2['textbox_3_599']+' '+
                        // colsec2['textbox_4_601'],' Start ' + colsec2['lat_610']+' '+
                        // colsec2['long_612']+' Start Time '+ colsec2['textbox_2_634'] + ' Stop ' + colsec2['lat_616']+' '+colsec2['long_617'] + ' Stop Time ' + colsec2['textbox_3_695'],
                        // colsec2['categories_622'],'-','-', colsec2['textbox_626']+' '+
                        // colsec2['m3_628'],colsec2['remarks_630']]);
                        this.objcolsection.push([
                          "Start " +
                          colsec2["textbox_1_593"] +
                          " " +
                          colsec2["textbox_2_594"] +
                          " Stop " +
                          colsec2["textbox_3_599"] +
                          " " +
                          colsec2["textbox_4_601"],
                          " Start " +
                          colsec2["lat_610"] +
                          " " +
                          colsec2["long_612"] +
                          //+' Start Time '+ colsec2['textbox_2_634']
                          " Stop " +
                          colsec2["lat_616"] +
                          " " +
                          colsec2["long_617"],
                          //' Stop Time ' + colsec2['textbox_3_695'],
                          colsec2["categories_622"],
                          "-",
                          "-",
                          colsec2["textbox_626"] + " " + colsec2["m3_628"],
                          colsec2["remarks_630"], usersign
                        ]);
                        colsec2 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec3["lat_641"] != null) {
                        if (colsec3["m3_660"] == null) {
                          colsec3["m3_660"] = "";
                        }
                        if (colsec3["textbox_1_635"] == null) {
                          colsec3["textbox_1_635"] = "";
                        }
                        if (colsec3["textbox_2_636"] == null) {
                          colsec3["textbox_2_636"] = "";
                        }
                        if (colsec3["lat_641"] == null) {
                          colsec3["lat_641"] = "";
                        }
                        if (colsec3["textbox_658"] == null) {
                          colsec3["textbox_658"] = "0.00";
                        }
                        if (colsec3["remarks_661"] == null) {
                          colsec3["remarks_661"] = "";
                        }
                        if (colsec3["long_643"] == null) {
                          colsec3["long_643"] = "";
                        }
                        if (colsec3["lat_646"] == null) {
                          colsec3["lat_646"] = "";
                        }
                        if (colsec3["long_648"] == null) {
                          colsec3["long_648"] = "";
                        }

                        this.objcolsection.push([
                          colsec3["textbox_1_635"] +
                          " " +
                          colsec3["textbox_2_636"],
                          " Start " +
                          colsec3["lat_641"] +
                          " " +
                          colsec3["long_643"] +
                          " Stop " +
                          colsec3["lat_646"] +
                          " " +
                          colsec3["long_648"],
                          colsec3["categories_653"],
                          colsec3["textbox_658"] + " " + colsec3["m3_660"],
                          "-",
                          "-",
                          colsec3["remarks_661"], usersign
                        ]);
                        colsec3 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec4["long_674"] != null) {
                        if (colsec4["textbox_1_666"] == null) {
                          colsec4["textbox_1_666"] = "";
                        }
                        if (colsec4["textbox_2_667"] == null) {
                          colsec4["textbox_2_667"] = "";
                        }
                        if (colsec4["lat_673"] == null) {
                          colsec4["lat_673"] = "";
                        }
                        if (colsec4["long_674"] == null) {
                          colsec4["long_674"] = "";
                        }
                        if (colsec4["water_depth_676"] == null) {
                          colsec4["water_depth_676"] = "";
                        }
                        if (colsec4["textbox_680"] == null) {
                          colsec4["textbox_680"] = "";
                        }
                        if (colsec4["textarea_683"] == null) {
                          colsec4["textarea_683"] = "0.00";
                        }
                        if (colsec4["m3_681"] == null) {
                          colsec4["m3_681"] = "";
                        }

                        if (colsec4["water_depth_676"] == "") {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["lat_673"] + " " + colsec4["long_674"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        } else {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["lat_673"] +
                            " " +
                            colsec4["long_674"] +
                            " " +
                            "Water Depth " +
                            colsec4["water_depth_676"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"], usersign
                          ]);
                        }

                        colsec4 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec4["name_of_port_675"] != null) {
                        if (colsec4["textbox_1_666"] == null) {
                          colsec4["textbox_1_666"] = "";
                        }
                        if (colsec4["textbox_2_667"] == null) {
                          colsec4["textbox_2_667"] = "";
                        }

                        if (colsec4["textbox_680"] == null) {
                          colsec4["textbox_680"] = "";
                        }
                        if (colsec4["textarea_683"] == null) {
                          colsec4["textarea_683"] = "0.00";
                        }
                        if (colsec4["m3_681"] == null) {
                          colsec4["m3_681"] = "";
                        }
                        if (colsec4["water_depth_676"] == null) {
                          colsec4["water_depth_676"] = "";
                        }

                        if (colsec4["water_depth_676"] == "") {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["name_of_port_675"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"],
                          ]);
                        } else {
                          this.objcol.push([
                            colsec4["textbox_1_666"] +
                            " " +
                            colsec4["textbox_2_667"],
                            colsec4["name_of_port_675"] +
                            " " +
                            "Water Depth " +
                            colsec4["water_depth_676"],
                            colsec4["categories_678"],
                            colsec4["textbox_680"] + " " + colsec4["m3_681"],
                            colsec4["textarea_683"], usersign
                          ]);
                        }

                        colsec4 = [];
                        this.userSign.push(usersign);
                      }
                    }
                    if (formId == 39) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var time = date.getHours() + ":" + date.getMinutes();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var fullDate =
                          year + "-" + month + "-" + day + " " + time;

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }
                      //this.in_array(colsec1,'<b>')
                      if (colsec1["j_579"] != null) {
                        var placcombintaion = "";
                        if (colsec1["textbox_1_566"] == null) {
                          colsec1["textbox_1_566"] = "";
                        }
                        if (colsec1["textbox_2_567"] == null) {
                          colsec1["textbox_2_567"] = "";
                        }
                        if (colsec1["lat_570"] == null) {
                          colsec1["lat_570"] = "";
                        }
                        if (colsec1["long_571"] == null) {
                          colsec1["long_571"] = "";
                        }
                        if (colsec1["j_579"] == null) {
                          colsec1["j_579"] = "";
                        }
                        if (colsec1["textbox_3_586"] == null) {
                          colsec1["textbox_3_586"] = "0.00";
                        }
                        this.objcolsection.push([
                          colsec1["textbox_1_566"] +
                          " " +
                          colsec1["textbox_2_567"],
                          colsec1["lat_570"] + " " + colsec1["long_571"],
                          colsec1["j_579"],
                          "-",
                          colsec1["textbox_3_586"] + " " + colsec1["m3_587"],
                          "-", usersign
                        ]);
                        colsec1 = [];
                        this.userSign.push(usersign);
                      }

                      if (colsec2["k_697"] != null) {
                        if (colsec2["textbox_1_633"] == null) {
                          colsec2["textbox_1_633"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["lat_686"] == null) {
                          colsec2["lat_686"] = "";
                        }
                        if (colsec2["long_687"] == null) {
                          colsec2["long_687"] = "";
                        }
                        if (colsec2["k_697"] == null) {
                          colsec2["k_697"] = "";
                        }
                        if (colsec2["lat_689"] == null) {
                          colsec2["lat_689"] = "";
                        }
                        if (colsec2["long_690"] == null) {
                          colsec2["long_690"] = "";
                        }
                        if (colsec2["textbox_2_634"] == null) {
                          colsec2["textbox_2_634"] = "";
                        }
                        if (colsec2["lat_692"] == null) {
                          colsec2["lat_692"] = "";
                        }
                        if (colsec2["long_693"] == null) {
                          colsec2["long_693"] = "";
                        }
                        if (colsec2["textbox_3_695"] == null) {
                          colsec2["textbox_3_695"] = "";
                        }

                        this.objcolsection.push([
                          colsec2["textbox_1_633"] +
                          " " +
                          colsec2["textbox_2_634"],
                          colsec2["lat_686"] + " " + colsec2["long_687"],
                          colsec2["k_697"],
                          colsec2["textbox_4_699"],
                          "-",
                          "start " +
                          colsec2["lat_689"] +
                          " " +
                          colsec2["long_690"] +
                          " " +
                          colsec2["textbox_2_634"] +
                          " \nstop " +
                          colsec2["lat_692"] +
                          " " +
                          colsec2["long_693"] +
                          " " +
                          colsec2["textbox_3_695"], usersign
                        ]);
                        colsec2 = [];
                        this.userSign.push(usersign);
                      }
                    }
                  }

                  console.log("mylog::mylog");
                  console.log(this.objcolsection);
                  this.createCollectionLayout(this.objcolsection);
                  this.createCollectionLayout(this.objcol);
                  console.log(this.objcol);
                  console.log(this.userSign);
                  if (
                    this.fSection1.length > 0 ||
                    this.fSection5.length > 0 ||
                    this.fSection2.length > 0 ||
                    this.fSection3.length > 0 ||
                    this.fSection4.length > 0
                  ) {
                    this.createCollectionLayout(this.fSection1);
                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                  }
                  console.log(this.objcolcollection);
                }
                //console.log(this.formDetails);
              }
            );
          }
        }

        console.log(this.formCount);
      }
    }
  }

  logValue(val: any, rowIndex: number, colIndex: number): any {
    console.log(`Row ${rowIndex}, column ${colIndex}: Value being passed to innerHTML`, val);
    return val;
  }
  createCollectionLayout(collection){
    console.log("====collection===1111111111111", this.objcolsection);
  }

  createCollectionLayout11(collection) {
    console.log("====collection===", collection);

    // Helper function to clean <b> and <strike> tags
    const cleanTags = (value, tag) => {
      const regex = new RegExp(`<${tag}>.*?<\\/${tag}>`, "gi");
      return value.replace(regex, '');
    };

    for (let key in collection) {
      for (let pey in collection[key]) {
        let oldValue = collection[key][pey];
        let newValue = oldValue;

        // Proceed if the value contains <b> tag
        // if (oldValue != null && oldValue.indexOf("<b>") !== -1) {
          if (typeof oldValue === 'string' && oldValue.indexOf("<b>") !== -1) {

            console.log("explodedArrayOld11", oldValue, newValue);
          let oldValueCopy = cleanTags(oldValue, 'b'); // Remove <b> tags
          let newValueCopy = cleanTags(newValue, 'strike'); // Remove <strike> tags
          console.log("explodedArrayOld21", oldValueCopy, newValueCopy);

          // Check if oldValue and newValue are different after cleaning
          if (oldValueCopy !== newValueCopy) {
            let randomNum = Math.floor(Math.random() * 10000) + 1;
            console.log("randomNum", randomNum);

            console.log("oldValue11", oldValueCopy);
            let oldValue1 = oldValueCopy.replace(/<strike>/gi, '<strike class="strike">');
            console.log("oldValue22", oldValue1);
            let oldValue2 = oldValue1.split("=>");
            let oldValue3 = oldValue2[0] ? oldValue2[0] : oldValue1;
            let oldTimeValue = oldValue2[1] ? oldValue2[1] : '';

            let oldValue4 = oldValue3.split("####");
            console.log("oldValue333", oldValue4);
            let oldData = oldValue4[0] ? oldValue4[0] : '';

            console.log("newValue11", newValueCopy);
            let newValue1 = newValueCopy.split("=>");
            let newValue2 = newValue1[0] ? newValue1[0] : newValueCopy;
            let newTimeValue = newValue1[1] ? newValue1[1] : '';
            let newValue3 = newValue2.split("####");
            console.log("newValue22", newValue3);

            let latestData = newValue3[0] ? newValue3[0] : '';
            let editedOn = newValue3[3] ? `<b>Edited On</b>: ${newValue3[3]}<br>` : '';
            let editBy = newValue3[2] ? `<b>Edited By</b>: ${newValue3[2]}<br>` : '';
            let editReason = newValue3[1] ? `<b>Reason</b>: ${newValue3[1]}` : '';

            let rawVal = `
            <div class="box-edit-top">${oldData} ${oldTimeValue}</strike></div>
            <div class="box-edit-message">
              ${latestData} ${newTimeValue}
              ${editReason !== '' ? `
                <div>
                  <div style="margin-top: 10px;">
                    <span class="box-edit-time">${editedOn} ${editBy} ${editReason}</span>
                  </div>
                </div>
              ` : ''}
            </div>
          `;

            // Raw value with the edited information
          //   let rawVal = `
          //   <div class="box-edit-top">${oldData} ${oldTimeValue}</strike></div>
          //   <div class="box-edit-message">
          //     ${latestData} ${newTimeValue}
          //     ${editReason !== '' ? `
          //       <span onclick="displayedit(event, ${randomNum})"
          //         style="float: right; cursor: pointer; font-size: 10px; color: blue;">
          //         View More
          //       </span>
          //       <div class="popover" id="cview_${randomNum}" style="display: none;">
          //         <div style="display: flex; justify-content: space-between; align-items: center;">
          //           <h3 style="margin: 0; text-align: center !important; width: 100%; font-weight: bold;">
          //             <u>Edit Log</u>
          //           </h3>
          //           <button class="close-btn" onclick="closePopover(${randomNum})"
          //             style="font-size: 18px; background: none; border: none; cursor: pointer;">
          //             &times;
          //           </button>
          //         </div>
          //         <div style="margin-top: 10px;">
          //           <span class="box-edit-time">${editedOn} ${editBy} ${editReason}</span>
          //         </div>
          //       </div>
          //     ` : ''}
          //   </div>
          // `;

            collection[key][pey] = this.sanitizer.bypassSecurityTrustHtml(rawVal);
          }
        }
      }
    }

    console.log("after html pop", collection);
  }


 closePopover(id) {
    document.getElementById('cview_'+id).style.display = 'none';
  }

  displayedit(event: MouseEvent, displayId: any) {
    const popovers = document.querySelectorAll('.popover');
    popovers.forEach(el => {
      if (el) el.setAttribute('style', 'display: none');
    });
    setTimeout(() => {
      const el = document.getElementById('cview_' + displayId);
      if (el) el.setAttribute('style', 'display: block');
      if (el) el.style.top = '50%'; // vertical position
      if (el) el.style.left = '50%'; // horizontal position
      if (el) el.style.padding = '10px'; // horizontal position
    }, 200); // 2000 milliseconds = 2 seconds
  }

  callHTypeAudit(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 42 || hid == 43) {
    } else {
      console.log("not found");
      return;
    }

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          var formId = this.formBuilder[i].formbuilderresponse[r].formId;
          if ((formId == 40 && hid == 42) || (formId == 41 && hid == 43)) {
            //alert(this.formBuilder[i].formbuilderresponse[r].formName + ' form Id' + formId );
            this.formCount.push(
              this.formBuilder[i].formbuilderresponse[r].formName
            );
            this.formBuilderSections = [];
            for (
              var u = 0;
              u <
              this.formBuilder[i].formbuilderresponse[r]
                .formbuildersectionnamelist.length;
              u++
            ) {
              this.formBuilderSections.push(
                this.formBuilder[i].formbuilderresponse[r]
                  .formbuildersectionnamelist[u]
              ); //.formbuilderlist
            }

            this.objcolsection = [];
            this.objcol = [];
            this.loading=true;
            this.reportsService.getFormDetailsByActionDateAndTime(
              formId,
              this.voyageNo,
              actionDate,
              actionTime,
              fromDate,
              toDate,
              (formResponse) => {
                this.loading=false;
                console.log('==formResponse1==', formResponse);
                let newData = formResponse.map((item) => {
                  if (item && item.data && item.data[0].formId) {
                    if (item.data && item.data[0].formId) {
                      let itemId = {
                        // [item.data[0].formId] : item.data[0]._id['$oid']
                        [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                      };
                      return item.data && item.data[0].formId && itemId;
                    }
                    return item && item;
                  }
                });

                const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
                this.formIdObject = mergedObject;
                // console.log('FormIdObject_List_4', this.formIdObject);

                console.log('==formResponse[0]1==', formResponse[0]);
                var response = this.modifyedData(formResponse[0]);

                console.log('==response1==', response);
                if (response.data != null) {
                  this.userSign = [];
                  for (var s = 0; s < response.data.length; s++) {
                    if (response.data[s].isDelete == "1") continue;
                    var findKey = false;
                    var sectionName = "";
                    this.formDetails = [];
                    var colsec1 = [];
                    var colsec2 = [];
                    var colsec3 = [];
                    var colsec4 = [];
                    var colsec5 = [];
                    var colsec6 = [];
                    var coldate = [];
                    this.showpop1 = 0;
                    this.showpop2 = 0;
                    var usersign = "";
                    this.editedBy = "";
                    var signdate = "";
                    var masterName = "";
                    var masterSignature = "";
                    var roleId = "";
                    var roleName = "";
                    var id = "";
                    if (response.data[s].editedBy != null) {
                      this.editedBy = response.data[s].editedBy;
                    }
                    usersign = response.data[s].userSign;

                    for (let key in response.data[s]) {
                      for (
                        var p = 0;
                        p < this.formBuilderSections.length;
                        p++
                      ) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //console.log(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response.data[s][key] != ""
                          ) {
                            coldate["date_created"] = response.data[s][key];
                            coldate["section_length"] =
                              this.formBuilderSections.length;
                          }
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase()
                          ) {
                            //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase());
                            sectionName =
                              this.formBuilderSections[p].sectionName;

                            if (formId == 41) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.auditform = 2;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Rank_759".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_officer_760"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Certificate_761"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_joining_762"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "officers_date_of_joining_763"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "code_no_764".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "name_765".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "SIB_No_766".toString().toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "crew_name_767".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_rank_768".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_place_769".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_date_770".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "crew_reason_771"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }

                            if (formId == 40) {
                              if (
                                response.data[s].date != null &&
                                response.data[s].date != ""
                              ) {
                                signdate = response.data[s].date;
                              }

                              if (
                                response.data[s].masterName != null &&
                                response.data[s].masterName != ""
                              ) {
                                masterName = response.data[s].masterName;
                              }

                              if (
                                response.data[s].masterSignature != null &&
                                response.data[s].masterSignature != ""
                              ) {
                                masterSignature =
                                  response.data[s].masterSignature;
                              }

                              if (
                                response.data[s].roleId != null &&
                                response.data[s].roleId != ""
                              ) {
                                roleId = response.data[s].roleId;
                              }

                              if (
                                response.data[s].roleName != null &&
                                response.data[s].roleName != ""
                              ) {
                                roleName = response.data[s].roleName;
                              }
                              if (
                                response.data[s]._id.$oid != null &&
                                response.data[s]._id.$oid != ""
                              ) {
                                id = response.data[s]._id.$oid;
                              }

                              this.masterSignature = masterSignature;
                              this.signdate = signdate;
                              this.roleName = roleName;
                              this.masterName = masterName;
                              this.id = id;
                              this.formId = formId;

                              this.auditform = 1;
                              //alert('hi')

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Participants_704"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Drill_Date_702".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Drill_Description_703"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 1) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Date_Time_of_Departure_705"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_Departure_706"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Time_of_departure_707"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Port_708".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Name_of_Port_709"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_710".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_Fwd_711".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Draft_Alt_712".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Actual_Freeboard_Amidships_713"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidship_port_714"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidship_stbd_715"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Amidships_mean_716"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Density_of_water_717"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Allowance_for_density_718"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec2[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                              }
                              //
                              if (p == 2) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Inspections_have_been_carried_out_719"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Equipment_720".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Date_of_equipment_721"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Firemens_outfits_722"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fire_extinguishers_723"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Fire_hydrants_724"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Hoses_and_nozzles_725"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "correct_position_726"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "position_date_727"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_pumps_operated_728"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "pumps_729".toString().toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "free_from_leakage_730"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_extinguishing_installation_731"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_732"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec3[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 3) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Test_and_inspections_733"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "survival_craft_734"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "survival_craft_date_735"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_and_rescue_boats_736"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_and_rescue_boats_date_737"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lifeboats_moved_738"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Lifeboats_moved_date_739"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "emergency_alarm_740"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "emergency_alarm_date_741"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_742"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec4[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 4) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "test_and_inspections_743"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_turned_744"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "lifeboats_turned_date_745"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ispection_of_immersion_746"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ispection_of_immersion_date_747"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Remarks_748"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec5[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }

                              if (p == 5) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "inspections_examinations_749"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Internation_shore_connection_750"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "shore_connection_date_751"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_fighting_equipment_752"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_fighting_equipment_date_753"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "fire_doors_and_dampers_754"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "doors_dampers_date_755"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bottle_connections_756"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Bottle_connections_date_757"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "examination_and_inspection_remarks_758"
                                      .toString()
                                      .toLowerCase() &&
                                    response.data[s][key] != "")
                                ) {
                                  colsec6[key.toString().toLowerCase()] =
                                    response.data[s][key];
                                }
                                //
                              }
                            }
                          }
                        }
                      }
                    }

                    if (formId == 41) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Rank_759".toString().toLowerCase()] != null &&
                        colsec1["Rank_759".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Name_of_officer_760".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_officer_760".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Certificate_761".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Certificate_761".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_joining_762".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_joining_762".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "officers_date_of_joining_763"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1["Rank_759".toString().toLowerCase()],
                          colsec1[
                          "Name_of_officer_760".toString().toLowerCase()
                          ],
                          colsec1["Certificate_761".toString().toLowerCase()],
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1[
                          "officers_date_of_joining_763"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2["code_no_764".toString().toLowerCase()] !=
                        null &&
                        colsec2["code_no_764".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec2["name_765".toString().toLowerCase()] == null
                        ) {
                          colsec2["name_765".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["SIB_No_766".toString().toLowerCase()] == null
                        ) {
                          colsec2["SIB_No_766".toString().toLowerCase()] = "";
                        }

                        this.fSection2.push([
                          colsec2["code_no_764".toString().toLowerCase()],
                          colsec2["name_765".toString().toLowerCase()],
                          colsec2["SIB_No_766".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3["crew_name_767".toString().toLowerCase()] !=
                        null &&
                        colsec3["crew_name_767".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec3["crew_rank_768".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_rank_768".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_place_769".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_place_769".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_date_770".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_date_770".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["crew_reason_771".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["crew_reason_771".toString().toLowerCase()] =
                            "";
                        }

                        this.fSection3.push([
                          colsec3["crew_name_767".toString().toLowerCase()],
                          colsec3["crew_rank_768".toString().toLowerCase()],
                          colsec3["crew_place_769".toString().toLowerCase()],
                          colsec3["crew_date_770".toString().toLowerCase()],
                          colsec3["crew_reason_771".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 40) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                        ]);
                      }

                      if (
                        colsec1["Drill_Date_702".toString().toLowerCase()] !=
                        null &&
                        colsec1["Drill_Date_702".toString().toLowerCase()] != ""
                      ) {
                        if (
                          colsec1[
                          "Participants_704".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Participants_704".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Drill_Date_702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Drill_Date_702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Drill_Description_703".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Drill_Description_703".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection1.push([
                          colsec1["Drill_Date_702".toString().toLowerCase()],
                          colsec1[
                          "Drill_Description_703".toString().toLowerCase()
                          ],
                          colsec1["Participants_704".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec2[
                        "Date_Time_of_Departure_705".toString().toLowerCase()
                        ] != null &&
                        colsec2[
                        "Date_Time_of_Departure_705".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec2[
                          "Date_Time_of_Departure_705"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_Time_of_Departure_705"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Date_of_Departure_706".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Date_of_Departure_706".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Time_of_departure_707".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Time_of_departure_707".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Name_of_Port_709".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["Name_of_Port_709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["Draft_Fwd_711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["Draft_Fwd_711".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["Draft_Alt_712".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["Draft_Alt_712".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2[
                          "Actual_Freeboard_Amidships_713"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Actual_Freeboard_Amidships_713"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidship_port_714".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidship_port_714".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidship_stbd_715".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidship_stbd_715".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Amidships_mean_716".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Amidships_mean_716".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Density_of_water_717".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Density_of_water_717".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2[
                          "Allowance_for_density_718".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "Allowance_for_density_718".toString().toLowerCase()
                          ] = "";
                        }

                        this.fSection2.push([
                          colsec2[
                          "Date_of_Departure_706".toString().toLowerCase()
                          ] +
                          " " +
                          colsec2[
                          "Time_of_departure_707".toString().toLowerCase()
                          ],
                          colsec2["Port_708".toString().toLowerCase()],
                          //colsec2['Name_of_Port_709'.toString().toLowerCase()] ,
                          colsec2["Draft_Fwd_711".toString().toLowerCase()],
                          colsec2["Draft_Alt_712".toString().toLowerCase()],
                          //colsec2['Actual_Freeboard_Amidships_713'.toString().toLowerCase()]  ,
                          colsec2["Amidship_port_714".toString().toLowerCase()],
                          colsec2["Amidship_stbd_715".toString().toLowerCase()],
                          colsec2[
                          "Amidships_mean_716".toString().toLowerCase()
                          ],
                          colsec2[
                          "Density_of_water_717".toString().toLowerCase()
                          ],
                          colsec2[
                          "Allowance_for_density_718".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                      }

                      if (
                        colsec3[
                        "Inspections_have_been_carried_out_719"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec3[
                        "Inspections_have_been_carried_out_719"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec3["Equipment_720".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Equipment_720".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Date_of_equipment_721".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Date_of_equipment_721".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Firemens_outfits_722".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Firemens_outfits_722".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fire_extinguishers_723".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fire_extinguishers_723".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Fire_hydrants_724".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Fire_hydrants_724".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "Hoses_and_nozzles_725".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Hoses_and_nozzles_725".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "correct_position_726".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "correct_position_726".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "position_date_727".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Location_when_bunkered_1005"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "fire_pumps_operated_728".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "fire_pumps_operated_728".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["pumps_729".toString().toLowerCase()] == null
                        ) {
                          colsec3["pumps_729".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3[
                          "free_from_leakage_730".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "free_from_leakage_730".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "fire_extinguishing_installation_731"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "fire_extinguishing_installation_731"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3[
                          "General_Remarks_732".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "General_Remarks_732".toString().toLowerCase()
                          ] = "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection3.push([
                          colsec3["Equipment_720".toString().toLowerCase()] +
                          " " +
                          colsec3[
                          "Firemens_outfits_722".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Fire_extinguishers_723".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Fire_hydrants_724".toString().toLowerCase()
                          ] +
                          " " +
                          colsec3[
                          "Hoses_and_nozzles_725".toString().toLowerCase()
                          ],
                          colsec3[
                          "Date_of_equipment_721".toString().toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          +" " +
                          colsec3[
                          "correct_position_726".toString().toLowerCase()
                          ],
                          colsec3["position_date_727".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          colsec3[
                          "fire_pumps_operated_728".toString().toLowerCase()
                          ],
                          colsec3["pumps_729".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          colsec3[
                          "free_from_leakage_730".toString().toLowerCase()
                          ],
                          //+ ' ' + colsec3['fire_extinguishing_installation_731'.toString().toLowerCase()]
                          //+ ' ' +  colsec3['General_Remarks_732'.toString().toLowerCase()]
                          colsec3[
                          "fire_extinguishing_installation_731"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.fSection3.push([
                          "Remarks: " +
                          colsec3[
                          "General_Remarks_732".toString().toLowerCase()
                          ],
                          " ",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec4[
                        "Test_and_inspections_733".toString().toLowerCase()
                        ] != null &&
                        colsec4[
                        "Test_and_inspections_733".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec4[
                          "survival_craft_734".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "survival_craft_734".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "survival_craft_date_735".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "survival_craft_date_735".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "lifeboats_and_rescue_boats_736"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "lifeboats_and_rescue_boats_736"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "lifeboats_and_rescue_boats_date_737"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "lifeboats_and_rescue_boats_date_737"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Lifeboats_moved_738".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Lifeboats_moved_738".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "Lifeboats_moved_date_739".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "Lifeboats_moved_date_739".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "emergency_alarm_740".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "emergency_alarm_740".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "emergency_alarm_date_741".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "emergency_alarm_date_741".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec4[
                          "General_Remarks_742".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec4[
                            "General_Remarks_742".toString().toLowerCase()
                          ] = "";
                        }

                        // Bunker_Delivery_Note_Ref_997,(Port_Name_998 + Delivery_Date_999),Fuel_Type_1001,t_1003,Tank_No_1006,Quantity_1007
                        this.fSection4.push([
                          colsec4[
                          "survival_craft_734".toString().toLowerCase()
                          ],
                          colsec4[
                          "survival_craft_date_735".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "lifeboats_and_rescue_boats_736"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec4[
                          "lifeboats_and_rescue_boats_date_737"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "Lifeboats_moved_738".toString().toLowerCase()
                          ],
                          colsec4[
                          "Lifeboats_moved_date_739".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          colsec4[
                          "emergency_alarm_740".toString().toLowerCase()
                          ],
                          colsec4[
                          "emergency_alarm_date_741".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection4.push([
                          "Remarks: " +
                          colsec4[
                          "General_Remarks_742".toString().toLowerCase()
                          ],
                          "",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec5[
                        "test_and_inspections_743".toString().toLowerCase()
                        ] != null &&
                        colsec5[
                        "test_and_inspections_743".toString().toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec5[
                          "lifeboats_turned_744".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "lifeboats_turned_744".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "lifeboats_turned_date_745".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "lifeboats_turned_date_745".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ispection_of_immersion_746"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ispection_of_immersion_746"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "ispection_of_immersion_date_747"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "ispection_of_immersion_date_747"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec5[
                          "General_Remarks_748".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec5[
                            "General_Remarks_748".toString().toLowerCase()
                          ] = "";
                        }

                        //  this.fSection5.push(
                        //      //[colsec5['test_and_inspections_743'.toString().toLowerCase()] + ' ' +
                        //  [colsec5['lifeboats_turned_744'.toString().toLowerCase()] + ' ' +
                        //  colsec5['lifeboats_turned_date_745'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['ispection_of_immersion_746'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['ispection_of_immersion_date_747'.toString().toLowerCase()]+ ' ' +
                        //  colsec5['General_Remarks_748'.toString().toLowerCase()],
                        //  colsec5['lifeboats_turned_date_745'.toString().toLowerCase()]

                        // ]);
                        //  this.userSign.push(usersign);

                        this.fSection5.push([
                          colsec5[
                          "lifeboats_turned_744".toString().toLowerCase()
                          ],
                          colsec5[
                          "lifeboats_turned_date_745".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection5.push([
                          colsec5[
                          "ispection_of_immersion_746"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec5[
                          "ispection_of_immersion_date_747"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection5.push([
                          "General Remarks: " +
                          colsec5[
                          "General_Remarks_748".toString().toLowerCase()
                          ],
                          "",
                        ]);

                        this.userSign.push(usersign);
                      }

                      if (
                        colsec6[
                        "inspections_examinations_749"
                          .toString()
                          .toLowerCase()
                        ] != null &&
                        colsec6[
                        "inspections_examinations_749"
                          .toString()
                          .toLowerCase()
                        ] != ""
                      ) {
                        if (
                          colsec6[
                          "Internation_shore_connection_750"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Internation_shore_connection_750"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "shore_connection_date_751".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "shore_connection_date_751".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_fighting_equipment_752"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_fighting_equipment_752"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_fighting_equipment_date_753"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_fighting_equipment_date_753"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "fire_doors_and_dampers_754"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "fire_doors_and_dampers_754"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "doors_dampers_date_755".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "doors_dampers_date_755".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "Bottle_connections_756".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bottle_connections_756".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "Bottle_connections_date_757"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "Bottle_connections_date_757"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec6[
                          "examination_and_inspection_remarks_758"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec6[
                            "examination_and_inspection_remarks_758"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }

                        this.fSection6.push([
                          colsec6[
                          "Internation_shore_connection_750"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "shore_connection_date_751".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "fire_fighting_equipment_752"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "fire_fighting_equipment_date_753"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "fire_doors_and_dampers_754"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec6[
                          "doors_dampers_date_755".toString().toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          colsec6[
                          "Bottle_connections_756".toString().toLowerCase()
                          ],
                          colsec6[
                          "Bottle_connections_date_757"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.userSign.push(usersign);
                        this.fSection6.push([
                          "Remarks: " +
                          colsec6[
                          "examination_and_inspection_remarks_758"
                            .toString()
                            .toLowerCase()
                          ],
                          " ",
                        ]);
                        this.userSign.push(usersign);
                        //                                                                     colsec6['fire_fighting_equipment_752'.toString().toLowerCase()]+ ' ' +
                        //                                                                     colsec6['fire_fighting_equipment_date_753'.toString().toLowerCase()]+ ' ' +
                        //                                                                     colsec6['fire_doors_and_dampers_754'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['Bottle_connections_756'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['Bottle_connections_date_757'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['examination_and_inspection_remarks_758'.toString().toLowerCase()] + ' ' +
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()] ,
                        //                                                                     colsec6['doors_dampers_date_755'.toString().toLowerCase()]

                        // ]);
                      }
                    }
                  }

                  console.log("mylog::mylog");
                  this.createCollectionLayout(this.objcolsection);
                  console.log("check-this.fSection2", this.fSection1);
                  console.log(this.objcolsection);

                  if (
                    this.fSection1.length > 0 ||
                    this.fSection5.length > 0 ||
                    this.fSection2.length > 0 ||
                    this.fSection6.length > 0 ||
                    this.fSection3.length > 0 ||
                    this.fSection4.length > 0
                  ) {
                    this.createCollectionLayout(this.fSection1);
                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);
                    this.createCollectionLayout(this.fSection6);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                    this.objcolcollection.push(this.fSection6);
                  }
                  console.log(this.objcolcollection);
                }
                //console.log(this.formDetails);
              }
            );
          }
        }

        console.log(this.formCount);
      }
    }
  }

  Officiallogbooklist(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    console.log("OLB 1 - " + hid);
    if (hid == "53-1") {
      this.olb = 1;
    } else if (hid == "53-2") {
      this.olb = 2;
    } else if (hid == "53-3") {
      this.olb = 3;
    } else if (hid == "53-4") {
      this.olb = 4;
    } else if (hid == "53-5") {
      this.olb = 5;
    } else if (hid == "53-6") {
      this.olb = 6;
    } else if (hid == "53-7") {
      this.olb = 7;
    } else if (hid == "53-8") {
      this.olb = 8;
    } else if (hid == "53-9") {
      this.olb = 9;
    } else if (hid == "53-10") {
      this.olb = 10;
    } else {
      console.log("not found");
      return;
    }
    //hid = 53;

    console.log("check-formbuilder-length", this.formBuilder.length);
    console.log("check-formbuilder", this.formBuilder);

    /////////////MAIN FUNCTIONS FOR ALL THE OTHER FORMS
    for (var i = 0; i < this.formBuilder.length; i++) {
      console.log("OLB 2 " + hid);
      this.formCount = [];
      this.objcolsection = [];
      var result = [];
      var strFormId = "";
      this.showpop9 = 0;

      for (var r = 0; r < this.formBuilder[i].formbuilderresponse.length; r++) {
        if (this.formBuilder[i].formbuilderresponse[r].formId == 76) {
          strFormId += this.formBuilder[i].formbuilderresponse[r].formId;
          this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
        }
      }

      console.log("check-strFormId", strFormId);
      console.log("check-formCount", this.formCount);

      var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");

      ///for others functions
      for (var r = 0; r < this.formBuilder[i].formbuilderresponse.length; r++) {
        var formId = this.formBuilder[i].formbuilderresponse[r].formId;
        if (
          (formId == 69 && hid == "53-1") ||
          (formId == 70 && hid == "53-2") ||
          (formId == 71 && hid == "53-3") ||
          (formId == 72 && hid == "53-4") ||
          (formId == 73 && hid == "53-5") ||
          (formId == 74 && hid == "53-6") ||
          (formId == 75 && hid == "53-7") ||
          (formId == 76 && hid == "53-8") ||
          (formId == 77 && hid == "53-9") ||
          (formId == 78 && hid == "53-10")
        ) {
          this.formCount.push(this.formBuilder[i].formbuilderresponse[r].formName);
          this.formBuilderSections = [];
          for (var u = 0; u < this.formBuilder[i].formbuilderresponse[r].formbuildersectionnamelist.length; u++) {
            this.formBuilderSections.push(this.formBuilder[i].formbuilderresponse[r].formbuildersectionnamelist[u]);
          }

          console.log("check-formbuildersectionnamelist", this.formBuilderSections);

          this.objcolsection = [];
          this.objcol = [];
          this.loading=true;
          this.reportsService.getFormDetailsByActionDateAndTime(formId, this.voyageNo, actionDate, actionTime, fromDate, toDate, (formResponse) => {

            console.log("check-formResponse", formResponse);
            this.loading=false;
            let newData = formResponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            console.log("check-newData", newData)

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            console.log("check-offical-log-book-this.formIdObject", this.formIdObject);
            console.log("check-formresponse-0-index", formResponse[0]);
            var response = this.modifyedData(formResponse[0]);
            console.log("check-res-after-modification", response);
            if (response.data != null) {
              for (var s = 0; s < response.data.length; s++) {
                if (response.data[s].isDelete == "1") continue;
                var findKey = false;
                var sectionName = "";
                this.formDetails = [];
                var colsec1 = [];
                var colsec2 = [];
                var colsec3 = [];
                var colsec4 = [];
                var colsec5 = [];
                var colsec6 = [];
                var coldate = [];
                this.showpop10 = 0;
                this.showpop11 = 0;
                this.showpop12 = 0;
                this.showpop13 = 0;
                this.showpop14 = 0;
                this.showpop15 = 0;
                this.showpop16 = 0;
                this.showpop17 = 0;
                this.showpop18 = 0;
                this.showpop19 = 0;
                this.olb = 0;
                var usersign = "";
                this.editedBy = "";
                var signdate = "";
                var masterName = "";
                var masterSignature = "";
                var chiefOfficersigndate = "";
                var chiefOfficerroleId = "";
                var chiefOfficerSignature = "";
                var roleId = "";
                var roleName = "";
                var id = "";
                if (response.data[s].editedBy != null) {
                  this.editedBy = response.data[s].editedBy;
                }
                usersign = response.data[s].userSign;
                //console.log("check-responsedata-235", response.data[s]);
                for (let key in response.data[s]) {
                  //console.log("check-outer-key", key)
                  //console.log("check-formbuildersection", this.formBuilderSections);
                  for (var p = 0; p < this.formBuilderSections.length; p++) {
                    for (var v = 0; v < this.formBuilderSections[p].formbuilderlist.length; v++) {
                      //console.log("check-middle-key", key);
                      if (key.toString().toLowerCase() == "created_at" && response.data[s][key] != "") {
                        coldate["date_created"] = response.data[s][key];
                        coldate["section_length"] = this.formBuilderSections.length;
                        //console.log("check-coldate", coldate);
                      }
                      //console.log("check-key-fieldname", key, this.formBuilderSections[p].formbuilderlist[v].fieldName)
                      if (key.toString().toLowerCase() == this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase()) {
                        sectionName = this.formBuilderSections[p].sectionName;

                        //console.log("check-sectionName", sectionName);
                        //console.log("check-hid-inside", hid);


                        if (hid == "53-1") {
                          if (response.data[s].date != null && response.data[s].date != "") {
                            signdate = response.data[s].date;
                          }

                          if (response.data[s].masterName != null && response.data[s].masterName != "") {
                            masterName = response.data[s].masterName;
                          }

                          if (response.data[s].masterSignature != null && response.data[s].masterSignature != "") {
                            masterSignature = response.data[s].masterSignature;
                          }

                          if (response.data[s].roleId != null && response.data[s].roleId != "") {
                            roleId = response.data[s].roleId;
                          }

                          if (response.data[s].roleName != null && response.data[s].roleName != "") {
                            roleName = response.data[s].roleName;
                          }

                          if (response.data[s]._id.$oid != null && response.data[s]._id.$oid != "") {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 1;

                          if (p == 0) {
                            if ((key.toString().toLowerCase() == "Name_of_Ship".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Name_of_Ship_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Port_of_registry_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Official_number".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Official_number_2".toString().toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] = response.data[s][key];
                            }
                          }

                          if (p == 1) {
                            if ((key.toString().toLowerCase() == "Gross_tonnage".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Gross_tonnage_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Register_(net)_tonnage".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Register_net_tonnage_2".toString().toLowerCase() && response.data[s][key] != "")
                            ) {
                              colsec2[key.toString().toLowerCase()] = response.data[s][key];
                            }
                          }

                          if (p == 2) {
                            if ((key.toString().toLowerCase() == "Name_of_masters".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Name_of_masters_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Certificate_of_competency_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Certificate_of_competency_2".toString().toLowerCase() && response.data[s][key] != "")
                            ) {
                              colsec3[key.toString().toLowerCase()] = response.data[s][key];
                            }
                          }

                          if (p == 3) {
                            if ((key.toString().toLowerCase() == "Name_of_the_registered_owner_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Name_of_the_registered_owner_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "address_of_the_registered_owner_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "address_of_the_registered_owner_2".toString().toLowerCase() && response.data[s][key] != "")
                            ) {
                              colsec4[key.toString().toLowerCase()] = response.data[s][key];
                            }
                            //
                          }

                          if (p == 4) {
                            if ((key.toString().toLowerCase() == "Date_at_which_log_book_opened_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_at_which_log_book_opened_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "place_at_which_log_book_opened".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "place_at_which_log_book_opened_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_at_which_log_book_closed_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_at_which_log_book_closed_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "place_at_which_log_book_closed_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "place_at_which_log_book_closed_2".toString().toLowerCase() && response.data[s][key] != "")
                            ) {
                              colsec5[key.toString().toLowerCase()] = response.data[s][key];
                            }
                            //
                          }

                          if (p == 5) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Delivered_to_the_superintendent"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Delivered_to_the_superintendent_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "on_Office_Stamp".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_2".toString().toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec6[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }

                        //OLB-2

                        console.log("this.formId  " + formId);

                        //if (formId == 70){
                        if (hid == "53-2") {
                          if (response.data[s].date != null && response.data[s].date != "") {
                            signdate = response.data[s].date;
                          }

                          if (response.data[s].masterName != null && response.data[s].masterName != "") {
                            masterName = response.data[s].masterName;
                          }

                          if (response.data[s].masterSignature != null && response.data[s].masterSignature != "") {
                            masterSignature = response.data[s].masterSignature;
                          }

                          if (response.data[s].roleId != null && response.data[s].roleId != "") {
                            roleId = response.data[s].roleId;
                          }

                          if (response.data[s].roleName != null && response.data[s].roleName != "") {
                            roleName = response.data[s].roleName;
                          }
                          if (response.data[s]._id.$oid != null && response.data[s]._id.$oid != "") {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 2;
                          console.log(
                            "this.olb  " + this.olb + "  " + this.formId
                          );

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Reference_number_in_list_of_crew"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Reference_number".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_of_seamen_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_of_seamen_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Capacity_in_which_employed_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Capacity_in_which_employed"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "If_entry_made_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "If_entry_made_2".toString().toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                        //OLB-3
                        if (hid == "53-3") {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].chiefOfficerDate != null &&
                            response.data[s].chiefOfficerDate != ""
                          ) {
                            chiefOfficersigndate =
                              response.data[s].chiefOfficerDate;
                          }

                          if (
                            response.data[s].chiefOfficerRoleId != null &&
                            response.data[s].chiefOfficerRoleId != ""
                          ) {
                            chiefOfficerroleId =
                              response.data[s].chiefOfficerRoleId;
                          }

                          if (
                            response.data[s].chiefOfficerSignature != null &&
                            response.data[s].chiefOfficerSignature != ""
                          ) {
                            chiefOfficerSignature =
                              response.data[s].chiefOfficerSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.chiefOfficerSignature = chiefOfficerSignature;
                          this.chiefOfficersigndate = chiefOfficersigndate;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 3;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "DATE_OF_BIRTH_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "DATE_OF_BIRTH_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "PLACE_OF_BIRTH_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "SURNAME_OF_CHILD_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "NAMES_if_any_AND_SURNAME_OF_CHILD_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "SEX_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "SEX_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "FATHER".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Occupation_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Occupation_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "rank_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "rank_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "profession_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "profession_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "usual_residence_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "usual_residence_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "MOTHER".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Maiden_surname_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Maiden_surname_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "surname_at_marriage_if_different_3"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "surname_at_marriage_if_different_4"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Usual_residence_3"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Usual_residence_4"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_the_mother_of_the_child_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_the_mother_of_the_child_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Port_at_which_return_is_made_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Port_at_which_return_is_made_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "date_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "date_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Title_of_officer_to_whom_return_is_made_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Title_of_officer_to_whom_return_is_made_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }

                          if (p == 1) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Date_of_Death_or_Loss_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Death_or_Loss_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_of_deceased_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Name_of_deceased_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_of_deceased_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Surname_of_deceased_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "if_married_woman_maiden_surname_if_known_of_deceased_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "SEX_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "SEX_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_birth_(if_known_or_age)_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_birth_if_known_or_age_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Occupation_5".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Occupation_6".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "rank_5".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "rank_6".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "profession_5".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "profession_6".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Usual_residence_at_time_of_death_or_loss_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Usual_residence_at_time_of_death_or_loss_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_5".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nationality_6".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Cause_of_death_or_loss_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Cause_of_death_or_loss_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_a_member_of_the_crew_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_a_member_of_the_crew_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Port_at_which_return_is_made_5"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Port_at_which_return_is_made_6"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_4".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Title_of_officer_to_whom_return_is_made_3"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Title_of_officer_to_whom_return_is_made_4"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec2[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                        //OLB-4
                        //if (formId == 72){
                        if (hid == "53-4" || formId == 72) {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 4;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Date_of_muster_drill_training_instruction_or_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_muster_drill_training_instruction_or_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_muster".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_muster_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_drill".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_drill_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              //       (key.toString().toLowerCase() == 'natraining_2'.toString().toLowerCase() && response.data[s][key] != '') ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_training_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_of_crew"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_of_crew_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_member_of_crew"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_member_of_crew_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                        //OLB-5
                        //if (formId == 73){
                        if (hid == "53-5" || formId == 73) {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 5;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Date_of_test_drill_inspection_or_pre_sea_check"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_test_drill_inspection_or_pre_sea_check_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Time_of_test_drill_inspection_or_pre_sea_check"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Time_of_test_drill_inspection_or_pre_sea_check_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "place_of_test_drill"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "place_of_test_drill_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "place_of_inspection_or_pre_sea_check"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "place_of_inspection_or_pre_sea_check_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_inspection_of_Steering_Gear"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_inspection_of_Steering_Gear_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_test_drill_or_check_of_Steering_Gear"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Nature_of_test_drill_or_check_of_Steering_Gear_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_officer"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_officer_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                        // OLB-6
                        //if (formId == 74){
                        if (hid == "53-6") {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 6;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Time_of_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Time_of_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Names_of_persons_making_the_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Names_of_persons_making_the_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Ranks_of_persons_making_the_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Ranks_of_persons_making_the_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_of_the_crew"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_master_of_the_crew_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_member_of_the_crew"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_member_of_the_crew_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                        //OLB-7

                        //if (formId == 75){
                        if (hid == "53-7") {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 7;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Date_of_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Names_of_persons_making_the_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Names_of_persons_making_the_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Ranks_of_persons_making_the_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Ranks_of_persons_making_the_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Result_of_inspection_of_supplies_of_food_and_water"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Result_of_inspection_of_supplies_of_food_and_water_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_persons_making_the_inspection"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Signature_of_persons_making_the_inspection_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }

                        //OLB-8
                        if (hid == "53-8") {
                          if (response.data[s].date != null && response.data[s].date != "") {
                            signdate = response.data[s].date;
                          }

                          if (response.data[s].masterName != null && response.data[s].masterName != "") {
                            masterName = response.data[s].masterName;
                          }

                          if (response.data[s].masterSignature != null && response.data[s].masterSignature != "") {
                            masterSignature = response.data[s].masterSignature;
                          }

                          if (response.data[s].roleId != null && response.data[s].roleId != "") {
                            roleId = response.data[s].roleId;
                          }

                          if (response.data[s].roleName != null && response.data[s].roleName != "") {
                            roleName = response.data[s].roleName;
                          }
                          if (response.data[s]._id.$oid != null && response.data[s]._id.$oid != "") {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 8;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Allowance_for_fresh_water_for_timber_freeboards_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Maximum_draught_of_water_in_summer_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                          }

                          if (p == 1) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Tropical_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Summer_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Winter_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Winter_North_Atlantic_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Timber_Tropical_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Timber_Summer_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Timber_Winter_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Timber_Winter_North_Atlantic_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec2[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                          }

                          if (p == 2) {
                            if (
                              //LOADLINE

                              (key.toString().toLowerCase() ==
                                "T_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "W_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "WNA_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "LT_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "LS_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "LW_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "LWNA_2".toString().toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec3[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                          }
                        }

                        //OLB-9
                        if (hid == "53-9") {
                          console.log("check-res-olb9", response.data[s])
                          if (response.data[s].date != null && response.data[s].date != "") {
                            signdate = response.data[s].date;
                          }

                          if (response.data[s].masterName != null && response.data[s].masterName != "") {
                            masterName = response.data[s].masterName;
                          }

                          if (response.data[s].masterSignature != null && response.data[s].masterSignature != "") {
                            masterSignature = response.data[s].masterSignature;
                          }

                          if (response.data[s].roleId != null && response.data[s].roleId != "") {
                            roleId = response.data[s].roleId;
                          }

                          if (response.data[s].roleName != null && response.data[s].roleName != "") {
                            roleName = response.data[s].roleName;
                          }
                          if (response.data[s]._id.$oid != null && response.data[s]._id.$oid != "") {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 9;

                          if (p == 0) {
                            console.log("check-key-299", key);
                            console.log("check-colsec1", colsec1);
                            console.log("check-before-response", response.data[s][key])
                            if ((key.toString().toLowerCase() == "Date_of_Departure_(1)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_of_Departure_1_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "hour_of_Departure_(1)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "hour_of_Departure_1_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Dock_2_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Wharf_(2)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Wharf_2_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "harbour_(2)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "harbour_2_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "other_place_(2)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "other_place_2_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "ACTUAL_DRAUGHT_OF_WATER".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Forward_(3)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Forward_3_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Aft_(4)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Aft_4_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "ACTUAL_FREEBOARD_AMIDSHIPS".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Port_(5)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Port_5_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Star_board_6_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Star_board_6_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_(7)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_7_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_3".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Density_of_Water_(8)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Density_of_Water_8_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_4".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "ALLOWANCE".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_Density_of_Water_(9)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_Density_of_Water_9_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_5".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_rubbish_(10)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_rubbish_10_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "weight_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_rubbish_(10)_3".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_rubbish_10_4".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_6".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2".toString()
                                .toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "distance_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_3".toString()
                                .toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_7".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Total_allowances_(12)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Total_allowances_12_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_8".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_(14)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "mm_9".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_of_posting_the_Notice_(Notice_FRE13)_(15)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "time_of_posting_the_Notice_(Notice_FRE13)_(15)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "time_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase() && response.data[s][key] != "") ||

                              //SIGNATURES SECTION
                              (key.toString().toLowerCase() == "Master_(16)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Master_16_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Officer_(17)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Officer_17_2".toString().toLowerCase() && response.data[s][key] != "") ||

                              //ARRIVALS SECTION
                              (key.toString().toLowerCase() == "Date_of_arrival_(18)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Date_of_arrival_18_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "hour_of_arrival_(18)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "hour_of_arrival_18_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Dock_(19)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "Dock_19_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "wharf_(19)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "wharf_19_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "harbour_(19)_1".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "harbour_19_2".toString().toLowerCase() && response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "other_place_(19)_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() == "other_place_19_2".toString().toLowerCase() && response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] = response.data[s][key];
                              console.log("check-colsec1-this.logValue", colsec1);
                              console.log("check-response-this.logValue", response.data[s][key]);
                            }
                          }
                        }
                        //OLB-10
                        // if (formId == 78){
                        if (hid == "53-10") {
                          if (
                            response.data[s].date != null &&
                            response.data[s].date != ""
                          ) {
                            signdate = response.data[s].date;
                          }

                          if (
                            response.data[s].masterName != null &&
                            response.data[s].masterName != ""
                          ) {
                            masterName = response.data[s].masterName;
                          }

                          if (
                            response.data[s].masterSignature != null &&
                            response.data[s].masterSignature != ""
                          ) {
                            masterSignature =
                              response.data[s].masterSignature;
                          }

                          if (
                            response.data[s].roleId != null &&
                            response.data[s].roleId != ""
                          ) {
                            roleId = response.data[s].roleId;
                          }

                          if (
                            response.data[s].roleName != null &&
                            response.data[s].roleName != ""
                          ) {
                            roleName = response.data[s].roleName;
                          }
                          if (
                            response.data[s]._id.$oid != null &&
                            response.data[s]._id.$oid != ""
                          ) {
                            id = response.data[s]._id.$oid;
                          }

                          this.masterSignature = masterSignature;
                          this.signdate = signdate;
                          this.roleName = roleName;
                          this.masterName = masterName;
                          this.id = id;
                          this.formId = formId;

                          this.olb = 10;

                          if (p == 0) {
                            if (
                              (key.toString().toLowerCase() ==
                                "Date_of_the_occurence_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_the_occurence_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "hour_of_the_occurence_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "hour_of_the_occurence_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_1".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Date_of_Entry_2".toString().toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "State_fine_imposed_if_any_1"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "") ||
                              (key.toString().toLowerCase() ==
                                "State_fine_imposed_if_any_2"
                                  .toString()
                                  .toLowerCase() &&
                                response.data[s][key] != "")
                            ) {
                              colsec1[key.toString().toLowerCase()] =
                                response.data[s][key];
                            }
                            //
                          }
                        }
                      }
                    }
                  }
                }

                if (hid == "53-1") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1["Name_of_Ship".toString().toLowerCase()] !=
                    null &&
                    colsec1["Name_of_Ship".toString().toLowerCase()] != ""
                  ) {
                    if (
                      colsec1["Name_of_Ship_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Name_of_Ship_1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1[
                      "Port_of_registry_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1["Port_of_registry_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Official_number".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Official_number".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Official_number_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Official_number_2".toString().toLowerCase()] =
                        "";
                    }

                    this.fSection1.push([
                      colsec1["Name_of_Ship_1".toString().toLowerCase()],
                      colsec1["Port_of_registry_2".toString().toLowerCase()],
                      colsec1["Official_number_2".toString().toLowerCase()],
                    ]);
                    this.userSign.push(usersign);
                  }

                  if (
                    colsec2["Gross_tonnage".toString().toLowerCase()] !=
                    null &&
                    colsec2["Gross_tonnage".toString().toLowerCase()] != ""
                  ) {
                    if (
                      colsec2["Gross_tonnage_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Gross_tonnage_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2[
                      "Register_(net)_tonnage".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Register_(net)_tonnage".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Register_net_tonnage_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Register_net_tonnage_2".toString().toLowerCase()
                      ] = "";
                    }

                    this.fSection2.push([
                      colsec2["Gross_tonnage_2".toString().toLowerCase()],
                      colsec2[
                      "Register_net_tonnage_2".toString().toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }

                  if (
                    colsec3["Name_of_masters".toString().toLowerCase()] !=
                    null &&
                    colsec3["Name_of_masters".toString().toLowerCase()] != ""
                  ) {
                    if (
                      colsec3["Name_of_masters_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec3["Name_of_masters_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec3[
                      "Certificate_of_competency_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec3[
                        "Certificate_of_competency_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec3[
                      "Certificate_of_competency_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec3[
                        "Certificate_of_competency_2".toString().toLowerCase()
                      ] = "";
                    }

                    this.fSection3.push([
                      colsec3["Name_of_masters_2".toString().toLowerCase()],
                      colsec3[
                      "Certificate_of_competency_2".toString().toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }

                  if (
                    colsec4[
                    "Name_of_the_registered_owner_1"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec4[
                    "Name_of_the_registered_owner_1"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec4[
                      "Name_of_the_registered_owner_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec4[
                        "Name_of_the_registered_owner_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec4[
                      "address_of_the_registered_owner_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec4[
                        "address_of_the_registered_owner_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec4[
                      "address_of_the_registered_owner_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec4[
                        "address_of_the_registered_owner_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection4.push([
                      colsec4[
                      "Name_of_the_registered_owner_2"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      colsec4[
                      "address_of_the_registered_owner_2"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }

                  if (
                    colsec5[
                    "Date_at_which_log_book_opened_1"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec5[
                    "Date_at_which_log_book_opened_1"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec5[
                      "Date_at_which_log_book_opened_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "Date_at_which_log_book_opened_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "place_at_which_log_book_opened"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "place_at_which_log_book_opened"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "place_at_which_log_book_opened_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "place_at_which_log_book_opened_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "Date_at_which_log_book_closed_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "Date_at_which_log_book_closed_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "Date_at_which_log_book_closed_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "Date_at_which_log_book_closed_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "place_at_which_log_book_closed_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "place_at_which_log_book_closed_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec5[
                      "place_at_which_log_book_closed_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec5[
                        "place_at_which_log_book_closed_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection5.push([
                      colsec5[
                      "Date_at_which_log_book_opened_2"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      colsec5[
                      "place_at_which_log_book_opened_1"
                        .toString()
                        .toLowerCase()
                      ],
                      colsec5[
                      "Date_at_which_log_book_closed_2"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      colsec5[
                      "place_at_which_log_book_closed_2"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }

                  if (
                    colsec6[
                    "Delivered_to_the_superintendent"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec6[
                    "Delivered_to_the_superintendent"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec6[
                      "Delivered_to_the_superintendent_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec6[
                        "Delivered_to_the_superintendent_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec6["on_Office_Stamp".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec6["on_Office_Stamp".toString().toLowerCase()] =
                        "";
                    }
                    if (colsec6["Date_1".toString().toLowerCase()] == null) {
                      colsec6["Date_1".toString().toLowerCase()] = "";
                    }
                    if (colsec6["Date_2".toString().toLowerCase()] == null) {
                      colsec6["Date_2".toString().toLowerCase()] = "";
                    }

                    this.fSection6.push([
                      //      colsec6['Delivered_to_the_superintendent'.toString().toLowerCase()],
                      colsec6[
                      "Delivered_to_the_superintendent_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //     colsec6['on_Office_Stamp'.toString().toLowerCase()],
                      //     colsec6['Date_1'.toString().toLowerCase()],
                      colsec6["Date_2".toString().toLowerCase()],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-2
                //if (formId == 70) {
                if (hid == "53-2") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1[
                    "Reference_number_in_list_of_crew"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec1[
                    "Reference_number_in_list_of_crew"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec1["Reference_number".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Reference_number".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Name_of_seamen_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Name_of_seamen_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Name_of_seamen_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Name_of_seamen_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Capacity_in_which_employed_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Capacity_in_which_employed_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Capacity_in_which_employed".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Capacity_in_which_employed".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["If_entry_made_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["If_entry_made_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["If_entry_made_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["If_entry_made_2".toString().toLowerCase()] =
                        "";
                    }

                    this.fSection1.push([
                      //colsec1['Reference_number_in_list_of_crew'.toString().toLowerCase()],
                      colsec1["Reference_number".toString().toLowerCase()],
                      //colsec1['Name_of_seamen_1'.toString().toLowerCase()],
                      colsec1["Name_of_seamen_2".toString().toLowerCase()],
                      //colsec1['Capacity_in_which_employed_1'.toString().toLowerCase()],
                      colsec1[
                      "Capacity_in_which_employed".toString().toLowerCase()
                      ],
                      //colsec1['If_entry_made_1'.toString().toLowerCase()],
                      colsec1["If_entry_made_2".toString().toLowerCase()],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-3

                if (hid == "53-3") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }
                  //BIRTHS SECTION
                  if (
                    colsec1["DATE_OF_BIRTH_1".toString().toLowerCase()] !=
                    null &&
                    colsec1["DATE_OF_BIRTH_1".toString().toLowerCase()] != ""
                  ) {
                    if (
                      colsec1["DATE_OF_BIRTH_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["DATE_OF_BIRTH_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["PLACE_OF_BIRTH_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["PLACE_OF_BIRTH_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "SURNAME_OF_CHILD_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1["SURNAME_OF_CHILD_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "NAMES_if_any_AND_SURNAME_OF_CHILD_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "NAMES_if_any_AND_SURNAME_OF_CHILD_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (colsec1["SEX_1".toString().toLowerCase()] == null) {
                      colsec1["SEX_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["SEX_2".toString().toLowerCase()] == null) {
                      colsec1["SEX_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["FATHER".toString().toLowerCase()] == null) {
                      colsec1["FATHER".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Name_1".toString().toLowerCase()] == null) {
                      colsec1["Name_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Name_2".toString().toLowerCase()] == null) {
                      colsec1["Name_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Surname_1".toString().toLowerCase()] == null
                    ) {
                      colsec1["Surname_1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Surname_2".toString().toLowerCase()] == null
                    ) {
                      colsec1["Surname_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Nationality_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nationality_1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Nationality_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nationality_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Occupation_1".toString().toLowerCase()] == null
                    ) {
                      colsec1["Occupation_1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Occupation_2".toString().toLowerCase()] == null
                    ) {
                      colsec1["Occupation_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["rank_1".toString().toLowerCase()] == null) {
                      colsec1["rank_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["rank_2".toString().toLowerCase()] == null) {
                      colsec1["rank_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["profession_1".toString().toLowerCase()] == null
                    ) {
                      colsec1["profession_1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["profession_2".toString().toLowerCase()] == null
                    ) {
                      colsec1["profession_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["usual_residence_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["usual_residence_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["usual_residence_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["usual_residence_2".toString().toLowerCase()] =
                        "";
                    }
                    if (colsec1["MOTHER".toString().toLowerCase()] == null) {
                      colsec1["MOTHER".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Name_3".toString().toLowerCase()] == null) {
                      colsec1["Name_3".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Name_4".toString().toLowerCase()] == null) {
                      colsec1["Name_4".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Surname_3".toString().toLowerCase()] == null
                    ) {
                      colsec1["Surname_3".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Surname_4".toString().toLowerCase()] == null
                    ) {
                      colsec1["Surname_4".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Nationality_3".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nationality_3".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Nationality_4".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nationality_4".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Maiden_surname_3".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Maiden_surname_3".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Maiden_surname_4".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Maiden_surname_4".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "surname_at_marriage_if_different_3"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "surname_at_marriage_if_different_3"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "surname_at_marriage_if_different_4"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "surname_at_marriage_if_different_4"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Usual_residence_3".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Usual_residence_3".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Usual_residence_4".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Usual_residence_4".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Signature_of_the_mother_of_the_child_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_the_mother_of_the_child_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_the_mother_of_the_child_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_the_mother_of_the_child_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Port_at_which_return_is_made_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Port_at_which_return_is_made_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Port_at_which_return_is_made_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Port_at_which_return_is_made_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (colsec1["date_1".toString().toLowerCase()] == null) {
                      colsec1["date_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["date_2".toString().toLowerCase()] == null) {
                      colsec1["date_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1[
                      "Title_of_officer_to_whom_return_is_made_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Title_of_officer_to_whom_return_is_made_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Title_of_officer_to_whom_return_is_made_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Title_of_officer_to_whom_return_is_made_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      //  colsec1['DATE_OF_BIRTH_1'.toString().toLowerCase()],
                      colsec1["DATE_OF_BIRTH_2".toString().toLowerCase()],
                      //   colsec1['PLACE_OF_BIRTH_1'.toString().toLowerCase()],
                      colsec1[
                      "PLACE_OF_BIRTH_Port_or_latitude_and_longitude_if_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec1['SURNAME_OF_CHILD_1'.toString().toLowerCase()],
                      colsec1[
                      "NAMES_if_any_AND_SURNAME_OF_CHILD_2"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec1['SEX_1'.toString().toLowerCase()],
                      colsec1["SEX_2".toString().toLowerCase()],
                      //  colsec1['FATHER'.toString().toLowerCase()],
                      //  colsec1['Name_1'.toString().toLowerCase()],
                      colsec1["Name_2".toString().toLowerCase()] +
                      " " +
                      //  colsec1['Surname_1'.toString().toLowerCase()],
                      colsec1["Surname_2".toString().toLowerCase()] +
                      " " +
                      //  colsec1['Nationality_1'.toString().toLowerCase()],
                      colsec1["Nationality_2".toString().toLowerCase()],
                      //  colsec1['Occupation_1'.toString().toLowerCase()],
                      colsec1["Occupation_2".toString().toLowerCase()] +
                      " " +
                      //  colsec1['rank_1'.toString().toLowerCase()],
                      colsec1["rank_2".toString().toLowerCase()] +
                      " " +
                      //  colsec1['profession_1'.toString().toLowerCase()],
                      colsec1["profession_2".toString().toLowerCase()] +
                      " " +
                      //  colsec1['usual_residence_1'.toString().toLowerCase()],
                      colsec1["usual_residence_2".toString().toLowerCase()],
                      //  colsec1['MOTHER'.toString().toLowerCase()],
                      //  colsec1['Name_3'.toString().toLowerCase()],
                      colsec1["Name_4".toString().toLowerCase()] +
                      " " +
                      //  colsec1['Surname_3'.toString().toLowerCase()],
                      colsec1["Surname_4".toString().toLowerCase()] +
                      " " +
                      //   colsec1['Nationality_3'.toString().toLowerCase()],
                      colsec1["Nationality_4".toString().toLowerCase()],
                      //  colsec1['Maiden_surname_3'.toString().toLowerCase()],
                      colsec1["Maiden_surname_4".toString().toLowerCase()] +
                      " " +
                      //  colsec1['surname_at_marriage_if_different_3'.toString().toLowerCase()],
                      colsec1[
                      "surname_at_marriage_if_different_4"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec1['Usual_residence_3'.toString().toLowerCase()],
                      colsec1["Usual_residence_4".toString().toLowerCase()],
                      //  colsec1['Signature_of_the_mother_of_the_child_1'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_the_mother_of_the_child_2"
                        .toString()
                        .toLowerCase()
                      ],
                      colsec1[
                      "Port_at_which_return_is_made_2"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec1['date_1'.toString().toLowerCase()],
                      colsec1["date_2".toString().toLowerCase()],
                      //  colsec1['Title_of_officer_to_whom_return_is_made_1'.toString().toLowerCase()],
                      colsec1[
                      "Title_of_officer_to_whom_return_is_made_2"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                  //DEATHS SECTION
                  if (
                    colsec2[
                    "Date_of_Death_or_Loss_1".toString().toLowerCase()
                    ] != null &&
                    colsec2[
                    "Date_of_Death_or_Loss_1".toString().toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec2[
                      "Date_of_Death_or_Loss_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Date_of_Death_or_Loss_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Name_of_deceased_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2["Name_of_deceased_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2[
                      "Name_of_deceased_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2["Name_of_deceased_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2[
                      "Surname_of_deceased_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Surname_of_deceased_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Surname_of_deceased_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Surname_of_deceased_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "if_married_woman_maiden_surname_if_known_of_deceased_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "if_married_woman_maiden_surname_if_known_of_deceased_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (colsec2["SEX_3".toString().toLowerCase()] == null) {
                      colsec2["SEX_3".toString().toLowerCase()] = "";
                    }
                    if (colsec2["SEX_4".toString().toLowerCase()] == null) {
                      colsec2["SEX_4".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2[
                      "Date_of_birth_(if_known_or_age)_5"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Date_of_birth_(if_known_or_age)_5"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Date_of_birth_if_known_or_age_6"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Date_of_birth_if_known_or_age_6"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2["Occupation_5".toString().toLowerCase()] == null
                    ) {
                      colsec2["Occupation_5".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2["Occupation_6".toString().toLowerCase()] == null
                    ) {
                      colsec2["Occupation_6".toString().toLowerCase()] = "";
                    }
                    if (colsec2["rank_5".toString().toLowerCase()] == null) {
                      colsec2["rank_5".toString().toLowerCase()] = "";
                    }
                    if (colsec2["rank_6".toString().toLowerCase()] == null) {
                      colsec2["rank_6".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2["profession_5".toString().toLowerCase()] == null
                    ) {
                      colsec2["profession_5".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2["profession_6".toString().toLowerCase()] == null
                    ) {
                      colsec2["profession_6".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2[
                      "Usual_residence_at_time_of_death_or_loss_5"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Usual_residence_at_time_of_death_or_loss_5"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Usual_residence_at_time_of_death_or_loss_6"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Usual_residence_at_time_of_death_or_loss_6"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2["Nationality_5".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Nationality_5".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2["Nationality_6".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Nationality_6".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2[
                      "Cause_of_death_or_loss_5".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Cause_of_death_or_loss_5".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Cause_of_death_or_loss_6".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Cause_of_death_or_loss_6".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Signature_of_master_5".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Signature_of_master_5".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Signature_of_master_6".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Signature_of_master_6".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Signature_of_a_member_of_the_crew_5"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Signature_of_a_member_of_the_crew_5"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Signature_of_a_member_of_the_crew_6"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Signature_of_a_member_of_the_crew_6"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Port_at_which_return_is_made_5"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Port_at_which_return_is_made_5"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Port_at_which_return_is_made_6"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Port_at_which_return_is_made_6"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (colsec2["Date_3".toString().toLowerCase()] == null) {
                      colsec2["Date_3".toString().toLowerCase()] = "";
                    }
                    if (colsec2["Date_4".toString().toLowerCase()] == null) {
                      colsec2["Date_4".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2[
                      "Title_of_officer_to_whom_return_is_made_3"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Title_of_officer_to_whom_return_is_made_3"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2[
                      "Title_of_officer_to_whom_return_is_made_4"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Title_of_officer_to_whom_return_is_made_4"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection2.push([
                      // colsec2['Date_of_Death_or_Loss_1'.toString().toLowerCase()],
                      colsec2[
                      "Date_of_Death_or_Loss_2".toString().toLowerCase()
                      ],
                      // colsec2['Place_of_Death_or_Loss(latitude_or_longitude_if_at_sea)_1'.toString().toLowerCase()],
                      colsec2[
                      "Place_of_Death_or_Los_latitude_or_longitude_if_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ],
                      //   colsec2['Name_of_deceased_1'.toString().toLowerCase()],
                      colsec2["Name_of_deceased_2".toString().toLowerCase()] +
                      " " +
                      //  colsec2['Surname_of_deceased_1'.toString().toLowerCase()],
                      colsec2[
                      "Surname_of_deceased_2".toString().toLowerCase()
                      ] +
                      " " +
                      colsec2[
                      "if_married_woman_maiden_surname_if_known_of_deceased_2"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec2['SEX_3'.toString().toLowerCase()],
                      colsec2["SEX_4".toString().toLowerCase()],
                      //  colsec2['Date_of_birth_5'.toString().toLowerCase()],
                      colsec2[
                      "Date_of_birth_if_known_or_age_6"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec2['Occupation_5'.toString().toLowerCase()],
                      colsec2["Occupation_6".toString().toLowerCase()] +
                      " " +
                      //  colsec2['rank_5'.toString().toLowerCase()],
                      colsec2["rank_6".toString().toLowerCase()] +
                      " " +
                      //  colsec2['profession_5'.toString().toLowerCase()],
                      colsec2["profession_6".toString().toLowerCase()],
                      //   colsec2['Usual_residence_at_time_of_death_or_loss_5'.toString().toLowerCase()],
                      colsec2[
                      "Usual_residence_at_time_of_death_or_loss_6"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec2['Nationality_5'.toString().toLowerCase()],
                      colsec2["Nationality_6".toString().toLowerCase()],
                      //  colsec2['Cause_of_death_or_loss_5'.toString().toLowerCase()],
                      colsec2[
                      "Cause_of_death_or_loss_6".toString().toLowerCase()
                      ],
                      //  colsec2['Signature_of_master_5'.toString().toLowerCase()],
                      colsec2[
                      "Signature_of_master_6".toString().toLowerCase()
                      ],
                      //  colsec2['Signature_of_a_member_of_the_crew_5'.toString().toLowerCase()],
                      colsec2[
                      "Signature_of_a_member_of_the_crew_6"
                        .toString()
                        .toLowerCase()
                      ],
                      //  colsec2['Port_at_which_return_is_made_5'.toString().toLowerCase()],
                      colsec2[
                      "Port_at_which_return_is_made_6"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      //  colsec2['Date_3'.toString().toLowerCase()],
                      colsec2["Date_4".toString().toLowerCase()],
                      //   colsec2['Title_of_officer_to_whom_return_is_made_3'.toString().toLowerCase()],
                      colsec2[
                      "Title_of_officer_to_whom_return_is_made_4"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-4
                //if (formId == 72) {
                if (hid == "53-4") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1[
                    "Date_of_muster_drill_training_instruction_or_inspection"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec1[
                    "Date_of_muster_drill_training_instruction_or_inspection"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec1[
                      "Date_of_muster_drill_training_instruction_or_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Date_of_muster_drill_training_instruction_or_inspection_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Nature_of_muster".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nature_of_muster".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Nature_of_muster_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1["Nature_of_muster_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Nature_of_drill".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nature_of_drill".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Nature_of_drill_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Nature_of_drill_1".toString().toLowerCase()] =
                        "";
                    }

                    if (
                      colsec1[
                      "Nature_of_training_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_training_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (colsec1["Nature1".toString().toLowerCase()] == null) {
                      colsec1["Nature1".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Date_of_Entry".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master_of_crew".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master_of_crew".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master_of_crew_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master_of_crew_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_member_of_crew".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_member_of_crew".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_member_of_crew_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_member_of_crew_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      //colsec1['Date_of_muster_drill_training_instruction_or_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Date_of_muster_drill_training_instruction_or_inspection_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //colsec1['Nature_of_muster'.toString().toLowerCase()],
                      colsec1["Nature_of_muster_1".toString().toLowerCase()] +
                      " " +
                      //colsec1['Nature_of_drill'.toString().toLowerCase()],
                      colsec1[
                      "Nature_of_drill_1".toString().toLowerCase()
                      ] +
                      " " +
                      //colsec1['natraining_2'.toString().toLowerCase()],
                      colsec1[
                      "Nature_of_training_1".toString().toLowerCase()
                      ] +
                      " " +
                      //colsec1['Nature_of_instruction_or_inspection_(including_the_condition_in_which_the_life-saving_and_fire_appliances_were_found)_and_the_record_of_the_occassions_on_which_the_lifeboats_were_swung_out_or_lowered'.toString().toLowerCase()],
                      colsec1["Nature1".toString().toLowerCase()],
                      //colsec1['Date_of_Entry'.toString().toLowerCase()],
                      colsec1["Date_of_Entry_1".toString().toLowerCase()],
                      //colsec1['Signature_of_master_of_crew'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_master_of_crew_1"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      //colsec1['Signature_of_member_of_crew'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_member_of_crew_1"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-5
                //if (formId == 74) {
                if (hid == "53-5") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1[
                    "Date_of_test_drill_inspection_or_pre_sea_check_1"
                      .toString()
                      .toLowerCase()
                    ] != null &&
                    colsec1[
                    "Date_of_test_drill_inspection_or_pre-sea_check_1"
                      .toString()
                      .toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec1[
                      "Date_of_test_drill_inspection_or_pre_sea_check"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Date_of_test_drill_inspection_or_pre_sea_check"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Time_of_test_drill_inspection_or_pre_sea_check"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Time_of_test_drill_inspection_or_pre_sea_check"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Time_of_test_drill_inspection_or_pre_sea_check_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Time_of_test_drill_inspection_or_pre_sea_check_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "place_of_test_drill".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "place_of_test_drill".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "place_of_test_drill_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "place_of_test_drill_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "place_of_inspection_or_pre_sea_check"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "place_of_inspection_or_pre_sea_check"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "place_of_inspection_or_pre_sea_check_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "place_of_inspection_or_pre_sea_check_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Nature_of_inspection_of_Steering_Gear"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_inspection_of_Steering_Gear"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Nature_of_inspection_of_Steering_Gear_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_inspection_of_Steering_Gear_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Nature_of_test_drill_or_check_of_Steering_Gear"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_test_drill_or_check_of_Steering_Gear"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Nature_of_test_drill_or_check_of_Steering_Gear_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Nature_of_test_drill_or_check_of_Steering_Gear_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_officer".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_officer".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_officer_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_officer_1".toString().toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      colsec1[
                      "Date_of_test_drill_inspection_or_pre_sea_check_1"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      colsec1[
                      "Time_of_test_drill_inspection_or_pre_sea_check_1"
                        .toString()
                        .toLowerCase()
                      ],
                      colsec1[
                      "place_of_test_drill_1".toString().toLowerCase()
                      ] +
                      " " +
                      colsec1[
                      "place_of_inspection_or_pre_sea_check_1"
                        .toString()
                        .toLowerCase()
                      ],
                      colsec1[
                      "Nature_of_inspection_of_Steering_Gear_1"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      colsec1[
                      "Nature_of_test_drill_or_check_of_Steering_Gear_1"
                        .toString()
                        .toLowerCase()
                      ],
                      colsec1["Date_of_Entry_1".toString().toLowerCase()],
                      colsec1[
                      "Signature_of_master_1".toString().toLowerCase()
                      ] +
                      " " +
                      colsec1[
                      "Signature_of_officer_1".toString().toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-6
                //if (formId == 75) {
                if (hid == "53-6") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1["Time_of_inspection".toString().toLowerCase()] !=
                    null &&
                    colsec1["Time_of_inspection".toString().toLowerCase()] !=
                    ""
                  ) {
                    if (
                      colsec1[
                      "Time_of_inspection_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Time_of_inspection_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Date_of_inspection".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1["Date_of_inspection".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Date_of_inspection_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Date_of_inspection_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Names_of_persons_making_the_inspection"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Names_of_persons_making_the_inspection"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Names_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Names_of_persons_making_the_inspection_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Ranks_of_persons_making_the_inspection"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Ranks_of_persons_making_the_inspection"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Ranks_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Ranks_of_persons_making_the_inspection_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Date_of_Entry".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master_of_the_crew"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master_of_the_crew"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_master_of_the_crew_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_master_of_the_crew_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_member_of_the_crew"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_member_of_the_crew"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_member_of_the_crew_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_member_of_the_crew_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      //   colsec1['Date_of_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Date_of_inspection_1".toString().toLowerCase()
                      ] +
                      "=>" +
                      //   colsec1['Time_of_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Time_of_inspection_1".toString().toLowerCase()
                      ],

                      //    colsec1['Names_of_persons_making_the_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Names_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      //    colsec1['Ranks_of_persons_making_the_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Ranks_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //    colsec1['Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations'.toString().toLowerCase()],
                      colsec1[
                      "Particulars_of_any_respects_in_which_crew_accomodation_or_any_part_of_it_is_found_not_to_comply_with_the_Regulations_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //   colsec1['Date_of_Entry'.toString().toLowerCase()],
                      colsec1["Date_of_Entry_1".toString().toLowerCase()],
                      //    colsec1['Signature_of_master_of_the_crew'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_master_of_the_crew_1"
                        .toString()
                        .toLowerCase()
                      ] +
                      " " +
                      //    colsec1['Signature_of_member_of_the_crew'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_member_of_the_crew_1"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-7
                //if (formId == 76) {
                if (hid == "53-7") {
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1["Date_of_Inspection".toString().toLowerCase()] !=
                    null &&
                    colsec1["Date_of_Inspection".toString().toLowerCase()] !=
                    ""
                  ) {
                    if (
                      colsec1[
                      "Date_of_Inspection_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Date_of_Inspection_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Names_of_persons_making_the_inspection"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Names_of_persons_making_the_inspection"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Names_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1["".toString().toLowerCase()] =
                        "Names_of_persons_making_the_inspection_1";
                    }
                    if (
                      colsec1[
                      "Ranks_of_persons_making_the_inspection"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Ranks_of_persons_making_the_inspection"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Ranks_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Ranks_of_persons_making_the_inspection_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Result_of_inspection_of_supplies_of_food_and_water"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Result_of_inspection_of_supplies_of_food_and_water"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Result_of_inspection_of_supplies_of_food_and_water_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Result_of_inspection_of_supplies_of_food_and_water_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Date_of_Entry".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Signature_of_persons_making_the_inspection"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_persons_making_the_inspection"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Signature_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Signature_of_persons_making_the_inspection_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      //    colsec1['Date_of_Inspection'.toString().toLowerCase()],
                      colsec1[
                      "Date_of_Inspection_1".toString().toLowerCase()
                      ],
                      //   colsec1['Names_of_persons_making_the_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Names_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //    colsec1['Ranks_of_persons_making_the_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Ranks_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //    colsec1['Result_of_inspection_of_supplies_of_food_and_water'.toString().toLowerCase()],
                      colsec1[
                      "Result_of_inspection_of_supplies_of_food_and_water_1"
                        .toString()
                        .toLowerCase()
                      ],
                      //    colsec1['Date_of_Entry'.toString().toLowerCase()],
                      colsec1["Date_of_Entry_1".toString().toLowerCase()],
                      //    colsec1['Signature_of_persons_making_the_inspection'.toString().toLowerCase()],
                      colsec1[
                      "Signature_of_persons_making_the_inspection_1"
                        .toString()
                        .toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }

                //OLB-8
                if (hid == "53-8") {
                  //if(formId ==77){}
                  if (
                    coldate["date_created"] != null &&
                    coldate["date_created"] != ""
                  ) {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([
                      year + "-" + month + "-" + day,
                      sectionLenght,
                    ]);
                  }

                  if (
                    colsec1[
                    "Allowance_for_fresh_water_for_all_freeboards_other_then_timber_2"
                      .toString()
                      .toLowerCase()
                    ] != null
                  ) {
                    if (
                      colsec1[
                      "Allowance_for_fresh_water_for_timber_freeboards_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Allowance_for_fresh_water_for_timber_freeboards_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "The_upper_edge_of_the_deckline_from_which_these_freeboards_are_measured_is_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Maximum_draught_of_water_in_summer_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Maximum_draught_of_water_in_summer_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    this.fSection1.push(colsec1);
                  }

                  if (
                    colsec2["Tropical_2".toString().toLowerCase()] != null
                  ) {
                    if (
                      colsec2["Summer_2".toString().toLowerCase()] == null
                    ) {
                      colsec2["Summer_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2["Winter_2".toString().toLowerCase()] == null
                    ) {
                      colsec2["Winter_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec2[
                      "Winter_North_Atlantic_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Winter_North_Atlantic_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec2["Timber_Tropical_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Timber_Tropical_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2["Timber_Summer_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Timber_Summer_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2["Timber_Winter_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec2["Timber_Winter_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec2[
                      "Timber_Winter_North_Atlantic_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec2[
                        "Timber_Winter_North_Atlantic_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    this.fSection2.push(colsec2);
                  }

                  if (colsec3["T_2".toString().toLowerCase()] != null) {
                    if (colsec3["W_2".toString().toLowerCase()] == null) {
                      colsec1["W_2".toString().toLowerCase()] = "";
                    }
                    if (colsec3["WNA_2".toString().toLowerCase()] == null) {
                      colsec3["WNA_2".toString().toLowerCase()] = "";
                    }
                    if (colsec3["LT_2".toString().toLowerCase()] == null) {
                      colsec3["LT_2".toString().toLowerCase()] = "";
                    }
                    if (colsec3["LS_2".toString().toLowerCase()] == null) {
                      colsec3["LS_2".toString().toLowerCase()] = "";
                    }
                    if (colsec3["LW_2".toString().toLowerCase()] == null) {
                      colsec3["LW_2".toString().toLowerCase()] = "";
                    }
                    if (colsec3["LWNA_2".toString().toLowerCase()] == null) {
                      colsec3["LWNA_2".toString().toLowerCase()] = "";
                    }
                    this.fSection3.push(colsec3);
                  }
                }

                //OLB-9
                if (hid == "53-9") {
                  if (coldate["date_created"] != null && coldate["date_created"] != "") {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([year + "-" + month + "-" + day, sectionLenght,]);
                  }

                  if (colsec1["Date_of_Departure_1_2".toString().toLowerCase()] != null && colsec1["Date_of_Departure_1_2".toString().toLowerCase()] != "") {
                    if (colsec1["Date_of_Departure_(1)_2".toString().toLowerCase()] == null) {
                      colsec1["Date_of_Departure_(1)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["hour_of_Departure_(1)_1".toString().toLowerCase()] == null) {
                      colsec1["hour_of_Departure_(1)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["hour_of_Departure_1_2".toString().toLowerCase()] == null) {
                      colsec1["hour_of_Departure_1_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Dock_2_2".toString().toLowerCase()] == null) {
                      colsec1["Dock_2_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Wharf_(2)_1".toString().toLowerCase()] == null) {
                      colsec1["Wharf_(2)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Wharf_2_2".toString().toLowerCase()] == null) {
                      colsec1["Wharf_2_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["harbour_(2)_1".toString().toLowerCase()] == null) {
                      colsec1["harbour_(2)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["harbour_2_2".toString().toLowerCase()] == null) {
                      colsec1["harbour_2_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["other_place_(2)_1".toString().toLowerCase()] == null) {
                      colsec1["other_place_(2)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["other_place_2_2".toString().toLowerCase()] == null) {
                      colsec1["other_place_2_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["ACTUAL_DRAUGHT_OF_WATER".toString().toLowerCase()] == null) {
                      colsec1["ACTUAL_DRAUGHT_OF_WATER".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Forward_(3)_1".toString().toLowerCase()] == null) {
                      colsec1["Forward_(3)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Forward_3_2".toString().toLowerCase()] == null) {
                      colsec1["Forward_3_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Aft_(4)_1".toString().toLowerCase()] == null) {
                      colsec1["Aft_(4)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Aft_4_2".toString().toLowerCase()] == null) {
                      colsec1[" Aft_4_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["ACTUAL_FREEBOARD_AMIDSHIPS".toString().toLowerCase()] == null) {
                      colsec1["ACTUAL_FREEBOARD_AMIDSHIPS".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Port_(5)_1".toString().toLowerCase()] == null) {
                      colsec1["Port_(5)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Port_5_2".toString().toLowerCase()] == null) {
                      colsec1["Port_5_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_1".toString().toLowerCase()] == null) {
                      colsec1["mm_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Star_board_6_1".toString().toLowerCase()] == null) {
                      colsec1["Star_board_6_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Star_board_6_2".toString().toLowerCase()] == null) {
                      colsec1["Star_board_6_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_2".toString().toLowerCase()] == null) {
                      colsec1["mm_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_(7)_1".toString().toLowerCase()] == null) {
                      colsec1["Mean_7_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_7_2".toString().toLowerCase()] == null) {
                      colsec1["Mean_7_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_3".toString().toLowerCase()] == null) {
                      colsec1["mm_3".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Density_of_Water_(8)_1".toString().toLowerCase()] == null) {
                      colsec1["Density_of_Water_(8)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Density_of_Water_8_2".toString().toLowerCase()] == null) {
                      colsec1["Density_of_Water_8_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_4".toString().toLowerCase()] == null) {
                      colsec1["mm_4".toString().toLowerCase()] = "";
                    }
                    if (colsec1["ALLOWANCE".toString().toLowerCase()] == null) {
                      colsec1["ALLOWANCE".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_Density_of_Water_(9)_1".toString().toLowerCase()] == null) {
                      colsec1["For_Density_of_Water_(9)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_Density_of_Water_9_2".toString().toLowerCase()] == null) {
                      colsec1["For_Density_of_Water_9_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_5".toString().toLowerCase()] == null) {
                      colsec1["mm_5".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_rubbish_(10)_1".toString().toLowerCase()] == null) {
                      colsec1["For_rubbish_(10)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_rubbish_10_2".toString().toLowerCase()] == null) {
                      colsec1["For_rubbish_10_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["weight_1".toString().toLowerCase()] == null) {
                      colsec1["weight_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_rubbish_(10)_3".toString().toLowerCase()] == null) {
                      colsec1["For_rubbish_(10)_3".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_rubbish_10_4".toString().toLowerCase()] == null) {
                      colsec1["For_rubbish_10_4".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_6".toString().toLowerCase()] == null) {
                      colsec1["mm_6".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_1".toString().toLowerCase()] == null) {
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2".toString()
                      .toLowerCase()] == null
                    ) {
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2".toString().toLowerCase()] = "";

                    }
                    if (colsec1["distance_1".toString().toLowerCase()] == null) {
                      colsec1["distance_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_3".toString().toLowerCase()] == null) {
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_(11)_3".toString()
                        .toLowerCase()] = "";
                    }
                    if (colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4".toString()
                      .toLowerCase()] == null) {
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_7".toString().toLowerCase()] == null) {
                      colsec1["mm_7".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Total_allowances_(12)_1".toString().toLowerCase()] == null) {
                      colsec1["Total_allowances_(12)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Total_allowances_12_2".toString().toLowerCase()] == null) {
                      colsec1["Total_allowances_12_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_8".toString().toLowerCase()] == null) {
                      colsec1["mm_8".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_1".toString().toLowerCase()] == null) {
                      colsec1["Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2".toString().toLowerCase()] == null) {
                      colsec1["Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_(13)_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_(14)_1".toString().toLowerCase()] == null) {
                      colsec1["Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_(14)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2".toString().toLowerCase()] == null) {
                      colsec1["Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["mm_9".toString().toLowerCase()] == null) {
                      colsec1["mm_9".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Date_of_posting_the_Notice_(Notice_FRE13)_(15)_1".toString().toLowerCase()] == null) {
                      colsec1["Date_of_posting_the_Notice_(Notice_FRE13)_(15)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Date_of_posting_the_Notice_(Notice_FRE13)_15_2".toString().toLowerCase()] == null) {
                      colsec1["Date_of_posting_the_Notice_(Notice_FRE13)_15_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["time_of_posting_the_Notice_Notice_FRE13_(15)_1".toString().toLowerCase()] == null) {
                      colsec1["time_of_posting_the_Notice_Notice_FRE13_(15)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["time_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase()] == null) {
                      colsec1["time_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase()] = "";
                    }

                    //SIGNATURES
                    if (colsec1["Master_(16)_1".toString().toLowerCase()] == null) {
                      colsec1["Master_(16)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Master_16_2".toString().toLowerCase()] == null) {
                      colsec1["Master_16_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Officer_(17)_1".toString().toLowerCase()] == null) {
                      colsec1["Officer_(17)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Officer_17_2".toString().toLowerCase()] == null) {
                      colsec1["Officer_17_2".toString().toLowerCase()] = "";
                    }

                    //ARRIVALS
                    if (colsec1["Date_of_arrival_(18)_1".toString().toLowerCase()] == null) {
                      colsec1["Date_of_arrival_(18)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Date_of_arrival_18_2".toString().toLowerCase()] == null) {
                      colsec1["Date_of_arrival_18_2".toString().toLowerCase()] = "";
                    }
                    if (
                      colsec1["hour_of_arrival_(18)_1".toString().toLowerCase()] == null) {
                      colsec1["hour_of_arrival_(18)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["hour_of_arrival_18_2".toString().toLowerCase()] == null) {
                      colsec1[
                        "hour_of_arrival_18_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (colsec1["Dock_(19)_1".toString().toLowerCase()] == null) {
                      colsec1["Dock_(19)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["Dock_19_2".toString().toLowerCase()] == null) {
                      colsec1["Dock_19_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["wharf_(19)_1".toString().toLowerCase()] == null) {
                      colsec1["wharf_(19)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["wharf_19_2".toString().toLowerCase()] == null) {
                      colsec1["wharf_19_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["harbour_(19)_1".toString().toLowerCase()] == null) {
                      colsec1["harbour_(19)_1".toString().toLowerCase()] = "";
                    }
                    if (colsec1["harbour_19_2".toString().toLowerCase()] == NullTemplateVisitor) {
                      colsec1["harbour_19_2".toString().toLowerCase()] = "";
                    }
                    if (colsec1["other_place_(19)_1".toString().toLowerCase()] == null) {
                      colsec1["other_place_(19)_1".toString().toLowerCase()] =
                        "";
                    }
                    if (colsec1["other_place_19_2".toString().toLowerCase()] == null
                    ) {
                      colsec1["other_place_19_2".toString().toLowerCase()] = "";
                    }

                    console.log("check-colsec1-before-fSection1.push", colsec1)

                    this.fSection1.push(
                      [colsec1["Date_of_Departure_1_2".toString().toLowerCase()] + " " +
                        colsec1["hour_of_Departure_1_2".toString().toLowerCase()],
                      colsec1["Dock_2_2".toString().toLowerCase()] + "," +
                      colsec1["Wharf_2_2".toString().toLowerCase()] + "," +
                      colsec1["harbour_2_2".toString().toLowerCase()] + "," +
                      colsec1["other_place_2_2".toString().toLowerCase()],
                      colsec1["Forward_3_2".toString().toLowerCase()],
                      colsec1["Aft_4_2".toString().toLowerCase()],
                      colsec1["Port_5_2".toString().toLowerCase()],
                      colsec1["Star_board_6_2".toString().toLowerCase()],
                      colsec1["Mean_7_2".toString().toLowerCase()],
                      colsec1["Density_of_Water_8_2".toString().toLowerCase()],
                      colsec1["For_Density_of_Water_9_2".toString().toLowerCase()],
                      colsec1["For_rubbish_10_2".toString().toLowerCase()],
                      colsec1["For_rubbish_10_4".toString().toLowerCase()],
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_2".toString().toLowerCase()],
                      colsec1["For_fuel_water_and_stores_to_be_consumed_on_stretch_of_inland_water_11_4".toString().toLowerCase()],
                      colsec1["Total_allowances_12_2".toString().toLowerCase()],
                      colsec1["Mean_Draught_in_salt_water_as_calculated_after_making_the_appropriate_allowances_13_2"
                        .toString().toLowerCase()],
                      colsec1["Mean_Freeboard_Amidships_in_salt_Water_as_calculated_after_making_the_appropriate_allowances_14_2".toString().toLowerCase()],
                      colsec1["Date_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase()] + " " +
                      colsec1["time_of_posting_the_Notice_Notice_FRE13_15_2".toString().toLowerCase()
                      ],

                      //SIGNATURES //
                      colsec1["Master_16_2".toString().toLowerCase()],
                      colsec1["Officer_17_2".toString().toLowerCase()],

                      //arrivals
                      colsec1["Date_of_arrival_18_2".toString().toLowerCase()] + " " +
                      colsec1["hour_of_arrival_18_2".toString().toLowerCase()],
                      colsec1["Dock_19_2".toString().toLowerCase()] + "," +
                      colsec1["wharf_19_2".toString().toLowerCase()] + "," +
                      colsec1["harbour_19_2".toString().toLowerCase()] + "," +
                      colsec1["other_place_19_2".toString().toLowerCase()],
                      ]);
                    console.log("check-fSection1", this.fSection1);
                    this.userSign.push(usersign);
                  }
                  console.log("check-whole-coldate", coldate)
                }

                //OLB-10
                // if (formId == 78) {
                if (hid == "53-10") {
                  if (coldate["date_created"] != null && coldate["date_created"] != "") {
                    var date = new Date(coldate["date_created"]);
                    var day = date.getDate();
                    var month = date.getMonth() + 1;
                    var year = date.getFullYear();

                    var sectionLenght = coldate["section_length"];
                    this.createdAt.push([year + "-" + month + "-" + day, sectionLenght,]);
                  }

                  if (
                    colsec1[
                    "Date_of_the_occurence_1".toString().toLowerCase()
                    ] != null &&
                    colsec1[
                    "Date_of_the_occurence_1".toString().toLowerCase()
                    ] != ""
                  ) {
                    if (
                      colsec1[
                      "Date_of_the_occurence_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Date_of_the_occurence_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "hour_of_the_occurence_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "hour_of_the_occurence_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "hour_of_the_occurence_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "hour_of_the_occurence_2".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_1".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1["Date_of_Entry_2".toString().toLowerCase()] ==
                      null
                    ) {
                      colsec1["Date_of_Entry_2".toString().toLowerCase()] =
                        "";
                    }
                    if (
                      colsec1[
                      "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_1"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2"
                        .toString()
                        .toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2"
                          .toString()
                          .toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "State_fine_imposed_if_any_1".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "State_fine_imposed_if_any_1".toString().toLowerCase()
                      ] = "";
                    }
                    if (
                      colsec1[
                      "State_fine_imposed_if_any_2".toString().toLowerCase()
                      ] == null
                    ) {
                      colsec1[
                        "State_fine_imposed_if_any_2".toString().toLowerCase()
                      ] = "";
                    }

                    this.fSection1.push([
                      colsec1[
                      "Date_of_the_occurence_2".toString().toLowerCase()
                      ] +
                      " " +
                      colsec1[
                      "hour_of_the_occurence_2".toString().toLowerCase()
                      ],

                      colsec1[
                      "Place_of_the_occurence_or_situation_by_latitude_and_longitude_at_sea_2"
                        .toString()
                        .toLowerCase()
                      ],

                      colsec1["Date_of_Entry_2".toString().toLowerCase()],

                      colsec1[
                      "Entries_required_by_Regulations_made_under_Section_143_of_the_merchant_Shipping_Act_1976_2"
                        .toString()
                        .toLowerCase()
                      ],

                      colsec1[
                      "State_fine_imposed_if_any_2".toString().toLowerCase()
                      ],
                    ]);
                    this.userSign.push(usersign);
                  }
                }
              }

              console.log("mylog::mylog");
              this.createCollectionLayout(this.objcolsection);
              console.log(this.objcolsection);
              console.log("check-this.fSection1", this.fSection1);

              if (
                this.fSection1.length > 0 ||
                this.fSection5.length > 0 ||
                this.fSection2.length > 0 ||
                this.fSection6.length > 0 ||
                this.fSection3.length > 0 ||
                this.fSection4.length > 0
              ) {
                this.createCollectionLayout(this.fSection1);
                this.createCollectionLayout(this.fSection2);
                this.createCollectionLayout(this.fSection3);
                this.createCollectionLayout(this.fSection4);
                this.createCollectionLayout(this.fSection5);
                this.createCollectionLayout(this.fSection6);
                let dummyObj = [];

                dummyObj.push(this.fSection1);
                dummyObj.push(this.fSection2);
                dummyObj.push(this.fSection3);
                dummyObj.push(this.fSection4);
                dummyObj.push(this.fSection5);
                dummyObj.push(this.fSection6);
                this.objcolcollection = dummyObj;
              }
              console.log("check-this.objcolcollection", this.objcolcollection);
            }
          }
          );
        }
      }

      console.log(this.formCount);
    }
  }

  getFormdataAllformsDeckBook(
    hid,
    dateValue,
    timeValue = "",
    fromDate = "",
    toDate = ""
  ) {
    this.deckLogActionDate = dateValue;
    //console.log("Action Dates:" + dateValue +'--'+ timeValue +'--'+ fromDate +'--'+ toDate); return;

    //      if(btn==1 && dateValue!=null){
    //         this.searchDeckLog(dateValue);
    //      }else if(btn==1 && dateValue==null){alert("Please select a date to filter details"); return false;
    //      }
    //alert(this.createdDate);
    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          strFormId += this.formBuilder[i].formbuilderresponse[r].formId + ",";
          this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        this.loading=true;
        this.reportsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          dateValue,
          timeValue,
          fromDate,
          toDate,
          (multiresponse) => {
            this.loading=false;
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            //multiresponse = [{"responsecode":200,"data":[{"_id":{"$oid":"5e94073ea3744d47ef6f50c9"},"created_at":"2020-04-12 23:31:26","updated_at":"2020-04-12 23:31:26","watchId":1481,"voyageId":522,"voyageNo":"12345","vesselId":64,"formId":43,"rowId":"rowId1586697162972","is_sync":false,"is_mobile_sync":false,"sectionId":"117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0,117.0","changeFields":null,"userId":11,"userName":"K ROHIT GUPTA","userSign":"UQBAAAAAACALSEK%0AAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgA%0AAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAA%0AAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAA%0AAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAA%0AAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAA%0AAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAA%0AAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAA%0AAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAA%0AbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACw%0AJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCW%0AEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtC%0AFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlR%0AAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQB%0AAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAAAAAAAMCWEAUA%0AAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAA%0AAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAA%0AAAAAYEuIAgAAAAAAADU1nUYAAACSSURBVFtCFAAAAAAAANgSogAAAAAAAMCWEAUAAAAAAAC2hCgA%0AAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYEuIAgAAAAAAAFtCFAAAAAAAANgSogAA%0AAAAAAMCWEAUAAAAAAAC2hCgAAAAAAACwJUQBAAAAAACALSEKAAAAAAAAbAlRAAAAAAAAYCuyN3rJ%0ACyVu2AAAAABJRU5ErkJggg%3D%3D%0A","timeStamp":1586627950289,"actionDate":"11-Apr-2020","actionDateFormat":{"$date":"2020-04-11T07:00:00.000Z"},"actionTime":"08-12","Log_Reading_772":"","Course_773":"Log Reading","Course_True_774":"","Course_Gyro_775":"022","Course_Standard_776":"025","Gyro_Error_777":"","Wind_778":"Log Reading","Wind_Direction_779":"s","Wind_Force_780":"2","Sea_Height_781":"","Weather_and_visibility_782":"BCx7","Baro_Meter_783":"1010","Temperature_784":"Log Reading","Temerature_Dry_785":"33","Temperature_Wet_786":"30","Temperature_Sea_787":"","IG_Press_788":"","Look_Out_789":"1&3","Watch_Entry_Remarks_790":"0700LT-1200LT\n0700-watch taken over from 2 off.complied with company and port regulation.vsl moored at corinto port,berth no 3 port side alongside with 4+2 lines F&A.\ncrane NO 3 rounds taken.physical conditions checked.all in order.\nwaters around vessel checked no traces of pollution found.\nF-6.72,M-7.41,A-8.06. density -1.022","Watch_Entry_General_Comments_791":"cont discharging of fertilizers in progress from no 3 cargo hold by ships crane and shore grab.gangway and mooring attented at all times.fire safety rounds taken. security patrol rounds maintained ,no breach noticed.scupprrs and rat guards in place.no delay on vsl account.\ncalm harbour waters,partly cloudy sky and good visibility.\n1200-watch handed over to 2nd off","Watch_Entry_Crew_Work_792":""}]}];
            var signdate = "";
            var masterName = "";
            var masterSignature = "";
            var roleId = "";
            var roleName = "";
            var id = "";
            var chiefOfficersigndate = "";
            var chiefOfficerName = "";
            var chiefOfficerSignature = "";
            var chiefOfficerroleId = "";
            var chiefOfficerroleName = "";

            let newData = multiresponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    // [item.data[0].formId] : item.data[0]._id['$oid']
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            // console.log('FormIdObject_List_6', this.formIdObject);

            if (multiresponse != null && multiresponse.length > 0) {
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }

              console.log("====response111====");
              console.log(response);
              console.log("====response222====");
              // all form response loop
              for (let ky in response) {
                if (
                  response[ky].data != null &&
                  response[ky].data != undefined
                ) {
                  var sectionName = "";
                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;
                    var actionTime = response[ky].data[s].actionTime;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName.charAt(
                          this.formBuilder[i].formbuilderresponse[r].formName
                            .length - 1
                        );
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    var p = 0;

                    this.showpop = 0;
                    this.editedBy = "";
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }
                    var usersign = response[ky].data[s].userSign;

                    if (
                      response[ky].data[s].masterDate != null &&
                      response[ky].data[s].masterDate != ""
                    ) {
                      signdate = response[ky].data[s].masterDate;
                    }

                    if (
                      response[ky].data[s].masterName != null &&
                      response[ky].data[s].masterName != ""
                    ) {
                      masterName = response[ky].data[s].masterName;
                    }

                    if (
                      response[ky].data[s].masterSignature != null &&
                      response[ky].data[s].masterSignature != ""
                    ) {
                      masterSignature = response[ky].data[s].masterSignature;
                    }

                    if (
                      response[ky].data[s].masterRoleId != null &&
                      response[ky].data[s].masterRoleId != ""
                    ) {
                      roleId = response[ky].data[s].masterRoleId;
                    }

                    if (
                      response[ky].data[s].masterRoleName != null &&
                      response[ky].data[s].masterRoleName != ""
                    ) {
                      roleName = response[ky].data[s].masterRoleName;
                    }
                    if (
                      response[ky].data[s]._id.$oid != null &&
                      response[ky].data[s]._id.$oid != ""
                    ) {
                      id = response[ky].data[s]._id.$oid;
                    }

                    if (
                      response[ky].data[s].chiefOfficerDate != null &&
                      response[ky].data[s].chiefOfficerDate != ""
                    ) {
                      chiefOfficersigndate =
                        response[ky].data[s].chiefOfficerDate;
                    }

                    if (
                      response[ky].data[s].chiefOfficerName != null &&
                      response[ky].data[s].chiefOfficerName != ""
                    ) {
                      chiefOfficerName = response[ky].data[s].chiefOfficerName;
                    }

                    if (
                      response[ky].data[s].chiefOfficerSignature != null &&
                      response[ky].data[s].chiefOfficerSignature != ""
                    ) {
                      chiefOfficerSignature =
                        response[ky].data[s].chiefOfficerSignature;
                    }

                    if (
                      response[ky].data[s].chiefOfficerRoleId != null &&
                      response[ky].data[s].chiefOfficerRoleId != ""
                    ) {
                      chiefOfficerroleId =
                        response[ky].data[s].chiefOfficerRoleId;
                    }

                    if (
                      response[ky].data[s].chiefOfficerRoleName != null &&
                      response[ky].data[s].chiefOfficerRoleName != ""
                    ) {
                      chiefOfficerroleName =
                        response[ky].data[s].chiefOfficerRoleName;
                    }

                    this.masterSignature = masterSignature;
                    this.masterName = masterName;
                    this.signdate = signdate;
                    this.roleName = roleName;
                    //this.roleid = roleId;
                    this.id = id;
                    this.formId = formId;
                    this.chiefOfficerSignature = chiefOfficerSignature;
                    this.chiefOfficerName = chiefOfficerName;
                    this.chiefOfficersigndate = chiefOfficersigndate;
                    //this.chiefOfficerroleId = chiefOfficerroleId;
                    this.chiefOfficerroleName = chiefOfficerroleName;

                    for (let key in response[ky].data[s]) {
                      for (p = 0; p < this.formBuilderSections.length; p++) {
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          //alert(key.toString().toLowerCase());
                          //alert(key.toString().toLowerCase() + '-- field--' + this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase() + '_' + this.formBuilderSections[p].formbuilderlist[v].fieldId.toString().toLowerCase());

                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] =
                              this.formBuilderSections.length;
                          }

                          //(dateValue!=0 && this.createdDate == dateCheck) &&
                          if (
                            key.toString().toLowerCase() ==
                            this.formBuilderSections[p].formbuilderlist[
                              v
                            ].fieldName
                              .toString()
                              .toLowerCase() ||
                            key.toString().toLowerCase() == "watchid"
                          ) {
                            if (formId == 43) {
                              this.deckLogBook = 1;
                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Log_Reading_772".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_773".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_True_774".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_Gyro_775".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Course_Standard_776".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Gyro_Error_777".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_778".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Direction_779".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Force_780".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sea_Height_781".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Weather_and_visibility_782".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Baro_Meter_783".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_784".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temerature_Dry_785".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_Wet_786".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Temperature_Sea_787".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "IG_Press_788".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Look_Out_789".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_Remarks_790".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_General_Comments_791".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "watchId".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Watch_Entry_Crew_Work_792".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }

                            if (formId == 44) {
                              this.deckLogBook = 1;

                              if (p == 0) {
                                if (
                                  (key.toString().toLowerCase() ==
                                    "Noon_Position_793".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Noon_LAT_794".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Noon_LONG_795".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Next_Port_796".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ETA_797".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "miles_run_in_last_24_hrs_798".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "HRS_STMG_799".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "AV_SPD_800".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Wind_Force_801".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Consumption_For_Propulsion_802".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "propulsion_HFO_803".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "propulsion_MDO_804".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "heating_HFO_806".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "heating_MDO_807".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Consumption_for_cleaning_808".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Cleaning_HFO_809".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Cleaning_MDO_810".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Slow_Speed_811".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "N_Miles_812".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "speed_hrs_813".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "AV_RPM_814".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Slip_815".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Sea_Conditions_816".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_817".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_HFO_818".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_MDO_819".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_LSFO_820".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_MGO_821".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "ROB_FW_822".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "General_Comments_823".toLowerCase() &&
                                    response[ky].data[s][key] != "") ||
                                  (key.toString().toLowerCase() ==
                                    "Crew_Work_824".toLowerCase() &&
                                    response[ky].data[s][key] != "")
                                ) {
                                  colsec1[key.toString().toLowerCase()] =
                                    response[ky].data[s][key];
                                }
                              }
                            }
                          }
                        }
                      }
                    }

                    // end getting response data into array

                    if (formId == 43) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (colsec1["watchId".toString().toLowerCase()] != null) {
                        if (
                          colsec1["watchId".toString().toLowerCase()] == null
                        ) {
                          colsec1["watchId".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Course_773".toString().toLowerCase()] == null
                        ) {
                          colsec1["Course_773".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Course_Gyro_775".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Course_Gyro_775".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Course_Standard_776".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Course_Standard_776".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Gyro_Error_777".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Gyro_Error_777".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1["Wind_778".toString().toLowerCase()] == null
                        ) {
                          colsec1["Wind_778".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Wind_Direction_779".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Wind_Direction_779".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Wind_Force_780".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Wind_Force_780".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Sea_Height_781".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Sea_Height_781".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1[
                          "Weather_and_visibility_782"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Weather_and_visibility_782"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Temperature_784".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Temperature_784".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Temerature_Dry_785".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temerature_Dry_785".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Temperature_Wet_786".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temperature_Wet_786".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Temperature_Sea_787".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Temperature_Sea_787".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IG_Press_788".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IG_Press_788".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Look_Out_789".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Look_Out_789".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_General_Comments_791"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_General_Comments_791"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ] = "";
                        }

                        var watchHr = actionTime;
                        //

                        this.fSection1.push([
                          watchHr,
                          colsec1["Log_Reading_772".toString().toLowerCase()],
                          colsec1["Course_True_774".toString().toLowerCase()],
                          colsec1["Course_Gyro_775".toString().toLowerCase()],
                          colsec1[
                          "Course_Standard_776".toString().toLowerCase()
                          ],
                          colsec1["Gyro_Error_777".toString().toLowerCase()],
                          colsec1[
                          "Wind_Direction_779".toString().toLowerCase()
                          ],
                          colsec1["Wind_Force_780".toString().toLowerCase()],
                          colsec1["Sea_Height_781".toString().toLowerCase()],
                          colsec1[
                          "Weather_and_visibility_782"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1["Baro_Meter_783".toString().toLowerCase()],
                          colsec1[
                          "Temerature_Dry_785".toString().toLowerCase()
                          ],
                          colsec1[
                          "Temperature_Wet_786".toString().toLowerCase()
                          ],
                          colsec1[
                          "Temperature_Sea_787".toString().toLowerCase()
                          ],
                          colsec1["IG_Press_788".toString().toLowerCase()],
                          colsec1["Look_Out_789".toString().toLowerCase()],
                        ]);

                        this.fSection3.push([
                          colsec1[
                          "Watch_Entry_Remarks_790".toString().toLowerCase()
                          ],
                        ]);
                        this.fSection4.push([
                          colsec1[
                          "Watch_Entry_General_Comments_791"
                            .toString()
                            .toLowerCase()
                          ],
                        ]);
                        this.fSection5.push([
                          colsec1[
                          "Watch_Entry_Crew_Work_792".toString().toLowerCase()
                          ],
                        ]);

                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                      }
                    }

                    if (formId == 44) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var date = new Date(coldate["date_created"]);
                        var day = date.getDate();
                        var month = date.getMonth() + 1;
                        var year = date.getFullYear();

                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1[
                        "Consumption_For_Propulsion_802"
                          .toString()
                          .toLowerCase()
                        ] != null
                      ) {
                        if (
                          colsec1["watchId".toString().toLowerCase()] == null
                        ) {
                          colsec1["watchId".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Noon_Position_793".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Noon_Position_793".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Noon_LAT_794".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Noon_LAT_794".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Noon_LONG_795".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Noon_LONG_795".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Next_Port_796".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Next_Port_796".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1["ETA_797".toString().toLowerCase()] == null
                        ) {
                          colsec1["ETA_797".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "miles_run_in_last_24_hrs_798"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "miles_run_in_last_24_hrs_798"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["AV_SPD_800".toString().toLowerCase()] == null
                        ) {
                          colsec1["AV_SPD_800".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Wind_Force_801".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Wind_Force_801".toString().toLowerCase()] =
                            "";
                        }

                        if (
                          colsec1[
                          "Consumption_For_Propulsion_802"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Consumption_For_Propulsion_802"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "propulsion_HFO_803".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "propulsion_HFO_803".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "propulsion_MDO_804".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "propulsion_MDO_804".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Cosumption_for_heating_805"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Cosumption_for_heating_805"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["heating_HFO_806".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["heating_HFO_806".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["heating_MDO_807".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["heating_MDO_807".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Consumption_for_cleaning_808"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Consumption_for_cleaning_808"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Cleaning_HFO_809".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Cleaning_HFO_809".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Cleaning_MDO_810".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["Cleaning_MDO_810".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Slow_Speed_811".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Slow_Speed_811".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["N_Miles_812".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["N_Miles_812".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["speed_hrs_813".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["speed_hrs_813".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["AV_RPM_814".toString().toLowerCase()] == null
                        ) {
                          colsec1["AV_RPM_814".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Slip_815".toString().toLowerCase()] == null
                        ) {
                          colsec1["Slip_815".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Sea_Conditions_816".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Sea_Conditions_816".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["ROB_817".toString().toLowerCase()] == null
                        ) {
                          colsec1["ROB_817".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_HFO_818".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_HFO_818".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_MDO_819".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_MDO_819".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_MGO_821".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["ROB_MGO_821".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["ROB_FW_822".toString().toLowerCase()] == null
                        ) {
                          colsec1["ROB_FW_822".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "General_Comments_823".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "General_Comments_823".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Crew_Work_824".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Crew_Work_824".toString().toLowerCase()] =
                            "";
                        }

                        this.fSection2.push([
                          colsec1["Noon_LAT_794".toString().toLowerCase()],
                          colsec1["Noon_LONG_795".toString().toLowerCase()],
                          colsec1["Next_Port_796".toString().toLowerCase()] +
                          "-" +
                          colsec1["ETA_797".toString().toLowerCase()],
                          colsec1[
                          "miles_run_in_last_24_hrs_798"
                            .toString()
                            .toLowerCase()
                          ],
                          colsec1["HRS_STMG_799".toString().toLowerCase()],
                          colsec1["AV_SPD_800".toString().toLowerCase()],
                          colsec1["Wind_Force_801".toString().toLowerCase()],
                          colsec1[
                          "propulsion_HFO_803".toString().toLowerCase()
                          ] +
                          "-" +
                          colsec1[
                          "propulsion_MDO_804".toString().toLowerCase()
                          ],
                          colsec1["heating_HFO_806".toString().toLowerCase()] +
                          "-" +
                          colsec1["heating_MDO_807".toString().toLowerCase()],
                          colsec1["Cleaning_HFO_809".toString().toLowerCase()] +
                          "-" +
                          colsec1[
                          "Cleaning_MDO_810".toString().toLowerCase()
                          ],
                          colsec1["N_Miles_812".toString().toLowerCase()] +
                          "-" +
                          colsec1["speed_hrs_813".toString().toLowerCase()],
                          colsec1["AV_RPM_814".toString().toLowerCase()],
                          colsec1["Slip_815".toString().toLowerCase()],
                          colsec1[
                          "Sea_Conditions_816".toString().toLowerCase()
                          ],
                          //colsec1['Sea_Conditions_816'.toString().toLowerCase()] ,
                          colsec1["ROB_HFO_818".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_MDO_819".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_LSFO_820".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_MGO_821".toString().toLowerCase()] +
                          " " +
                          colsec1["ROB_FW_822".toString().toLowerCase()],
                        ]);

                        this.fSection6.push([
                          colsec1[
                          "General_Comments_823".toString().toLowerCase()
                          ],
                        ]);
                        this.fSection7.push([
                          colsec1["Crew_Work_824".toString().toLowerCase()],
                        ]);

                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                        this.userSign.push(usersign);
                      }
                    }

                    // end collection column data to make it tabular
                  }

                  // collection of data into seperate array to be used in html
                  console.log("mylog::mylog123");
                  console.log("check-this.fSection4", this.fSection1);
                  this.objcolcollection = [];

                  if (
                    this.fSection1.length > 0 ||
                    (this.fSection3.length > 0 &&
                      this.fSection5.length > 0 &&
                      this.fSection4.length > 0) ||
                    (this.fSection2.length > 0 &&
                      this.fSection6.length > 0 &&
                      this.fSection7.length > 0)
                  ) {
                    if (this.fSection1.length > 0)
                      this.createCollectionLayout(this.fSection1);

                    this.createCollectionLayout(this.fSection2);
                    this.createCollectionLayout(this.fSection3);
                    this.createCollectionLayout(this.fSection4);
                    this.createCollectionLayout(this.fSection5);
                    this.createCollectionLayout(this.fSection6);
                    this.createCollectionLayout(this.fSection7);

                    this.objcolcollection.push(this.fSection1);
                    this.objcolcollection.push(this.fSection2);
                    this.objcolcollection.push(this.fSection3);
                    this.objcolcollection.push(this.fSection4);
                    this.objcolcollection.push(this.fSection5);
                    this.objcolcollection.push(this.fSection6);
                    this.objcolcollection.push(this.fSection7);
                  }

                  console.log(this.objcolcollection);
                }
              }
            }
          }
        );

        break;
      }
    }
  }

  callEngineLogBookData(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    this.mainEngineData = [];
    this.cleanReports();
    console.log("===this.formId===", this.formId);
    console.log("===hid===", hid);
    console.log("===actionDate===", actionDate);
    console.log("===actionTime===", actionTime);
    console.log("===fromDate===", fromDate);
    console.log("===toDate===", toDate);
    this.signdate = '';
    this.masterName = '';
    this.masterSignature = '';
    this.id = '';
    this.loading=true;
    this.reportsService.getFormDetailsByActionDateAndTime(
      this.formId,
      this.voyageNo,
      actionDate,
      actionTime,
      fromDate,
      toDate,
      (formResponse) => {
        this.loading=false;
        console.log(
          "====getFormDetailsByActionDateAndTime formResponse===",
          formResponse
        );
        var usersign = '';
        var vesselId = '';
        var voyageNo = '';

        let newData = formResponse.map((item) => {
          if (item && item.data && item.data[item.data.length - 1].formId) {
            if (item.data && item.data[item.data.length - 1].formId) {
              let itemId = {
                [item.data[item.data.length - 1].formId]: item.data[item.data.length - 1]._id['$oid']
                // [item.data[0].formId] : item.data[item.data.length - 1]._id['$oid']
              };
              return item.data && item.data[item.data.length - 1].formId && itemId;
            }
            return item && item;
          }
        });


        const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
        console.log("mergedObject ::", mergedObject);
        this.formIdObject = mergedObject;
        // console.log('FormIdObject_List_7', newData, this.formIdObject);

        if (hid == 7 || hid == 9) {

          var dataLen = formResponse[0].data.length;
          console.log("==length===", dataLen);
          dataLen = parseInt(dataLen) - 1;
          console.log("==dataLen===", dataLen);

          this.mainEngineData = formResponse;

          if (formResponse[0].data != undefined) {
            if (formResponse[0].data[dataLen].date != null && formResponse[0].data[dataLen].date != '') {
              this.signdate = formResponse[0].data[dataLen].date;
            }
            if (formResponse[0].data[dataLen].masterName != null && formResponse[0].data[dataLen].masterName != '') {
              this.masterName = formResponse[0].data[dataLen].masterName;
            }
            if (formResponse[0].data[dataLen].formId != null && formResponse[0].data[dataLen].formId != '') {
              this.formId = formResponse[0].data[dataLen].formId;
            }
            if (formResponse[0].data[dataLen].masterRoleName != null && formResponse[0].data[dataLen].masterRoleName != '') {
              this.roleName = formResponse[0].data[dataLen].masterRoleName;
            }
            if (formResponse[0].data[dataLen]._id.$oid != null && formResponse[0].data[dataLen]._id.$oid != '') {
              this.id = formResponse[0].data[dataLen]._id.$oid;
            }
            if (formResponse[0].data[dataLen].masterSignature != null && formResponse[0].data[dataLen].masterSignature != '') {
              this.masterSignature = formResponse[0].data[dataLen].masterSignature;
              console.log("masterSignature inside if-else :::",);
            }
            if (formResponse[0].data[dataLen].usersign != null && formResponse[0].data[dataLen].usersign != '') {
              usersign = formResponse[0].data[dataLen].usersign;
            }
            if (formResponse[0].data[dataLen].vesselId != null && formResponse[0].data[dataLen].vesselId != '') {
              vesselId = formResponse[0].data[dataLen].vesselId;
            }
            if (formResponse[0].data[dataLen].voyageNo != null && formResponse[0].data[dataLen].voyageNo != '') {
              voyageNo = formResponse[0].data[dataLen].voyageNo;
            }

          } else if (formResponse[1].data != undefined) {

            if (formResponse[1].data[dataLen].date != null && formResponse[1].data[dataLen].date != '') {
              this.signdate = formResponse[1].data[dataLen].date;
            }
            if (formResponse[1].data[dataLen].masterName != null && formResponse[1].data[dataLen].masterName != '') {
              this.masterName = formResponse[1].data[dataLen].masterName;
            }
            if (formResponse[1].data[dataLen].formId != null && formResponse[1].data[dataLen].formId != '') {
              this.formId = formResponse[1].data[dataLen].formId;
            }
            if (formResponse[1].data[dataLen].masterRoleName != null && formResponse[1].data[dataLen].masterRoleName != '') {
              this.roleName = formResponse[1].data[dataLen].masterRoleName;
            }
            if (formResponse[1].data[dataLen]._id.$oid != null && formResponse[1].data[dataLen]._id.$oid != '') {
              this.id = formResponse[1].data[dataLen]._id.$oid;
            }
            if (formResponse[1].data[dataLen].masterSignature != null && formResponse[1].data[dataLen].masterSignature != '') {
              this.masterSignature = formResponse[1].data[dataLen].masterSignature;
              console.log("masterSignature inside if-else :::");
            }
            if (formResponse[1].data[dataLen].usersign != null && formResponse[1].data[dataLen].usersign != '') {
              usersign = formResponse[1].data[dataLen].usersign;
            }
            if (formResponse[1].data[dataLen].vesselId != null && formResponse[1].data[dataLen].vesselId != '') {
              vesselId = formResponse[1].data[dataLen].vesselId;
            }
            if (formResponse[1].data[dataLen].voyageNo != null && formResponse[1].data[dataLen].voyageNo != '') {
              voyageNo = formResponse[1].data[dataLen].voyageNo;
            }
            // this.signdate = formResponse[1].data[0].date;
            // this.masterName = formResponse[1].data[0].masterName;
            // this.formId = formResponse[1].data[0].formId;
            // this.roleName = formResponse[1].data[0].masterRoleName;
            // this.id = formResponse[1].data[0]._id.$oid;
            // this.masterSignature = formResponse[1].data[0].masterSignature;
            // usersign = formResponse[1].data[0].userSign;
            // usersign = formResponse[1].data[0].userSign;
            // vesselId = formResponse[1].data[0].vesselId;
            // voyageNo = formResponse[1].data[0].voyageNo;

          } else if (formResponse[2].data != undefined) {


            if (formResponse[2].data[dataLen].date != null && formResponse[2].data[dataLen].date != '') {
              this.signdate = formResponse[2].data[dataLen].date;
            }
            if (formResponse[2].data[dataLen].masterName != null && formResponse[2].data[dataLen].masterName != '') {
              this.masterName = formResponse[2].data[dataLen].masterName;
            }
            if (formResponse[2].data[dataLen].formId != null && formResponse[2].data[dataLen].formId != '') {
              this.formId = formResponse[2].data[dataLen].formId;
            }
            if (formResponse[2].data[dataLen].masterRoleName != null && formResponse[2].data[dataLen].masterRoleName != '') {
              this.roleName = formResponse[2].data[dataLen].masterRoleName;
            }
            if (formResponse[2].data[dataLen]._id.$oid != null && formResponse[2].data[dataLen]._id.$oid != '') {
              this.id = formResponse[2].data[dataLen]._id.$oid;
            }
            if (formResponse[2].data[dataLen].masterSignature != null && formResponse[2].data[dataLen].masterSignature != '') {
              this.masterSignature = formResponse[2].data[dataLen].masterSignature;
              console.log("masterSignature inside if-else :::");
            }
            if (formResponse[2].data[dataLen].usersign != null && formResponse[2].data[dataLen].usersign != '') {
              usersign = formResponse[2].data[dataLen].usersign;
            }
            if (formResponse[2].data[dataLen].vesselId != null && formResponse[2].data[dataLen].vesselId != '') {
              vesselId = formResponse[2].data[dataLen].vesselId;
            }
            if (formResponse[2].data[dataLen].voyageNo != null && formResponse[2].data[dataLen].voyageNo != '') {
              voyageNo = formResponse[2].data[dataLen].voyageNo;
            }

            // this.signdate = formResponse[2].data[0].date;
            // this.masterName = formResponse[2].data[0].masterName;
            // this.formId = formResponse[2].data[0].formId;
            // this.roleName = formResponse[2].data[0].masterRoleName;
            // this.id = formResponse[2].data[0]._id.$oid;
            // this.masterSignature = formResponse[2].data[0].masterSignature;
            // usersign = formResponse[2].data[0].userSign;
            // usersign = formResponse[2].data[0].userSign;
            // vesselId = formResponse[2].data[0].vesselId;
            // voyageNo = formResponse[2].data[0].voyageNo;
          }
          this.userSign.push(usersign);


          // if (
          //   formResponse[0].data[0].masterName != null &&
          //   formResponse[0].data[0].masterName != ""
          // ) {
          //   this.masterName = formResponse[0].data[0].masterName;
          // }

          // if (
          //   formResponse[0].data[0].masterSignature != null &&
          //   formResponse[0].data[0].masterSignature != ""
          // ) {
          //   this.masterSignature = formResponse[0].data[0].masterSignature;
          // }

          // if (
          //   formResponse[0].data[0].formId != null &&
          //   formResponse[0].data[0].formId != ""
          // ) {
          //   this.formId = formResponse[0].data[0].formId;
          // }

          // if (
          //   formResponse[0].data[0].masterRoleName != null &&
          //   formResponse[0].data[0].masterRoleName != ""
          // ) {
          //   this.roleName = formResponse[0].data[0].masterRoleName;
          // }
          // if (
          //   formResponse[0].data[0]._id.$oid != null &&
          //   formResponse[0].data[0]._id.$oid != ""
          // ) {
          //   this.id = formResponse[0].data[0]._id.$oid;
          // }

          // var usersign = formResponse[0].data[0].userSign;
          // this.userSign.push(usersign);

          this.getFormRecordsList = [];
          console.log("===this.formId===122", this.formId, this.formIdObject);
        } else if (formResponse[0].data != null) {
          var dataLen = formResponse[0].data.length;
          console.log("==length===", dataLen);
          dataLen = parseInt(dataLen) - 1;
          console.log("==dataLen===", dataLen);
          this.mainEngineData[0] = formResponse[0].data[dataLen];
          this.id = formResponse[0].data[dataLen]._id.$oid;
          vesselId = formResponse[0].data[dataLen].vesselId;
          voyageNo = formResponse[0].data[dataLen].voyageNo;

          if (
            formResponse[0].data[dataLen].date != null &&
            formResponse[0].data[dataLen].date != ""
          ) {
            this.signdate = formResponse[0].data[dataLen].date;
          }

          if (
            formResponse[0].data[dataLen].masterName != null &&
            formResponse[0].data[dataLen].masterName != ""
          ) {
            this.masterName = formResponse[0].data[dataLen].masterName;
          }

          if (
            formResponse[0].data[dataLen].masterSignature != null &&
            formResponse[0].data[dataLen].masterSignature != ""
          ) {
            this.masterSignature = formResponse[0].data[dataLen].masterSignature;
          }

          if (
            formResponse[0].data[dataLen].formId != null &&
            formResponse[0].data[dataLen].formId != ""
          ) {
            this.formId = formResponse[0].data[dataLen].formId;
          }

          if (
            formResponse[0].data[dataLen].masterRoleName != null &&
            formResponse[0].data[dataLen].masterRoleName != ""
          ) {
            this.roleName = formResponse[0].data[dataLen].masterRoleName;
          }
          if (
            formResponse[0].data[dataLen]._id.$oid != null &&
            formResponse[0].data[dataLen]._id.$oid != ""
          ) {
            this.id = formResponse[0].data[dataLen]._id.$oid;
          }

          usersign = formResponse[0].data[dataLen].userSign;
          this.userSign.push(usersign);



          this.getFormRecordsList = [];
        }
        console.log("====this.signdate====", this.signdate);
        console.log("====this.masterName====", this.masterName);
        console.log("====this.masterSignature====", this.masterSignature);
        this.showLogBookHID = hid;
        console.log("===mainEngineData==", this.mainEngineData);
        console.log("===mainEngineData length==", this.mainEngineData.length);
        this.getFormRecordsList = [];
        this.vesselInfo = [];
        if (vesselId && voyageNo) {
          this.reportsService.getCOSPByvesselId(vesselId, voyageNo,
            (responseData) => {
              console.log(
                "====getCOSPByvesselId responseData===",
                responseData
              );
              if (responseData.data != null && responseData.data.length > 0) {
                this.vesselInfo = responseData.data;
                console.log("===vesselInfo ==", this.vesselInfo);
              }
            }
          );
        }
      }
    );

    if (hid == 6) {
      this.vesselInfo = [];
      this.reportsService.getCOSPByvesselId(
        this.currentVessel,
        this.voyageNo,
        (formResponse) => {
          console.log("====Response===", formResponse);
          this.vesselInfo = formResponse;
          console.log("===vesselInfo ==", this.vesselInfo);
        }
      );
    }
  }

  counter(i: number) {
    return new Array(i);
  }

  onReportClick(index: number, id: number, event: Event) {

    if (!this.selectedVoyage) {
      this.showErrMsg('Wait...', this.companyList.length > 0
        ? "Please select a company, vessel and voyage before proceeding."
        : "Please select a vessel and voyage before proceeding.")
      return;
    }

    this.currentBook = index;
    this.cleanReports();

    if (id !== 56) {
      for (let book1 of this.bookType[this.currentBook].children) {
        this.callHTypeGarbeg(book1.hName, book1.id, 0, 0, '');
        return 1;
      }
    }

    if (id == 56) {
      this.cleanReports();
      this.show = 'RECORD OF ENGINE PARAMETERS REPORT';
    }
  }


  cleanReports() {
    this.garbegForm1 = 0;
    this.garbegForm2 = 0;
    this.blstForm = 0;
    this.orbForm = 0;
    this.auditform = 0;
    this.oilnozoneForm = 0;
    this.showpop = 0;
    this.showpop2 = 0;
    this.showpop3 = 0;
    this.showpop4 = 0;
    this.showpop1 = 0;
    this.showpop5 = 0;
    this.showpop6 = 0;
    this.showpop7 = 0;
    this.showpop8 = 0;
    this.showpop9 = 0;
    this.showpop10 = 0;
    this.showpop11 = 0;
    this.showpop12 = 0;
    this.showpop13 = 0;
    this.showpop14 = 0;
    this.showpop15 = 0;
    this.showpop16 = 0;
    this.showpop17 = 0;
    this.showpop18 = 0;
    this.showpop19 = 0;
    this.deckLogBook = 0;
    this.orbpart2 = 0;
    this.olb = 0;
    this.objcolcollection = [];
    this.fSection1 = [];
    this.fSection2 = [];
    this.fSection3 = [];
    this.fSection4 = [];
    this.fSection5 = [];
    this.fSection6 = [];
    this.gmdss = 0;
    this.mainEngineData = [];
    this.show = '';
    this.showLogBookHID = -1;
  }

  onSubReport(id, event: Event) {
    this.showLogBookHID = id;
  }

  searchDeckLog(val) {
    var mydate = new Date(val);
    var month = mydate.getMonth() + 1;
    var year = mydate.getFullYear();
    var date = mydate.getDate();
    var strmon = month.toString();
    if (month != 10 && month != 11 && month != 12) {
      strmon = "0" + month;
    }
    this.createdDate = date + "-" + strmon + "-" + year;
    this.showpop = 0;
    this.objcolcollection = [];
  }

  checkDeckLogDateWise(date, watchId) {
    if (watchId != "") {
      for (var wh = 0; wh < this.watchHours.length; wh++) {
        if (date == this.watchHours[wh].date) {
          for (var hrs = 0; hrs < this.watchHours[wh].watchHour.length; hrs++) {
            if (this.watchHours[wh].watchHour[hrs].id == watchId) {
              return true;
            }
          }
        }
      }
    }

    return false;
  }

  in_array(array, id) {
    return array.some(function (o) {
      return o["section"] === id;
    });
  }

  onSubReportPop(id, bookstatus) {
    console.log("===onSubReportPop hid===", id);
    this.showLogBookHID = "";

    if (id == "49-3") {
      this.showpop9 = 1;
      var fineStringFormsId = "67,68";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          console.log('==gmdss-radio-log-getFormRecordsList==', this.getFormRecordsList);
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == 37) {
      this.showpop4 = 1;
      var fineStringFormsId =
        "49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];
          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == 36) {
      this.showpop3 = 1;
      var fineStringFormsId = "32,33,34,35,36,37";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];
          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == 42) {
      if(bookstatus == 'inner-book') {
      this.showpop1 = 1;
    }
      var fineStringFormsId = "40";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (id == 43) {
      this.showpop2 = 1;
      var fineStringFormsId = "41";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (id == 47) {
      this.showpop5 = 1;
      var fineStringFormsId = "47";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (id == 48) {
      this.showpop6 = 1;
      var fineStringFormsId = "48";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (id == 40) {
      this.showpop8 = 1;
      var fineStringFormsId = "39";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (
      id == 6 ||
      id == 7 ||
      id == 46 ||
      id == 8 ||
      id == 45 ||
      id == 17 ||
      id == 12 ||
      id == 9 ||
      id == 14
    ) {
      //} else if (id == 6 || id == 7 || id == 46 || id == 8 || id == 45) {

      var fromDate = '';
      var toDate = '';
      if (document.getElementById("dp4") != undefined && document.getElementById("dp3") != undefined) {
        fromDate = (document.getElementById("dp4") as HTMLInputElement).value;
        fromDate = this.datePipe.transform(fromDate, "dd-MMM-yyyy");
        toDate = (document.getElementById("dp3") as HTMLInputElement).value;
        toDate = this.datePipe.transform(toDate, "dd-MMM-yyyy");
      }

      if (id == 6) {
        this.formId = "22";
        this.reportTitle = "Main Engine";
      } else if (id == 7) {
        this.formId = "1,20,21";
        this.reportTitle = "Auxiliary Engine";
      } else if (id == 46) {
        this.formId = "46";
        this.reportTitle = "Noon Report";
      } else if (id == 8) {
        this.formId = "2";
        this.reportTitle = "Reefer Report";
      } else if (id == 45) {
        this.formId = "45";
        this.reportTitle = "Running counters and Consumptions";
      } else if (id == 17) {
        this.formId = "18";
        this.reportTitle = "Boiler";
      } else if (id == 12) {
        this.formId = "13";
        this.reportTitle = "F W Generator";
      } else if (id == 9) {
        this.formId = "4,6";
        this.reportTitle = "Air Condition";
      } else if (id == 14) {
        this.formId = "15";
        this.reportTitle = "Incinerator";
      }
      console.log("===formId==" + this.formId);
      this.getFormRecordsList = [];
      this.showLogBookHID = id;
      if (fromDate && toDate) {
        this.reportsService.getFormDataWithAllRecordsByVoyageNoWithFromToDateTime(
          this.formId,
          this.voyageNo,
          fromDate,
          toDate,
          (response) => {
            this.loading = false;
            this.getFormRecordsList = response;
            console.log("===this.response[0].data===", response[0].data);
            this.filteredFormRecordsList = response[0].data;
            this.createWatchHoursJson()
            console.log("===this.getFormRecordsList===", this.getFormRecordsList);
          }
        );
      } else {
        this.reportsService.getFormDetailsByIds(
          this.formId,
          this.voyageNo,
          (response) => {
            this.loading = false;
            this.getFormRecordsList = response;
            console.log("===this.response[0].data===", response[0].data);
            this.filteredFormRecordsList = response[0].data;
            this.createWatchHoursJson()
            console.log("===this.getFormRecordsList===", this.getFormRecordsList);
          }
        );
      }
    } else if (id == 39) {
      //alert('hi');
      this.showpop7 = 1;
      var fineStringFormsId = "38";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          console.log(response[0].data);
          this.getFormRecordsList = response;
          console.log("===this.response[0].data===", response[0].data);
          this.filteredFormRecordsList = response[0].data;
        }
      );
    } else if (id == "53-1") {
      this.showpop10 = 1;
      var fineStringFormsId = "69";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-2") {
      this.showpop11 = 1;
      var fineStringFormsId = "70";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          console.log('==constructArray==', constructArray)

          this.getFormRecordsList = constructArray;
          console.log('==getFormRecordsList==', this.getFormRecordsList)
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-3") {
      this.showpop12 = 1;
      var fineStringFormsId = "71";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-4") {
      this.showpop13 = 1;
      var fineStringFormsId = "72";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-5") {
      this.showpop14 = 1;
      var fineStringFormsId = "73";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }


          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-6") {
      this.showpop15 = 1;
      var fineStringFormsId = "74";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-7") {
      this.showpop16 = 1;
      var fineStringFormsId = "75";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];
          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-8") {
      this.showpop17 = 1;
      var fineStringFormsId = "76";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-9") {
      this.showpop18 = 1;
      var fineStringFormsId = "77";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == "53-10") {
      this.showpop19 = 1;
      var fineStringFormsId = "78";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          combindResponse = _.sortBy(combindResponse, "timeStamp");
          console.log(combindResponse);
          this.getFormRecordsList = _.groupBy(combindResponse, "actionDate");
          console.log(this.getFormRecordsList);
          var constructArray = [];

          interface RecordItem {
            actionTime?: string;
            isEdit?: boolean;
          }

          for (const [key, value] of Object.entries(this.getFormRecordsList)) {
            const item = value as RecordItem;

            constructArray.push({
              actionDate: key,
              actionTime: item.actionTime || "",
              isEdit: item.isEdit !== undefined ? item.isEdit : false
            });
          }

          this.getFormRecordsList = constructArray;
          this.filteredFormRecordsList = constructArray;
        }
      );
    } else if (id == 44) {
      this.showpop = 1;
      var fineStringFormsId = "43,44";
      this.reportsService.getFormDetailsByIds(
        fineStringFormsId,
        this.voyageNo,
        (response) => {
          this.loading = false;
          var combindResponse = [];
          for (let key in response) {
            for (let ky in response[key].data) {
              combindResponse.push(response[key].data[ky]);
            }
          }
          var combindResponse1 = _.groupBy(
            combindResponse,
            "actionDate"
          );
          console.log("==this.combindResponse1+++++==", combindResponse1);
          this.allDeckLogBookGroupByDate = _.sortBy(combindResponse1, "actionDate");
          console.log("==this.allDeckLogBookGroupByDate==", this.allDeckLogBookGroupByDate);
        }
      );
    }else{
      this.loading=false;
    }
  }


  filterListByDateRange() {
    // Apply date range filter if both dates are set
    if (this.fromDate && this.toDate) {
      this.filteredFormRecordsList = this.filteredFormRecordsList.filter(item => {
        const actionDate = new Date(item.actionDate);
        const from = new Date(this.fromDate);
        const to = new Date(this.toDate);
        return actionDate >= from && actionDate <= to;
      });
    } else if (this.fromDate) {
      // Filter by "from" date
      const from = new Date(this.fromDate);
      this.filteredFormRecordsList = this.filteredFormRecordsList.filter(item => {
        const actionDate = new Date(item.actionDate);
        return actionDate >= from;
      });
    } else if (this.toDate) {
      // Filter by "to" date
      const to = new Date(this.toDate);
      this.filteredFormRecordsList = this.filteredFormRecordsList.filter(item => {
        const actionDate = new Date(item.actionDate);
        return actionDate <= to;
      });
    } else {
      // If no date range is set, show full list
      this.filteredFormRecordsList = this.getFormRecordsList[0].data;
    }
  }

  filterListByStatus(bookType? : string) {
    console.log('==bookType==', bookType)
    // Always start fresh from original data

    if(bookType !== 'officallogBook' && bookType !== 'oilRecordBook' && bookType !== 'gmdsseadiologbook') {
      var filtered = this.getFormRecordsList[0].data;
    }

    if(bookType == 'officallogBook') {
      console.log('==filterListByStatus-getFormRecordsList==', this.getFormRecordsList);
      var filtered = this.getFormRecordsList;
    }

    if(bookType == 'oilRecordBook') {
      console.log('==filterListByStatus-oilRecordBook-getFormRecordsList==', this.getFormRecordsList);
      var filtered = this.getFormRecordsList;
      console.log('==-innerfiltered==', filtered);
    }

    if(bookType == 'gmdsseadiologbook') {
      console.log('==filterListByStatus-gmdsseadiologbook-getFormRecordsList==', this.getFormRecordsList);
      var filtered = this.getFormRecordsList;
      console.log('==-innerfiltered==', filtered);
    }



    console.log('==filtered==', filtered);

    // Apply status filter if any
    if (this.selectedStatus !== '') {
      filtered = filtered.filter(item => String(item.isEdit) === this.selectedStatus);
    }

    // Apply date range filter on top
    if (this.fromDate || this.toDate) {
      filtered = filtered.filter(item => {
        const actionDate = new Date(item.actionDate);
        const from = this.fromDate ? new Date(this.fromDate) : null;
        const to = this.toDate ? new Date(this.toDate) : null;

        if (from && to) {
          return actionDate >= from && actionDate <= to;
        } else if (from) {
          return actionDate >= from;
        } else if (to) {
          return actionDate <= to;
        }
        return true;
      });
    }

    // Finally assign the result
    this.filteredFormRecordsList = filtered;
  }

  clearDateFilter(bookType? : string) {
    console.log('==clearDateFilter-bookType==', bookType);
    this.fromDate = '';
    this.toDate = '';
    this.selectedStatus = '';

    if(bookType == 'officallogBook') {
      console.log('==officallogBook-trigger==')
      this.filterListByStatus('officallogBook');
    }

    if(bookType == 'oilRecordBook') {
      console.log('==oilRecordBook-trigger==')
      this.filterListByStatus('oilRecordBook');
    }

    if(bookType == 'gmdsseadiologbook') {
      console.log('==gmdsseadiologbook-trigger==')
      this.filterListByStatus('gmdsseadiologbook');
    }


    if(bookType !== 'officallogBook' && bookType !== 'oilRecordBook' && bookType !== 'gmdsseadiologbook') {
      console.log('==normal-trigger==')
      this.filterListByStatus();
    }
  }



  gmdss_log_book(hid) {
    if (hid == 49) {
      this.gmdss = 1;
    } else if (hid == "49-1") {
      this.gmdss = 2;
    } else if (hid == "49-2") {
      this.gmdss = 3;
    } else if (hid == "49-3") {
      this.gmdss = 4;
    }
    hid = 49;

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        this.showpop9 = 0;

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 67 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 68
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);
        //  this.reportsService.getFormDetailsByActionDateAndTime(fineStringFormsId,this.voyageNo,actionDate,actionTime,fromDate,toDate,(multiresponse) => {
        this.reportsService.getFormDetails(
          fineStringFormsId,
          this.voyageNo,
          (multiresponse) => {
            this.loading = false;
            let newData = multiresponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    // [item.data[0].formId] : item.data[0]._id['$oid']
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            // console.log('FormIdObject_List_8', this.formIdObject);

            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var colsec9 = [];
            if (multiresponse != null && multiresponse.length > 0) {
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }
              // all form response loop
              console.log("response");
              //console.log(response);
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";

                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;

                    this.editedBy = "";
                    var usersign = "";
                    console.log("===chanage value checking====");
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    //alert(this.editedBy); return;

                    usersign = response[ky].data[s].userSign;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    //console.log();
                    for (let key in response[ky].data[s]) {
                      var sectionlength = this.formBuilderSections.length;
                      if (sectionlength == 4) {
                        sectionlength = 3;
                      }

                      for (var p = 0; p < sectionlength; p++) {
                        //alert(p)
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] = sectionlength;
                          }
                          //if(key.toString().toLowerCase()==this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase()){
                          if (formId == 67) {
                            //this.gmdss = 1;
                            if (p == 0) {
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1622".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "call_sign_1623".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "MMSI_1624".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_of_registry_1625".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "IMO_number_1626".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Gross_tonage_1627".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_kneel_laid_1628".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1629".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sea_area_1630".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_of_expiry_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1632".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "indicate_methods_1633".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "duplication_of_equipment_1534".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1635".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1636".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "shore_1637".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1638".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "no_1639".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Details_of_service_company_1640".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1641".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Adress_1642".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "maintanence_capability_1643".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1644".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1645".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "owner_name_1646".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1647".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1648".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Managing_owner_1649".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1650".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1651".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 1) {
                              //                                                                                      if((key.toString().toLowerCase()=='Name_1653'.toLowerCase() && response[ky].data[s][key]!='') ){
                              //                                                                                          alert(response[ky].data[s][key])
                              //                                                                                          colsec2[key.toString().toLowerCase()] = response[ky].data[s][key];
                              //                                                                                      }

                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1653".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "dates_1654".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1655".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "DATE_1656".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "To_1657".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1658".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "classes_1659".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "class_1660".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1661".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certificate_1662".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certi_1663".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "responsibility_1664".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1665".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Ranks_1666".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "entries_1667".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1668".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "ranks_1669".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec2[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 2) {
                              //this.gmdss = 3;
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1670".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "number_1671".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "period_1672".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1673".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1674".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "to_1675".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1676".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Delivered_1677".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_1678".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "text_1679".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "port_1680".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "day_1681".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1682".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1683".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1684".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Counter_sign_1685".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1686".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec3[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          if (formId == 68) {
                            if (p == 0) {
                              // this.gmdss = 4;
                              if (
                                (key.toString().toLowerCase() ==
                                  "vessel_name_1700".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1704".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1705".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "time_1706".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1707".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_from_1708".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_to_1709".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "remarks_1710".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "channel_1711".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1712".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                                if (
                                  key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase()
                                ) {
                                  this.mvsv = response[ky].data[s][key];
                                }
                                if (
                                  key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase()
                                ) {
                                  this.calsign = response[ky].data[s][key];
                                }
                                if (
                                  key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase()
                                ) {
                                  this.mmsi = response[ky].data[s][key];
                                }
                              }
                            }
                          }

                          //j}
                        }
                      }
                    }

                    //add form values
                    if (formId == 67) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["IMO_number_1626".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "Name_of_ship_1622".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1622".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["call_sign_1623".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["call_sign_1623".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["MMSI_1624".toString().toLowerCase()] == null
                        ) {
                          colsec1["MMSI_1624".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Port_of_registry_1625".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Port_of_registry_1625".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IMO_number_1626".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IMO_number_1626".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Gross_tonage_1627".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Gross_tonage_1627".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_kneel_laid_1628".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_kneel_laid_1628".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1629".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1629".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sea_area_1630".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["sea_area_1630".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_expiry_1631".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_expiry_1631".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1632".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1632".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "indicate_methods_1633".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "indicate_methods_1633".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "duplication_of_equipment_1534"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "duplication_of_equipment_1534"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1635".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1635".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1636".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1636".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["shore_1637".toString().toLowerCase()] == null
                        ) {
                          colsec1["shore_1637".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["yes_1638".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1638".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["no_1639".toString().toLowerCase()] == null
                        ) {
                          colsec1["no_1639".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Details_of_service_company_1640"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Details_of_service_company_1640"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1641".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1641".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Adress_1642".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Adress_1642".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "maintanence_capability_1643"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "maintanence_capability_1643"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1644".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1644".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1645".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1645".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["owner_name_1646".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["owner_name_1646".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Name_1647".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1647".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1648".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1648".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Managing_owner_1649".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Managing_owner_1649".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1650".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1650".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1651".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1651".toString().toLowerCase()] = "";
                        }

                        this.fSection1.push(colsec1);
                      }

                      if (
                        colsec2["Name_1653".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec2["Name_1631".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1631".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1653".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1653".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["dates_1654".toString().toLowerCase()] == null
                        ) {
                          colsec2["dates_1654".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["from_1655".toString().toLowerCase()] == null
                        ) {
                          colsec2["from_1655".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["DATE_1656".toString().toLowerCase()] == null
                        ) {
                          colsec2["DATE_1656".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["To_1657".toString().toLowerCase()] == null
                        ) {
                          colsec2["To_1657".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Date_1658".toString().toLowerCase()] == null
                        ) {
                          colsec2["Date_1658".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["classes_1659".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["classes_1659".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["class_1660".toString().toLowerCase()] == null
                        ) {
                          colsec2["class_1660".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["date_1661".toString().toLowerCase()] == null
                        ) {
                          colsec2["date_1661".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "certificate_1662".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["certificate_1662".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["certi_1663".toString().toLowerCase()] == null
                        ) {
                          colsec2["certi_1663".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "responsibility_1664".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "responsibility_1664".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2["Name_1665".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1665".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Ranks_1666".toString().toLowerCase()] == null
                        ) {
                          colsec2["Ranks_1666".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["entries_1667".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["entries_1667".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1668".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1668".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["ranks_1669".toString().toLowerCase()] == null
                        ) {
                          colsec2["ranks_1669".toString().toLowerCase()] = "";
                        }
                        //console.log("second data:");
                        //console.log(colsec2);
                        this.fSection2.push(response[ky].data[s]);
                      }

                      if (
                        colsec3["from_1673".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec3[
                          "Name_of_ship_1670".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1670".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["number_1671".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["number_1671".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["period_1672".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["period_1672".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["from_1673".toString().toLowerCase()] == null
                        ) {
                          colsec3["from_1673".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1674".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1674".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["to_1675".toString().toLowerCase()] == null
                        ) {
                          colsec3["to_1675".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Date_1676".toString().toLowerCase()] == null
                        ) {
                          colsec3["Date_1676".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Delivered_1677".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Delivered_1677".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Port_1678".toString().toLowerCase()] == null
                        ) {
                          colsec3["Port_1678".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["text_1679".toString().toLowerCase()] == null
                        ) {
                          colsec3["text_1679".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["port_1680".toString().toLowerCase()] == null
                        ) {
                          colsec3["port_1680".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["day_1681".toString().toLowerCase()] == null
                        ) {
                          colsec3["day_1681".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1682".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1682".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["sign_1683".toString().toLowerCase()] == null
                        ) {
                          colsec3["sign_1683".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["signature_1684".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1684".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Counter_sign_1685".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Counter_sign_1685".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["signature_1686".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1686".toString().toLowerCase()] =
                            "";
                        }
                        this.fSection3.push(colsec3);
                      }
                    }

                    if (formId == 68) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["utc_1707".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec1[
                          "vessel_name_1700".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["vessel_name_1700".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["name_1701".toString().toLowerCase()] == null
                        ) {
                          colsec1["name_1701".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["calisign_1702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["calisign_1702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["textbox_1703".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["textbox_1703".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["date_1704".toString().toLowerCase()] == null
                        ) {
                          colsec1["date_1704".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1705".toString().toLowerCase()] == null
                        ) {
                          colsec1["utc_1705".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["time_1706".toString().toLowerCase()] == null
                        ) {
                          colsec1["time_1706".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1707".toString().toLowerCase()] == null
                        ) {
                          colsec1[
                            "station_from_1708".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "station_from_1708".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "station_from_1695".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["station_to_1709".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["station_to_1709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["remarks_1710".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["remarks_1710".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["channel_1711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["channel_1711".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sign_1712".toString().toLowerCase()] == null
                        ) {
                          colsec1["sign_1712".toString().toLowerCase()] = "";
                        }

                        //date_1691 time_1693 , station_to_1696 ,station_from_1695, remarks_1697 ,channel_1698

                        this.fSection4.push([
                          colsec1["date_1704".toString().toLowerCase()] +
                          " " +
                          colsec1["time_1706".toString().toLowerCase()],
                          colsec1["station_to_1709".toString().toLowerCase()],
                          colsec1["station_from_1708".toString().toLowerCase()],
                          colsec1["remarks_1710".toString().toLowerCase()],
                          colsec1["channel_1711".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }
                    // end collection column data to make it tabular
                  }
                }

                // collection of data into seperate array to be used in html
                console.log("mylog::mylognewreport");
                this.objcolcollection = [];
                if (
                  this.fSection1.length > 0 ||
                  this.fSection2.length > 0 ||
                  this.fSection3.length > 0 ||
                  this.fSection4.length > 0
                ) {
                  this.objcolcollection.push(
                    this.fSection1[this.fSection1.length - 1]
                  );
                  this.objcolcollection.push(this.fSection2);
                  this.objcolcollection.push(
                    this.fSection3[this.fSection3.length - 1]
                  );
                  this.createCollectionLayout(this.fSection4);
                  this.objcolcollection.push(this.fSection4);
                }

                console.log(this.objcolcollection);
                console.log("COLLECTION 0" + " " + this.objcolcollection[0]);
                console.log("COLLECTION 1" + " " + this.objcolcollection[1]);
                console.log("COLLECTION 2" + " " + this.objcolcollection[2]);
              }
            }
          }
        );

        break;
      }
    }
  }

  gmdss_log_book_list(
    hid,
    actionDate = "",
    actionTime = "",
    fromDate = "",
    toDate = ""
  ) {
    if (hid == 49) {
      this.gmdss = 1;
    } else if (hid == "49-1") {
      this.gmdss = 2;
    } else if (hid == "49-2") {
      this.gmdss = 3;
    } else if (hid == "49-3") {
      this.gmdss = 4;
    }
    hid = 49;

    for (var i = 0; i < this.formBuilder.length; i++) {
      if (this.formBuilder[i].hid == hid) {
        this.formCount = [];
        this.objcolsection = [];
        var result = [];
        var strFormId = "";
        this.showpop9 = 0;

        for (
          var r = 0;
          r < this.formBuilder[i].formbuilderresponse.length;
          r++
        ) {
          if (
            this.formBuilder[i].formbuilderresponse[r].formId == 67 ||
            this.formBuilder[i].formbuilderresponse[r].formId == 68
          ) {
            strFormId +=
              this.formBuilder[i].formbuilderresponse[r].formId + ",";
            this.formCount.push(this.formBuilder[i].formbuilderresponse[r]);
          }
        }

        var fineStringFormsId = strFormId.replace(/(^,)|(,$)/g, "");
        //alert(fineStringFormsId);
        this.loading=true;
        this.reportsService.getFormDetailsByActionDateAndTime(
          fineStringFormsId,
          this.voyageNo,
          actionDate,
          actionTime,
          fromDate,
          toDate,
          (multiresponse) => {
            this.loading=false;
            // this.reportsService.getFormDetails(fineStringFormsId,this.voyageNo,(multiresponse) => {
            this.objcolsection = [];
            var cnt1 = 0;
            var cnt2 = 0;
            var cnt3 = 0;
            var cnt4 = 0;
            var cnt5 = 0;
            var cnt6 = 0;
            var cnt7 = 0;
            var colsec1 = [];
            var colsec2 = [];
            var colsec3 = [];
            var colsec4 = [];
            var colsec5 = [];
            var colsec6 = [];
            var colsec7 = [];
            var colsec8 = [];
            var coldate = [];
            var colsec9 = [];

            let newData = multiresponse.map((item) => {
              if (item && item.data && item.data[0].formId) {
                if (item.data && item.data[0].formId) {
                  let itemId = {
                    // [item.data[0].formId] : item.data[0]._id['$oid']
                    [item.data[0].formId]: item.data[item.data.length - 1]._id['$oid']
                  };
                  return item.data && item.data[0].formId && itemId;
                }
                return item && item;
              }
            });

            const mergedObject = newData && newData.length > 0 && Object.assign({}, ...newData);
            this.formIdObject = mergedObject;
            // console.log('FormIdObject_List_9', this.formIdObject);
            if (multiresponse != null && multiresponse.length > 0) {
              this.userSign = [];
              let response = [];
              for (let ky in multiresponse) {
                response.push(this.modifyedData(multiresponse[ky]));
              }
              // all form response loop
              console.log("response");
              //console.log(response);
              for (let ky in response) {
                if (response[ky].data != null) {
                  var sectionName = "";

                  for (var s = 0; s < response[ky].data.length; s++) {
                    if (response[ky].data[s].isDelete == "1") continue;
                    var formId = response[ky].data[s].formId;

                    this.editedBy = "";
                    var usersign = "";
                    console.log("===chanage value checking====");
                    if (response[ky].data[s].editedBy != null) {
                      this.editedBy = response[ky].data[s].editedBy;
                    }

                    //alert(this.editedBy); return;

                    usersign = response[ky].data[s].userSign;

                    this.formBuilderSections = [];
                    for (
                      var r = 0;
                      r < this.formBuilder[i].formbuilderresponse.length;
                      r++
                    ) {
                      if (
                        this.formBuilder[i].formbuilderresponse[r].formId ==
                        formId
                      ) {
                        sectionName = this.formBuilder[i].formbuilderresponse[
                          r
                        ].formName
                          .replace(/Code/gi, "")
                          .replace(/ORB2/gi, "")
                          .replace(/ORB/gi, ""); //.charAt(this.formBuilder[i].formbuilderresponse[r].formName.length-1);
                        for (
                          var u = 0;
                          u <
                          this.formBuilder[i].formbuilderresponse[r]
                            .formbuildersectionnamelist.length;
                          u++
                        ) {
                          this.formBuilderSections.push(
                            this.formBuilder[i].formbuilderresponse[r]
                              .formbuildersectionnamelist[u]
                          ); //.formbuilderlist
                        }
                      }
                    }

                    //console.log();
                    for (let key in response[ky].data[s]) {
                      var sectionlength = this.formBuilderSections.length;
                      if (sectionlength == 4) {
                        sectionlength = 3;
                      }

                      for (var p = 0; p < sectionlength; p++) {
                        //alert(p)
                        for (
                          var v = 0;
                          v <
                          this.formBuilderSections[p].formbuilderlist.length;
                          v++
                        ) {
                          if (
                            key.toString().toLowerCase() == "created_at" &&
                            response[ky].data[s][key] != ""
                          ) {
                            coldate["date_created"] = response[ky].data[s][key];
                            coldate["section_length"] = sectionlength;
                          }
                          //if(key.toString().toLowerCase()==this.formBuilderSections[p].formbuilderlist[v].fieldName.toString().toLowerCase()){
                          if (formId == 67) {
                            //this.gmdss = 1;
                            if (p == 0) {
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1622".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "call_sign_1623".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "MMSI_1624".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_of_registry_1625".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "IMO_number_1626".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Gross_tonage_1627".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_kneel_laid_1628".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1629".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sea_area_1630".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_of_expiry_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1632".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "indicate_methods_1633".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "duplication_of_equipment_1534".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1635".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1636".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "shore_1637".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1638".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "no_1639".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Details_of_service_company_1640".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1641".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Adress_1642".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "maintanence_capability_1643".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "yes_1644".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "No_1645".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "owner_name_1646".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1647".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1648".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Managing_owner_1649".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1650".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Address_1651".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 1) {
                              //                                                                                      if((key.toString().toLowerCase()=='Name_1653'.toLowerCase() && response[ky].data[s][key]!='') ){
                              //                                                                                          alert(response[ky].data[s][key])
                              //                                                                                          colsec2[key.toString().toLowerCase()] = response[ky].data[s][key];
                              //                                                                                      }

                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_1631".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1653".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "dates_1654".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1655".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "DATE_1656".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "To_1657".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1658".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "classes_1659".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "class_1660".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1661".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certificate_1662".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "certi_1663".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "responsibility_1664".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1665".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Ranks_1666".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "entries_1667".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Name_1668".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "ranks_1669".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec2[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }

                            if (p == 2) {
                              //this.gmdss = 3;
                              if (
                                (key.toString().toLowerCase() ==
                                  "Name_of_ship_1670".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "number_1671".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "period_1672".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "from_1673".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1674".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "to_1675".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Date_1676".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Delivered_1677".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Port_1678".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "text_1679".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "port_1680".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "day_1681".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1682".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1683".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1684".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "Counter_sign_1685".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "signature_1686".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec3[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          if (formId == 68) {
                            if (p == 0) {
                              // this.gmdss = 4;
                              if (
                                (key.toString().toLowerCase() ==
                                  "vessel_name_1700".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "name_1701".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "calisign_1702".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "textbox_1703".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "date_1704".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1705".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "time_1706".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "utc_1707".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_from_1708".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "station_to_1709".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "remarks_1710".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "channel_1711".toLowerCase() &&
                                  response[ky].data[s][key] != "") ||
                                (key.toString().toLowerCase() ==
                                  "sign_1712".toLowerCase() &&
                                  response[ky].data[s][key] != "")
                              ) {
                                colsec1[key.toString().toLowerCase()] =
                                  response[ky].data[s][key];
                              }
                            }
                          }

                          //j}
                        }
                      }
                    }

                    //add form values
                    if (formId == 67) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["Name_of_ship_1622".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "Name_of_ship_1622".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1622".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["call_sign_1623".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["call_sign_1623".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["MMSI_1624".toString().toLowerCase()] == null
                        ) {
                          colsec1["MMSI_1624".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Port_of_registry_1625".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Port_of_registry_1625".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["IMO_number_1626".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["IMO_number_1626".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Gross_tonage_1627".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Gross_tonage_1627".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "Date_kneel_laid_1628".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_kneel_laid_1628".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1629".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1629".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sea_area_1630".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["sea_area_1630".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1[
                          "Date_of_expiry_1631".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Date_of_expiry_1631".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Date_1632".toString().toLowerCase()] == null
                        ) {
                          colsec1["Date_1632".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "indicate_methods_1633".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "indicate_methods_1633".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "duplication_of_equipment_1534"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "duplication_of_equipment_1534"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1635".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1635".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1636".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1636".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["shore_1637".toString().toLowerCase()] == null
                        ) {
                          colsec1["shore_1637".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["yes_1638".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1638".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["no_1639".toString().toLowerCase()] == null
                        ) {
                          colsec1["no_1639".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Details_of_service_company_1640"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Details_of_service_company_1640"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1641".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1641".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Adress_1642".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Adress_1642".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "maintanence_capability_1643"
                            .toString()
                            .toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "maintanence_capability_1643"
                              .toString()
                              .toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["yes_1644".toString().toLowerCase()] == null
                        ) {
                          colsec1["yes_1644".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["No_1645".toString().toLowerCase()] == null
                        ) {
                          colsec1["No_1645".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["owner_name_1646".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["owner_name_1646".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["Name_1647".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1647".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1648".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1648".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1[
                          "Managing_owner_1649".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Managing_owner_1649".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["Name_1650".toString().toLowerCase()] == null
                        ) {
                          colsec1["Name_1650".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["Address_1651".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["Address_1651".toString().toLowerCase()] = "";
                        }

                        this.fSection1.push(colsec1);
                      }

                      if (
                        colsec2["Name_1653".toString().toLowerCase()] != null
                      ) {
                        if (
                          colsec2["Name_1631".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1631".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1653".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1653".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["dates_1654".toString().toLowerCase()] == null
                        ) {
                          colsec2["dates_1654".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["from_1655".toString().toLowerCase()] == null
                        ) {
                          colsec2["from_1655".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["DATE_1656".toString().toLowerCase()] == null
                        ) {
                          colsec2["DATE_1656".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["To_1657".toString().toLowerCase()] == null
                        ) {
                          colsec2["To_1657".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Date_1658".toString().toLowerCase()] == null
                        ) {
                          colsec2["Date_1658".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["classes_1659".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["classes_1659".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["class_1660".toString().toLowerCase()] == null
                        ) {
                          colsec2["class_1660".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["date_1661".toString().toLowerCase()] == null
                        ) {
                          colsec2["date_1661".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "certificate_1662".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2["certificate_1662".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec2["certi_1663".toString().toLowerCase()] == null
                        ) {
                          colsec2["certi_1663".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2[
                          "responsibility_1664".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec2[
                            "responsibility_1664".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec2["Name_1665".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1665".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Ranks_1666".toString().toLowerCase()] == null
                        ) {
                          colsec2["Ranks_1666".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["entries_1667".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec2["entries_1667".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["Name_1668".toString().toLowerCase()] == null
                        ) {
                          colsec2["Name_1668".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec2["ranks_1669".toString().toLowerCase()] == null
                        ) {
                          colsec2["ranks_1669".toString().toLowerCase()] = "";
                        }
                        //console.log("second data:");
                        //console.log(colsec2);
                        this.fSection2.push(response[ky].data[s]);
                      }

                      if (
                        colsec3["Name_of_ship_1670".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec3[
                          "Name_of_ship_1670".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "Name_of_ship_1670".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["number_1671".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["number_1671".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["period_1672".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["period_1672".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["from_1673".toString().toLowerCase()] == null
                        ) {
                          colsec3["from_1673".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1674".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1674".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["to_1675".toString().toLowerCase()] == null
                        ) {
                          colsec3["to_1675".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Date_1676".toString().toLowerCase()] == null
                        ) {
                          colsec3["Date_1676".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["Delivered_1677".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["Delivered_1677".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3["Port_1678".toString().toLowerCase()] == null
                        ) {
                          colsec3["Port_1678".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["text_1679".toString().toLowerCase()] == null
                        ) {
                          colsec3["text_1679".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["port_1680".toString().toLowerCase()] == null
                        ) {
                          colsec3["port_1680".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["day_1681".toString().toLowerCase()] == null
                        ) {
                          colsec3["day_1681".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["date_1682".toString().toLowerCase()] == null
                        ) {
                          colsec3["date_1682".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["sign_1683".toString().toLowerCase()] == null
                        ) {
                          colsec3["sign_1683".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec3["signature_1684".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1684".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec3[
                          "Counter_sign_1685".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec3[
                            "Counter_sign_1685".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec3["signature_1686".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec3["signature_1686".toString().toLowerCase()] =
                            "";
                        }
                        this.fSection3.push(colsec3);
                      }
                    }

                    if (formId == 68) {
                      if (
                        coldate["date_created"] != null &&
                        coldate["date_created"] != ""
                      ) {
                        var dataPart = coldate["date_created"]
                          .toString()
                          .split(" ");

                        var dateSplit = dataPart[0].toString().split("-");
                        var day = dateSplit[2];
                        var month = dateSplit[1];
                        var year = dateSplit[0];
                        this.createdDate = day + "-" + month + "-" + year;
                        var sectionLenght = coldate["section_length"];
                        this.createdAt.push([
                          year + "-" + month + "-" + day,
                          sectionLenght,
                          sectionName,
                          cnt1++,
                        ]);
                      }

                      if (
                        colsec1["vessel_name_1700".toString().toLowerCase()] !=
                        null
                      ) {
                        if (
                          colsec1[
                          "vessel_name_1700".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1["vessel_name_1700".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["name_1701".toString().toLowerCase()] == null
                        ) {
                          colsec1["name_1701".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["calisign_1702".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["calisign_1702".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["textbox_1703".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["textbox_1703".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["date_1704".toString().toLowerCase()] == null
                        ) {
                          colsec1["date_1704".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1705".toString().toLowerCase()] == null
                        ) {
                          colsec1["utc_1705".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["time_1706".toString().toLowerCase()] == null
                        ) {
                          colsec1["time_1706".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["utc_1707".toString().toLowerCase()] == null
                        ) {
                          colsec1[
                            "station_from_1708".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1[
                          "station_from_1708".toString().toLowerCase()
                          ] == null
                        ) {
                          colsec1[
                            "station_from_1695".toString().toLowerCase()
                          ] = "";
                        }
                        if (
                          colsec1["station_to_1709".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["station_to_1709".toString().toLowerCase()] =
                            "";
                        }
                        if (
                          colsec1["remarks_1710".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["remarks_1710".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["channel_1711".toString().toLowerCase()] ==
                          null
                        ) {
                          colsec1["channel_1711".toString().toLowerCase()] = "";
                        }
                        if (
                          colsec1["sign_1712".toString().toLowerCase()] == null
                        ) {
                          colsec1["sign_1712".toString().toLowerCase()] = "";
                        }

                        //date_1691 time_1693 , station_to_1696 ,station_from_1695, remarks_1697 ,channel_1698

                        this.fSection4.push([
                          colsec1["date_1704".toString().toLowerCase()] +
                          " " +
                          colsec1["time_1706".toString().toLowerCase()],
                          colsec1["station_to_1709".toString().toLowerCase()],
                          colsec1["station_from_1708".toString().toLowerCase()],
                          colsec1["remarks_1710".toString().toLowerCase()],
                          colsec1["channel_1711".toString().toLowerCase()],
                        ]);
                        this.userSign.push(usersign);
                      }
                    }
                    // end collection column data to make it tabular
                  }
                }

                // collection of data into seperate array to be used in html
                console.log("mylog::mylognewreport");
                this.objcolcollection = [];
                if (
                  this.fSection1.length > 0 ||
                  this.fSection2.length > 0 ||
                  this.fSection3.length > 0 ||
                  this.fSection4.length > 0
                ) {
                  this.objcolcollection.push(
                    this.fSection1[this.fSection1.length - 1]
                  );
                  this.objcolcollection.push(this.fSection2);
                  this.objcolcollection.push(
                    this.fSection3[this.fSection3.length - 1]
                  );
                  this.createCollectionLayout(this.fSection4);
                  this.objcolcollection.push(this.fSection4);
                }

                console.log(this.objcolcollection);
              }
            }
          }
        );

        break;
      }
    }
  }

  print(event: any): void {
    //var printContents = document.getElementById('print-section').innerHTML;
    const page_header =
      document.getElementById("page_header") != null
        ? document.getElementById("page_header").innerHTML
        : "";
    //const page_body = (document.getElementById('page_body')!=null)?document.getElementById('page_body').innerHTML:'';

    const page_body =
      document.getElementById("page_body") != null
        ? document.getElementById("page_body").innerHTML
        : document.getElementById("print-section").innerHTML;

    const page_footer =
      document.getElementById("page_footer") != null
        ? document.getElementById("page_footer").innerHTML
        : "";
    const stylesHtml = this.getTagsHtml("style");
    const linksHtml = this.getTagsHtml("link");
    const bookname = document.getElementById("bookname").innerHTML;

    const popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=500,width=500"
    );
    //popupWin.document.open();
    popupWin.document.write(`
        <html>
            <head>
                <title>${bookname}</title>
                 <style>

                @media print {

                    @page {
                      margin:5px;
                      font-size:20px;
                      padding:5px; text-align:left;
                    }

                .row {
                    display: -webkit-box;
                    display: inline-flex;
                    text-align:left;

                }
                    .col-sm-12 {
                        width: 100%;
                        text-align:left;
                    }
                    .col-sm-2 {
                        width: 350px;
                        text-align:left;

                        margin:5px 0x;
                    }
                    .smtext {position: absolute;}
                    .sign-date {font-size:15px;line-height:50px !important; border:1px solid black}
                    .date-txt {font-size:20px}
                    .col-sm-9 {
                        width:83%;
                    clear:both
                        font-size:20px;margin:5px 0x;
                }
                #page-header {margin:0px}


                .frontprint {width:100%}
                .frontprint .col-sm-2 {width:25%}
                .frontprint .col-sm-10 {width:75%}

                .printtext1 {font-size:0.8em !important;}
                .footerprint {width:100%}
.footerprint .col-sm-2 {width:25%}
.footerprint .col-sm-10 {width:70%}


.grabfront {width:100%; margin:0px; padding:0px;}
.grabfront .col-sm-2 {width:200px; text-align:left}
.grabfront fronthead1 {width:100px !important; text-align:left}

                .printtext {font-size:1.0em}
                    .col-sm-10 {
                        width:83%;
                        clear:both
                        font-size:20px;margin:5px 0x;
               }
                    .col-sm-3 {width:200px;
                        text-align:left;
                        font-size:20px; padding:0px;}
                    input {background: #fff;
                        border: 0px;
                        border-bottom: 1px solid #ccc;
                        padding: 5px 10px;
                        width: 100%; margin-left:10px; margin-bottom:10px;}

                    table {border-collapse: collapse;border:1px solid #fff; font-size:20px;}
                    table td, table th {border:1px solid #fff; }
                   thead h2 {
                        margin: 0;
                        color: #464457;
                        font-size:0.8em;
                        text-align: left;
                        padding:20px 0;
               }

                  tfoot .col-md-12 {width:100%; text-align:right; font-size:0.8em}
                  tfoot .col-sm-2 {
                    width:350px;
                    text-align:left;

                    margin:5px 0x;
                }
                    tbody .table th {border:1px solid #ccc; text-align:left;  font-size:20px!important; padding:10px}
                    tbody .table td {border:1px solid #ccc;  font-size:20px!important; padding:10px; display: table-cell;
                    }
                    thead th{ border:0px solid red;}
                      tfoot th {bottom: 0; left:0; border:0px solid red; background : white; height:100px;}
                .textblack {font-size:20px}
                .card {

                    width: 100%;
                }
                .garbagefont {transform: scale(1.0); transform-origin:0 0; }
                .scale {transform: scale(1.0); transform-origin:0 0; }
                .scalefuel {transform: scale(0.9); transform-origin:0 0; }
                .scale td, .scale th {font-size:1em}
                ul {
                    font-size: 20px;
                    line-height: 1.5em;
                    padding: 0;
                    display: contents;
                    width:100%;
               }
                ul li {
                    list-style: none;
                    position: relative;
                    padding: 0 20px 0 0px !important;
                    display: -webkit-box;
                    display: inline-block;
               }
                ul.square li::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 9px;
                    width: 6px;
                    height: 6px;
                    background-color: black;
               }
                ul.round li::before {
                    content: "";
                   /*position: absolute;
                   */
                    content: "";
                    left: 0;
                    top: 9px;
                    width: 6px;
                    height: 6px;
                    background-color: black;
                    border-radius: 50%;
                    -moz-border-radius: 50%;
                    -webkit-border-radius: 50%;
                    margin-right: 15px;
                    position: absolute;
               }
               thead  input {width:90%;  font-size:1.0em}
              thead label {padding-left:10px; }
              tfoot th input {width:90%;}
              tfoot th label {padding-left:10px; }
               .text-right {text-align:left;}



            }

            .signtext  {width:100%;text-align:left}

            .signtext .col-sm-5 {width:300px;}
            .signtext .col-sm-7 {width:400px;}

            .signtext .offset-7 {margin-left:50%}
            .signtext .rev {margin-left:75%}
            .col-sm-7 {
               width: 58.33333333%;
            }

            .mainmastr {width: 100%;
               }

               .revtext {width: 100%; tex-align:left;
               }

            .mastesign .col-sm-7 {
                width:300px;
             }
             .mastesign .col-sm-7 input {width:90%}
             .mastesign .col-sm-5 {
                width:250px;
             }
             .mastdate .col-sm-7 {
                width:300px;
             }
             .mastdate .col-sm-5 {
                width:220px; padding-left:10px;
             }
             .card-title  {text-align:left; line-height:50px; padding-left:0px !important;
                padding-bottom:10px; margin-left: 0px !important; font-size:1.0em}

             .garbage1 {width:200px}
             .garbage2 {width:300px}
             .garbage3 {width:250px}
             .garbage4 {width:350px}
             .garbage5 {width:150px}
             .garbage6 {width:400pt}

               .formprview  {display: flex;    white-space: nowrap; font-size:13px;}
.formlabel {padding-top:16px;}
.inputwidth   {width:100%; padding: 0 10px;}
.forminput {background: none;
  border: 0px;
  border-bottom: 1px solid #ddd;}
  .radio-label  {
    padding: 10px 25px 0 7px;
  }

  .inputwidth1 {width:94% !important; }

  .formprviewinner  {display: flex;}

  .radio {padding-top: 9px;}

  .formprviewinner .formlabel1 {padding-top:16px;}
  .formprviewinner .inputwidth1   {width:100%; padding: 0 10px;}
  .textsmall {font-size:13px;}

             .decklog .col-sm-2 {width:250px}



    .input-container {
        background-color: rgba(255, 255, 255, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 0;
        width: auto;
        height: 38px !important;
        margin-left: 75px;
        border-radius: 4px;
        margin-top: 30px;
    }

    .browse-btn {
      background: #4841a9;
      color: #fff;
      min-height: 35px;
      padding: 6px 18px;
      border: none;
      margin-right: 0px !important;
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
    }

    .text-forms {
      margin-top: 8px;
      margin-left: 5px;
    }

    .label-custom {
      position: absolute;
      bottom: 44px;
    }

    // span.file-info, .file-info1 {
    //     color: #fff;
    //     position: absolute;
    //     top: 38px;
    //     left: 26px;
    // }

// table {
//     width: 90%;
//     align-content: center;
//     /* text-align: center; */
//     align-self: center;
//     margin-left: auto;
//     margin-right: auto;

//   }

//   /* div{
//     margin-left: auto;
//     margin-right: auto;
//     text-align: center;
//   } */

//   .button{
//      margin-left: 50px
//   }

//   form{
//     margin-left: auto;
//     margin-right: auto;
//     align-content: center;
//     text-align: center;
//   }


//   example-container {
//     display: flex;
//     flex-direction: column;
//   }

//   .example-container > * {
//     width: 100%;
//   }

//   .example-container {
//     display: flex;
//     flex-direction: column;
//   }

//   .example-container > * {
//     width: 100%;
//   }

//   .example-right-align {
//     text-align: right;
//   }

//   input.example-right-align::-webkit-outer-spin-button,
//   input.example-right-align::-webkit-inner-spin-button {
//     display: none;
//   }

//   input.example-right-align {
//     -moz-appearance: textfield;
//   }

//   .container{
//     margin-top: 30px;
// }



.example-full-width label{font-family: "Poppins", sans-serif;
  display: inherit !important;font-size: 14px;}

  .example-full-width input {border:1px solid #ddd;font-family: "Poppins", sans-serif; padding:8px; margin-top: -14px;}
  .example-full-width  {border-top:0px!important;padding:0px !important;}

  .card .card-body {padding:10px;}

  .imgdiv {padding:0px !important; border-radius: 8px;}


  ul li {
    display: inline;
    list-style-type: none;
// margin-right: 34px;
    }


    .mat-form-field-appearance-legacy .mat-form-field-underline {height: 0px !important; }
    .mat-form-field-appearance-legacy .mat-form-field-underline {      background-color: #fff;}
    .mat-form-field-infix {border-top:0px;}


    p {font-size:13px}

    .img {width:auto; height: auto;
      margin: -15px;    padding-bottom: 0px;border-radius: 5px 0 0 5px;}
      .card-stacked {
          display: flex;
      flex-direction: column;
      flex: 1;
      position: absolute;
      margin-left: 120px;
      top: 33%; font-size: 15px; font-weight: normal
      }
      .card-stacked .card-content {
          -webkit-flex-grow: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
      }

      .card {

          // height: 110px;
      }

      // .itemwidhth {width: 25% !important;}

      img {border-radius: 5px 0 0 5px;}

      .item {width:250px !important; padding-right: 20px;}
      .banner {width:100%}
      .rightRs {display: block;
        float: right;
        margin-top: -56px;
        z-index: 999;
        border:0px solid red;
        background:transparent;
        position: relative;}

        .leftRs {display: block;
          float: left;
          margin-top: -56px;
          border:0px solid red;
          background:transparent;
          z-index: 999;
          position: relative;}


          .item .float-right {width:150px;    font-family: "Poppins", sans-serif;}
            .ngxcarouselPointDefault .ngxcarouselPoint {display: none;}




            ul {

              font-size: 13px;
              line-height: 1.5em;
              margin: 5px 0 15px;
              padding: 0;
              display: contents;
              li {
                list-style: none;
    position: relative;
    padding: 0 20px 0 0px !important;
    display: -webkit-box;
    display: inline-block;
              }
            }
            ul.square {
              li {
                &::before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: 9px;
                  width: 6px;
                  height: 6px;
                  background-color: black;
                }
              }
            }
            ul.round {
              li {
                &::before {
                  content: "";
                  /*position: absolute;*/
                  content: "";
                    left: 0;
                    top: 9px;
                    width: 6px;
                    height: 6px;
                    background-color: black;
                    border-radius: 50%;
                    -moz-border-radius: 50%;
                    -webkit-border-radius: 50%;
                    margin-right: 15px;
                    position: absolute;
                }
              }
            }


            .textlabel {display: flex;
              /* margin-bottom: 0.5rem; */
              vertical-align: middle;

              align-items: center;}

            .textblack {    color: #000;
              font-size: 14px;
              font-weight: 500;}



            #print-section{ padding-left: 2px; padding-right: 10px;}

.report_heading_title{line-height:  18px;}

#general_comments, #crew_work {
    width: 100%;
    padding: 15px 10px !important;
    margin: 8px 0;
    height: 80px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-bottom: 0px solid #ccc;
}

.formprview  {display: flex;    white-space: nowrap; font-size:13px;}
.formlabel {padding-top:16px;}
.inputwidth   {width:100%; padding: 0 10px;}
.forminput {background: none;
  border: 0px;
  border-bottom: 1px solid #ddd;}
  .radio-label  {
    padding: 10px 25px 0 7px;
  }

  .inputwidth1 {width:94% !important; }

  .formprviewinner  {display: flex;}

  .radio {padding-top: 9px;}

  .formprviewinner .formlabel1 {padding-top:16px;}
  .formprviewinner .inputwidth1   {width:100%; padding: 0 10px;}
  .textsmall {font-size:13px;}
 .colorschema {
    color:red;
 }
    .table td,
    .table th {
        white-space: normal
    }

    .table-wrap .table th,
    .table-wrap .table td {
        padding: 10px 9px;
        vertical-align: middle;
        border: 1px solid #f2f2f2;
    }
    .inputwidth{
        width:20% !important;
    }

    .colorschema {
        color:white !important;
        background-color: #f2a5a5 !important;
    }
    ::ng-deep.mat-form-field-infix{
        width: 100px !important;
    }


    .rightRs {display: block;
        float: right;
        margin-top: -66px;
        z-index: 999;
        border:0px solid red;
        background:transparent;
        position: relative;}

        .leftRs {display: block;
          float: left;
          margin-top: -66px;
          border:0px solid red;
          background:transparent;
          z-index: 999;
          position: relative;}

        ::ng-deep.mat-select-value-text {
  color: #000 !important;
}

 ::ng-deep.card-body {
    padding-bottom: 0px !important;
    padding-top: 15px !important;
}
.smtext {position: absolute;}

.report-box-row{display:flex; border:1px solid #000; border-left: 0; height: 180px;
    font-family: Arial, Helvetica, sans-serif;  font-size: 12px; font-weight: normal; box-sizing:border-box;}
    .report-col-row{display:flex; border:1px solid #000; border-left: 0; border-top: 0; height: 30px;
    font-family: Arial, Helvetica, sans-serif; box-sizing:border-box;  font-size: 12px; font-weight: normal;}
    .repo-col{display:flex; flex-basis: 0;flex-grow: 1;max-width: 100%;
    border:1px solid #000; border-right: 0; border-top:0; border-bottom: 0;
    position: relative; box-sizing: border-box; align-items: center;justify-content: center;}
    .report-head-col{display:flex; flex-basis: 0; flex-grow: 1;max-width: 100%;
    overflow: hidden; border:1px solid #000; border-right: 0; border-top:0; border-bottom: 0;
    position: relative; box-sizing: border-box; box-sizing:border-box;}
    .watch-col {max-width: 17.4%;flex:0 0 17.4%;display: flex;}
    .watch-col .report-head-col:first-child {flex-grow: revert !important;flex: 0 0 32.5%;max-width: 32.5%;}
    .report-col-row .repo-col:first-child {flex-grow: revert !important; flex: 0 0 5.6%;flex:5.6%;}
    .report-title-text{transform: rotate(270deg) translate(-50%, -50%);width: 100%;
    position: absolute;top: 50%;;left:32%;display: flex;justify-content: center;
    align-items: center;white-space: nowrap;margin-top: -20px;}
    .rp-col-15{max-width: 35.4%; flex: 0 0 35.4%; flex-wrap: wrap;  text-align: center;}
    .rp-col-20{ flex-wrap: wrap; text-align: center }
    .rp-col-5{flex: 0 0 33.50%;max-width: 33.50%;text-align: center;border: 1px solid #000;
    border-left: 0; box-sizing:border-box;border-bottom: 0;  border-top:0}
    .rep-w-100{flex: 0 0 100%;max-width: 100%; box-sizing:border-box; border-bottom:1px solid #000;  height: 30px;display: flex;justify-content: center;align-items: center;}
    .report-head-col.repo-col-1{flex: 0 0 6.60%;max-width: 6.60%;border: 1px solid #000;
    border-left: 0;border-bottom: 0;box-sizing:border-box;border-top: 0;
    height: calc(100% - 30px);}.report-head-col.repo-in-1{flex: 0 0 20%;
     max-width: 20%;border: 1px solid #000;border-left: 0;border-bottom: 0;box-sizing:border-box;
    border-top: 0;height: calc(100% - 30px);}
    .repo-flex{ display: flex; flex-wrap: wrap;}
    .repo-br-0{ border-right: 0 !important;}
    .repo-bl-0{ border-left: 0 !important;}
    .fuel-col {width: 41%;flex: 0 0 41%;border: 1px solid;
    height: 100%;margin-left: auto; border-right: 0;border-top: 0; border-bottom: 0;
    display: flex; align-items: center; justify-content: center;}
    .coolwater{width: 59%;flex: 0 0 59%;}.flex-rp{ display: flex;}.col-26{ display: flex; flex: 0 0 26%; max-width: 26%;margin-left: auto;}
            .col-26 .report-head-col.repo-col-1 {
              flex: 0 0 25%;
              max-width: 25%;
              height: 100%;
              box-sizing:border-box;
          }
          .rp-col-20 .report-head-col.repo-col-1 {
            flex: 0 0 5%;
          max-width: 5%;
            margin-left: auto;
            border-right: 0;
            border-left:1px solid #000;
        }
        .rp-col-20 .report-head-col.repo-col-1 .report-title-text{ left:26%}

        .temp-row {
          max-width: 95%;
          flex:0 0 95%;
          box-sizing: border-box;
          text-align: center;
      }
      .rep-w-100.bearing{height:calc(100% - 30px); justify-content: start; align-items: self-start; border: 0;}
      .fr-wtr, .nozzle, .lubri-oil {
        max-width: 10.6%;
        flex: 0 0 10.6%;
        border-right: 1px solid #000;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
      }
      .lubri-oil{max-width: 79%;
        flex: 0 0 79%; border-right: 0;}

        .cyl, .temp-vert, .pist-cooling {
          max-width: 10.6%;
          flex: 0 0 10.6%;
          border-right: 1px solid #000;
          height: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
      }
      .pist-cooling {
        max-width: 16%;
        flex: 0 0 16%;
      }
      .bearing-col {
        width: 68.2%;
        border-right: 0;
      }

      .cyl .report-head-col.repo-in-1,.temp-vert .report-head-col.repo-in-1 {
        flex: 0 0 50%;
        max-width: 50%;
      }


      .cyl .rep-w-100 {
        height: auto;
      }
      .temp-vert .report-head-col.repo-in-1 {
        height: 100%;
      }
      .cyl .report-head-col.repo-in-1:last-child,
      .temp-vert .report-head-col.repo-in-1:last-child {
        border: 0;
      }
      .cyl .report-title-text,.temp-vert .report-title-text {
        left: 24% !important;
      }

      .pist-col .report-head-col.repo-in-1 {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
      .pist-col  .report-head-col.repo-in-1:last-child{
        border: 0;
      }
      .bearing-col .rep-w-100 {
        justify-content: flex-start;
      }

      .pist-col {
        width: 23%;
        border-right: 1px solid;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
      }

      .bear-col {
        width: 77%;
        height: 100%;
        display: flex;
          flex-wrap: wrap;
      }
      .pist-col .rep-w-100,.bear-col .rep-w-100 {
        justify-content: center !important;
      }
      .bear-col .rep-w-100 {
        font-size: 16px;
      }

      .bearing-col >.rep-w-100 {
        height: 118px;
        border: 0;
      }
      .bear-col .report-head-col.repo-in-1 {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .bear-col .report-head-col.repo-in-1:last-child {
        border: 0;
      }

    .watch-col .report-head-col:first-child .report-title-text {
      left: 15%; top:40%
    }
    .table-auxiliary .report-box-row{ height: 130px;}
    .table-auxiliary .watch-col{ max-width: 10.1%;flex: 0 0 10.1%;}
    .table-auxiliary .watch-col .report-head-col:first-child{ flex:0 0 56%; max-width: 56%;}
    .table-auxiliary  .report-title-text{ top: 35%;left: 15%;}
    .table-auxiliary .watch-col .report-head-col:first-child .report-title-text {top: 30%;}

    .repo-flex[_ngcontent-jal-c5] {
      display: flex;
      flex-wrap: wrap;
      border-left: 1px solid #000;
    }

    .pressure-col {
      border-left: 1px solid #000;
      width: 18.1%;
    }

    .table-auxiliary .report-head-col.repo-in-1{
      flex: auto; max-width: none;}

      .pressure-col .rep-w-100 {
        border-right: 1px solid #000;
    }


    .verticalTableHeader {text-align: center; white-space: nowrap;max-width: 20px;}
    .verticalTableHeader p {margin: 0 -100%;display: inline-block;
        g-origin: 50% 50%;-webkit-transform: rotate(270deg);-moz-transform: rotate(270deg);
        -ms-transform: rotate(270deg);-o-transform: rotate(270deg);transform: rotate(270deg);
    }
    .verticalTableHeader p:before {
    content: '';width: 0;padding-top: 110%;display: inline-block;vertical-align: middle;}
    table.auxiliary-engine {font-family: Arial, Helvetica, sans-serif;font-size: 0.9rem;text-align: center}
    table.auxiliary-engine td, .table-ship table td {border: 1px solid #000;border-bottom: 0;border-left: 0;padding: 5px}
    .auxiliary-engine-wrap {padding: 30px;}
    .auxiliary-inner {border: 1px solid #000;border-top: 0;
    border-right: 0; margin-top:10px;font-family: Arial, Helvetica, sans-serif;}
    .text-center {text-align: center;}
    .table-ship table td {font-size: .7rem;overflow: hidden;padding: 10px 0;}
    tr.f-bold {font-weight: 500}
    .auxiliary-engine-sec{ margin-top:30px;}


  .cyltable-sec{font-family: Arial, Helvetica, sans-serif; font-size: 12px;}
  .cylHeadRow {display: flex;border: 1px solid #000; font-family: Arial, Helvetica, sans-serif; font-size: 12px; border-left: 0;height: 180px;font-weight: normal; box-sizing: border-box;}
  .cylCol-20 {border-left: 1px solid #000;border-right: 1px solid;flex: 0 0 48.5%; max-width: 48.5%; position: relative;}
  .cylCol-9 {border-right: 1px solid;flex: 0 0 21.75%;box-sizing: border-box; max-width:21.75%; position: relative; display: flex;}
  .cylCol-10 {border-right: 1px solid #000; box-sizing: border-box; flex: 0 0 24.2%; position: relative; max-width:24.2%; display: flex;}
  .cylCol-1 {flex: 0 0 5.5%;max-width: 5.5%;box-sizing: border-box; position: relative;}
  .cylWrap{ flex-wrap: wrap;}
  .cylFlex{ display: flex;}
  .cylW-100{flex: 0 0 100%; max-width: 100%;}
  .cylRow{display: flex;border: 1px solid #000;border-left: 0;border-top: 0;height: 30px;
  box-sizing: border-box;font-size: 12px;font-weight: normal;}

  .cyl-head-col{display: flex;flex-basis: 0;flex-grow: 1;max-width: 100%;overflow: hidden;border: 1px solid #000;
  border-right: 0;border-top: 0;border-bottom: 0;position: relative;box-sizing: border-box;}
  .cylCol-1 .cyl-head-col{ border: 0;}
  .cyl-title-text{
    transform: rotate(270deg) translate(-50%, -50%);
  width: 100%;position: absolute;top: 50%;left: 15%;white-space: nowrap;margin-top: -20px;}
  .cylRow>div {display: flex;flex-basis: 0;flex-grow: 1;max-width: 100%; justify-content: center;align-items: center;
  border: 1px solid #000;border-right: 0;border-top: 0;border-bottom: 0;position: relative;box-sizing: border-box;}

  .cylRow>div:last-child{flex-grow: revert !important;flex: 0 0 5.6%;}
  .cylGrow{display: flex;flex:0 0 100%;max-width: 100%; border-bottom:1px solid #000;}
  .cylItemCenter{ align-items: center;}
  .cylJustifyCenter{ justify-content: center;}.cylHieght{ height: 30px; font-family: Arial, Helvetica, sans-serif; font-size: 12px;}
  .fromT {flex: 0 0 49%; text-align: left;}.toT {flex: 0 0 25%; text-align: left;}
  .dateT{ text-align: left;}.cylSing {height: calc(100% - 30px);max-width: 5%;border-right: 1px solid #000;flex: 0 0 5%;display: flex;}
  .cylSing .cyl-head-col {border: 0;}.cyl-title-text.t-small{width: 100%;top: 58%;left: 30%;margin-top: 0;}
  .cylSing.sing2 {flex: 0 0 70%;max-width: 70%;}
  .sing2 .cylSing {max-width: none;flex-basis: 0;flex-grow: 1;max-width: 100%;display: flex;align-items: center;justify-content: center;height: 58px;}
  .cylSing.sing2 .cy-50 .rep-w-100 {height: 90px;}
  .sing2 .cylSing:last-child{ border: 0;}
  .cy-50 {flex: 0 0 50%;display: flex;justify-content: center;border-right: 1px solid;height: 100%;flex-wrap: wrap;}
  .cy-50:last-child {border: 0;}.sing2>.rep-w-100.flex-rp {height: auto; border: 0;}
  .cylSing.singSmall2 {flex-basis: 0; flex-grow: 1;max-width: 100%;border: 0; flex-wrap: nowrap;}
  .cylFuel {flex: 0 0 60%;max-width: 60%;border-right: 1px solid;flex-wrap: wrap;display: flex;}
  .cylFuel .cylSing:last-child,.cylSea .cylSing:last-child {border: 0;}
  .cylFuel .cylSing,.cylSea .cylSing {flex-basis: 0;flex-grow: 1;max-width: 100%;}
  .cylFuel .cyl-title-text.t-small {top: 45%;}.cylSea {max-width: 40%; flex:0 0 40%;display: flex;}
  .cylSea .cylSing {height: 100%;}.cylSea .cyl-title-text.t-small {top: 50%;}.fw-b {font-size: 18px !important;left: 40% !important;}
  .tubo {flex: 0 0 66%;border-right: 1px solid #000;display: flex;flex-wrap: wrap; }
  .accom {flex: 0 0 34%;display: flex;flex-wrap: wrap;}

  .tubo .cylSing {display: flex;flex: 0 0 17%;max-width: none;}
  .scav {display: flex;width: 51%;border-right: 1px solid;flex-wrap: wrap;}

  .steam, .steam-tube {
    flex: 0 0 20%;
    border-right: 1px solid #000;
    display: flex;
    flex-wrap: wrap;
  }
  .steam .rep-w-100.flex-rp, .steam-tube .rep-w-100.flex-rp {
    height: auto;
    text-align: center;
  }


  .accom .cylSing,.scav .cylSing ,.gastem .cylSing,
  .steam .cylSing,.steam-tube .cylSing{display: flex;flex-basis: 0; flex-grow: 1;max-width: 100%;}
  .accom .cylSing:last-child,.scav .cylSing:last-child,
  .gastem .cylSing:last-child,.steam-tube .cylSing:last-child, .steam .cylSing:last-child {border: 0;}
  .gastem {display: flex;flex-wrap: wrap; flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;}
  .accom .cyl-title-text.t-small {top: 52%;}
  .steam .cyl-title-text.t-small,
  .steam-tube .cyl-title-text.t-small {top: 40%;}
  .steam .cylSing{height: calc(100% - 56px);}
  .steam-tube .cylSing{height: calc(100% - 38px);}
  .fresh-water .cylSing {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .fresh-water {
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 60%;
    max-width: 60%;
  }
  .fresh-water .cylSing:last-child {
    border: 0;
  }
  .fresh-water .cylSing .cyl-title-text.t-small{top:50%}
  .enject .cyl-title-text.t-small {
    top: 67% !important;
  }
  .me-lubricating .cyl-title-text.t-small {
    left: -26px;
    white-space: normal;
    top: 12px !important;
    width: 100px;
    line-height: 11px;
  }
  .table-column-row {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }
  .day-tbl-col{
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    flex-wrap: wrap;
  }

  .day-tank,
  .noo-report {
    flex: 0 0 48%; max-width: 48%;
    box-sizing: border-box;
  }
  .daily-fuel{  box-sizing: border-box;}
  .noo-report{ padding-left:20px; padding-right: 20px; }
  .noo-report table.auxiliary-engine,
  .daily-fuel table.auxiliary-engine,.remark-table table.auxiliary-engine {
    text-align: left;
  }
  .day-tank table.auxiliary-engine td{font-weight: 600;font-size: 12px;}
  .noo-report .auxiliary-inner,.daily-fuel .auxiliary-inner, .remark-table .auxiliary-inner{ border: 0;}
  .noo-report table.auxiliary-engine td,
  .daily-fuel table.auxiliary-engine td,
  .remark-table table.auxiliary-engine td{ border :0; padding:5px 0 0; font-weight: 600;font-size: 12px;}
  .noo-report table.auxiliary-engine td:first-child {width: 140px; padding:10px 15px}
  .daily-fuel table.auxiliary-engine td:first-child { padding:10px 15px}
  .noo-report table.auxiliary-engine td.tbl-underline,
  .daily-fuel table.auxiliary-engine td.tbl-underline,
  .last-tbl td.tbl-underline{border-bottom: 1px solid #000!important;}
  .remark-table table.auxiliary-engine td.dotted-underline{border-bottom: 1px dashed #000!important; height: 30px;}
  .remark-table {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 30px;
  }
  .oil-remaining {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .oil-remaining .auxiliary-inner {
    border: 0;
  }
  .oil-remaining table.auxiliary-engine td:first-child {
    border: 0;
  border-right: 1px solid #000;
    width: 160px;
    text-align: left;
  }
  .oil-remaining table.auxiliary-engine td {font-weight: 600;font-size: 12px;}
  .oil-remaining table.auxiliary-engine tr:last-child td{ border-bottom: 1px solid #000;}
  .oil-remaining table.auxiliary-engine tr:last-child td:first-child{ border-bottom: 0;}

  .last-tbl td {
    text-align: right;
  }
  .chief {
    display: flex;
    justify-content: end;
    font-size: 16px; font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
  }
  .chief-line {
    border-bottom: 1px solid #000;
    font-family: Arial, Helvetica, sans-serif;
    width: 200px;
  }
  .cyltable-sec {
    margin-top: 20px;
}


}

    .input-container {
        background-color: rgba(255, 255, 255, 0.4);
        border: 1px solid rgba(255, 255, 255, 0.3);
        border-radius: 0;
        width: auto;
        height: 38px !important;
        margin-left: 75px;
        border-radius: 4px;
        margin-top: 30px;
    }

    .browse-btn {
      background: #4841a9;
      color: #fff;
      min-height: 35px;
      padding: 6px 18px;
      border: none;
      margin-right: 0px !important;
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
    }

    .text-forms {
      margin-top: 8px;
      margin-left: 5px;
    }

    .label-custom {
      position: absolute;
      bottom: 44px;
    }

    // span.file-info, .file-info1 {
    //     color: #fff;
    //     position: absolute;
    //     top: 38px;
    //     left: 26px;
    // }

// table {
//     width: 90%;
//     align-content: center;
//     /* text-align: center; */
//     align-self: center;
//     margin-left: auto;
//     margin-right: auto;

//   }

//   /* div{
//     margin-left: auto;
//     margin-right: auto;
//     text-align: center;
//   } */

//   .button{
//      margin-left: 50px
//   }

//   form{
//     margin-left: auto;
//     margin-right: auto;
//     align-content: center;
//     text-align: center;
//   }


//   example-container {
//     display: flex;
//     flex-direction: column;
//   }

//   .example-container > * {
//     width: 100%;
//   }

//   .example-container {
//     display: flex;
//     flex-direction: column;
//   }

//   .example-container > * {
//     width: 100%;
//   }

//   .example-right-align {
//     text-align: right;
//   }

//   input.example-right-align::-webkit-outer-spin-button,
//   input.example-right-align::-webkit-inner-spin-button {
//     display: none;
//   }

//   input.example-right-align {
//     -moz-appearance: textfield;
//   }

//   .container{
//     margin-top: 30px;
// }



.example-full-width label{font-family: "Poppins", sans-serif;
  display: inherit !important;font-size: 14px;}

  .example-full-width input {border:1px solid #ddd;font-family: "Poppins", sans-serif; padding:8px; margin-top: -14px;}
  .example-full-width  {border-top:0px!important;padding:0px !important;}

  .card .card-body {padding:10px;}

  .imgdiv {padding:0px !important; border-radius: 8px;}


  ul li {
    display: inline;
    list-style-type: none;
// margin-right: 34px;
    }


    .mat-form-field-appearance-legacy .mat-form-field-underline {height: 0px !important; }
    .mat-form-field-appearance-legacy .mat-form-field-underline {      background-color: #fff;}
    .mat-form-field-infix {border-top:0px;}


    p {font-size:13px}

    .img {width:auto; height: auto;
      margin: -15px;    padding-bottom: 0px;border-radius: 5px 0 0 5px;}
      .card-stacked {
          display: flex;
      flex-direction: column;
      flex: 1;
      position: absolute;
      margin-left: 120px;
      top: 33%; font-size: 15px; font-weight: normal
      }
      .card-stacked .card-content {
          -webkit-flex-grow: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
      }

      .card {

          // height: 110px;
      }

      // .itemwidhth {width: 25% !important;}

      img {border-radius: 5px 0 0 5px;}

      .item {width:250px !important; padding-right: 20px;}
      .banner {width:100%}
      .rightRs {display: block;
        float: right;
        margin-top: -56px;
        z-index: 999;
        border:0px solid red;
        background:transparent;
        position: relative;}

        .leftRs {display: block;
          float: left;
          margin-top: -56px;
          border:0px solid red;
          background:transparent;
          z-index: 999;
          position: relative;}


          .item .float-right {width:150px;    font-family: "Poppins", sans-serif;}
            .ngxcarouselPointDefault .ngxcarouselPoint {display: none;}





            ul {

              font-size: 13px;
              line-height: 1.5em;
              margin: 5px 0 15px;
              padding: 0;
              display: contents;
              li {
                list-style: none;
    position: relative;
    padding: 0 20px 0 0px !important;
    display: -webkit-box;
    display: inline-block;
              }
            }
            ul.square {
              li {
                &::before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: 9px;
                  width: 6px;
                  height: 6px;
                  background-color: black;
                }
              }
            }
            ul.round {
              li {
                &::before {
                  content: "";
                  /*position: absolute;*/
                  content: "";
                    left: 0;
                    top: 9px;
                    width: 6px;
                    height: 6px;
                    background-color: black;
                    border-radius: 50%;
                    -moz-border-radius: 50%;
                    -webkit-border-radius: 50%;
                    margin-right: 15px;
                    position: absolute;
                }
              }
            }


            .textlabel {display: flex;
              /* margin-bottom: 0.5rem; */
              vertical-align: middle;

              align-items: center;}

            .textblack {    color: #000;
              font-size: 14px;
              font-weight: 500;}



            #print-section{ padding-left: 2px; padding-right: 10px;}

.report_heading_title{line-height:  18px;}

#general_comments, #crew_work {
    width: 100%;
    padding: 15px 10px !important;
    margin: 8px 0;
    height: 80px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-bottom: 0px solid #ccc;
}

.formprview  {display: flex;    white-space: nowrap; font-size:13px;}
.formlabel {padding-top:16px;}
.inputwidth   {width:100%; padding: 0 10px;}
.forminput {background: none;
  border: 0px;
  border-bottom: 1px solid #ddd;}
  .radio-label  {
    padding: 10px 25px 0 7px;
  }

  .inputwidth1 {width:94% !important; }

  .formprviewinner  {display: flex;}

  .radio {padding-top: 9px;}

  .formprviewinner .formlabel1 {padding-top:16px;}
  .formprviewinner .inputwidth1   {width:100%; padding: 0 10px;}
  .textsmall {font-size:13px;}
 .colorschema {
    color:red;
 }
    .table td,
    .table th {
        white-space: normal
    }

    .table-wrap .table th,
    .table-wrap .table td {
        padding: 10px 9px;
        vertical-align: middle;
        border: 1px solid #f2f2f2;
    }
    .inputwidth{
        width:20% !important;
    }

    .colorschema {
        color:white !important;
        background-color: #f2a5a5 !important;
    }
    ::ng-deep.mat-form-field-infix{
        width: 100px !important;
    }


    .rightRs {display: block;
        float: right;
        margin-top: -66px;
        z-index: 999;
        border:0px solid red;
        background:transparent;
        position: relative;}

        .leftRs {display: block;
          float: left;
          margin-top: -66px;
          border:0px solid red;
          background:transparent;
          z-index: 999;
          position: relative;}

        ::ng-deep.mat-select-value-text {
  color: #000 !important;
}

 ::ng-deep.card-body {
    padding-bottom: 0px !important;
    padding-top: 15px !important;
}
.smtext {position: absolute;}

.report-box-row{display:flex; border:1px solid #000; border-left: 0; height: 180px;
    font-family: Arial, Helvetica, sans-serif;  font-size: 12px; font-weight: normal; box-sizing:border-box;}
    .report-col-row{display:flex; border:1px solid #000; border-left: 0; border-top: 0; height: 30px;
    font-family: Arial, Helvetica, sans-serif; box-sizing:border-box;  font-size: 12px; font-weight: normal;}
    .repo-col{display:flex; flex-basis: 0;flex-grow: 1;max-width: 100%;
    border:1px solid #000; border-right: 0; border-top:0; border-bottom: 0;
    position: relative; box-sizing: border-box; align-items: center;justify-content: center;}
    .report-head-col{display:flex; flex-basis: 0; flex-grow: 1;max-width: 100%;
    overflow: hidden; border:1px solid #000; border-right: 0; border-top:0; border-bottom: 0;
    position: relative; box-sizing: border-box; box-sizing:border-box;}
    .watch-col {max-width: 17.4%;flex:0 0 17.4%;display: flex;}
    .watch-col .report-head-col:first-child {flex-grow: revert !important;flex: 0 0 32.5%;max-width: 32.5%;}
    .report-col-row .repo-col:first-child {flex-grow: revert !important; flex: 0 0 5.6%;flex:5.6%;}
    .report-title-text{transform: rotate(270deg) translate(-50%, -50%);width: 100%;
    position: absolute;top: 50%;;left:32%;display: flex;justify-content: center;
    align-items: center;white-space: nowrap;margin-top: -20px;}
    .rp-col-15{max-width: 35.4%; flex: 0 0 35.4%; flex-wrap: wrap;  text-align: center;}
    .rp-col-20{ flex-wrap: wrap; text-align: center }
    .rp-col-5{flex: 0 0 33.50%;max-width: 33.50%;text-align: center;border: 1px solid #000;
    border-left: 0; box-sizing:border-box;border-bottom: 0;  border-top:0}
    .rep-w-100{flex: 0 0 100%;max-width: 100%; box-sizing:border-box; border-bottom:1px solid #000;  height: 30px;display: flex;justify-content: center;align-items: center;}
    .report-head-col.repo-col-1{flex: 0 0 6.60%;max-width: 6.60%;border: 1px solid #000;
    border-left: 0;border-bottom: 0;box-sizing:border-box;border-top: 0;
    height: calc(100% - 30px);}.report-head-col.repo-in-1{flex: 0 0 20%;
     max-width: 20%;border: 1px solid #000;border-left: 0;border-bottom: 0;box-sizing:border-box;
    border-top: 0;height: calc(100% - 30px);}
    .repo-flex{ display: flex; flex-wrap: wrap;}
    .repo-br-0{ border-right: 0 !important;}
    .repo-bl-0{ border-left: 0 !important;}
    .fuel-col {width: 41%;flex: 0 0 41%;border: 1px solid;
    height: 100%;margin-left: auto; border-right: 0;border-top: 0; border-bottom: 0;
    display: flex; align-items: center; justify-content: center;}
    .coolwater{width: 59%;flex: 0 0 59%;}.flex-rp{ display: flex;}.col-26{ display: flex; flex: 0 0 26%; max-width: 26%;margin-left: auto;}
            .col-26 .report-head-col.repo-col-1 {
              flex: 0 0 25%;
              max-width: 25%;
              height: 100%;
              box-sizing:border-box;
          }
          .rp-col-20 .report-head-col.repo-col-1 {
            flex: 0 0 5%;
          max-width: 5%;
            margin-left: auto;
            border-right: 0;
            border-left:1px solid #000;
        }
        .rp-col-20 .report-head-col.repo-col-1 .report-title-text{ left:26%}

        .temp-row {
          max-width: 95%;
          flex:0 0 95%;
          box-sizing: border-box;
          text-align: center;
      }
      .rep-w-100.bearing{height:calc(100% - 30px); justify-content: start; align-items: self-start; border: 0;}
      .fr-wtr, .nozzle, .lubri-oil {
        max-width: 10.6%;
        flex: 0 0 10.6%;
        border-right: 1px solid #000;
        height: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
      }
      .lubri-oil{max-width: 79%;
        flex: 0 0 79%; border-right: 0;}

        .cyl, .temp-vert, .pist-cooling {
          max-width: 10.6%;
          flex: 0 0 10.6%;
          border-right: 1px solid #000;
          height: 100%;
          align-items: center;
          display: flex;
          justify-content: center;
      }
      .pist-cooling {
        max-width: 16%;
        flex: 0 0 16%;
      }
      .bearing-col {
        width: 68.2%;
        border-right: 0;
      }

      .cyl .report-head-col.repo-in-1,.temp-vert .report-head-col.repo-in-1 {
        flex: 0 0 50%;
        max-width: 50%;
      }


      .cyl .rep-w-100 {
        height: auto;
      }
      .temp-vert .report-head-col.repo-in-1 {
        height: 100%;
      }
      .cyl .report-head-col.repo-in-1:last-child,
      .temp-vert .report-head-col.repo-in-1:last-child {
        border: 0;
      }
      .cyl .report-title-text,.temp-vert .report-title-text {
        left: 24% !important;
      }

      .pist-col .report-head-col.repo-in-1 {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
      }
      .pist-col  .report-head-col.repo-in-1:last-child{
        border: 0;
      }
      .bearing-col .rep-w-100 {
        justify-content: flex-start;
      }

      .pist-col {
        width: 23%;
        border-right: 1px solid;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
      }

      .bear-col {
        width: 77%;
        height: 100%;
        display: flex;
          flex-wrap: wrap;
      }
      .pist-col .rep-w-100,.bear-col .rep-w-100 {
        justify-content: center !important;
      }
      .bear-col .rep-w-100 {
        font-size: 16px;
      }

      .bearing-col >.rep-w-100 {
        height: 118px;
        border: 0;
      }
      .bear-col .report-head-col.repo-in-1 {
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .bear-col .report-head-col.repo-in-1:last-child {
        border: 0;
      }
      .report-header-title {font-weight: 600;font-size: 18px; text-align:left; margin-bottom:15px; font-family: Arial, Helvetica, sans-serif;}

    .watch-col .report-head-col:first-child .report-title-text {
      left: 15%; top:40%
    }
    .table-auxiliary .report-box-row{ height: 130px;}
    .table-auxiliary .watch-col{ max-width: 10.1%;flex: 0 0 10.1%;}
    .table-auxiliary .watch-col .report-head-col:first-child{ flex:0 0 56%; max-width: 56%;}
    .table-auxiliary  .report-title-text{ top: 35%;left: 15%;}
    .table-auxiliary .watch-col .report-head-col:first-child .report-title-text {top: 30%;}

    .repo-flex[_ngcontent-jal-c5] {
      display: flex;
      flex-wrap: wrap;
      border-left: 1px solid #000;
    }

    .pressure-col {
      border-left: 1px solid #000;
      width: 18.1%;
    }

    .table-auxiliary .report-head-col.repo-in-1{
      flex: auto; max-width: none;}

      .pressure-col .rep-w-100 {
        border-right: 1px solid #000;
    }


    .verticalTableHeader {text-align: center; white-space: nowrap;max-width: 20px;}
    .verticalTableHeader p {margin: 0 -100%;display: inline-block;
        g-origin: 50% 50%;-webkit-transform: rotate(270deg);-moz-transform: rotate(270deg);
        -ms-transform: rotate(270deg);-o-transform: rotate(270deg);transform: rotate(270deg);
    }
    .verticalTableHeader p:before {
    content: '';width: 0;padding-top: 110%;display: inline-block;vertical-align: middle;}
    table.auxiliary-engine {font-family: Arial, Helvetica, sans-serif;font-size: 0.9rem;text-align: center}
    table.auxiliary-engine td, .table-ship table td {border: 1px solid #000;border-bottom: 0;border-left: 0;padding: 5px}
    .auxiliary-engine-wrap {padding: 30px;}
    .auxiliary-inner {border: 1px solid #000;border-top: 0;
    border-right: 0; margin-top:10px;font-family: Arial, Helvetica, sans-serif;}
    .text-center {text-align: center;}
    .table-ship table td {font-size: .7rem;overflow: hidden;padding: 10px 0;}
    tr.f-bold {font-weight: 500}

    .auxiliary-engine-sec{ margin-top:30px;}


  .cyltable-sec{font-family: Arial, Helvetica, sans-serif; font-size: 12px;}
  .cylHeadRow {display: flex;border: 1px solid #000; font-family: Arial, Helvetica, sans-serif; font-size: 12px; border-left: 0;height: 180px;font-weight: normal; box-sizing: border-box;}
  .cylCol-20 {border-left: 1px solid #000;border-right: 1px solid;flex: 0 0 48.5%; max-width: 48.5%; position: relative;}
  .cylCol-9 {border-right: 1px solid;flex: 0 0 21.75%;box-sizing: border-box; max-width:21.75%; position: relative; display: flex;}
  .cylCol-10 {border-right: 1px solid #000; box-sizing: border-box; flex: 0 0 24.2%; position: relative; max-width:24.2%; display: flex;}
  .cylCol-1 {flex: 0 0 5.5%;max-width: 5.5%;box-sizing: border-box; position: relative;}
  .cylWrap{ flex-wrap: wrap;}
  .cylFlex{ display: flex;}
  .cylW-100{flex: 0 0 100%; max-width: 100%;}
  .cylRow{display: flex;border: 1px solid #000;border-left: 0;border-top: 0;height: 30px;
  box-sizing: border-box;font-size: 12px;font-weight: normal;}

  .cyl-head-col{display: flex;flex-basis: 0;flex-grow: 1;max-width: 100%;overflow: hidden;border: 1px solid #000;
  border-right: 0;border-top: 0;border-bottom: 0;position: relative;box-sizing: border-box;}
  .cylCol-1 .cyl-head-col{ border: 0;}
  .cyl-title-text{
    transform: rotate(270deg) translate(-50%, -50%);
  width: 100%;position: absolute;top: 50%;left: 15%;white-space: nowrap;margin-top: -20px;}
  .cylRow>div {display: flex;flex-basis: 0;flex-grow: 1;max-width: 100%; justify-content: center;align-items: center;
  border: 1px solid #000;border-right: 0;border-top: 0;border-bottom: 0;position: relative;box-sizing: border-box;}

  .cylRow>div:last-child{flex-grow: revert !important;flex: 0 0 5.6%;}
  .cylGrow{display: flex;flex:0 0 100%;max-width: 100%; border-bottom:1px solid #000;}
  .cylItemCenter{ align-items: center;}
  .cylJustifyCenter{ justify-content: center;}.cylHieght{ height: 30px; font-family: Arial, Helvetica, sans-serif; font-size: 12px;}
  .fromT {flex: 0 0 49%; text-align: left;}.toT {flex: 0 0 25%; text-align: left;}
  .dateT{ text-align: left;}.cylSing {height: calc(100% - 30px);max-width: 5%;border-right: 1px solid #000;flex: 0 0 5%;display: flex;}
  .cylSing .cyl-head-col {border: 0;}.cyl-title-text.t-small{width: 100%;top: 58%;left: 30%;margin-top: 0;}
  .cylSing.sing2 {flex: 0 0 70%;max-width: 70%;}
  .sing2 .cylSing {max-width: none;flex-basis: 0;flex-grow: 1;max-width: 100%;display: flex;align-items: center;justify-content: center;height: 58px;}
  .cylSing.sing2 .cy-50 .rep-w-100 {height: 90px;}
  .sing2 .cylSing:last-child{ border: 0;}
  .cy-50 {flex: 0 0 50%;display: flex;justify-content: center;border-right: 1px solid;height: 100%;flex-wrap: wrap;}
  .cy-50:last-child {border: 0;}.sing2>.rep-w-100.flex-rp {height: auto; border: 0;}
  .cylSing.singSmall2 {flex-basis: 0; flex-grow: 1;max-width: 100%;border: 0; flex-wrap: nowrap;}
  .cylFuel {flex: 0 0 60%;max-width: 60%;border-right: 1px solid;flex-wrap: wrap;display: flex;}
  .cylFuel .cylSing:last-child,.cylSea .cylSing:last-child {border: 0;}
  .cylFuel .cylSing,.cylSea .cylSing {flex-basis: 0;flex-grow: 1;max-width: 100%;}
  .cylFuel .cyl-title-text.t-small {top: 45%;}.cylSea {max-width: 40%; flex:0 0 40%;display: flex;}
  .cylSea .cylSing {height: 100%;}.cylSea .cyl-title-text.t-small {top: 50%;}.fw-b {font-size: 18px !important;left: 40% !important;}
  .tubo {flex: 0 0 66%;border-right: 1px solid #000;display: flex;flex-wrap: wrap; }
  .accom {flex: 0 0 34%;display: flex;flex-wrap: wrap;}

  .tubo .cylSing {display: flex;flex: 0 0 17%;max-width: none;}
  .scav {display: flex;width: 51%;border-right: 1px solid;flex-wrap: wrap;}

  .steam, .steam-tube {
    flex: 0 0 20%;
    border-right: 1px solid #000;
    display: flex;
    flex-wrap: wrap;
  }
  .steam .rep-w-100.flex-rp, .steam-tube .rep-w-100.flex-rp {
    height: auto;
    text-align: center;
  }


  .accom .cylSing,.scav .cylSing ,.gastem .cylSing,
  .steam .cylSing,.steam-tube .cylSing{display: flex;flex-basis: 0; flex-grow: 1;max-width: 100%;}
  .accom .cylSing:last-child,.scav .cylSing:last-child,
  .gastem .cylSing:last-child,.steam-tube .cylSing:last-child, .steam .cylSing:last-child {border: 0;}
  .gastem {display: flex;flex-wrap: wrap; flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;}
  .accom .cyl-title-text.t-small {top: 52%;}
  .steam .cyl-title-text.t-small,
  .steam-tube .cyl-title-text.t-small {top: 40%;}
  .steam .cylSing{height: calc(100% - 56px);}
  .steam-tube .cylSing{height: calc(100% - 38px);}
  .fresh-water .cylSing {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .fresh-water {
    display: flex;
    flex-wrap: wrap;
    flex: 0 0 60%;
    max-width: 60%;
  }
  .fresh-water .cylSing:last-child {
    border: 0;
  }
  .fresh-water .cylSing .cyl-title-text.t-small{top:50%}
  .enject .cyl-title-text.t-small {
    top: 67% !important;
  }
  .me-lubricating .cyl-title-text.t-small {
    left: -26px;
    white-space: normal;
    top: 12px !important;
    width: 100px;
    line-height: 11px;
  }
  .table-column-row {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
  }
  .day-tbl-col{
    flex: 0 0 50%;
    max-width: 50%;
    display: flex;
    flex-wrap: wrap;
  }

  .day-tank,
  .noo-report {
    flex: 0 0 48%; max-width: 48%;
    box-sizing: border-box;
  }
  .daily-fuel{  box-sizing: border-box;}
  .noo-report{ padding-left:20px; padding-right: 20px; }
  .noo-report table.auxiliary-engine,
  .daily-fuel table.auxiliary-engine,.remark-table table.auxiliary-engine {
    text-align: left;
  }
  .day-tank table.auxiliary-engine td{font-weight: 600;font-size: 12px;}
  .noo-report .auxiliary-inner,.daily-fuel .auxiliary-inner, .remark-table .auxiliary-inner{ border: 0;}
  .noo-report table.auxiliary-engine td,
  .daily-fuel table.auxiliary-engine td,
  .remark-table table.auxiliary-engine td{ border :0; padding:5px 0 0; font-weight: 600;font-size: 12px;}
  .noo-report table.auxiliary-engine td:first-child {width: 140px;}
  .noo-report table.auxiliary-engine td.tbl-underline,
  .daily-fuel table.auxiliary-engine td.tbl-underline,
  .last-tbl td.tbl-underline{border-bottom: 1px solid #000!important;}
  .remark-table table.auxiliary-engine td.dotted-underline{border-bottom: 1px dashed #000!important; height: 30px;}
  .remark-table {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 30px;
  }
  .oil-remaining {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .oil-remaining .auxiliary-inner {
    border: 0;
  }
  .oil-remaining table.auxiliary-engine td:first-child {
    border: 0;
  border-right: 1px solid #000;
    width: 160px;
    text-align: left;
  }
  .oil-remaining table.auxiliary-engine td {font-weight: 600;font-size: 12px;}
  .oil-remaining table.auxiliary-engine tr:last-child td{ border-bottom: 1px solid #000;}
  .oil-remaining table.auxiliary-engine tr:last-child td:first-child{ border-bottom: 0;}

  .last-tbl td {
    text-align: right;
  }
  .chief {
    display: flex;
    justify-content: end;
    font-size: 16px; font-weight: 600;
    font-family: Arial, Helvetica, sans-serif;
  }
  .chief-line {
    border-bottom: 1px solid #000;
    font-family: Arial, Helvetica, sans-serif;
    width: 200px;
  }
  .cyltable-sec {
    margin-top: 20px;
}
.frsh-table{
	font-family: Arial, Helvetica, sans-serif; border-left: 0; border-top:0; margin: 0 auto;
    font-size: 12px;}
	.frsh-table td{    width: 3rem;
    font-size: 12px; text-align: center; padding: 10px 1px; border:1px solid #000}
	.bc-head-txt-label {
	left: calc(50% - 0.5rem);
	line-height: 1;
	padding-top: 0rem;
	position: relative;
	transform: rotate(180deg);
	white-space: nowrap;
	-ms-writing-mode: tb-rl;
	-webkit-writing-mode: vertical-rl;
	writing-mode: vertical-rl;
  font-size: 12px;
}


.d-flex {
  display: flex !important; font-size:14px;
  font-family: Arial, Helvetica, sans-serif; margin-bottom:15px;
}
.justify-content-between {
  justify-content: space-between !important;
}
.mr-3{
  margin-right: 1rem !important;
}

}
.justify-content-between {
  justify-content: space-between !important;
}
.mr-3{
  margin-right: 1rem !important;
}



}


                </style>

            </head>
            <body onload="window.print();window.close()">
            <table border="0" width="100%" style="font-size:2em;" >
                 <thead><tr><th>${page_header}</th></tr></thead>
                 <tbody><tr><th>${page_body}</th></tr></tbody>
                 <tfoot><tr><th>${page_footer}</th></tr></tfoot>
                 </table>
            </body>
        </html>
        `);
    popupWin.document.close();
  }

  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join("\r\n");
  }

  downloadPDF(pdfTitle: any) {
    var node = (document.getElementById("header-footer") != null) ? document.getElementById("header-footer") : document.getElementById("print-section");
    var newPdfTitle = pdfTitle ? pdfTitle : 'Title';
    const htmlContent = node.innerHTML;
    this.commonService.openDialog(htmlContent, newPdfTitle, 'log');
  }

  getSignature(imagedata: string) {
    return imagedata != "" && imagedata != null
      ? this.domSanitizer.bypassSecurityTrustUrl(
        "data:image/jpg;base64," + imagedata
      )
      : this.domSanitizer.bypassSecurityTrustUrl(
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAABQUlEQVRYhe3WTytEYRTH8Q+NNERZmFIWlhQrspK1LUuy8C5EsmFnyxvwHpQsrZSVWVhYSA01CxulFA2LeYY7/tzM4xoW91en+3See875du7TPQ+5/rGeI+wcQ38JkClEI2EMcCYQsQDlxLP0FwCDOJNBJ2IBZAVxhLkIgM+s/FVQRwxZCkCaWq5VwCYucYUtdLXO1fKnfNWGj63cbifARQicxXRYV9oJcB8Ce36YKDWuMyJhpsoBcoAcoNCGGqkz4DsdKAaL0QAWI2OdqP/B9rDj87Fawi6quMFCYq+I4xC3FgMwjgfU8IRHTCX2V3CreVg1ZkU/DoPvCsMxALDu4yTsxX7Cf4DJsK5hxtu9sIqx2OLUD+lpSNgdfMsh+R2WEu9ea+5GGSM/Kd7QhObWwypG3/nmA0RF/cz0ZVE816/rBQZFh/X/XGGHAAAAAElFTkSuQmCC"
      );
  }

  logbookAuthorizedBy: any = [];
  userName: string = "";
  usersignature: string = "";
  private isButtonVisible = true;
  private isSignVisible = false;
  roleid: string = this.session.get("roleid");

  onAuthrorizeSheet() {
    var date = new Date();
    var currentdate = formatDate(date, "dd-MMM-yyyy h:mm:ss a", "en-US");
    this.masterName =
      this.session.get("firstname") + " " + this.session.get("lastname");
    this.roleid = this.session.get("roleid");
    this.roleName = this.session.get("rolename");
    this.signdate = currentdate; //"01-Sep-2020";
    this.isButtonVisible = false;
    this.isSignVisible = true;

    this.masterSignature = this.session.get("userSignature");

    var formId = this.formId;
    var recordId = this.id; //'5f4a3c6b218c856851a358b8';

    this.logbookAuthorizedBy = [];
    this.logbookAuthorizedBy = {
      date: this.signdate,
      masterName: this.masterName,
      masterSignature: this.masterSignature,
      roleId: this.roleid,
      roleName: this.roleName,
      formAndRecordId: this.formIdObject

    };

    console.log("===this.logbookAuthorizedBy==", this.logbookAuthorizedBy);

    // console.log("===this.formId==", formId, this.formIdObject);

    // return;

    this.reportsService.updateRankSignatureByFormAndRecordId(
      this.logbookAuthorizedBy,
      (response) => {
        console.log('check-logauthorized', this.logbookAuthorizedBy)
        if (response.responsecode === 200 || response.responsecode === "200") {
          this.formIdObject = null;
          console.log("============saved successfully============");
        }
      }
    );
  }

  async validateMasterByOtp(): Promise<boolean | 'cancel'> {
    this.loading = true;
    try {
      let dialogRef;

      console.log('==otpService.getIsOtpActive==', this.otpService.getIsOtpActive())

      if (this.otpService.getIsOtpActive()) {
        dialogRef = this.dialog.open(OtpDialogComponent, {
          width: '500px',
          disableClose: true,
          data: { type: 'emailOtpActive', vesselId: this.newVesselId },
        });
      } else {
        dialogRef = this.dialog.open(OtpDialogComponent, {
          width: '500px',
          disableClose: true,
          data: { type: 'approvalOtpActive', vesselId: this.newVesselId },
        });
      }

      const result = await dialogRef.afterClosed().toPromise();
      console.log('==Dialogbox-closed-result==', result);

      if (result == false) {
        this.otpService.clearOtpTimer();
      }

      return result;
    } catch (error) {
      this.showErrMsg('Error', 'Something went wrong while sending OTP');
      return false;
    } finally {
      this.loading = false;
    }
  }

  async notifyMaster() {
    const isValid = await this.validateMasterByOtp();
    if (isValid == true) {
      console.log("✅ OTP Verified Successfully.");
      this.showSuccessMsg('Verification Successful', 'Your identity has been verified successfully.')
      this.onAuthrorizeSheet();
    } else if (isValid == false) {
      this.showErrMsg('Invalid OTP', 'The OTP you entered is incorrect. Please try again.')
    } else if (isValid == 'cancel') {
      console.log("OTP dialog was closed manually. No Verification attempted")
    }
  }

  async notifyMasterDeckLogSheet() {
    const isValid = await this.validateMasterByOtp();
    if (isValid == true) {
      console.log("✅ OTP Verified Successfully.");
      this.showSuccessMsg('Verification Successful', 'Your identity has been verified successfully.')
      this.onAuthrorizeDeckLogSheet();
    } else if (isValid == false) {
      this.showErrMsg('Invalid OTP', 'The OTP you entered is incorrect. Please try again.')
    } else if (isValid == 'cancel') {
      console.log("OTP dialog was closed manually. No Verification attempted")
    }
  }

  onAuthrorizeDeckLogSheet() {
    var date = new Date();
    var currentdate = formatDate(date, "dd-MMM-yyyy", "en-US");

    if (this.masterName == "" && this.roleid != "12")
      this.masterName =
        this.session.get("firstname") + " " + this.session.get("lastname");

    if (this.roleid == "") {
      this.roleid = this.session.get("roleid");
    }

    if (this.roleName == "" && this.roleid != "12")
      this.roleName = this.session.get("rolename");

    if (this.signdate == "") this.signdate = currentdate; //"04-Sep-2020";

    if (this.masterSignature == "" && this.roleid != "12")
      this.masterSignature = this.session.get("userSignature");

    if (this.chiefOfficerName == "" && this.roleid == "12")
      this.chiefOfficerName =
        this.session.get("firstname") + " " + this.session.get("lastname");

    //if(this.chiefOfficerroleId=="" && this.roleid=='12')
    this.chiefOfficerroleId = this.session.get("roleid");

    if (this.chiefOfficerroleName == "" && this.roleid == "12")
      this.chiefOfficerroleName = this.session.get("rolename");

    this.chiefOfficersigndate = currentdate;

    if (this.chiefOfficerSignature == "" && this.roleid == "12")
      this.chiefOfficerSignature = this.session.get("userSignature");

    var formId = this.formId;
    var recordId = this.id; //'5f4a3c6b218c856851a358b8';

    this.logbookAuthorizedBy = [];
    this.logbookAuthorizedBy = {
      chiefOfficerDate: this.chiefOfficersigndate,
      chiefOfficerName: this.chiefOfficerName,
      chiefOfficerRoleId: this.chiefOfficerroleId,
      chiefOfficerRoleName: this.chiefOfficerroleName,
      chiefOfficerSignature: this.chiefOfficerSignature,
      masterDate: this.signdate,
      masterName: this.masterName,
      masterRoleId: this.roleid,
      masterRoleName: this.roleName,
      masterSignature: this.masterSignature,
      formIdAndRecordId: this.formIdObject,
    };

    // console.log('logbookAuthorizedBy: ', this.logbookAuthorizedBy);
    // return;

    //  alert("chiefOfficerDate  "+this.chiefOfficersigndate+'   chiefOfficerName  '+this.chiefOfficerName+'   chiefOfficerRoleId   '+this.chiefOfficerroleId+'  chiefOfficerRoleName  '+this.chiefOfficerroleName+'   masterDate   '+this.signdate+'  masterName  '+this.masterName+'  masterRoleId   '+this.roleid+'   masterRoleName   '+this.roleName
    //  );
    this.reportsService.updateRankSignatureForDeckByFormAndRecordId(this.logbookAuthorizedBy,
      (response) => {
        if (response.responsecode === 200 || response.responsecode === "200") {
          console.log("============saved successfully============");
        }
      }
    );
  }

  showErrMsg(title: string, text: string) {
    this.errorbox.title = title;
    this.errorbox.text = text;
    this.errorbox.show();
  }

  showSuccessMsg(title: string, text: string) {
    this.successbox.title = title;
    this.successbox.text = text;
    this.successbox.show();
  }

  getVesselDetailByVesselId(vesselid) {
    this.vts.getVesselDataById(vesselid, (vesselData) => {
      console.log("check-vessel-data", vesselData);
      this.vesselData = vesselData.data;
    })
  }

  getCospDetail(vesselId: number, voyageno: string) {
    this.rs.getCOSPByvesselId(vesselId, voyageno, (responseData) => {
      console.log('==responsecode==', responseData)
      this.cospData = responseData.data[0];
    })
  }
}

